import { jsx as y, jsxs as B, Fragment as Zr } from "react/jsx-runtime";
import * as x from "react";
import j, { createContext as go, useContext as ho, useCallback as _o, useState as Ce, useRef as Et, useEffect as Me, useMemo as fo, createElement as Kr, forwardRef as vt, useImperativeHandle as qr } from "react";
import "react-dom";
import { D as na, c as Wr, n as mo, s as Hr } from "./stay-request-BksSqoEP.js";
import { f as cz, i as uz, h as dz, a as gz, g as hz, b as _z, j as fz, e as mz, d as pz, k as bz, l as yz, m as vz, p as kz, u as wz } from "./stay-request-BksSqoEP.js";
var kt = (t) => t.type === "checkbox", Ue = (t) => t instanceof Date, de = (t) => t == null;
const po = (t) => typeof t == "object";
var te = (t) => !de(t) && !Array.isArray(t) && po(t) && !Ue(t), bo = (t) => te(t) && t.target ? kt(t.target) ? t.target.checked : t.target.value : t, Jr = (t) => t.substring(0, t.search(/\.\d+(\.|$)/)) || t, yo = (t, e) => t.has(Jr(e)), Yr = (t) => {
  const e = t.constructor && t.constructor.prototype;
  return te(e) && e.hasOwnProperty("isPrototypeOf");
}, In = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function ie(t) {
  let e;
  const n = Array.isArray(t), a = typeof FileList < "u" ? t instanceof FileList : !1;
  if (t instanceof Date)
    e = new Date(t);
  else if (!(In && (t instanceof Blob || a)) && (n || te(t)))
    if (e = n ? [] : Object.create(Object.getPrototypeOf(t)), !n && !Yr(t))
      e = t;
    else
      for (const o in t)
        t.hasOwnProperty(o) && (e[o] = ie(t[o]));
  else
    return t;
  return e;
}
var Wt = (t) => /^\w*$/.test(t), ee = (t) => t === void 0, Ln = (t) => Array.isArray(t) ? t.filter(Boolean) : [], Dn = (t) => Ln(t.replace(/["|']|\]/g, "").split(/\.|\[/)), S = (t, e, n) => {
  if (!e || !te(t))
    return n;
  const a = (Wt(e) ? [e] : Dn(e)).reduce((o, r) => de(o) ? o : o[r], t);
  return ee(a) || a === t ? ee(t[e]) ? n : t[e] : a;
}, me = (t) => typeof t == "boolean", G = (t, e, n) => {
  let a = -1;
  const o = Wt(e) ? [e] : Dn(e), r = o.length, i = r - 1;
  for (; ++a < r; ) {
    const s = o[a];
    let l = n;
    if (a !== i) {
      const c = t[s];
      l = te(c) || Array.isArray(c) ? c : isNaN(+o[a + 1]) ? {} : [];
    }
    if (s === "__proto__" || s === "constructor" || s === "prototype")
      return;
    t[s] = l, t = t[s];
  }
};
const jt = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, we = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Oe = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, vo = j.createContext(null);
vo.displayName = "HookFormContext";
const Mn = () => j.useContext(vo);
var ko = (t, e, n, a = !0) => {
  const o = {
    defaultValues: e._defaultValues
  };
  for (const r in t)
    Object.defineProperty(o, r, {
      get: () => {
        const i = r;
        return e._proxyFormState[i] !== we.all && (e._proxyFormState[i] = !a || we.all), n && (n[i] = !0), t[i];
      }
    });
  return o;
};
const En = typeof window < "u" ? j.useLayoutEffect : j.useEffect;
function Qr(t) {
  const e = Mn(), { control: n = e.control, disabled: a, name: o, exact: r } = t || {}, [i, s] = j.useState(n._formState), l = j.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  });
  return En(() => n._subscribe({
    name: o,
    formState: l.current,
    exact: r,
    callback: (c) => {
      !a && s({
        ...n._formState,
        ...c
      });
    }
  }), [o, a, r]), j.useEffect(() => {
    l.current.isValid && n._setValid(!0);
  }, [n]), j.useMemo(() => ko(i, n, l.current, !1), [i, n]);
}
var xe = (t) => typeof t == "string", wo = (t, e, n, a, o) => xe(t) ? (a && e.watch.add(t), S(n, t, o)) : Array.isArray(t) ? t.map((r) => (a && e.watch.add(r), S(n, r))) : (a && (e.watchAll = !0), n), pn = (t) => de(t) || !po(t);
function De(t, e, n = /* @__PURE__ */ new WeakSet()) {
  if (pn(t) || pn(e))
    return t === e;
  if (Ue(t) && Ue(e))
    return t.getTime() === e.getTime();
  const a = Object.keys(t), o = Object.keys(e);
  if (a.length !== o.length)
    return !1;
  if (n.has(t) || n.has(e))
    return !0;
  n.add(t), n.add(e);
  for (const r of a) {
    const i = t[r];
    if (!o.includes(r))
      return !1;
    if (r !== "ref") {
      const s = e[r];
      if (Ue(i) && Ue(s) || te(i) && te(s) || Array.isArray(i) && Array.isArray(s) ? !De(i, s, n) : i !== s)
        return !1;
    }
  }
  return !0;
}
function Xr(t) {
  const e = Mn(), { control: n = e.control, name: a, defaultValue: o, disabled: r, exact: i, compute: s } = t || {}, l = j.useRef(o), c = j.useRef(s), u = j.useRef(void 0);
  c.current = s;
  const d = j.useMemo(() => n._getWatch(a, l.current), [n, a]), [h, f] = j.useState(c.current ? c.current(d) : d);
  return En(() => n._subscribe({
    name: a,
    formState: {
      values: !0
    },
    exact: i,
    callback: (m) => {
      if (!r) {
        const b = wo(a, n._names, m.values || n._formValues, !1, l.current);
        if (c.current) {
          const w = c.current(b);
          De(w, u.current) || (f(w), u.current = w);
        } else
          f(b);
      }
    }
  }), [n, r, a, i]), j.useEffect(() => n._removeUnmounted()), h;
}
function ei(t) {
  const e = Mn(), { name: n, disabled: a, control: o = e.control, shouldUnregister: r, defaultValue: i } = t, s = yo(o._names.array, n), l = j.useMemo(() => S(o._formValues, n, S(o._defaultValues, n, i)), [o, n, i]), c = Xr({
    control: o,
    name: n,
    defaultValue: l,
    exact: !0
  }), u = Qr({
    control: o,
    name: n,
    exact: !0
  }), d = j.useRef(t), h = j.useRef(o.register(n, {
    ...t.rules,
    value: c,
    ...me(t.disabled) ? { disabled: t.disabled } : {}
  }));
  d.current = t;
  const f = j.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!S(u.errors, n)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!S(u.dirtyFields, n)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!S(u.touchedFields, n)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!S(u.validatingFields, n)
    },
    error: {
      enumerable: !0,
      get: () => S(u.errors, n)
    }
  }), [u, n]), m = j.useCallback((k) => h.current.onChange({
    target: {
      value: bo(k),
      name: n
    },
    type: jt.CHANGE
  }), [n]), b = j.useCallback(() => h.current.onBlur({
    target: {
      value: S(o._formValues, n),
      name: n
    },
    type: jt.BLUR
  }), [n, o._formValues]), w = j.useCallback((k) => {
    const N = S(o._fields, n);
    N && k && (N._f.ref = {
      focus: () => k.focus && k.focus(),
      select: () => k.select && k.select(),
      setCustomValidity: (A) => k.setCustomValidity(A),
      reportValidity: () => k.reportValidity()
    });
  }, [o._fields, n]), I = j.useMemo(() => ({
    name: n,
    value: c,
    ...me(a) || u.disabled ? { disabled: u.disabled || a } : {},
    onChange: m,
    onBlur: b,
    ref: w
  }), [n, a, u.disabled, m, b, w, c]);
  return j.useEffect(() => {
    const k = o._options.shouldUnregister || r;
    o.register(n, {
      ...d.current.rules,
      ...me(d.current.disabled) ? { disabled: d.current.disabled } : {}
    });
    const N = (A, L) => {
      const F = S(o._fields, A);
      F && F._f && (F._f.mount = L);
    };
    if (N(n, !0), k) {
      const A = ie(S(o._options.defaultValues, n));
      G(o._defaultValues, n, A), ee(S(o._formValues, n)) && G(o._formValues, n, A);
    }
    return !s && o.register(n), () => {
      (s ? k && !o._state.action : k) ? o.unregister(n) : N(n, !1);
    };
  }, [n, o, s, r]), j.useEffect(() => {
    o._setDisabledField({
      disabled: a,
      name: n
    });
  }, [a, n, o]), j.useMemo(() => ({
    field: I,
    formState: u,
    fieldState: f
  }), [I, u, f]);
}
const aa = (t) => t.render(ei(t));
var jn = (t, e, n, a, o) => e ? {
  ...n[t],
  types: {
    ...n[t] && n[t].types ? n[t].types : {},
    [a]: o || !0
  }
} : {}, ct = (t) => Array.isArray(t) ? t : [t], oa = () => {
  let t = [];
  return {
    get observers() {
      return t;
    },
    next: (o) => {
      for (const r of t)
        r.next && r.next(o);
    },
    subscribe: (o) => (t.push(o), {
      unsubscribe: () => {
        t = t.filter((r) => r !== o);
      }
    }),
    unsubscribe: () => {
      t = [];
    }
  };
}, he = (t) => te(t) && !Object.keys(t).length, Pn = (t) => t.type === "file", $e = (t) => typeof t == "function", Pt = (t) => {
  if (!In)
    return !1;
  const e = t ? t.ownerDocument : 0;
  return t instanceof (e && e.defaultView ? e.defaultView.HTMLElement : HTMLElement);
}, $o = (t) => t.type === "select-multiple", Tn = (t) => t.type === "radio", ti = (t) => Tn(t) || kt(t), dn = (t) => Pt(t) && t.isConnected;
function ni(t, e) {
  const n = e.slice(0, -1).length;
  let a = 0;
  for (; a < n; )
    t = ee(t) ? a++ : t[e[a++]];
  return t;
}
function ai(t) {
  for (const e in t)
    if (t.hasOwnProperty(e) && !ee(t[e]))
      return !1;
  return !0;
}
function re(t, e) {
  const n = Array.isArray(e) ? e : Wt(e) ? [e] : Dn(e), a = n.length === 1 ? t : ni(t, n), o = n.length - 1, r = n[o];
  return a && delete a[r], o !== 0 && (te(a) && he(a) || Array.isArray(a) && ai(a)) && re(t, n.slice(0, -1)), t;
}
var Co = (t) => {
  for (const e in t)
    if ($e(t[e]))
      return !0;
  return !1;
};
function Tt(t, e = {}) {
  const n = Array.isArray(t);
  if (te(t) || n)
    for (const a in t)
      Array.isArray(t[a]) || te(t[a]) && !Co(t[a]) ? (e[a] = Array.isArray(t[a]) ? [] : {}, Tt(t[a], e[a])) : de(t[a]) || (e[a] = !0);
  return e;
}
function So(t, e, n) {
  const a = Array.isArray(t);
  if (te(t) || a)
    for (const o in t)
      Array.isArray(t[o]) || te(t[o]) && !Co(t[o]) ? ee(e) || pn(n[o]) ? n[o] = Array.isArray(t[o]) ? Tt(t[o], []) : { ...Tt(t[o]) } : So(t[o], de(e) ? {} : e[o], n[o]) : n[o] = !De(t[o], e[o]);
  return n;
}
var rt = (t, e) => So(t, e, Tt(e));
const ra = {
  value: !1,
  isValid: !1
}, ia = { value: !0, isValid: !0 };
var xo = (t) => {
  if (Array.isArray(t)) {
    if (t.length > 1) {
      const e = t.filter((n) => n && n.checked && !n.disabled).map((n) => n.value);
      return { value: e, isValid: !!e.length };
    }
    return t[0].checked && !t[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      t[0].attributes && !ee(t[0].attributes.value) ? ee(t[0].value) || t[0].value === "" ? ia : { value: t[0].value, isValid: !0 } : ia
    ) : ra;
  }
  return ra;
}, zo = (t, { valueAsNumber: e, valueAsDate: n, setValueAs: a }) => ee(t) ? t : e ? t === "" ? NaN : t && +t : n && xe(t) ? new Date(t) : a ? a(t) : t;
const sa = {
  isValid: !1,
  value: null
};
var Ao = (t) => Array.isArray(t) ? t.reduce((e, n) => n && n.checked && !n.disabled ? {
  isValid: !0,
  value: n.value
} : e, sa) : sa;
function la(t) {
  const e = t.ref;
  return Pn(e) ? e.files : Tn(e) ? Ao(t.refs).value : $o(e) ? [...e.selectedOptions].map(({ value: n }) => n) : kt(e) ? xo(t.refs).value : zo(ee(e.value) ? t.ref.value : e.value, t);
}
var oi = (t, e, n, a) => {
  const o = {};
  for (const r of t) {
    const i = S(e, r);
    i && G(o, r, i._f);
  }
  return {
    criteriaMode: n,
    names: [...t],
    fields: o,
    shouldUseNativeValidation: a
  };
}, Rt = (t) => t instanceof RegExp, it = (t) => ee(t) ? t : Rt(t) ? t.source : te(t) ? Rt(t.value) ? t.value.source : t.value : t, ca = (t) => ({
  isOnSubmit: !t || t === we.onSubmit,
  isOnBlur: t === we.onBlur,
  isOnChange: t === we.onChange,
  isOnAll: t === we.all,
  isOnTouch: t === we.onTouched
});
const ua = "AsyncFunction";
var ri = (t) => !!t && !!t.validate && !!($e(t.validate) && t.validate.constructor.name === ua || te(t.validate) && Object.values(t.validate).find((e) => e.constructor.name === ua)), ii = (t) => t.mount && (t.required || t.min || t.max || t.maxLength || t.minLength || t.pattern || t.validate), da = (t, e, n) => !n && (e.watchAll || e.watch.has(t) || [...e.watch].some((a) => t.startsWith(a) && /^\.\w+/.test(t.slice(a.length))));
const ut = (t, e, n, a) => {
  for (const o of n || Object.keys(t)) {
    const r = S(t, o);
    if (r) {
      const { _f: i, ...s } = r;
      if (i) {
        if (i.refs && i.refs[0] && e(i.refs[0], o) && !a)
          return !0;
        if (i.ref && e(i.ref, i.name) && !a)
          return !0;
        if (ut(s, e))
          break;
      } else if (te(s) && ut(s, e))
        break;
    }
  }
};
function ga(t, e, n) {
  const a = S(t, n);
  if (a || Wt(n))
    return {
      error: a,
      name: n
    };
  const o = n.split(".");
  for (; o.length; ) {
    const r = o.join("."), i = S(e, r), s = S(t, r);
    if (i && !Array.isArray(i) && n !== r)
      return { name: n };
    if (s && s.type)
      return {
        name: r,
        error: s
      };
    if (s && s.root && s.root.type)
      return {
        name: `${r}.root`,
        error: s.root
      };
    o.pop();
  }
  return {
    name: n
  };
}
var si = (t, e, n, a) => {
  n(t);
  const { name: o, ...r } = t;
  return he(r) || Object.keys(r).length >= Object.keys(e).length || Object.keys(r).find((i) => e[i] === (!a || we.all));
}, li = (t, e, n) => !t || !e || t === e || ct(t).some((a) => a && (n ? a === e : a.startsWith(e) || e.startsWith(a))), ci = (t, e, n, a, o) => o.isOnAll ? !1 : !n && o.isOnTouch ? !(e || t) : (n ? a.isOnBlur : o.isOnBlur) ? !t : (n ? a.isOnChange : o.isOnChange) ? t : !0, ui = (t, e) => !Ln(S(t, e)).length && re(t, e), di = (t, e, n) => {
  const a = ct(S(t, n));
  return G(a, "root", e[n]), G(t, n, a), t;
}, Dt = (t) => xe(t);
function ha(t, e, n = "validate") {
  if (Dt(t) || Array.isArray(t) && t.every(Dt) || me(t) && !t)
    return {
      type: n,
      message: Dt(t) ? t : "",
      ref: e
    };
}
var Je = (t) => te(t) && !Rt(t) ? t : {
  value: t,
  message: ""
}, _a = async (t, e, n, a, o, r) => {
  const { ref: i, refs: s, required: l, maxLength: c, minLength: u, min: d, max: h, pattern: f, validate: m, name: b, valueAsNumber: w, mount: I } = t._f, k = S(n, b);
  if (!I || e.has(b))
    return {};
  const N = s ? s[0] : i, A = (T) => {
    o && N.reportValidity && (N.setCustomValidity(me(T) ? "" : T || ""), N.reportValidity());
  }, L = {}, F = Tn(i), U = kt(i), ne = F || U, Q = (w || Pn(i)) && ee(i.value) && ee(k) || Pt(i) && i.value === "" || k === "" || Array.isArray(k) && !k.length, X = jn.bind(null, b, a, L), ce = (T, P, R, Z = Oe.maxLength, W = Oe.minLength) => {
    const ae = T ? P : R;
    L[b] = {
      type: T ? Z : W,
      message: ae,
      ref: i,
      ...X(T ? Z : W, ae)
    };
  };
  if (r ? !Array.isArray(k) || !k.length : l && (!ne && (Q || de(k)) || me(k) && !k || U && !xo(s).isValid || F && !Ao(s).isValid)) {
    const { value: T, message: P } = Dt(l) ? { value: !!l, message: l } : Je(l);
    if (T && (L[b] = {
      type: Oe.required,
      message: P,
      ref: N,
      ...X(Oe.required, P)
    }, !a))
      return A(P), L;
  }
  if (!Q && (!de(d) || !de(h))) {
    let T, P;
    const R = Je(h), Z = Je(d);
    if (!de(k) && !isNaN(k)) {
      const W = i.valueAsNumber || k && +k;
      de(R.value) || (T = W > R.value), de(Z.value) || (P = W < Z.value);
    } else {
      const W = i.valueAsDate || new Date(k), ae = (Fe) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + Fe), ve = i.type == "time", ke = i.type == "week";
      xe(R.value) && k && (T = ve ? ae(k) > ae(R.value) : ke ? k > R.value : W > new Date(R.value)), xe(Z.value) && k && (P = ve ? ae(k) < ae(Z.value) : ke ? k < Z.value : W < new Date(Z.value));
    }
    if ((T || P) && (ce(!!T, R.message, Z.message, Oe.max, Oe.min), !a))
      return A(L[b].message), L;
  }
  if ((c || u) && !Q && (xe(k) || r && Array.isArray(k))) {
    const T = Je(c), P = Je(u), R = !de(T.value) && k.length > +T.value, Z = !de(P.value) && k.length < +P.value;
    if ((R || Z) && (ce(R, T.message, P.message), !a))
      return A(L[b].message), L;
  }
  if (f && !Q && xe(k)) {
    const { value: T, message: P } = Je(f);
    if (Rt(T) && !k.match(T) && (L[b] = {
      type: Oe.pattern,
      message: P,
      ref: i,
      ...X(Oe.pattern, P)
    }, !a))
      return A(P), L;
  }
  if (m) {
    if ($e(m)) {
      const T = await m(k, n), P = ha(T, N);
      if (P && (L[b] = {
        ...P,
        ...X(Oe.validate, P.message)
      }, !a))
        return A(P.message), L;
    } else if (te(m)) {
      let T = {};
      for (const P in m) {
        if (!he(T) && !a)
          break;
        const R = ha(await m[P](k, n), N, P);
        R && (T = {
          ...R,
          ...X(P, R.message)
        }, A(R.message), a && (L[b] = T));
      }
      if (!he(T) && (L[b] = {
        ref: N,
        ...T
      }, !a))
        return L;
    }
  }
  return A(!0), L;
};
const gi = {
  mode: we.onSubmit,
  reValidateMode: we.onChange,
  shouldFocusError: !0
};
function hi(t = {}) {
  let e = {
    ...gi,
    ...t
  }, n = {
    submitCount: 0,
    isDirty: !1,
    isReady: !1,
    isLoading: $e(e.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1
  }, a = {}, o = te(e.defaultValues) || te(e.values) ? ie(e.defaultValues || e.values) || {} : {}, r = e.shouldUnregister ? {} : ie(o), i = {
    action: !1,
    mount: !1,
    watch: !1
  }, s = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, l, c = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let d = {
    ...u
  };
  const h = {
    array: oa(),
    state: oa()
  }, f = e.criteriaMode === we.all, m = (g) => (_) => {
    clearTimeout(c), c = setTimeout(g, _);
  }, b = async (g) => {
    if (!e.disabled && (u.isValid || d.isValid || g)) {
      const _ = e.resolver ? he((await U()).errors) : await Q(a, !0);
      _ !== n.isValid && h.state.next({
        isValid: _
      });
    }
  }, w = (g, _) => {
    !e.disabled && (u.isValidating || u.validatingFields || d.isValidating || d.validatingFields) && ((g || Array.from(s.mount)).forEach((p) => {
      p && (_ ? G(n.validatingFields, p, _) : re(n.validatingFields, p));
    }), h.state.next({
      validatingFields: n.validatingFields,
      isValidating: !he(n.validatingFields)
    }));
  }, I = (g, _ = [], p, z, C = !0, $ = !0) => {
    if (z && p && !e.disabled) {
      if (i.action = !0, $ && Array.isArray(S(a, g))) {
        const O = p(S(a, g), z.argA, z.argB);
        C && G(a, g, O);
      }
      if ($ && Array.isArray(S(n.errors, g))) {
        const O = p(S(n.errors, g), z.argA, z.argB);
        C && G(n.errors, g, O), ui(n.errors, g);
      }
      if ((u.touchedFields || d.touchedFields) && $ && Array.isArray(S(n.touchedFields, g))) {
        const O = p(S(n.touchedFields, g), z.argA, z.argB);
        C && G(n.touchedFields, g, O);
      }
      (u.dirtyFields || d.dirtyFields) && (n.dirtyFields = rt(o, r)), h.state.next({
        name: g,
        isDirty: ce(g, _),
        dirtyFields: n.dirtyFields,
        errors: n.errors,
        isValid: n.isValid
      });
    } else
      G(r, g, _);
  }, k = (g, _) => {
    G(n.errors, g, _), h.state.next({
      errors: n.errors
    });
  }, N = (g) => {
    n.errors = g, h.state.next({
      errors: n.errors,
      isValid: !1
    });
  }, A = (g, _, p, z) => {
    const C = S(a, g);
    if (C) {
      const $ = S(r, g, ee(p) ? S(o, g) : p);
      ee($) || z && z.defaultChecked || _ ? G(r, g, _ ? $ : la(C._f)) : R(g, $), i.mount && b();
    }
  }, L = (g, _, p, z, C) => {
    let $ = !1, O = !1;
    const V = {
      name: g
    };
    if (!e.disabled) {
      if (!p || z) {
        (u.isDirty || d.isDirty) && (O = n.isDirty, n.isDirty = V.isDirty = ce(), $ = O !== V.isDirty);
        const K = De(S(o, g), _);
        O = !!S(n.dirtyFields, g), K ? re(n.dirtyFields, g) : G(n.dirtyFields, g, !0), V.dirtyFields = n.dirtyFields, $ = $ || (u.dirtyFields || d.dirtyFields) && O !== !K;
      }
      if (p) {
        const K = S(n.touchedFields, g);
        K || (G(n.touchedFields, g, p), V.touchedFields = n.touchedFields, $ = $ || (u.touchedFields || d.touchedFields) && K !== p);
      }
      $ && C && h.state.next(V);
    }
    return $ ? V : {};
  }, F = (g, _, p, z) => {
    const C = S(n.errors, g), $ = (u.isValid || d.isValid) && me(_) && n.isValid !== _;
    if (e.delayError && p ? (l = m(() => k(g, p)), l(e.delayError)) : (clearTimeout(c), l = null, p ? G(n.errors, g, p) : re(n.errors, g)), (p ? !De(C, p) : C) || !he(z) || $) {
      const O = {
        ...z,
        ...$ && me(_) ? { isValid: _ } : {},
        errors: n.errors,
        name: g
      };
      n = {
        ...n,
        ...O
      }, h.state.next(O);
    }
  }, U = async (g) => {
    w(g, !0);
    const _ = await e.resolver(r, e.context, oi(g || s.mount, a, e.criteriaMode, e.shouldUseNativeValidation));
    return w(g), _;
  }, ne = async (g) => {
    const { errors: _ } = await U(g);
    if (g)
      for (const p of g) {
        const z = S(_, p);
        z ? G(n.errors, p, z) : re(n.errors, p);
      }
    else
      n.errors = _;
    return _;
  }, Q = async (g, _, p = {
    valid: !0
  }) => {
    for (const z in g) {
      const C = g[z];
      if (C) {
        const { _f: $, ...O } = C;
        if ($) {
          const V = s.array.has($.name), K = C._f && ri(C._f);
          K && u.validatingFields && w([z], !0);
          const pe = await _a(C, s.disabled, r, f, e.shouldUseNativeValidation && !_, V);
          if (K && u.validatingFields && w([z]), pe[$.name] && (p.valid = !1, _))
            break;
          !_ && (S(pe, $.name) ? V ? di(n.errors, pe, $.name) : G(n.errors, $.name, pe[$.name]) : re(n.errors, $.name));
        }
        !he(O) && await Q(O, _, p);
      }
    }
    return p.valid;
  }, X = () => {
    for (const g of s.unMount) {
      const _ = S(a, g);
      _ && (_._f.refs ? _._f.refs.every((p) => !dn(p)) : !dn(_._f.ref)) && rn(g);
    }
    s.unMount = /* @__PURE__ */ new Set();
  }, ce = (g, _) => !e.disabled && (g && _ && G(r, g, _), !De(Fe(), o)), T = (g, _, p) => wo(g, s, {
    ...i.mount ? r : ee(_) ? o : xe(g) ? { [g]: _ } : _
  }, p, _), P = (g) => Ln(S(i.mount ? r : o, g, e.shouldUnregister ? S(o, g, []) : [])), R = (g, _, p = {}) => {
    const z = S(a, g);
    let C = _;
    if (z) {
      const $ = z._f;
      $ && (!$.disabled && G(r, g, zo(_, $)), C = Pt($.ref) && de(_) ? "" : _, $o($.ref) ? [...$.ref.options].forEach((O) => O.selected = C.includes(O.value)) : $.refs ? kt($.ref) ? $.refs.forEach((O) => {
        (!O.defaultChecked || !O.disabled) && (Array.isArray(C) ? O.checked = !!C.find((V) => V === O.value) : O.checked = C === O.value || !!C);
      }) : $.refs.forEach((O) => O.checked = O.value === C) : Pn($.ref) ? $.ref.value = "" : ($.ref.value = C, $.ref.type || h.state.next({
        name: g,
        values: ie(r)
      })));
    }
    (p.shouldDirty || p.shouldTouch) && L(g, C, p.shouldTouch, p.shouldDirty, !0), p.shouldValidate && ke(g);
  }, Z = (g, _, p) => {
    for (const z in _) {
      if (!_.hasOwnProperty(z))
        return;
      const C = _[z], $ = g + "." + z, O = S(a, $);
      (s.array.has(g) || te(C) || O && !O._f) && !Ue(C) ? Z($, C, p) : R($, C, p);
    }
  }, W = (g, _, p = {}) => {
    const z = S(a, g), C = s.array.has(g), $ = ie(_);
    G(r, g, $), C ? (h.array.next({
      name: g,
      values: ie(r)
    }), (u.isDirty || u.dirtyFields || d.isDirty || d.dirtyFields) && p.shouldDirty && h.state.next({
      name: g,
      dirtyFields: rt(o, r),
      isDirty: ce(g, $)
    })) : z && !z._f && !de($) ? Z(g, $, p) : R(g, $, p), da(g, s) && h.state.next({ ...n, name: g }), h.state.next({
      name: i.mount ? g : void 0,
      values: ie(r)
    });
  }, ae = async (g) => {
    i.mount = !0;
    const _ = g.target;
    let p = _.name, z = !0;
    const C = S(a, p), $ = (K) => {
      z = Number.isNaN(K) || Ue(K) && isNaN(K.getTime()) || De(K, S(r, p, K));
    }, O = ca(e.mode), V = ca(e.reValidateMode);
    if (C) {
      let K, pe;
      const St = _.type ? la(C._f) : bo(g), Pe = g.type === jt.BLUR || g.type === jt.FOCUS_OUT, Vr = !ii(C._f) && !e.resolver && !S(n.errors, p) && !C._f.deps || ci(Pe, S(n.touchedFields, p), n.isSubmitted, V, O), cn = da(p, s, Pe);
      G(r, p, St), Pe ? (!_ || !_.readOnly) && (C._f.onBlur && C._f.onBlur(g), l && l(0)) : C._f.onChange && C._f.onChange(g);
      const un = L(p, St, Pe), Gr = !he(un) || cn;
      if (!Pe && h.state.next({
        name: p,
        type: g.type,
        values: ie(r)
      }), Vr)
        return (u.isValid || d.isValid) && (e.mode === "onBlur" ? Pe && b() : Pe || b()), Gr && h.state.next({ name: p, ...cn ? {} : un });
      if (!Pe && cn && h.state.next({ ...n }), e.resolver) {
        const { errors: ea } = await U([p]);
        if ($(St), z) {
          const Ur = ga(n.errors, a, p), ta = ga(ea, a, Ur.name || p);
          K = ta.error, p = ta.name, pe = he(ea);
        }
      } else
        w([p], !0), K = (await _a(C, s.disabled, r, f, e.shouldUseNativeValidation))[p], w([p]), $(St), z && (K ? pe = !1 : (u.isValid || d.isValid) && (pe = await Q(a, !0)));
      z && (C._f.deps && ke(C._f.deps), F(p, pe, K, un));
    }
  }, ve = (g, _) => {
    if (S(n.errors, _) && g.focus)
      return g.focus(), 1;
  }, ke = async (g, _ = {}) => {
    let p, z;
    const C = ct(g);
    if (e.resolver) {
      const $ = await ne(ee(g) ? g : C);
      p = he($), z = g ? !C.some((O) => S($, O)) : p;
    } else g ? (z = (await Promise.all(C.map(async ($) => {
      const O = S(a, $);
      return await Q(O && O._f ? { [$]: O } : O);
    }))).every(Boolean), !(!z && !n.isValid) && b()) : z = p = await Q(a);
    return h.state.next({
      ...!xe(g) || (u.isValid || d.isValid) && p !== n.isValid ? {} : { name: g },
      ...e.resolver || !g ? { isValid: p } : {},
      errors: n.errors
    }), _.shouldFocus && !z && ut(a, ve, g ? C : s.mount), z;
  }, Fe = (g) => {
    const _ = {
      ...i.mount ? r : o
    };
    return ee(g) ? _ : xe(g) ? S(_, g) : g.map((p) => S(_, p));
  }, ue = (g, _) => ({
    invalid: !!S((_ || n).errors, g),
    isDirty: !!S((_ || n).dirtyFields, g),
    error: S((_ || n).errors, g),
    isValidating: !!S(n.validatingFields, g),
    isTouched: !!S((_ || n).touchedFields, g)
  }), Ne = (g) => {
    g && ct(g).forEach((_) => re(n.errors, _)), h.state.next({
      errors: g ? n.errors : {}
    });
  }, je = (g, _, p) => {
    const z = (S(a, g, { _f: {} })._f || {}).ref, C = S(n.errors, g) || {}, { ref: $, message: O, type: V, ...K } = C;
    G(n.errors, g, {
      ...K,
      ..._,
      ref: z
    }), h.state.next({
      name: g,
      errors: n.errors,
      isValid: !1
    }), p && p.shouldFocus && z && z.focus && z.focus();
  }, Ct = (g, _) => $e(g) ? h.state.subscribe({
    next: (p) => "values" in p && g(T(void 0, _), p)
  }) : T(g, _, !0), Wn = (g) => h.state.subscribe({
    next: (_) => {
      li(g.name, _.name, g.exact) && si(_, g.formState || u, Fr, g.reRenderRoot) && g.callback({
        values: { ...r },
        ...n,
        ..._,
        defaultValues: o
      });
    }
  }).unsubscribe, Pr = (g) => (i.mount = !0, d = {
    ...d,
    ...g.formState
  }, Wn({
    ...g,
    formState: d
  })), rn = (g, _ = {}) => {
    for (const p of g ? ct(g) : s.mount)
      s.mount.delete(p), s.array.delete(p), _.keepValue || (re(a, p), re(r, p)), !_.keepError && re(n.errors, p), !_.keepDirty && re(n.dirtyFields, p), !_.keepTouched && re(n.touchedFields, p), !_.keepIsValidating && re(n.validatingFields, p), !e.shouldUnregister && !_.keepDefaultValue && re(o, p);
    h.state.next({
      values: ie(r)
    }), h.state.next({
      ...n,
      ..._.keepDirty ? { isDirty: ce() } : {}
    }), !_.keepIsValid && b();
  }, Hn = ({ disabled: g, name: _ }) => {
    (me(g) && i.mount || g || s.disabled.has(_)) && (g ? s.disabled.add(_) : s.disabled.delete(_));
  }, sn = (g, _ = {}) => {
    let p = S(a, g);
    const z = me(_.disabled) || me(e.disabled);
    return G(a, g, {
      ...p || {},
      _f: {
        ...p && p._f ? p._f : { ref: { name: g } },
        name: g,
        mount: !0,
        ..._
      }
    }), s.mount.add(g), p ? Hn({
      disabled: me(_.disabled) ? _.disabled : e.disabled,
      name: g
    }) : A(g, !0, _.value), {
      ...z ? { disabled: _.disabled || e.disabled } : {},
      ...e.progressive ? {
        required: !!_.required,
        min: it(_.min),
        max: it(_.max),
        minLength: it(_.minLength),
        maxLength: it(_.maxLength),
        pattern: it(_.pattern)
      } : {},
      name: g,
      onChange: ae,
      onBlur: ae,
      ref: (C) => {
        if (C) {
          sn(g, _), p = S(a, g);
          const $ = ee(C.value) && C.querySelectorAll && C.querySelectorAll("input,select,textarea")[0] || C, O = ti($), V = p._f.refs || [];
          if (O ? V.find((K) => K === $) : $ === p._f.ref)
            return;
          G(a, g, {
            _f: {
              ...p._f,
              ...O ? {
                refs: [
                  ...V.filter(dn),
                  $,
                  ...Array.isArray(S(o, g)) ? [{}] : []
                ],
                ref: { type: $.type, name: g }
              } : { ref: $ }
            }
          }), A(g, !1, void 0, $);
        } else
          p = S(a, g, {}), p._f && (p._f.mount = !1), (e.shouldUnregister || _.shouldUnregister) && !(yo(s.array, g) && i.action) && s.unMount.add(g);
      }
    };
  }, ln = () => e.shouldFocusError && ut(a, ve, s.mount), Tr = (g) => {
    me(g) && (h.state.next({ disabled: g }), ut(a, (_, p) => {
      const z = S(a, p);
      z && (_.disabled = z._f.disabled || g, Array.isArray(z._f.refs) && z._f.refs.forEach((C) => {
        C.disabled = z._f.disabled || g;
      }));
    }, 0, !1));
  }, Jn = (g, _) => async (p) => {
    let z;
    p && (p.preventDefault && p.preventDefault(), p.persist && p.persist());
    let C = ie(r);
    if (h.state.next({
      isSubmitting: !0
    }), e.resolver) {
      const { errors: $, values: O } = await U();
      n.errors = $, C = ie(O);
    } else
      await Q(a);
    if (s.disabled.size)
      for (const $ of s.disabled)
        re(C, $);
    if (re(n.errors, "root"), he(n.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await g(C, p);
      } catch ($) {
        z = $;
      }
    } else
      _ && await _({ ...n.errors }, p), ln(), setTimeout(ln);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: he(n.errors) && !z,
      submitCount: n.submitCount + 1,
      errors: n.errors
    }), z)
      throw z;
  }, Rr = (g, _ = {}) => {
    S(a, g) && (ee(_.defaultValue) ? W(g, ie(S(o, g))) : (W(g, _.defaultValue), G(o, g, ie(_.defaultValue))), _.keepTouched || re(n.touchedFields, g), _.keepDirty || (re(n.dirtyFields, g), n.isDirty = _.defaultValue ? ce(g, ie(S(o, g))) : ce()), _.keepError || (re(n.errors, g), u.isValid && b()), h.state.next({ ...n }));
  }, Yn = (g, _ = {}) => {
    const p = g ? ie(g) : o, z = ie(p), C = he(g), $ = C ? o : z;
    if (_.keepDefaultValues || (o = p), !_.keepValues) {
      if (_.keepDirtyValues) {
        const O = /* @__PURE__ */ new Set([
          ...s.mount,
          ...Object.keys(rt(o, r))
        ]);
        for (const V of Array.from(O))
          S(n.dirtyFields, V) ? G($, V, S(r, V)) : W(V, S($, V));
      } else {
        if (In && ee(g))
          for (const O of s.mount) {
            const V = S(a, O);
            if (V && V._f) {
              const K = Array.isArray(V._f.refs) ? V._f.refs[0] : V._f.ref;
              if (Pt(K)) {
                const pe = K.closest("form");
                if (pe) {
                  pe.reset();
                  break;
                }
              }
            }
          }
        if (_.keepFieldsRef)
          for (const O of s.mount)
            W(O, S($, O));
        else
          a = {};
      }
      r = e.shouldUnregister ? _.keepDefaultValues ? ie(o) : {} : ie($), h.array.next({
        values: { ...$ }
      }), h.state.next({
        values: { ...$ }
      });
    }
    s = {
      mount: _.keepDirtyValues ? s.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, i.mount = !u.isValid || !!_.keepIsValid || !!_.keepDirtyValues, i.watch = !!e.shouldUnregister, h.state.next({
      submitCount: _.keepSubmitCount ? n.submitCount : 0,
      isDirty: C ? !1 : _.keepDirty ? n.isDirty : !!(_.keepDefaultValues && !De(g, o)),
      isSubmitted: _.keepIsSubmitted ? n.isSubmitted : !1,
      dirtyFields: C ? {} : _.keepDirtyValues ? _.keepDefaultValues && r ? rt(o, r) : n.dirtyFields : _.keepDefaultValues && g ? rt(o, g) : _.keepDirty ? n.dirtyFields : {},
      touchedFields: _.keepTouched ? n.touchedFields : {},
      errors: _.keepErrors ? n.errors : {},
      isSubmitSuccessful: _.keepIsSubmitSuccessful ? n.isSubmitSuccessful : !1,
      isSubmitting: !1,
      defaultValues: o
    });
  }, Qn = (g, _) => Yn($e(g) ? g(r) : g, _), Br = (g, _ = {}) => {
    const p = S(a, g), z = p && p._f;
    if (z) {
      const C = z.refs ? z.refs[0] : z.ref;
      C.focus && (C.focus(), _.shouldSelect && $e(C.select) && C.select());
    }
  }, Fr = (g) => {
    n = {
      ...n,
      ...g
    };
  }, Xn = {
    control: {
      register: sn,
      unregister: rn,
      getFieldState: ue,
      handleSubmit: Jn,
      setError: je,
      _subscribe: Wn,
      _runSchema: U,
      _focusError: ln,
      _getWatch: T,
      _getDirty: ce,
      _setValid: b,
      _setFieldArray: I,
      _setDisabledField: Hn,
      _setErrors: N,
      _getFieldArray: P,
      _reset: Yn,
      _resetDefaultValues: () => $e(e.defaultValues) && e.defaultValues().then((g) => {
        Qn(g, e.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: X,
      _disableForm: Tr,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return a;
      },
      get _formValues() {
        return r;
      },
      get _state() {
        return i;
      },
      set _state(g) {
        i = g;
      },
      get _defaultValues() {
        return o;
      },
      get _names() {
        return s;
      },
      set _names(g) {
        s = g;
      },
      get _formState() {
        return n;
      },
      get _options() {
        return e;
      },
      set _options(g) {
        e = {
          ...e,
          ...g
        };
      }
    },
    subscribe: Pr,
    trigger: ke,
    register: sn,
    handleSubmit: Jn,
    watch: Ct,
    setValue: W,
    getValues: Fe,
    reset: Qn,
    resetField: Rr,
    clearErrors: Ne,
    unregister: rn,
    setError: je,
    setFocus: Br,
    getFieldState: ue
  };
  return {
    ...Xn,
    formControl: Xn
  };
}
function _i(t = {}) {
  const e = j.useRef(void 0), n = j.useRef(void 0), [a, o] = j.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: $e(t.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: t.errors || {},
    disabled: t.disabled || !1,
    isReady: !1,
    defaultValues: $e(t.defaultValues) ? void 0 : t.defaultValues
  });
  if (!e.current)
    if (t.formControl)
      e.current = {
        ...t.formControl,
        formState: a
      }, t.defaultValues && !$e(t.defaultValues) && t.formControl.reset(t.defaultValues, t.resetOptions);
    else {
      const { formControl: i, ...s } = hi(t);
      e.current = {
        ...s,
        formState: a
      };
    }
  const r = e.current.control;
  return r._options = t, En(() => {
    const i = r._subscribe({
      formState: r._proxyFormState,
      callback: () => o({ ...r._formState }),
      reRenderRoot: !0
    });
    return o((s) => ({
      ...s,
      isReady: !0
    })), r._formState.isReady = !0, i;
  }, [r]), j.useEffect(() => r._disableForm(t.disabled), [r, t.disabled]), j.useEffect(() => {
    t.mode && (r._options.mode = t.mode), t.reValidateMode && (r._options.reValidateMode = t.reValidateMode);
  }, [r, t.mode, t.reValidateMode]), j.useEffect(() => {
    t.errors && (r._setErrors(t.errors), r._focusError());
  }, [r, t.errors]), j.useEffect(() => {
    t.shouldUnregister && r._subjects.state.next({
      values: r._getWatch()
    });
  }, [r, t.shouldUnregister]), j.useEffect(() => {
    if (r._proxyFormState.isDirty) {
      const i = r._getDirty();
      i !== a.isDirty && r._subjects.state.next({
        isDirty: i
      });
    }
  }, [r, a.isDirty]), j.useEffect(() => {
    t.values && !De(t.values, n.current) ? (r._reset(t.values, {
      keepFieldsRef: !0,
      ...r._options.resetOptions
    }), n.current = t.values, o((i) => ({ ...i }))) : r._resetDefaultValues();
  }, [r, t.values]), j.useEffect(() => {
    r._state.mount || (r._setValid(), r._state.mount = !0), r._state.watch && (r._state.watch = !1, r._subjects.state.next({ ...r._formState })), r._removeUnmounted();
  }), e.current.formState = ko(a, r), e.current;
}
const fi = (t, e, n, a) => {
  const o = [n, {
    code: e,
    ...a || {}
  }];
  if (t?.services?.logger?.forward)
    return t.services.logger.forward(o, "warn", "react-i18next::", !0);
  Ze(o[0]) && (o[0] = `react-i18next:: ${o[0]}`), t?.services?.logger?.warn ? t.services.logger.warn(...o) : console?.warn && console.warn(...o);
}, fa = {}, bn = (t, e, n, a) => {
  Ze(n) && fa[n] || (Ze(n) && (fa[n] = /* @__PURE__ */ new Date()), fi(t, e, n, a));
}, No = (t, e) => () => {
  if (t.isInitialized)
    e();
  else {
    const n = () => {
      setTimeout(() => {
        t.off("initialized", n);
      }, 0), e();
    };
    t.on("initialized", n);
  }
}, yn = (t, e, n) => {
  t.loadNamespaces(e, No(t, n));
}, ma = (t, e, n, a) => {
  if (Ze(n) && (n = [n]), t.options.preload && t.options.preload.indexOf(e) > -1) return yn(t, n, a);
  n.forEach((o) => {
    t.options.ns.indexOf(o) < 0 && t.options.ns.push(o);
  }), t.loadLanguages(e, No(t, a));
}, mi = (t, e, n = {}) => !e.languages || !e.languages.length ? (bn(e, "NO_LANGUAGES", "i18n.languages were undefined or empty", {
  languages: e.languages
}), !0) : e.hasLoadedNamespace(t, {
  lng: n.lng,
  precheck: (a, o) => {
    if (n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && a.services.backendConnector.backend && a.isLanguageChangingTo && !o(a.isLanguageChangingTo, t)) return !1;
  }
}), Ze = (t) => typeof t == "string", pi = (t) => typeof t == "object" && t !== null, bi = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, yi = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, vi = (t) => yi[t], ki = (t) => t.replace(bi, vi);
let wi = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: ki
};
const $i = () => wi;
let Ci;
const Si = () => Ci, Oo = go();
class xi {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(e) {
    e.forEach((n) => {
      this.usedNamespaces[n] || (this.usedNamespaces[n] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const zi = (t, e) => {
  const n = Et();
  return Me(() => {
    n.current = t;
  }, [t, e]), n.current;
}, Io = (t, e, n, a) => t.getFixedT(e, n, a), Ai = (t, e, n, a) => _o(Io(t, e, n, a), [t, e, n, a]), Rn = (t, e = {}) => {
  const {
    i18n: n
  } = e, {
    i18n: a,
    defaultNS: o
  } = ho(Oo) || {}, r = n || a || Si();
  if (r && !r.reportNamespaces && (r.reportNamespaces = new xi()), !r) {
    bn(r, "NO_I18NEXT_INSTANCE", "useTranslation: You will need to pass in an i18next instance by using initReactI18next");
    const A = (F, U) => Ze(U) ? U : pi(U) && Ze(U.defaultValue) ? U.defaultValue : Array.isArray(F) ? F[F.length - 1] : F, L = [A, {}, !1];
    return L.t = A, L.i18n = {}, L.ready = !1, L;
  }
  r.options.react?.wait && bn(r, "DEPRECATED_OPTION", "useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const i = {
    ...$i(),
    ...r.options.react,
    ...e
  }, {
    useSuspense: s,
    keyPrefix: l
  } = i;
  let c = t || o || r.options?.defaultNS;
  c = Ze(c) ? [c] : c || ["translation"], r.reportNamespaces.addUsedNamespaces?.(c);
  const u = (r.isInitialized || r.initializedStoreOnce) && c.every((A) => mi(A, r, i)), d = Ai(r, e.lng || null, i.nsMode === "fallback" ? c : c[0], l), h = () => d, f = () => Io(r, e.lng || null, i.nsMode === "fallback" ? c : c[0], l), [m, b] = Ce(h);
  let w = c.join();
  e.lng && (w = `${e.lng}${w}`);
  const I = zi(w), k = Et(!0);
  Me(() => {
    const {
      bindI18n: A,
      bindI18nStore: L
    } = i;
    k.current = !0, !u && !s && (e.lng ? ma(r, e.lng, c, () => {
      k.current && b(f);
    }) : yn(r, c, () => {
      k.current && b(f);
    })), u && I && I !== w && k.current && b(f);
    const F = () => {
      k.current && b(f);
    };
    return A && r?.on(A, F), L && r?.store.on(L, F), () => {
      k.current = !1, r && A && A?.split(" ").forEach((U) => r.off(U, F)), L && r && L.split(" ").forEach((U) => r.store.off(U, F));
    };
  }, [r, w]), Me(() => {
    k.current && u && b(h);
  }, [r, l, u]);
  const N = [m, r, u];
  if (N.t = m, N.i18n = r, N.ready = u, u || !u && !s) return N;
  throw new Promise((A) => {
    e.lng ? ma(r, e.lng, c, () => A()) : yn(r, c, () => A());
  });
};
function Ni({
  i18n: t,
  defaultNS: e,
  children: n
}) {
  const a = fo(() => ({
    i18n: t,
    defaultNS: e
  }), [t, e]);
  return Kr(Oo.Provider, {
    value: a
  }, n);
}
function Lo(t) {
  var e, n, a = "";
  if (typeof t == "string" || typeof t == "number") a += t;
  else if (typeof t == "object") if (Array.isArray(t)) {
    var o = t.length;
    for (e = 0; e < o; e++) t[e] && (n = Lo(t[e])) && (a && (a += " "), a += n);
  } else for (n in t) t[n] && (a && (a += " "), a += n);
  return a;
}
function H() {
  for (var t, e, n = 0, a = "", o = arguments.length; n < o; n++) (t = arguments[n]) && (e = Lo(t)) && (a && (a += " "), a += e);
  return a;
}
const Oi = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], Ii = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, Li = Oi.map((t) => ({
  name: t,
  class: `icon-${t}`,
  paths: Ii[t]
})), Di = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, Mi = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl",
  "8xl": "is-8xl",
  "9xl": "is-9xl",
  "10xl": "is-10xl"
};
function Ei(t = 0) {
  const e = [];
  for (let n = 0; n < t; n++)
    e[n] = `path${n + 1}`;
  return e.map((n) => /* @__PURE__ */ y("span", { className: n }, n));
}
const Ke = vt(
  ({ name: t, size: e = "medium", color: n = "base", className: a = "", ...o }, r) => {
    const i = Li.find((l) => l.name === t), s = H("icon", `ds-${i?.class}`, Mi[e], Di[n], a);
    return /* @__PURE__ */ y("i", { className: s, ...o, ref: r, children: Ei(i?.paths) });
  }
);
Ke.displayName = "Icon";
const ji = "_loader_1ksyv_29", Pi = "_circle_1ksyv_41", Ye = {
  loader: ji,
  "is-small": "_is-small_1ksyv_29",
  "is-medium": "_is-medium_1ksyv_33",
  "is-large": "_is-large_1ksyv_37",
  circle: Pi,
  "moving-element": "_moving-element_1ksyv_44",
  "on-dark": "_on-dark_1ksyv_47",
  "is-secondary": "_is-secondary_1ksyv_53",
  "dialog-overlay-show": "_dialog-overlay-show_1ksyv_1",
  "dialog-content-show": "_dialog-content-show_1ksyv_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ksyv_1"
}, Ti = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large"
}, Ri = {
  primary: "is-primary",
  secondary: "is-secondary"
};
function Bi({ onDark: t, size: e = "medium", color: n = "primary", className: a }) {
  return /* @__PURE__ */ B(
    "svg",
    {
      className: H(
        Ye.loader,
        Ye[Ti[e]],
        Ye[Ri[n]],
        t && Ye["on-dark"],
        a
      ),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      children: [
        /* @__PURE__ */ y("rect", { width: "100", height: "100", fill: "none", className: "bk" }),
        /* @__PURE__ */ y("circle", { className: Ye.circle, cx: "50", cy: "50", r: "40", fill: "none", strokeWidth: "10", strokeLinecap: "round" }),
        /* @__PURE__ */ B(
          "circle",
          {
            className: Ye["moving-element"],
            cx: "50",
            cy: "50",
            r: "40",
            fill: "none",
            strokeWidth: "6",
            strokeLinecap: "round",
            children: [
              /* @__PURE__ */ y("animate", { attributeName: "stroke-dashoffset", dur: "2s", repeatCount: "indefinite", from: "502", to: "0" }),
              /* @__PURE__ */ y(
                "animate",
                {
                  attributeName: "stroke-dasharray",
                  dur: "2s",
                  repeatCount: "indefinite",
                  values: "150.6 100.4;1 250;150.6 100.4"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
const Fi = "_button_z1os6_29", Vi = "_disabled_z1os6_43", Gi = "_loader_z1os6_263", Ie = {
  button: Fi,
  disabled: Vi,
  "is-primary": "_is-primary_z1os6_51",
  "is-contrasted": "_is-contrasted_z1os6_65",
  "is-secondary": "_is-secondary_z1os6_74",
  "is-tertiary": "_is-tertiary_z1os6_97",
  "is-eco-green": "_is-eco-green_z1os6_120",
  "is-ghost": "_is-ghost_z1os6_134",
  "is-destructive": "_is-destructive_z1os6_157",
  "is-hollow": "_is-hollow_z1os6_171",
  "is-destructive-ghost": "_is-destructive-ghost_z1os6_189",
  "is-facebook": "_is-facebook_z1os6_203",
  "is-apple": "_is-apple_z1os6_217",
  "is-google": "_is-google_z1os6_231",
  "is-regular": "_is-regular_z1os6_245",
  "is-medium": "_is-medium_z1os6_248",
  "is-small": "_is-small_z1os6_251",
  "is-full-width": "_is-full-width_z1os6_254",
  "is-loading": "_is-loading_z1os6_257",
  loader: Gi,
  "dialog-overlay-show": "_dialog-overlay-show_z1os6_1",
  "dialog-content-show": "_dialog-content-show_z1os6_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_z1os6_1"
}, nt = vt(
  ({
    text: t,
    color: e = "primary",
    size: n = "medium",
    isFullWidth: a = !1,
    icon: o,
    iconPosition: r = "left",
    isLoading: i = !1,
    iconSize: s = "medium",
    isContrasted: l = !1,
    disabled: c = !1,
    className: u,
    children: d,
    ...h
  }, f) => {
    const m = H(
      Ie.button,
      Ie[Ui[e]],
      Ie[Zi[n]],
      a && Ie["is-full-width"],
      c && Ie.disabled,
      r === "right" && Ie["has-icon-right"],
      l && Ie["is-contrasted"],
      i && Ie["is-loading"],
      u
    ), b = /* @__PURE__ */ B(Zr, { children: [
      i && /* @__PURE__ */ y(Bi, { className: Ie.loader, onDark: !0, size: "small" }),
      o && r === "left" && /* @__PURE__ */ y(Ke, { color: "inherit", size: s, name: o }),
      d ?? t,
      o && r === "right" && /* @__PURE__ */ y(Ke, { color: "inherit", size: s, name: o })
    ] });
    if (Ki(h))
      return /* @__PURE__ */ y(
        "a",
        {
          ...h,
          href: c ? void 0 : h.href,
          className: m,
          target: h.target,
          ref: f,
          children: b
        }
      );
    if (qi(h))
      return /* @__PURE__ */ y(
        "button",
        {
          disabled: i || c,
          ...h,
          className: m,
          ref: f,
          children: b
        }
      );
  }
);
nt.displayName = "Button";
const Ui = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  "eco-green": "is-eco-green",
  ghost: "is-ghost",
  "destructive-ghost": "is-destructive-ghost",
  destructive: "is-destructive",
  hollow: "is-hollow",
  facebook: "is-facebook",
  apple: "is-apple",
  google: "is-google"
}, Zi = {
  small: "is-small",
  medium: "is-medium",
  regular: "is-regular"
};
function Ki(t) {
  return "href" in t && typeof t.href == "string";
}
function qi(t) {
  return !("href" in t);
}
const Wi = "_buttons_1obz3_29", pa = {
  buttons: Wi,
  "flex-grow-buttons": "_flex-grow-buttons_1obz3_44"
}, Do = ({ children: t, flexGrowButtons: e }) => /* @__PURE__ */ y("div", { className: H(pa.buttons, e && pa["flex-grow-buttons"]), children: t }), ba = {
  MOBILE: 640,
  TABLET: 768
}, Hi = "_text_1g0xp_29", Ve = {
  text: Hi,
  "is-small": "_is-small_1g0xp_34",
  "is-ellipsis": "_is-ellipsis_1g0xp_38",
  "is-center": "_is-center_1g0xp_44",
  "color-primary": "_color-primary_1g0xp_47",
  "color-secondary": "_color-secondary_1g0xp_50",
  "color-tertiary": "_color-tertiary_1g0xp_53",
  "color-eco-green": "_color-eco-green_1g0xp_56",
  "color-success": "_color-success_1g0xp_59",
  "color-error": "_color-error_1g0xp_62",
  "color-inverted": "_color-inverted_1g0xp_65",
  "color-warning": "_color-warning_1g0xp_68",
  "color-highlight": "_color-highlight_1g0xp_71",
  "color-inherit": "_color-inherit_1g0xp_74",
  "is-bold": "_is-bold_1g0xp_77",
  "size-xs": "_size-xs_1g0xp_80",
  "size-sm": "_size-sm_1g0xp_83",
  "size-base": "_size-base_1g0xp_86",
  "size-lg": "_size-lg_1g0xp_89",
  "size-xl": "_size-xl_1g0xp_92",
  "dialog-overlay-show": "_dialog-overlay-show_1g0xp_1",
  "dialog-content-show": "_dialog-content-show_1g0xp_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1g0xp_1"
};
function _t({
  children: t,
  dangerouslySetInnerHTML: e,
  isSmall: n,
  ellipsis: a,
  isSpan: o,
  className: r = "",
  color: i = "primary",
  isBold: s,
  size: l,
  title: c,
  center: u,
  ...d
}) {
  const h = H(
    Ve.text,
    n && Ve["is-small"],
    a && Ve["is-ellipsis"],
    i && Ve[`color-${i}`],
    s && Ve["is-bold"],
    l && Ve[`size-${l}`],
    u && Ve["is-center"],
    r
  ), f = o ? "span" : "div";
  return e ? /* @__PURE__ */ y(f, { className: h, dangerouslySetInnerHTML: e, ...d, title: c }) : /* @__PURE__ */ y(f, { className: h, ...d, children: t });
}
const Ji = "_title_1s6y9_29", Yi = "_subtitle_1s6y9_106", Ge = {
  "title-container": "_title-container_1s6y9_29",
  "color-inverted": "_color-inverted_1s6y9_32",
  "is-primary": "_is-primary_1s6y9_35",
  "is-secondary": "_is-secondary_1s6y9_38",
  "is-tertiary": "_is-tertiary_1s6y9_41",
  "is-success": "_is-success_1s6y9_44",
  "is-error": "_is-error_1s6y9_47",
  "is-eco-green": "_is-eco-green_1s6y9_50",
  title: Ji,
  "is-1": "_is-1_1s6y9_61",
  "is-impact": "_is-impact_1s6y9_70",
  "is-2": "_is-2_1s6y9_74",
  "is-3": "_is-3_1s6y9_84",
  "text-align-left": "_text-align-left_1s6y9_94",
  "text-align-right": "_text-align-right_1s6y9_97",
  "text-align-center": "_text-align-center_1s6y9_100",
  "text-align-justify": "_text-align-justify_1s6y9_103",
  subtitle: Yi,
  "dialog-overlay-show": "_dialog-overlay-show_1s6y9_1",
  "dialog-content-show": "_dialog-content-show_1s6y9_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1s6y9_1"
}, Qi = {
  default: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "color-inverted"
};
function Mo({
  color: t = "default",
  children: e,
  level: n = 3,
  hasHeaderTag: a = !1,
  isImpact: o,
  subtitle: r,
  className: i = "",
  title: s,
  textAlign: l,
  ...c
}) {
  const u = `h${n}`, d = `${a ? u : "p"}`, h = H(
    Ge.title,
    Ge[`is-${n}`],
    o && Ge["is-impact"],
    l && Ge[`text-align-${l}`],
    i
  );
  return /* @__PURE__ */ B("div", { className: H(Ge["title-container"], Ge[Qi[t]]), children: [
    /* @__PURE__ */ y(d, { className: h, ...c, title: s, children: e }),
    r && /* @__PURE__ */ y("p", { className: H(Ge.subtitle), children: r })
  ] });
}
const gn = {
  "flex-children": "_flex-children_1c6gy_29",
  "justify-self-start": "_justify-self-start_1c6gy_29",
  "justify-self-end": "_justify-self-end_1c6gy_32",
  "justify-self-center": "_justify-self-center_1c6gy_35",
  "align-self-start": "_align-self-start_1c6gy_38",
  "align-self-end": "_align-self-end_1c6gy_41",
  "align-self-center": "_align-self-center_1c6gy_44",
  "dialog-overlay-show": "_dialog-overlay-show_1c6gy_1",
  "dialog-content-show": "_dialog-content-show_1c6gy_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1c6gy_1"
}, Xi = ({ alignSelf: t, justifySelf: e, children: n }) => {
  const a = H(
    gn["flex-children"],
    t && gn[`align-self-${t}`],
    e && gn[`justify-self-${e}`]
  );
  return /* @__PURE__ */ y("div", { className: a, children: n });
}, es = "_flex_1taae_29", ts = "_wrap_1taae_67", ns = "_nowrap_1taae_70", as = "_shrink_1taae_88", be = {
  flex: es,
  "flex-row": "_flex-row_1taae_34",
  "flex-column": "_flex-column_1taae_37",
  "justify-start": "_justify-start_1taae_40",
  "justify-end": "_justify-end_1taae_43",
  "justify-center": "_justify-center_1taae_46",
  "justify-space-between": "_justify-space-between_1taae_49",
  "justify-space-around": "_justify-space-around_1taae_52",
  "align-start": "_align-start_1taae_55",
  "align-end": "_align-end_1taae_58",
  "align-center": "_align-center_1taae_61",
  "align-stretch": "_align-stretch_1taae_64",
  wrap: ts,
  nowrap: ns,
  "wrap-reverse": "_wrap-reverse_1taae_73",
  "is-full-width": "_is-full-width_1taae_79",
  "is-full-height": "_is-full-height_1taae_82",
  "flex-grow": "_flex-grow_1taae_85",
  shrink: as,
  "hide-on-mobile": "_hide-on-mobile_1taae_91",
  "gap-0": "_gap-0_1taae_99",
  "gap-1": "_gap-1_1taae_102",
  "gap-2": "_gap-2_1taae_105",
  "gap-3": "_gap-3_1taae_108",
  "gap-4": "_gap-4_1taae_111",
  "gap-5": "_gap-5_1taae_114",
  "gap-6": "_gap-6_1taae_117",
  "gap-7": "_gap-7_1taae_120",
  "gap-8": "_gap-8_1taae_123",
  "gap-9": "_gap-9_1taae_126",
  "gap-10": "_gap-10_1taae_129",
  "gap-11": "_gap-11_1taae_132",
  "gap-12": "_gap-12_1taae_135",
  "gap-14": "_gap-14_1taae_138",
  "gap-16": "_gap-16_1taae_141",
  "gap-18": "_gap-18_1taae_144",
  "gap-20": "_gap-20_1taae_147",
  "gap-24": "_gap-24_1taae_150",
  "gap-28": "_gap-28_1taae_153",
  "gap-32": "_gap-32_1taae_156",
  "gap-36": "_gap-36_1taae_159",
  "gap-40": "_gap-40_1taae_162",
  "gap-44": "_gap-44_1taae_165",
  "gap-48": "_gap-48_1taae_168",
  "gap-52": "_gap-52_1taae_171",
  "gap-56": "_gap-56_1taae_174",
  "gap-60": "_gap-60_1taae_177",
  "gap-64": "_gap-64_1taae_180",
  "gap-72": "_gap-72_1taae_183",
  "gap-80": "_gap-80_1taae_186",
  "gap-96": "_gap-96_1taae_189",
  "no-margin": "_no-margin_1taae_192",
  "dialog-overlay-show": "_dialog-overlay-show_1taae_1",
  "dialog-content-show": "_dialog-content-show_1taae_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1taae_1"
};
function Eo({
  children: t,
  direction: e = "row",
  justifyContent: n = "start",
  alignItems: a = "start",
  flexWrap: o = "wrap",
  className: r = "",
  isFullWidth: i = !1,
  isFullHeight: s = !1,
  gap: l,
  style: c,
  noMargin: u = !1,
  flexGrow: d = !1,
  hideOnMobile: h = !1,
  shrink: f = !1,
  ...m
}) {
  const b = H(
    be.flex,
    be[`flex-${e}`],
    be[`justify-${n}`],
    be[`align-${a}`],
    be[o],
    i && be["is-full-width"],
    s && be["is-full-height"],
    l && be[`gap-${l}`],
    u && be["no-margin"],
    d && be["flex-grow"],
    h && be["hide-on-mobile"],
    f && be.shrink,
    r
  );
  return /* @__PURE__ */ y("div", { className: b, ...m, style: c, children: t });
}
Eo.FlexChildren = Xi;
function Ee(t, e, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(a) {
    if (t?.(a), n === !1 || !a.defaultPrevented)
      return e?.(a);
  };
}
var ft = globalThis?.document ? x.useLayoutEffect : () => {
}, os = x[" useInsertionEffect ".trim().toString()] || ft;
function jo({
  prop: t,
  defaultProp: e,
  onChange: n = () => {
  },
  caller: a
}) {
  const [o, r, i] = rs({
    defaultProp: e,
    onChange: n
  }), s = t !== void 0, l = s ? t : o;
  {
    const u = x.useRef(t !== void 0);
    x.useEffect(() => {
      const d = u.current;
      d !== s && console.warn(
        `${a} is changing from ${d ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = s;
    }, [s, a]);
  }
  const c = x.useCallback(
    (u) => {
      if (s) {
        const d = is(u) ? u(t) : u;
        d !== t && i.current?.(d);
      } else
        r(u);
    },
    [s, t, r, i]
  );
  return [l, c];
}
function rs({
  defaultProp: t,
  onChange: e
}) {
  const [n, a] = x.useState(t), o = x.useRef(n), r = x.useRef(e);
  return os(() => {
    r.current = e;
  }, [e]), x.useEffect(() => {
    o.current !== n && (r.current?.(n), o.current = n);
  }, [n, o]), [n, a, r];
}
function is(t) {
  return typeof t == "function";
}
function ya(t, e) {
  if (typeof t == "function")
    return t(e);
  t != null && (t.current = e);
}
function Po(...t) {
  return (e) => {
    let n = !1;
    const a = t.map((o) => {
      const r = ya(o, e);
      return !n && typeof r == "function" && (n = !0), r;
    });
    if (n)
      return () => {
        for (let o = 0; o < a.length; o++) {
          const r = a[o];
          typeof r == "function" ? r() : ya(t[o], null);
        }
      };
  };
}
function qe(...t) {
  return x.useCallback(Po(...t), t);
}
function Ht(t, e = []) {
  let n = [];
  function a(r, i) {
    const s = x.createContext(i), l = n.length;
    n = [...n, i];
    const c = (d) => {
      const { scope: h, children: f, ...m } = d, b = h?.[t]?.[l] || s, w = x.useMemo(() => m, Object.values(m));
      return /* @__PURE__ */ y(b.Provider, { value: w, children: f });
    };
    c.displayName = r + "Provider";
    function u(d, h) {
      const f = h?.[t]?.[l] || s, m = x.useContext(f);
      if (m) return m;
      if (i !== void 0) return i;
      throw new Error(`\`${d}\` must be used within \`${r}\``);
    }
    return [c, u];
  }
  const o = () => {
    const r = n.map((i) => x.createContext(i));
    return function(i) {
      const s = i?.[t] || r;
      return x.useMemo(
        () => ({ [`__scope${t}`]: { ...i, [t]: s } }),
        [i, s]
      );
    };
  };
  return o.scopeName = t, [a, ss(o, ...e)];
}
function ss(...t) {
  const e = t[0];
  if (t.length === 1) return e;
  const n = () => {
    const a = t.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(o) {
      const r = a.reduce((i, { useScope: s, scopeName: l }) => {
        const c = s(o)[`__scope${l}`];
        return { ...i, ...c };
      }, {});
      return x.useMemo(() => ({ [`__scope${e.scopeName}`]: r }), [r]);
    };
  };
  return n.scopeName = e.scopeName, n;
}
// @__NO_SIDE_EFFECTS__
function vn(t) {
  const e = /* @__PURE__ */ ls(t), n = x.forwardRef((a, o) => {
    const { children: r, ...i } = a, s = x.Children.toArray(r), l = s.find(us);
    if (l) {
      const c = l.props.children, u = s.map((d) => d === l ? x.Children.count(c) > 1 ? x.Children.only(null) : x.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ y(e, { ...i, ref: o, children: x.isValidElement(c) ? x.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ y(e, { ...i, ref: o, children: r });
  });
  return n.displayName = `${t}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function ls(t) {
  const e = x.forwardRef((n, a) => {
    const { children: o, ...r } = n;
    if (x.isValidElement(o)) {
      const i = gs(o), s = ds(r, o.props);
      return o.type !== x.Fragment && (s.ref = a ? Po(a, i) : i), x.cloneElement(o, s);
    }
    return x.Children.count(o) > 1 ? x.Children.only(null) : null;
  });
  return e.displayName = `${t}.SlotClone`, e;
}
var cs = Symbol("radix.slottable");
function us(t) {
  return x.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === cs;
}
function ds(t, e) {
  const n = { ...e };
  for (const a in e) {
    const o = t[a], r = e[a];
    /^on[A-Z]/.test(a) ? o && r ? n[a] = (...i) => {
      const s = r(...i);
      return o(...i), s;
    } : o && (n[a] = o) : a === "style" ? n[a] = { ...o, ...r } : a === "className" && (n[a] = [o, r].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function gs(t) {
  let e = Object.getOwnPropertyDescriptor(t.props, "ref")?.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = Object.getOwnPropertyDescriptor(t, "ref")?.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var hs = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], at = hs.reduce((t, e) => {
  const n = /* @__PURE__ */ vn(`Primitive.${e}`), a = x.forwardRef((o, r) => {
    const { asChild: i, ...s } = o, l = i ? n : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ y(l, { ...s, ref: r });
  });
  return a.displayName = `Primitive.${e}`, { ...t, [e]: a };
}, {}), _s = x.createContext(void 0);
function To(t) {
  const e = x.useContext(_s);
  return t || e || "ltr";
}
function fs(t) {
  const e = t + "CollectionProvider", [n, a] = Ht(e), [o, r] = n(
    e,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (b) => {
    const { scope: w, children: I } = b, k = j.useRef(null), N = j.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ y(o, { scope: w, itemMap: N, collectionRef: k, children: I });
  };
  i.displayName = e;
  const s = t + "CollectionSlot", l = /* @__PURE__ */ vn(s), c = j.forwardRef(
    (b, w) => {
      const { scope: I, children: k } = b, N = r(s, I), A = qe(w, N.collectionRef);
      return /* @__PURE__ */ y(l, { ref: A, children: k });
    }
  );
  c.displayName = s;
  const u = t + "CollectionItemSlot", d = "data-radix-collection-item", h = /* @__PURE__ */ vn(u), f = j.forwardRef(
    (b, w) => {
      const { scope: I, children: k, ...N } = b, A = j.useRef(null), L = qe(w, A), F = r(u, I);
      return j.useEffect(() => (F.itemMap.set(A, { ref: A, ...N }), () => void F.itemMap.delete(A))), /* @__PURE__ */ y(h, { [d]: "", ref: L, children: k });
    }
  );
  f.displayName = u;
  function m(b) {
    const w = r(t + "CollectionConsumer", b);
    return j.useCallback(() => {
      const I = w.collectionRef.current;
      if (!I) return [];
      const k = Array.from(I.querySelectorAll(`[${d}]`));
      return Array.from(w.itemMap.values()).sort(
        (N, A) => k.indexOf(N.ref.current) - k.indexOf(A.ref.current)
      );
    }, [w.collectionRef, w.itemMap]);
  }
  return [
    { Provider: i, Slot: c, ItemSlot: f },
    m,
    a
  ];
}
var ms = x[" useId ".trim().toString()] || (() => {
}), ps = 0;
function bs(t) {
  const [e, n] = x.useState(ms());
  return ft(() => {
    n((a) => a ?? String(ps++));
  }, [t]), e ? `radix-${e}` : "";
}
function ys(t, e) {
  return x.useReducer((n, a) => e[n][a] ?? n, t);
}
var Ro = (t) => {
  const { present: e, children: n } = t, a = vs(e), o = typeof n == "function" ? n({ present: a.isPresent }) : x.Children.only(n), r = qe(a.ref, ks(o));
  return typeof n == "function" || a.isPresent ? x.cloneElement(o, { ref: r }) : null;
};
Ro.displayName = "Presence";
function vs(t) {
  const [e, n] = x.useState(), a = x.useRef(null), o = x.useRef(t), r = x.useRef("none"), i = t ? "mounted" : "unmounted", [s, l] = ys(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return x.useEffect(() => {
    const c = xt(a.current);
    r.current = s === "mounted" ? c : "none";
  }, [s]), ft(() => {
    const c = a.current, u = o.current;
    if (u !== t) {
      const d = r.current, h = xt(c);
      t ? l("MOUNT") : h === "none" || c?.display === "none" ? l("UNMOUNT") : l(u && d !== h ? "ANIMATION_OUT" : "UNMOUNT"), o.current = t;
    }
  }, [t, l]), ft(() => {
    if (e) {
      let c;
      const u = e.ownerDocument.defaultView ?? window, d = (f) => {
        const m = xt(a.current).includes(CSS.escape(f.animationName));
        if (f.target === e && m && (l("ANIMATION_END"), !o.current)) {
          const b = e.style.animationFillMode;
          e.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            e.style.animationFillMode === "forwards" && (e.style.animationFillMode = b);
          });
        }
      }, h = (f) => {
        f.target === e && (r.current = xt(a.current));
      };
      return e.addEventListener("animationstart", h), e.addEventListener("animationcancel", d), e.addEventListener("animationend", d), () => {
        u.clearTimeout(c), e.removeEventListener("animationstart", h), e.removeEventListener("animationcancel", d), e.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [e, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: x.useCallback((c) => {
      a.current = c ? getComputedStyle(c) : null, n(c);
    }, [])
  };
}
function xt(t) {
  return t?.animationName || "none";
}
function ks(t) {
  let e = Object.getOwnPropertyDescriptor(t.props, "ref")?.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = Object.getOwnPropertyDescriptor(t, "ref")?.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
function ws(t) {
  const e = x.useRef(t);
  return x.useEffect(() => {
    e.current = t;
  }), x.useMemo(() => (...n) => e.current?.(...n), []);
}
var hn = "rovingFocusGroup.onEntryFocus", $s = { bubbles: !1, cancelable: !0 }, wt = "RovingFocusGroup", [kn, Bo, Cs] = fs(wt), [Ss, Fo] = Ht(
  wt,
  [Cs]
), [xs, zs] = Ss(wt), Vo = x.forwardRef(
  (t, e) => /* @__PURE__ */ y(kn.Provider, { scope: t.__scopeRovingFocusGroup, children: /* @__PURE__ */ y(kn.Slot, { scope: t.__scopeRovingFocusGroup, children: /* @__PURE__ */ y(As, { ...t, ref: e }) }) })
);
Vo.displayName = wt;
var As = x.forwardRef((t, e) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: a,
    loop: o = !1,
    dir: r,
    currentTabStopId: i,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: u = !1,
    ...d
  } = t, h = x.useRef(null), f = qe(e, h), m = To(r), [b, w] = jo({
    prop: i,
    defaultProp: s ?? null,
    onChange: l,
    caller: wt
  }), [I, k] = x.useState(!1), N = ws(c), A = Bo(n), L = x.useRef(!1), [F, U] = x.useState(0);
  return x.useEffect(() => {
    const ne = h.current;
    if (ne)
      return ne.addEventListener(hn, N), () => ne.removeEventListener(hn, N);
  }, [N]), /* @__PURE__ */ y(
    xs,
    {
      scope: n,
      orientation: a,
      dir: m,
      loop: o,
      currentTabStopId: b,
      onItemFocus: x.useCallback(
        (ne) => w(ne),
        [w]
      ),
      onItemShiftTab: x.useCallback(() => k(!0), []),
      onFocusableItemAdd: x.useCallback(
        () => U((ne) => ne + 1),
        []
      ),
      onFocusableItemRemove: x.useCallback(
        () => U((ne) => ne - 1),
        []
      ),
      children: /* @__PURE__ */ y(
        at.div,
        {
          tabIndex: I || F === 0 ? -1 : 0,
          "data-orientation": a,
          ...d,
          ref: f,
          style: { outline: "none", ...t.style },
          onMouseDown: Ee(t.onMouseDown, () => {
            L.current = !0;
          }),
          onFocus: Ee(t.onFocus, (ne) => {
            const Q = !L.current;
            if (ne.target === ne.currentTarget && Q && !I) {
              const X = new CustomEvent(hn, $s);
              if (ne.currentTarget.dispatchEvent(X), !X.defaultPrevented) {
                const ce = A().filter((Z) => Z.focusable), T = ce.find((Z) => Z.active), P = ce.find((Z) => Z.id === b), R = [T, P, ...ce].filter(
                  Boolean
                ).map((Z) => Z.ref.current);
                Zo(R, u);
              }
            }
            L.current = !1;
          }),
          onBlur: Ee(t.onBlur, () => k(!1))
        }
      )
    }
  );
}), Go = "RovingFocusGroupItem", Uo = x.forwardRef(
  (t, e) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: a = !0,
      active: o = !1,
      tabStopId: r,
      children: i,
      ...s
    } = t, l = bs(), c = r || l, u = zs(Go, n), d = u.currentTabStopId === c, h = Bo(n), { onFocusableItemAdd: f, onFocusableItemRemove: m, currentTabStopId: b } = u;
    return x.useEffect(() => {
      if (a)
        return f(), () => m();
    }, [a, f, m]), /* @__PURE__ */ y(
      kn.ItemSlot,
      {
        scope: n,
        id: c,
        focusable: a,
        active: o,
        children: /* @__PURE__ */ y(
          at.span,
          {
            tabIndex: d ? 0 : -1,
            "data-orientation": u.orientation,
            ...s,
            ref: e,
            onMouseDown: Ee(t.onMouseDown, (w) => {
              a ? u.onItemFocus(c) : w.preventDefault();
            }),
            onFocus: Ee(t.onFocus, () => u.onItemFocus(c)),
            onKeyDown: Ee(t.onKeyDown, (w) => {
              if (w.key === "Tab" && w.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (w.target !== w.currentTarget) return;
              const I = Is(w, u.orientation, u.dir);
              if (I !== void 0) {
                if (w.metaKey || w.ctrlKey || w.altKey || w.shiftKey) return;
                w.preventDefault();
                let k = h().filter((N) => N.focusable).map((N) => N.ref.current);
                if (I === "last") k.reverse();
                else if (I === "prev" || I === "next") {
                  I === "prev" && k.reverse();
                  const N = k.indexOf(w.currentTarget);
                  k = u.loop ? Ls(k, N + 1) : k.slice(N + 1);
                }
                setTimeout(() => Zo(k));
              }
            }),
            children: typeof i == "function" ? i({ isCurrentTabStop: d, hasTabStop: b != null }) : i
          }
        )
      }
    );
  }
);
Uo.displayName = Go;
var Ns = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Os(t, e) {
  return e !== "rtl" ? t : t === "ArrowLeft" ? "ArrowRight" : t === "ArrowRight" ? "ArrowLeft" : t;
}
function Is(t, e, n) {
  const a = Os(t.key, n);
  if (!(e === "vertical" && ["ArrowLeft", "ArrowRight"].includes(a)) && !(e === "horizontal" && ["ArrowUp", "ArrowDown"].includes(a)))
    return Ns[a];
}
function Zo(t, e = !1) {
  const n = document.activeElement;
  for (const a of t)
    if (a === n || (a.focus({ preventScroll: e }), document.activeElement !== n)) return;
}
function Ls(t, e) {
  return t.map((n, a) => t[(e + a) % t.length]);
}
var Ds = Vo, Ms = Uo;
function Es(t) {
  const [e, n] = x.useState(void 0);
  return ft(() => {
    if (t) {
      n({ width: t.offsetWidth, height: t.offsetHeight });
      const a = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const r = o[0];
        let i, s;
        if ("borderBoxSize" in r) {
          const l = r.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          i = c.inlineSize, s = c.blockSize;
        } else
          i = t.offsetWidth, s = t.offsetHeight;
        n({ width: i, height: s });
      });
      return a.observe(t, { box: "border-box" }), () => a.unobserve(t);
    } else
      n(void 0);
  }, [t]), e;
}
function js(t) {
  const e = x.useRef({ value: t, previous: t });
  return x.useMemo(() => (e.current.value !== t && (e.current.previous = e.current.value, e.current.value = t), e.current.previous), [t]);
}
var Bn = "Radio", [Ps, Ko] = Ht(Bn), [Ts, Rs] = Ps(Bn), qo = x.forwardRef(
  (t, e) => {
    const {
      __scopeRadio: n,
      name: a,
      checked: o = !1,
      required: r,
      disabled: i,
      value: s = "on",
      onCheck: l,
      form: c,
      ...u
    } = t, [d, h] = x.useState(null), f = qe(e, (w) => h(w)), m = x.useRef(!1), b = d ? c || !!d.closest("form") : !0;
    return /* @__PURE__ */ B(Ts, { scope: n, checked: o, disabled: i, children: [
      /* @__PURE__ */ y(
        at.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": o,
          "data-state": Yo(o),
          "data-disabled": i ? "" : void 0,
          disabled: i,
          value: s,
          ...u,
          ref: f,
          onClick: Ee(t.onClick, (w) => {
            o || l?.(), b && (m.current = w.isPropagationStopped(), m.current || w.stopPropagation());
          })
        }
      ),
      b && /* @__PURE__ */ y(
        Jo,
        {
          control: d,
          bubbles: !m.current,
          name: a,
          value: s,
          checked: o,
          required: r,
          disabled: i,
          form: c,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
qo.displayName = Bn;
var Wo = "RadioIndicator", Ho = x.forwardRef(
  (t, e) => {
    const { __scopeRadio: n, forceMount: a, ...o } = t, r = Rs(Wo, n);
    return /* @__PURE__ */ y(Ro, { present: a || r.checked, children: /* @__PURE__ */ y(
      at.span,
      {
        "data-state": Yo(r.checked),
        "data-disabled": r.disabled ? "" : void 0,
        ...o,
        ref: e
      }
    ) });
  }
);
Ho.displayName = Wo;
var Bs = "RadioBubbleInput", Jo = x.forwardRef(
  ({
    __scopeRadio: t,
    control: e,
    checked: n,
    bubbles: a = !0,
    ...o
  }, r) => {
    const i = x.useRef(null), s = qe(i, r), l = js(n), c = Es(e);
    return x.useEffect(() => {
      const u = i.current;
      if (!u) return;
      const d = window.HTMLInputElement.prototype, h = Object.getOwnPropertyDescriptor(
        d,
        "checked"
      ).set;
      if (l !== n && h) {
        const f = new Event("click", { bubbles: a });
        h.call(u, n), u.dispatchEvent(f);
      }
    }, [l, n, a]), /* @__PURE__ */ y(
      at.input,
      {
        type: "radio",
        "aria-hidden": !0,
        defaultChecked: n,
        ...o,
        tabIndex: -1,
        ref: s,
        style: {
          ...o.style,
          ...c,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
Jo.displayName = Bs;
function Yo(t) {
  return t ? "checked" : "unchecked";
}
var Fs = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], Jt = "RadioGroup", [Vs, qx] = Ht(Jt, [
  Fo,
  Ko
]), Qo = Fo(), Xo = Ko(), [Gs, Us] = Vs(Jt), er = x.forwardRef(
  (t, e) => {
    const {
      __scopeRadioGroup: n,
      name: a,
      defaultValue: o,
      value: r,
      required: i = !1,
      disabled: s = !1,
      orientation: l,
      dir: c,
      loop: u = !0,
      onValueChange: d,
      ...h
    } = t, f = Qo(n), m = To(c), [b, w] = jo({
      prop: r,
      defaultProp: o ?? null,
      onChange: d,
      caller: Jt
    });
    return /* @__PURE__ */ y(
      Gs,
      {
        scope: n,
        name: a,
        required: i,
        disabled: s,
        value: b,
        onValueChange: w,
        children: /* @__PURE__ */ y(
          Ds,
          {
            asChild: !0,
            ...f,
            orientation: l,
            dir: m,
            loop: u,
            children: /* @__PURE__ */ y(
              at.div,
              {
                role: "radiogroup",
                "aria-required": i,
                "aria-orientation": l,
                "data-disabled": s ? "" : void 0,
                dir: m,
                ...h,
                ref: e
              }
            )
          }
        )
      }
    );
  }
);
er.displayName = Jt;
var tr = "RadioGroupItem", nr = x.forwardRef(
  (t, e) => {
    const { __scopeRadioGroup: n, disabled: a, ...o } = t, r = Us(tr, n), i = r.disabled || a, s = Qo(n), l = Xo(n), c = x.useRef(null), u = qe(e, c), d = r.value === o.value, h = x.useRef(!1);
    return x.useEffect(() => {
      const f = (b) => {
        Fs.includes(b.key) && (h.current = !0);
      }, m = () => h.current = !1;
      return document.addEventListener("keydown", f), document.addEventListener("keyup", m), () => {
        document.removeEventListener("keydown", f), document.removeEventListener("keyup", m);
      };
    }, []), /* @__PURE__ */ y(
      Ms,
      {
        asChild: !0,
        ...s,
        focusable: !i,
        active: d,
        children: /* @__PURE__ */ y(
          qo,
          {
            disabled: i,
            required: r.required,
            checked: d,
            ...l,
            ...o,
            name: r.name,
            ref: u,
            onCheck: () => r.onValueChange(o.value),
            onKeyDown: Ee((f) => {
              f.key === "Enter" && f.preventDefault();
            }),
            onFocus: Ee(o.onFocus, () => {
              h.current && c.current?.click();
            })
          }
        )
      }
    );
  }
);
nr.displayName = tr;
var Zs = "RadioGroupIndicator", ar = x.forwardRef(
  (t, e) => {
    const { __scopeRadioGroup: n, ...a } = t, o = Xo(n);
    return /* @__PURE__ */ y(Ho, { ...o, ...a, ref: e });
  }
);
ar.displayName = Zs;
var Ks = er, qs = nr, Ws = ar;
const Hs = "_indicator_o29me_51", Js = "_label_o29me_66", zt = {
  "radio-item": "_radio-item_o29me_29",
  "radio-button": "_radio-button_o29me_33",
  indicator: Hs,
  label: Js
};
function Ys({ value: t, id: e, label: n, description: a }) {
  return /* @__PURE__ */ B("div", { className: zt["radio-item"], children: [
    /* @__PURE__ */ y(qs, { value: t, id: e, className: zt["radio-button"], "aria-label": n, children: /* @__PURE__ */ y(Ws, { className: zt.indicator }) }),
    /* @__PURE__ */ B("label", { htmlFor: e, className: zt.label, children: [
      n,
      a && /* @__PURE__ */ y("p", { children: a })
    ] })
  ] });
}
function Qs() {
  const [t, e] = Ce({
    width: typeof window > "u" ? void 0 : window.innerWidth,
    height: typeof window > "u" ? void 0 : window.innerHeight
  });
  return Me(() => {
    function n() {
      e({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", n), n(), () => window.removeEventListener("resize", n);
  }, []), t;
}
function or() {
  const { width: t } = Qs();
  let e = "desktop";
  return t && t <= ba.MOBILE ? e = "mobile" : t && t <= ba.TABLET && (e = "tablet"), {
    currentWidth: t,
    currentDevice: e,
    isMobile: e === "mobile",
    isTablet: e === "tablet",
    isDesktop: e === "desktop",
    isReady: typeof window < "u"
  };
}
const Xs = ({
  initialPhoneNumber: t = "",
  initialCountry: e = "",
  onChangePhoneNumber: n,
  onChangeCountry: a
}) => {
  const [o, r] = Ce(t), [i, s] = Ce(e);
  return {
    phoneNumber: o,
    country: i,
    handlePhoneNumberChange: (l) => {
      r(l), n?.(l);
    },
    handleCountryChange: (l) => {
      s(l), a?.(l);
    }
  };
}, el = {
  ad: "Andorra",
  ae: "De Forenede Arabiske Emirater",
  af: "Afghanistan",
  ag: "Antigua og Barbuda",
  ai: "Anguilla",
  al: "Albanien",
  am: "Armenien",
  ao: "Angola",
  ar: "Argentina",
  as: "Amerikansk Samoa",
  at: "Østrig",
  au: "Australien",
  aw: "Aruba",
  ax: "Åland",
  az: "Aserbajdsjan",
  ba: "Bosnien-Hercegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgien",
  bf: "Burkina Faso",
  bg: "Bulgarien",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "De tidligere Nederlandske Antiller",
  br: "Brasilien",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Hviderusland",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocosøerne",
  cd: "Congo-Kinshasa",
  cf: "Den Centralafrikanske Republik",
  cg: "Congo-Brazzaville",
  ch: "Schweiz",
  ci: "Elfenbenskysten",
  ck: "Cookøerne",
  cl: "Chile",
  cm: "Cameroun",
  cn: "Kina",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Kap Verde",
  cw: "Curaçao",
  cx: "Juleøen",
  cy: "Cypern",
  cz: "Tjekkiet",
  de: "Tyskland",
  dj: "Djibouti",
  dk: "Danmark",
  dm: "Dominica",
  do: "Den Dominikanske Republik",
  dz: "Algeriet",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Egypten",
  eh: "Vestsahara",
  er: "Eritrea",
  es: "Spanien",
  et: "Etiopien",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falklandsøerne",
  fm: "Mikronesien",
  fo: "Færøerne",
  fr: "Frankrig",
  ga: "Gabon",
  gb: "Storbritannien",
  gd: "Grenada",
  ge: "Georgien",
  gf: "Fransk Guyana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Grønland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Ækvatorialguinea",
  gr: "Grækenland",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "SAR Hongkong",
  hn: "Honduras",
  hr: "Kroatien",
  ht: "Haiti",
  hu: "Ungarn",
  id: "Indonesien",
  ie: "Irland",
  il: "Israel",
  im: "Isle of Man",
  in: "Indien",
  io: "Det Britiske Territorium i Det Indiske Ocean",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italien",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kirgisistan",
  kh: "Cambodja",
  ki: "Kiribati",
  km: "Comorerne",
  kn: "Saint Kitts og Nevis",
  kp: "Nordkorea",
  kr: "Sydkorea",
  kw: "Kuwait",
  ky: "Caymanøerne",
  kz: "Kasakhstan",
  la: "Laos",
  lb: "Libanon",
  lc: "Saint Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litauen",
  lu: "Luxembourg",
  lv: "Letland",
  ly: "Libyen",
  ma: "Marokko",
  mc: "Monaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "Saint Martin",
  mg: "Madagaskar",
  mh: "Marshalløerne",
  mk: "Nordmakedonien",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongoliet",
  mo: "SAR Macao",
  mp: "Nordmarianerne",
  mq: "Martinique",
  mr: "Mauretanien",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldiverne",
  mw: "Malawi",
  mx: "Mexico",
  my: "Malaysia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "Ny Kaledonien",
  ne: "Niger",
  nf: "Norfolk Island",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Holland",
  no: "Norge",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "New Zealand",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Fransk Polynesien",
  pg: "Papua Ny Guinea",
  ph: "Filippinerne",
  pk: "Pakistan",
  pl: "Polen",
  pm: "Saint Pierre og Miquelon",
  pr: "Puerto Rico",
  ps: "De palæstinensiske områder",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Rumænien",
  rs: "Serbien",
  ru: "Rusland",
  rw: "Rwanda",
  sa: "Saudi-Arabien",
  sb: "Salomonøerne",
  sc: "Seychellerne",
  sd: "Sudan",
  se: "Sverige",
  sg: "Singapore",
  sh: "St. Helena",
  si: "Slovenien",
  sj: "Svalbard og Jan Mayen",
  sk: "Slovakiet",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Surinam",
  ss: "Sydsudan",
  st: "São Tomé og Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syrien",
  sz: "Eswatini",
  tc: "Turks- og Caicosøerne",
  td: "Tchad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadsjikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunesien",
  to: "Tonga",
  tr: "Tyrkiet",
  tt: "Trinidad og Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraine",
  ug: "Uganda",
  us: "USA",
  uy: "Uruguay",
  uz: "Usbekistan",
  va: "Vatikanstaten",
  vc: "Saint Vincent og Grenadinerne",
  ve: "Venezuela",
  vg: "De Britiske Jomfruøer",
  vi: "De Amerikanske Jomfruøer",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis og Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "Sydafrika",
  zm: "Zambia",
  zw: "Zimbabwe"
}, tl = {
  selectedCountryAriaLabel: "Valgt land",
  noCountrySelected: "Intet land er valgt",
  countryListAriaLabel: "Liste over lande",
  searchPlaceholder: "Søg",
  zeroSearchResults: "Ingen resultater fundet",
  oneSearchResult: "1 resultat fundet",
  multipleSearchResults: "${count} resultater fundet",
  // additional countries (not supported by country-list library)
  ac: "Ascension",
  xk: "Kosovo"
}, nl = { ...el, ...tl }, al = {
  ad: "Andorra",
  ae: "Vereinigte Arabische Emirate",
  af: "Afghanistan",
  ag: "Antigua und Barbuda",
  ai: "Anguilla",
  al: "Albanien",
  am: "Armenien",
  ao: "Angola",
  ar: "Argentinien",
  as: "Amerikanisch-Samoa",
  at: "Österreich",
  au: "Australien",
  aw: "Aruba",
  ax: "Ålandinseln",
  az: "Aserbaidschan",
  ba: "Bosnien und Herzegowina",
  bb: "Barbados",
  bd: "Bangladesch",
  be: "Belgien",
  bf: "Burkina Faso",
  bg: "Bulgarien",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "St. Barthélemy",
  bm: "Bermuda",
  bn: "Brunei Darussalam",
  bo: "Bolivien",
  bq: "Bonaire, Sint Eustatius und Saba",
  br: "Brasilien",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botsuana",
  by: "Belarus",
  bz: "Belize",
  ca: "Kanada",
  cc: "Kokosinseln",
  cd: "Kongo-Kinshasa",
  cf: "Zentralafrikanische Republik",
  cg: "Kongo-Brazzaville",
  ch: "Schweiz",
  ci: "Côte d’Ivoire",
  ck: "Cookinseln",
  cl: "Chile",
  cm: "Kamerun",
  cn: "China",
  co: "Kolumbien",
  cr: "Costa Rica",
  cu: "Kuba",
  cv: "Cabo Verde",
  cw: "Curaçao",
  cx: "Weihnachtsinsel",
  cy: "Zypern",
  cz: "Tschechien",
  de: "Deutschland",
  dj: "Dschibuti",
  dk: "Dänemark",
  dm: "Dominica",
  do: "Dominikanische Republik",
  dz: "Algerien",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Ägypten",
  eh: "Westsahara",
  er: "Eritrea",
  es: "Spanien",
  et: "Äthiopien",
  fi: "Finnland",
  fj: "Fidschi",
  fk: "Falklandinseln",
  fm: "Mikronesien",
  fo: "Färöer",
  fr: "Frankreich",
  ga: "Gabun",
  gb: "Vereinigtes Königreich",
  gd: "Grenada",
  ge: "Georgien",
  gf: "Französisch-Guayana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Grönland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Äquatorialguinea",
  gr: "Griechenland",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Sonderverwaltungsregion Hongkong",
  hn: "Honduras",
  hr: "Kroatien",
  ht: "Haiti",
  hu: "Ungarn",
  id: "Indonesien",
  ie: "Irland",
  il: "Israel",
  im: "Isle of Man",
  in: "Indien",
  io: "Britisches Territorium im Indischen Ozean",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italien",
  je: "Jersey",
  jm: "Jamaika",
  jo: "Jordanien",
  jp: "Japan",
  ke: "Kenia",
  kg: "Kirgisistan",
  kh: "Kambodscha",
  ki: "Kiribati",
  km: "Komoren",
  kn: "St. Kitts und Nevis",
  kp: "Nordkorea",
  kr: "Südkorea",
  kw: "Kuwait",
  ky: "Kaimaninseln",
  kz: "Kasachstan",
  la: "Laos",
  lb: "Libanon",
  lc: "St. Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litauen",
  lu: "Luxemburg",
  lv: "Lettland",
  ly: "Libyen",
  ma: "Marokko",
  mc: "Monaco",
  md: "Republik Moldau",
  me: "Montenegro",
  mf: "St. Martin",
  mg: "Madagaskar",
  mh: "Marshallinseln",
  mk: "Nordmazedonien",
  ml: "Mali",
  mm: "Myanmar",
  mn: "Mongolei",
  mo: "Sonderverwaltungsregion Macau",
  mp: "Nördliche Marianen",
  mq: "Martinique",
  mr: "Mauretanien",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Malediven",
  mw: "Malawi",
  mx: "Mexiko",
  my: "Malaysia",
  mz: "Mosambik",
  na: "Namibia",
  nc: "Neukaledonien",
  ne: "Niger",
  nf: "Norfolkinsel",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Niederlande",
  no: "Norwegen",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Neuseeland",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Französisch-Polynesien",
  pg: "Papua-Neuguinea",
  ph: "Philippinen",
  pk: "Pakistan",
  pl: "Polen",
  pm: "St. Pierre und Miquelon",
  pr: "Puerto Rico",
  ps: "Palästinensische Autonomiegebiete",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Katar",
  re: "Réunion",
  ro: "Rumänien",
  rs: "Serbien",
  ru: "Russland",
  rw: "Ruanda",
  sa: "Saudi-Arabien",
  sb: "Salomonen",
  sc: "Seychellen",
  sd: "Sudan",
  se: "Schweden",
  sg: "Singapur",
  sh: "St. Helena",
  si: "Slowenien",
  sj: "Spitzbergen und Jan Mayen",
  sk: "Slowakei",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "Südsudan",
  st: "São Tomé und Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syrien",
  sz: "Eswatini",
  tc: "Turks- und Caicosinseln",
  td: "Tschad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadschikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunesien",
  to: "Tonga",
  tr: "Türkei",
  tt: "Trinidad und Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tansania",
  ua: "Ukraine",
  ug: "Uganda",
  us: "Vereinigte Staaten",
  uy: "Uruguay",
  uz: "Usbekistan",
  va: "Vatikanstadt",
  vc: "St. Vincent und die Grenadinen",
  ve: "Venezuela",
  vg: "Britische Jungferninseln",
  vi: "Amerikanische Jungferninseln",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis und Futuna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Südafrika",
  zm: "Sambia",
  zw: "Simbabwe"
}, ol = {
  selectedCountryAriaLabel: "Ausgewähltes Land",
  noCountrySelected: "Kein Land ausgewählt",
  countryListAriaLabel: "Liste der Länder",
  searchPlaceholder: "Suchen",
  zeroSearchResults: "Keine Suchergebnisse",
  oneSearchResult: "1 Suchergebnis",
  multipleSearchResults: "${count} Suchergebnisse",
  // additional countries (not supported by country-list library)
  ac: "Ascension-Insel",
  xk: "Kosovo"
}, rl = { ...al, ...ol }, il = {
  ad: "Andorra",
  ae: "United Arab Emirates",
  af: "Afghanistan",
  ag: "Antigua & Barbuda",
  ai: "Anguilla",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "American Samoa",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Åland Islands",
  az: "Azerbaijan",
  ba: "Bosnia & Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgium",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "St. Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Caribbean Netherlands",
  br: "Brazil",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Belarus",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocos (Keeling) Islands",
  cd: "Congo - Kinshasa",
  cf: "Central African Republic",
  cg: "Congo - Brazzaville",
  ch: "Switzerland",
  ci: "Côte d’Ivoire",
  ck: "Cook Islands",
  cl: "Chile",
  cm: "Cameroon",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cape Verde",
  cw: "Curaçao",
  cx: "Christmas Island",
  cy: "Cyprus",
  cz: "Czechia",
  de: "Germany",
  dj: "Djibouti",
  dk: "Denmark",
  dm: "Dominica",
  do: "Dominican Republic",
  dz: "Algeria",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egypt",
  eh: "Western Sahara",
  er: "Eritrea",
  es: "Spain",
  et: "Ethiopia",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falkland Islands",
  fm: "Micronesia",
  fo: "Faroe Islands",
  fr: "France",
  ga: "Gabon",
  gb: "United Kingdom",
  gd: "Grenada",
  ge: "Georgia",
  gf: "French Guiana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Greenland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Equatorial Guinea",
  gr: "Greece",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Hong Kong SAR China",
  hn: "Honduras",
  hr: "Croatia",
  ht: "Haiti",
  hu: "Hungary",
  id: "Indonesia",
  ie: "Ireland",
  il: "Israel",
  im: "Isle of Man",
  in: "India",
  io: "British Indian Ocean Territory",
  iq: "Iraq",
  ir: "Iran",
  is: "Iceland",
  it: "Italy",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kyrgyzstan",
  kh: "Cambodia",
  ki: "Kiribati",
  km: "Comoros",
  kn: "St. Kitts & Nevis",
  kp: "North Korea",
  kr: "South Korea",
  kw: "Kuwait",
  ky: "Cayman Islands",
  kz: "Kazakhstan",
  la: "Laos",
  lb: "Lebanon",
  lc: "St. Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Lithuania",
  lu: "Luxembourg",
  lv: "Latvia",
  ly: "Libya",
  ma: "Morocco",
  mc: "Monaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "St. Martin",
  mg: "Madagascar",
  mh: "Marshall Islands",
  mk: "North Macedonia",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongolia",
  mo: "Macao SAR China",
  mp: "Northern Mariana Islands",
  mq: "Martinique",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldives",
  mw: "Malawi",
  mx: "Mexico",
  my: "Malaysia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "New Caledonia",
  ne: "Niger",
  nf: "Norfolk Island",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Netherlands",
  no: "Norway",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "New Zealand",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "French Polynesia",
  pg: "Papua New Guinea",
  ph: "Philippines",
  pk: "Pakistan",
  pl: "Poland",
  pm: "St. Pierre & Miquelon",
  pr: "Puerto Rico",
  ps: "Palestinian Territories",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Romania",
  rs: "Serbia",
  ru: "Russia",
  rw: "Rwanda",
  sa: "Saudi Arabia",
  sb: "Solomon Islands",
  sc: "Seychelles",
  sd: "Sudan",
  se: "Sweden",
  sg: "Singapore",
  sh: "St. Helena",
  si: "Slovenia",
  sj: "Svalbard & Jan Mayen",
  sk: "Slovakia",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "South Sudan",
  st: "São Tomé & Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syria",
  sz: "Eswatini",
  tc: "Turks & Caicos Islands",
  td: "Chad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tajikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunisia",
  to: "Tonga",
  tr: "Turkey",
  tt: "Trinidad & Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraine",
  ug: "Uganda",
  us: "United States",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Vatican City",
  vc: "St. Vincent & Grenadines",
  ve: "Venezuela",
  vg: "British Virgin Islands",
  vi: "U.S. Virgin Islands",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis & Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "South Africa",
  zm: "Zambia",
  zw: "Zimbabwe"
}, sl = {
  selectedCountryAriaLabel: "Change country, selected ${countryName} (${dialCode})",
  noCountrySelected: "Select country",
  countryListAriaLabel: "List of countries",
  searchPlaceholder: "Search",
  clearSearchAriaLabel: "Clear search",
  zeroSearchResults: "No results found",
  oneSearchResult: "1 result found",
  multipleSearchResults: "${count} results found",
  // additional countries (not supported by country-list library)
  ac: "Ascension Island",
  xk: "Kosovo"
}, ll = { ...il, ...sl }, cl = {
  ad: "Andorra",
  ae: "Emiratos Árabes Unidos",
  af: "Afganistán",
  ag: "Antigua y Barbuda",
  ai: "Anguila",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "Samoa Americana",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Islas Åland",
  az: "Azerbaiyán",
  ba: "Bosnia y Herzegovina",
  bb: "Barbados",
  bd: "Bangladés",
  be: "Bélgica",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Baréin",
  bi: "Burundi",
  bj: "Benín",
  bl: "San Bartolomé",
  bm: "Bermudas",
  bn: "Brunéi",
  bo: "Bolivia",
  bq: "Caribe neerlandés",
  br: "Brasil",
  bs: "Bahamas",
  bt: "Bután",
  bw: "Botsuana",
  by: "Bielorrusia",
  bz: "Belice",
  ca: "Canadá",
  cc: "Islas Cocos",
  cd: "República Democrática del Congo",
  cf: "República Centroafricana",
  cg: "Congo",
  ch: "Suiza",
  ci: "Côte d’Ivoire",
  ck: "Islas Cook",
  cl: "Chile",
  cm: "Camerún",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cabo Verde",
  cw: "Curazao",
  cx: "Isla de Navidad",
  cy: "Chipre",
  cz: "Chequia",
  de: "Alemania",
  dj: "Yibuti",
  dk: "Dinamarca",
  dm: "Dominica",
  do: "República Dominicana",
  dz: "Argelia",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egipto",
  eh: "Sáhara Occidental",
  er: "Eritrea",
  es: "España",
  et: "Etiopía",
  fi: "Finlandia",
  fj: "Fiyi",
  fk: "Islas Malvinas",
  fm: "Micronesia",
  fo: "Islas Feroe",
  fr: "Francia",
  ga: "Gabón",
  gb: "Reino Unido",
  gd: "Granada",
  ge: "Georgia",
  gf: "Guayana Francesa",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Groenlandia",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadalupe",
  gq: "Guinea Ecuatorial",
  gr: "Grecia",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bisáu",
  gy: "Guyana",
  hk: "RAE de Hong Kong (China)",
  hn: "Honduras",
  hr: "Croacia",
  ht: "Haití",
  hu: "Hungría",
  id: "Indonesia",
  ie: "Irlanda",
  il: "Israel",
  im: "Isla de Man",
  in: "India",
  io: "Territorio Británico del Océano Índico",
  iq: "Irak",
  ir: "Irán",
  is: "Islandia",
  it: "Italia",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordania",
  jp: "Japón",
  ke: "Kenia",
  kg: "Kirguistán",
  kh: "Camboya",
  ki: "Kiribati",
  km: "Comoras",
  kn: "San Cristóbal y Nieves",
  kp: "Corea del Norte",
  kr: "Corea del Sur",
  kw: "Kuwait",
  ky: "Islas Caimán",
  kz: "Kazajistán",
  la: "Laos",
  lb: "Líbano",
  lc: "Santa Lucía",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesoto",
  lt: "Lituania",
  lu: "Luxemburgo",
  lv: "Letonia",
  ly: "Libia",
  ma: "Marruecos",
  mc: "Mónaco",
  md: "Moldavia",
  me: "Montenegro",
  mf: "San Martín",
  mg: "Madagascar",
  mh: "Islas Marshall",
  mk: "Macedonia del Norte",
  ml: "Mali",
  mm: "Myanmar (Birmania)",
  mn: "Mongolia",
  mo: "RAE de Macao (China)",
  mp: "Islas Marianas del Norte",
  mq: "Martinica",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauricio",
  mv: "Maldivas",
  mw: "Malaui",
  mx: "México",
  my: "Malasia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "Nueva Caledonia",
  ne: "Níger",
  nf: "Isla Norfolk",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Países Bajos",
  no: "Noruega",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nueva Zelanda",
  om: "Omán",
  pa: "Panamá",
  pe: "Perú",
  pf: "Polinesia Francesa",
  pg: "Papúa Nueva Guinea",
  ph: "Filipinas",
  pk: "Pakistán",
  pl: "Polonia",
  pm: "San Pedro y Miquelón",
  pr: "Puerto Rico",
  ps: "Territorios Palestinos",
  pt: "Portugal",
  pw: "Palaos",
  py: "Paraguay",
  qa: "Catar",
  re: "Reunión",
  ro: "Rumanía",
  rs: "Serbia",
  ru: "Rusia",
  rw: "Ruanda",
  sa: "Arabia Saudí",
  sb: "Islas Salomón",
  sc: "Seychelles",
  sd: "Sudán",
  se: "Suecia",
  sg: "Singapur",
  sh: "Santa Elena",
  si: "Eslovenia",
  sj: "Svalbard y Jan Mayen",
  sk: "Eslovaquia",
  sl: "Sierra Leona",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Surinam",
  ss: "Sudán del Sur",
  st: "Santo Tomé y Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Siria",
  sz: "Esuatini",
  tc: "Islas Turcas y Caicos",
  td: "Chad",
  tg: "Togo",
  th: "Tailandia",
  tj: "Tayikistán",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistán",
  tn: "Túnez",
  to: "Tonga",
  tr: "Turquía",
  tt: "Trinidad y Tobago",
  tv: "Tuvalu",
  tw: "Taiwán",
  tz: "Tanzania",
  ua: "Ucrania",
  ug: "Uganda",
  us: "Estados Unidos",
  uy: "Uruguay",
  uz: "Uzbekistán",
  va: "Ciudad del Vaticano",
  vc: "San Vicente y las Granadinas",
  ve: "Venezuela",
  vg: "Islas Vírgenes Británicas",
  vi: "Islas Vírgenes de EE. UU.",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis y Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "Sudáfrica",
  zm: "Zambia",
  zw: "Zimbabue"
}, ul = {
  selectedCountryAriaLabel: "País seleccionado",
  noCountrySelected: "Ningún país seleccionado",
  countryListAriaLabel: "Lista de países",
  searchPlaceholder: "Buscar",
  zeroSearchResults: "No se han encontrado resultados",
  oneSearchResult: "1 resultado encontrado",
  multipleSearchResults: "${count} resultados encontrados",
  // additional countries (not supported by country-list library)
  ac: "isla Ascencion",
  xk: "Kosovo"
}, dl = { ...cl, ...ul }, gl = {
  ad: "Andorre",
  ae: "Émirats arabes unis",
  af: "Afghanistan",
  ag: "Antigua-et-Barbuda",
  ai: "Anguilla",
  al: "Albanie",
  am: "Arménie",
  ao: "Angola",
  ar: "Argentine",
  as: "Samoa américaines",
  at: "Autriche",
  au: "Australie",
  aw: "Aruba",
  ax: "Îles Åland",
  az: "Azerbaïdjan",
  ba: "Bosnie-Herzégovine",
  bb: "Barbade",
  bd: "Bangladesh",
  be: "Belgique",
  bf: "Burkina Faso",
  bg: "Bulgarie",
  bh: "Bahreïn",
  bi: "Burundi",
  bj: "Bénin",
  bl: "Saint-Barthélemy",
  bm: "Bermudes",
  bn: "Brunéi Darussalam",
  bo: "Bolivie",
  bq: "Pays-Bas caribéens",
  br: "Brésil",
  bs: "Bahamas",
  bt: "Bhoutan",
  bw: "Botswana",
  by: "Biélorussie",
  bz: "Belize",
  ca: "Canada",
  cc: "Îles Cocos",
  cd: "Congo-Kinshasa",
  cf: "République centrafricaine",
  cg: "Congo-Brazzaville",
  ch: "Suisse",
  ci: "Côte d’Ivoire",
  ck: "Îles Cook",
  cl: "Chili",
  cm: "Cameroun",
  cn: "Chine",
  co: "Colombie",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cap-Vert",
  cw: "Curaçao",
  cx: "Île Christmas",
  cy: "Chypre",
  cz: "Tchéquie",
  de: "Allemagne",
  dj: "Djibouti",
  dk: "Danemark",
  dm: "Dominique",
  do: "République dominicaine",
  dz: "Algérie",
  ec: "Équateur",
  ee: "Estonie",
  eg: "Égypte",
  eh: "Sahara occidental",
  er: "Érythrée",
  es: "Espagne",
  et: "Éthiopie",
  fi: "Finlande",
  fj: "Fidji",
  fk: "Îles Malouines",
  fm: "États fédérés de Micronésie",
  fo: "Îles Féroé",
  fr: "France",
  ga: "Gabon",
  gb: "Royaume-Uni",
  gd: "Grenade",
  ge: "Géorgie",
  gf: "Guyane française",
  gg: "Guernesey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Groenland",
  gm: "Gambie",
  gn: "Guinée",
  gp: "Guadeloupe",
  gq: "Guinée équatoriale",
  gr: "Grèce",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinée-Bissau",
  gy: "Guyana",
  hk: "R.A.S. chinoise de Hong Kong",
  hn: "Honduras",
  hr: "Croatie",
  ht: "Haïti",
  hu: "Hongrie",
  id: "Indonésie",
  ie: "Irlande",
  il: "Israël",
  im: "Île de Man",
  in: "Inde",
  io: "Territoire britannique de l’océan Indien",
  iq: "Irak",
  ir: "Iran",
  is: "Islande",
  it: "Italie",
  je: "Jersey",
  jm: "Jamaïque",
  jo: "Jordanie",
  jp: "Japon",
  ke: "Kenya",
  kg: "Kirghizistan",
  kh: "Cambodge",
  ki: "Kiribati",
  km: "Comores",
  kn: "Saint-Christophe-et-Niévès",
  kp: "Corée du Nord",
  kr: "Corée du Sud",
  kw: "Koweït",
  ky: "Îles Caïmans",
  kz: "Kazakhstan",
  la: "Laos",
  lb: "Liban",
  lc: "Sainte-Lucie",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Libéria",
  ls: "Lesotho",
  lt: "Lituanie",
  lu: "Luxembourg",
  lv: "Lettonie",
  ly: "Libye",
  ma: "Maroc",
  mc: "Monaco",
  md: "Moldavie",
  me: "Monténégro",
  mf: "Saint-Martin",
  mg: "Madagascar",
  mh: "Îles Marshall",
  mk: "Macédoine du Nord",
  ml: "Mali",
  mm: "Myanmar (Birmanie)",
  mn: "Mongolie",
  mo: "R.A.S. chinoise de Macao",
  mp: "Îles Mariannes du Nord",
  mq: "Martinique",
  mr: "Mauritanie",
  ms: "Montserrat",
  mt: "Malte",
  mu: "Maurice",
  mv: "Maldives",
  mw: "Malawi",
  mx: "Mexique",
  my: "Malaisie",
  mz: "Mozambique",
  na: "Namibie",
  nc: "Nouvelle-Calédonie",
  ne: "Niger",
  nf: "Île Norfolk",
  ng: "Nigéria",
  ni: "Nicaragua",
  nl: "Pays-Bas",
  no: "Norvège",
  np: "Népal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nouvelle-Zélande",
  om: "Oman",
  pa: "Panama",
  pe: "Pérou",
  pf: "Polynésie française",
  pg: "Papouasie-Nouvelle-Guinée",
  ph: "Philippines",
  pk: "Pakistan",
  pl: "Pologne",
  pm: "Saint-Pierre-et-Miquelon",
  pr: "Porto Rico",
  ps: "Territoires palestiniens",
  pt: "Portugal",
  pw: "Palaos",
  py: "Paraguay",
  qa: "Qatar",
  re: "La Réunion",
  ro: "Roumanie",
  rs: "Serbie",
  ru: "Russie",
  rw: "Rwanda",
  sa: "Arabie saoudite",
  sb: "Îles Salomon",
  sc: "Seychelles",
  sd: "Soudan",
  se: "Suède",
  sg: "Singapour",
  sh: "Sainte-Hélène",
  si: "Slovénie",
  sj: "Svalbard et Jan Mayen",
  sk: "Slovaquie",
  sl: "Sierra Leone",
  sm: "Saint-Marin",
  sn: "Sénégal",
  so: "Somalie",
  sr: "Suriname",
  ss: "Soudan du Sud",
  st: "Sao Tomé-et-Principe",
  sv: "Salvador",
  sx: "Saint-Martin (partie néerlandaise)",
  sy: "Syrie",
  sz: "Eswatini",
  tc: "Îles Turques-et-Caïques",
  td: "Tchad",
  tg: "Togo",
  th: "Thaïlande",
  tj: "Tadjikistan",
  tk: "Tokelau",
  tl: "Timor oriental",
  tm: "Turkménistan",
  tn: "Tunisie",
  to: "Tonga",
  tr: "Turquie",
  tt: "Trinité-et-Tobago",
  tv: "Tuvalu",
  tw: "Taïwan",
  tz: "Tanzanie",
  ua: "Ukraine",
  ug: "Ouganda",
  us: "États-Unis",
  uy: "Uruguay",
  uz: "Ouzbékistan",
  va: "État de la Cité du Vatican",
  vc: "Saint-Vincent-et-les-Grenadines",
  ve: "Venezuela",
  vg: "Îles Vierges britanniques",
  vi: "Îles Vierges des États-Unis",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis-et-Futuna",
  ws: "Samoa",
  ye: "Yémen",
  yt: "Mayotte",
  za: "Afrique du Sud",
  zm: "Zambie",
  zw: "Zimbabwe"
}, hl = {
  selectedCountryAriaLabel: "Pays sélectionné",
  noCountrySelected: "Aucun pays sélectionné",
  countryListAriaLabel: "Liste des pays",
  searchPlaceholder: "Recherche",
  zeroSearchResults: "Aucun résultat trouvé",
  oneSearchResult: "1 résultat trouvé",
  multipleSearchResults: "${count} résultats trouvés",
  // additional countries (not supported by country-list library)
  ac: "Île de l'Ascension",
  xk: "Kosovo"
}, _l = { ...gl, ...hl }, fl = {
  ad: "Andora",
  ae: "Ujedinjeni Arapski Emirati",
  af: "Afganistan",
  ag: "Antigva i Barbuda",
  ai: "Angvila",
  al: "Albanija",
  am: "Armenija",
  ao: "Angola",
  ar: "Argentina",
  as: "Američka Samoa",
  at: "Austrija",
  au: "Australija",
  aw: "Aruba",
  ax: "Ålandski otoci",
  az: "Azerbajdžan",
  ba: "Bosna i Hercegovina",
  bb: "Barbados",
  bd: "Bangladeš",
  be: "Belgija",
  bf: "Burkina Faso",
  bg: "Bugarska",
  bh: "Bahrein",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint Barthélemy",
  bm: "Bermudi",
  bn: "Brunej",
  bo: "Bolivija",
  bq: "Karipski otoci Nizozemske",
  br: "Brazil",
  bs: "Bahami",
  bt: "Butan",
  bw: "Bocvana",
  by: "Bjelorusija",
  bz: "Belize",
  ca: "Kanada",
  cc: "Kokosovi (Keelingovi) otoci",
  cd: "Kongo - Kinshasa",
  cf: "Srednjoafrička Republika",
  cg: "Kongo - Brazzaville",
  ch: "Švicarska",
  ci: "Obala Bjelokosti",
  ck: "Cookovi Otoci",
  cl: "Čile",
  cm: "Kamerun",
  cn: "Kina",
  co: "Kolumbija",
  cr: "Kostarika",
  cu: "Kuba",
  cv: "Zelenortska Republika",
  cw: "Curaçao",
  cx: "Božićni otok",
  cy: "Cipar",
  cz: "Češka",
  de: "Njemačka",
  dj: "Džibuti",
  dk: "Danska",
  dm: "Dominika",
  do: "Dominikanska Republika",
  dz: "Alžir",
  ec: "Ekvador",
  ee: "Estonija",
  eg: "Egipat",
  eh: "Zapadna Sahara",
  er: "Eritreja",
  es: "Španjolska",
  et: "Etiopija",
  fi: "Finska",
  fj: "Fidži",
  fk: "Falklandski otoci",
  fm: "Mikronezija",
  fo: "Farski otoci",
  fr: "Francuska",
  ga: "Gabon",
  gb: "Ujedinjeno Kraljevstvo",
  gd: "Grenada",
  ge: "Gruzija",
  gf: "Francuska Gijana",
  gg: "Guernsey",
  gh: "Gana",
  gi: "Gibraltar",
  gl: "Grenland",
  gm: "Gambija",
  gn: "Gvineja",
  gp: "Guadalupe",
  gq: "Ekvatorska Gvineja",
  gr: "Grčka",
  gt: "Gvatemala",
  gu: "Guam",
  gw: "Gvineja Bisau",
  gy: "Gvajana",
  hk: "PUP Hong Kong Kina",
  hn: "Honduras",
  hr: "Hrvatska",
  ht: "Haiti",
  hu: "Mađarska",
  id: "Indonezija",
  ie: "Irska",
  il: "Izrael",
  im: "Otok Man",
  in: "Indija",
  io: "Britanski Indijskooceanski teritorij",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italija",
  je: "Jersey",
  jm: "Jamajka",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenija",
  kg: "Kirgistan",
  kh: "Kambodža",
  ki: "Kiribati",
  km: "Komori",
  kn: "Sveti Kristofor i Nevis",
  kp: "Sjeverna Koreja",
  kr: "Južna Koreja",
  kw: "Kuvajt",
  ky: "Kajmanski otoci",
  kz: "Kazahstan",
  la: "Laos",
  lb: "Libanon",
  lc: "Sveta Lucija",
  li: "Lihtenštajn",
  lk: "Šri Lanka",
  lr: "Liberija",
  ls: "Lesoto",
  lt: "Litva",
  lu: "Luksemburg",
  lv: "Latvija",
  ly: "Libija",
  ma: "Maroko",
  mc: "Monako",
  md: "Moldavija",
  me: "Crna Gora",
  mf: "Saint Martin",
  mg: "Madagaskar",
  mh: "Maršalovi Otoci",
  mk: "Sjeverna Makedonija",
  ml: "Mali",
  mm: "Mjanmar (Burma)",
  mn: "Mongolija",
  mo: "PUP Makao Kina",
  mp: "Sjevernomarijanski otoci",
  mq: "Martinique",
  mr: "Mauretanija",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauricijus",
  mv: "Maldivi",
  mw: "Malavi",
  mx: "Meksiko",
  my: "Malezija",
  mz: "Mozambik",
  na: "Namibija",
  nc: "Nova Kaledonija",
  ne: "Niger",
  nf: "Otok Norfolk",
  ng: "Nigerija",
  ni: "Nikaragva",
  nl: "Nizozemska",
  no: "Norveška",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Novi Zeland",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Francuska Polinezija",
  pg: "Papua Nova Gvineja",
  ph: "Filipini",
  pk: "Pakistan",
  pl: "Poljska",
  pm: "Saint-Pierre-et-Miquelon",
  pr: "Portoriko",
  ps: "Palestinsko područje",
  pt: "Portugal",
  pw: "Palau",
  py: "Paragvaj",
  qa: "Katar",
  re: "Réunion",
  ro: "Rumunjska",
  rs: "Srbija",
  ru: "Rusija",
  rw: "Ruanda",
  sa: "Saudijska Arabija",
  sb: "Salomonski Otoci",
  sc: "Sejšeli",
  sd: "Sudan",
  se: "Švedska",
  sg: "Singapur",
  sh: "Sveta Helena",
  si: "Slovenija",
  sj: "Svalbard i Jan Mayen",
  sk: "Slovačka",
  sl: "Sijera Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalija",
  sr: "Surinam",
  ss: "Južni Sudan",
  st: "Sveti Toma i Princip",
  sv: "Salvador",
  sx: "Sint Maarten",
  sy: "Sirija",
  sz: "Esvatini",
  tc: "Otoci Turks i Caicos",
  td: "Čad",
  tg: "Togo",
  th: "Tajland",
  tj: "Tadžikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunis",
  to: "Tonga",
  tr: "Turska",
  tt: "Trinidad i Tobago",
  tv: "Tuvalu",
  tw: "Tajvan",
  tz: "Tanzanija",
  ua: "Ukrajina",
  ug: "Uganda",
  us: "Sjedinjene Američke Države",
  uy: "Urugvaj",
  uz: "Uzbekistan",
  va: "Vatikanski Grad",
  vc: "Sveti Vincent i Grenadini",
  ve: "Venezuela",
  vg: "Britanski Djevičanski otoci",
  vi: "Američki Djevičanski otoci",
  vn: "Vijetnam",
  vu: "Vanuatu",
  wf: "Wallis i Futuna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Južnoafrička Republika",
  zm: "Zambija",
  zw: "Zimbabve"
}, ml = {
  selectedCountryAriaLabel: "Odabrana zemlja",
  noCountrySelected: "Zemlja nije odabrana",
  countryListAriaLabel: "Lista zemalja",
  searchPlaceholder: "Pretraži",
  zeroSearchResults: "Nema pronađenih rezultata",
  oneSearchResult: "Pronađen 1 rezultat",
  multipleSearchResults: "${count} rezultata pronađeno",
  // additional countries (not supported by country-list library)
  ac: "Ascension",
  xk: "Kosovo"
}, pl = { ...fl, ...ml }, bl = {
  ad: "Andorra",
  ae: "Emirati Arabi Uniti",
  af: "Afghanistan",
  ag: "Antigua e Barbuda",
  ai: "Anguilla",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "Samoa americane",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Isole Åland",
  az: "Azerbaigian",
  ba: "Bosnia ed Erzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgio",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Bahrein",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint-Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Caraibi olandesi",
  br: "Brasile",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Bielorussia",
  bz: "Belize",
  ca: "Canada",
  cc: "Isole Cocos (Keeling)",
  cd: "Congo - Kinshasa",
  cf: "Repubblica Centrafricana",
  cg: "Congo-Brazzaville",
  ch: "Svizzera",
  ci: "Costa d’Avorio",
  ck: "Isole Cook",
  cl: "Cile",
  cm: "Camerun",
  cn: "Cina",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Capo Verde",
  cw: "Curaçao",
  cx: "Isola Christmas",
  cy: "Cipro",
  cz: "Cechia",
  de: "Germania",
  dj: "Gibuti",
  dk: "Danimarca",
  dm: "Dominica",
  do: "Repubblica Dominicana",
  dz: "Algeria",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egitto",
  eh: "Sahara occidentale",
  er: "Eritrea",
  es: "Spagna",
  et: "Etiopia",
  fi: "Finlandia",
  fj: "Figi",
  fk: "Isole Falkland",
  fm: "Micronesia",
  fo: "Isole Fær Øer",
  fr: "Francia",
  ga: "Gabon",
  gb: "Regno Unito",
  gd: "Grenada",
  ge: "Georgia",
  gf: "Guyana francese",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibilterra",
  gl: "Groenlandia",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadalupa",
  gq: "Guinea Equatoriale",
  gr: "Grecia",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "RAS di Hong Kong",
  hn: "Honduras",
  hr: "Croazia",
  ht: "Haiti",
  hu: "Ungheria",
  id: "Indonesia",
  ie: "Irlanda",
  il: "Israele",
  im: "Isola di Man",
  in: "India",
  io: "Territorio britannico dell’Oceano Indiano",
  iq: "Iraq",
  ir: "Iran",
  is: "Islanda",
  it: "Italia",
  je: "Jersey",
  jm: "Giamaica",
  jo: "Giordania",
  jp: "Giappone",
  ke: "Kenya",
  kg: "Kirghizistan",
  kh: "Cambogia",
  ki: "Kiribati",
  km: "Comore",
  kn: "Saint Kitts e Nevis",
  kp: "Corea del Nord",
  kr: "Corea del Sud",
  kw: "Kuwait",
  ky: "Isole Cayman",
  kz: "Kazakistan",
  la: "Laos",
  lb: "Libano",
  lc: "Saint Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Lituania",
  lu: "Lussemburgo",
  lv: "Lettonia",
  ly: "Libia",
  ma: "Marocco",
  mc: "Monaco",
  md: "Moldavia",
  me: "Montenegro",
  mf: "Saint Martin",
  mg: "Madagascar",
  mh: "Isole Marshall",
  mk: "Macedonia del Nord",
  ml: "Mali",
  mm: "Myanmar (Birmania)",
  mn: "Mongolia",
  mo: "RAS di Macao",
  mp: "Isole Marianne settentrionali",
  mq: "Martinica",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldive",
  mw: "Malawi",
  mx: "Messico",
  my: "Malaysia",
  mz: "Mozambico",
  na: "Namibia",
  nc: "Nuova Caledonia",
  ne: "Niger",
  nf: "Isola Norfolk",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Paesi Bassi",
  no: "Norvegia",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nuova Zelanda",
  om: "Oman",
  pa: "Panamá",
  pe: "Perù",
  pf: "Polinesia francese",
  pg: "Papua Nuova Guinea",
  ph: "Filippine",
  pk: "Pakistan",
  pl: "Polonia",
  pm: "Saint-Pierre e Miquelon",
  pr: "Portorico",
  ps: "Territori palestinesi",
  pt: "Portogallo",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Riunione",
  ro: "Romania",
  rs: "Serbia",
  ru: "Russia",
  rw: "Ruanda",
  sa: "Arabia Saudita",
  sb: "Isole Salomone",
  sc: "Seychelles",
  sd: "Sudan",
  se: "Svezia",
  sg: "Singapore",
  sh: "Sant’Elena",
  si: "Slovenia",
  sj: "Svalbard e Jan Mayen",
  sk: "Slovacchia",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "Sud Sudan",
  st: "São Tomé e Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Siria",
  sz: "Swaziland",
  tc: "Isole Turks e Caicos",
  td: "Ciad",
  tg: "Togo",
  th: "Thailandia",
  tj: "Tagikistan",
  tk: "Tokelau",
  tl: "Timor Est",
  tm: "Turkmenistan",
  tn: "Tunisia",
  to: "Tonga",
  tr: "Turchia",
  tt: "Trinidad e Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ucraina",
  ug: "Uganda",
  us: "Stati Uniti",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Città del Vaticano",
  vc: "Saint Vincent e Grenadine",
  ve: "Venezuela",
  vg: "Isole Vergini Britanniche",
  vi: "Isole Vergini Americane",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis e Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "Sudafrica",
  zm: "Zambia",
  zw: "Zimbabwe"
}, yl = {
  selectedCountryAriaLabel: "Paese selezionato",
  noCountrySelected: "Nessun paese selezionato",
  countryListAriaLabel: "Elenco dei paesi",
  searchPlaceholder: "Ricerca",
  zeroSearchResults: "Nessun risultato trovato",
  oneSearchResult: "1 risultato trovato",
  multipleSearchResults: "${count} risultati trovati",
  // additional countries (not supported by country-list library)
  ac: "Isola di Ascensione",
  xk: "Kosovo"
}, vl = { ...bl, ...yl }, kl = {
  ad: "Andorra",
  ae: "Verenigde Arabische Emiraten",
  af: "Afghanistan",
  ag: "Antigua en Barbuda",
  ai: "Anguilla",
  al: "Albanië",
  am: "Armenië",
  ao: "Angola",
  ar: "Argentinië",
  as: "Amerikaans-Samoa",
  at: "Oostenrijk",
  au: "Australië",
  aw: "Aruba",
  ax: "Åland",
  az: "Azerbeidzjan",
  ba: "Bosnië en Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "België",
  bf: "Burkina Faso",
  bg: "Bulgarije",
  bh: "Bahrein",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint-Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Caribisch Nederland",
  br: "Brazilië",
  bs: "Bahama’s",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Belarus",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocoseilanden",
  cd: "Congo-Kinshasa",
  cf: "Centraal-Afrikaanse Republiek",
  cg: "Congo-Brazzaville",
  ch: "Zwitserland",
  ci: "Ivoorkust",
  ck: "Cookeilanden",
  cl: "Chili",
  cm: "Kameroen",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Kaapverdië",
  cw: "Curaçao",
  cx: "Christmaseiland",
  cy: "Cyprus",
  cz: "Tsjechië",
  de: "Duitsland",
  dj: "Djibouti",
  dk: "Denemarken",
  dm: "Dominica",
  do: "Dominicaanse Republiek",
  dz: "Algerije",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Egypte",
  eh: "Westelijke Sahara",
  er: "Eritrea",
  es: "Spanje",
  et: "Ethiopië",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falklandeilanden",
  fm: "Micronesia",
  fo: "Faeröer",
  fr: "Frankrijk",
  ga: "Gabon",
  gb: "Verenigd Koninkrijk",
  gd: "Grenada",
  ge: "Georgië",
  gf: "Frans-Guyana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Groenland",
  gm: "Gambia",
  gn: "Guinee",
  gp: "Guadeloupe",
  gq: "Equatoriaal-Guinea",
  gr: "Griekenland",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinee-Bissau",
  gy: "Guyana",
  hk: "Hongkong SAR van China",
  hn: "Honduras",
  hr: "Kroatië",
  ht: "Haïti",
  hu: "Hongarije",
  id: "Indonesië",
  ie: "Ierland",
  il: "Israël",
  im: "Isle of Man",
  in: "India",
  io: "Brits Indische Oceaanterritorium",
  iq: "Irak",
  ir: "Iran",
  is: "IJsland",
  it: "Italië",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordanië",
  jp: "Japan",
  ke: "Kenia",
  kg: "Kirgizië",
  kh: "Cambodja",
  ki: "Kiribati",
  km: "Comoren",
  kn: "Saint Kitts en Nevis",
  kp: "Noord-Korea",
  kr: "Zuid-Korea",
  kw: "Koeweit",
  ky: "Kaaimaneilanden",
  kz: "Kazachstan",
  la: "Laos",
  lb: "Libanon",
  lc: "Saint Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litouwen",
  lu: "Luxemburg",
  lv: "Letland",
  ly: "Libië",
  ma: "Marokko",
  mc: "Monaco",
  md: "Moldavië",
  me: "Montenegro",
  mf: "Saint-Martin",
  mg: "Madagaskar",
  mh: "Marshalleilanden",
  mk: "Noord-Macedonië",
  ml: "Mali",
  mm: "Myanmar (Birma)",
  mn: "Mongolië",
  mo: "Macau SAR van China",
  mp: "Noordelijke Marianen",
  mq: "Martinique",
  mr: "Mauritanië",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldiven",
  mw: "Malawi",
  mx: "Mexico",
  my: "Maleisië",
  mz: "Mozambique",
  na: "Namibië",
  nc: "Nieuw-Caledonië",
  ne: "Niger",
  nf: "Norfolk",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Nederland",
  no: "Noorwegen",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nieuw-Zeeland",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Frans-Polynesië",
  pg: "Papoea-Nieuw-Guinea",
  ph: "Filipijnen",
  pk: "Pakistan",
  pl: "Polen",
  pm: "Saint-Pierre en Miquelon",
  pr: "Puerto Rico",
  ps: "Palestijnse gebieden",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Roemenië",
  rs: "Servië",
  ru: "Rusland",
  rw: "Rwanda",
  sa: "Saoedi-Arabië",
  sb: "Salomonseilanden",
  sc: "Seychellen",
  sd: "Soedan",
  se: "Zweden",
  sg: "Singapore",
  sh: "Sint-Helena",
  si: "Slovenië",
  sj: "Spitsbergen en Jan Mayen",
  sk: "Slowakije",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalië",
  sr: "Suriname",
  ss: "Zuid-Soedan",
  st: "Sao Tomé en Principe",
  sv: "El Salvador",
  sx: "Sint-Maarten",
  sy: "Syrië",
  sz: "eSwatini",
  tc: "Turks- en Caicoseilanden",
  td: "Tsjaad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadzjikistan",
  tk: "Tokelau",
  tl: "Oost-Timor",
  tm: "Turkmenistan",
  tn: "Tunesië",
  to: "Tonga",
  tr: "Turkije",
  tt: "Trinidad en Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Oekraïne",
  ug: "Oeganda",
  us: "Verenigde Staten",
  uy: "Uruguay",
  uz: "Oezbekistan",
  va: "Vaticaanstad",
  vc: "Saint Vincent en de Grenadines",
  ve: "Venezuela",
  vg: "Britse Maagdeneilanden",
  vi: "Amerikaanse Maagdeneilanden",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis en Futuna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Zuid-Afrika",
  zm: "Zambia",
  zw: "Zimbabwe"
}, wl = {
  selectedCountryAriaLabel: "Geselecteerd land",
  noCountrySelected: "Geen land geselecteerd",
  countryListAriaLabel: "Lijst met landen",
  searchPlaceholder: "Zoekopdracht",
  zeroSearchResults: "Geen resultaten gevonden",
  oneSearchResult: "1 resultaat gevonden",
  multipleSearchResults: "${count} resultaten gevonden",
  // additional countries (not supported by country-list library)
  ac: "Ascension-eiland",
  xk: "Kosovo"
}, va = { ...kl, ...wl }, $l = {
  ad: "Andorra",
  ae: "Emirados Árabes Unidos",
  af: "Afeganistão",
  ag: "Antígua e Barbuda",
  ai: "Anguila",
  al: "Albânia",
  am: "Armênia",
  ao: "Angola",
  ar: "Argentina",
  as: "Samoa Americana",
  at: "Áustria",
  au: "Austrália",
  aw: "Aruba",
  ax: "Ilhas Aland",
  az: "Azerbaijão",
  ba: "Bósnia e Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Bélgica",
  bf: "Burquina Faso",
  bg: "Bulgária",
  bh: "Bahrein",
  bi: "Burundi",
  bj: "Benin",
  bl: "São Bartolomeu",
  bm: "Bermudas",
  bn: "Brunei",
  bo: "Bolívia",
  bq: "Países Baixos Caribenhos",
  br: "Brasil",
  bs: "Bahamas",
  bt: "Butão",
  bw: "Botsuana",
  by: "Bielorrússia",
  bz: "Belize",
  ca: "Canadá",
  cc: "Ilhas Cocos (Keeling)",
  cd: "Congo - Kinshasa",
  cf: "República Centro-Africana",
  cg: "República do Congo",
  ch: "Suíça",
  ci: "Costa do Marfim",
  ck: "Ilhas Cook",
  cl: "Chile",
  cm: "Camarões",
  cn: "China",
  co: "Colômbia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cabo Verde",
  cw: "Curaçao",
  cx: "Ilha Christmas",
  cy: "Chipre",
  cz: "Tchéquia",
  de: "Alemanha",
  dj: "Djibuti",
  dk: "Dinamarca",
  dm: "Dominica",
  do: "República Dominicana",
  dz: "Argélia",
  ec: "Equador",
  ee: "Estônia",
  eg: "Egito",
  eh: "Saara Ocidental",
  er: "Eritreia",
  es: "Espanha",
  et: "Etiópia",
  fi: "Finlândia",
  fj: "Fiji",
  fk: "Ilhas Malvinas",
  fm: "Micronésia",
  fo: "Ilhas Faroe",
  fr: "França",
  ga: "Gabão",
  gb: "Reino Unido",
  gd: "Granada",
  ge: "Geórgia",
  gf: "Guiana Francesa",
  gg: "Guernsey",
  gh: "Gana",
  gi: "Gibraltar",
  gl: "Groenlândia",
  gm: "Gâmbia",
  gn: "Guiné",
  gp: "Guadalupe",
  gq: "Guiné Equatorial",
  gr: "Grécia",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guiné-Bissau",
  gy: "Guiana",
  hk: "Hong Kong, RAE da China",
  hn: "Honduras",
  hr: "Croácia",
  ht: "Haiti",
  hu: "Hungria",
  id: "Indonésia",
  ie: "Irlanda",
  il: "Israel",
  im: "Ilha de Man",
  in: "Índia",
  io: "Território Britânico do Oceano Índico",
  iq: "Iraque",
  ir: "Irã",
  is: "Islândia",
  it: "Itália",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordânia",
  jp: "Japão",
  ke: "Quênia",
  kg: "Quirguistão",
  kh: "Camboja",
  ki: "Quiribati",
  km: "Comores",
  kn: "São Cristóvão e Névis",
  kp: "Coreia do Norte",
  kr: "Coreia do Sul",
  kw: "Kuwait",
  ky: "Ilhas Cayman",
  kz: "Cazaquistão",
  la: "Laos",
  lb: "Líbano",
  lc: "Santa Lúcia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Libéria",
  ls: "Lesoto",
  lt: "Lituânia",
  lu: "Luxemburgo",
  lv: "Letônia",
  ly: "Líbia",
  ma: "Marrocos",
  mc: "Mônaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "São Martinho",
  mg: "Madagascar",
  mh: "Ilhas Marshall",
  mk: "Macedônia do Norte",
  ml: "Mali",
  mm: "Mianmar (Birmânia)",
  mn: "Mongólia",
  mo: "Macau, RAE da China",
  mp: "Ilhas Marianas do Norte",
  mq: "Martinica",
  mr: "Mauritânia",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Maurício",
  mv: "Maldivas",
  mw: "Malaui",
  mx: "México",
  my: "Malásia",
  mz: "Moçambique",
  na: "Namíbia",
  nc: "Nova Caledônia",
  ne: "Níger",
  nf: "Ilha Norfolk",
  ng: "Nigéria",
  ni: "Nicarágua",
  nl: "Países Baixos",
  no: "Noruega",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nova Zelândia",
  om: "Omã",
  pa: "Panamá",
  pe: "Peru",
  pf: "Polinésia Francesa",
  pg: "Papua-Nova Guiné",
  ph: "Filipinas",
  pk: "Paquistão",
  pl: "Polônia",
  pm: "São Pedro e Miquelão",
  pr: "Porto Rico",
  ps: "Territórios palestinos",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguai",
  qa: "Catar",
  re: "Reunião",
  ro: "Romênia",
  rs: "Sérvia",
  ru: "Rússia",
  rw: "Ruanda",
  sa: "Arábia Saudita",
  sb: "Ilhas Salomão",
  sc: "Seicheles",
  sd: "Sudão",
  se: "Suécia",
  sg: "Singapura",
  sh: "Santa Helena",
  si: "Eslovênia",
  sj: "Svalbard e Jan Mayen",
  sk: "Eslováquia",
  sl: "Serra Leoa",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somália",
  sr: "Suriname",
  ss: "Sudão do Sul",
  st: "São Tomé e Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Síria",
  sz: "Essuatíni",
  tc: "Ilhas Turcas e Caicos",
  td: "Chade",
  tg: "Togo",
  th: "Tailândia",
  tj: "Tadjiquistão",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turcomenistão",
  tn: "Tunísia",
  to: "Tonga",
  tr: "Turquia",
  tt: "Trinidad e Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzânia",
  ua: "Ucrânia",
  ug: "Uganda",
  us: "Estados Unidos",
  uy: "Uruguai",
  uz: "Uzbequistão",
  va: "Cidade do Vaticano",
  vc: "São Vicente e Granadinas",
  ve: "Venezuela",
  vg: "Ilhas Virgens Britânicas",
  vi: "Ilhas Virgens Americanas",
  vn: "Vietnã",
  vu: "Vanuatu",
  wf: "Wallis e Futuna",
  ws: "Samoa",
  ye: "Iêmen",
  yt: "Mayotte",
  za: "África do Sul",
  zm: "Zâmbia",
  zw: "Zimbábue"
}, Cl = {
  selectedCountryAriaLabel: "País selecionado",
  noCountrySelected: "Nenhum país selecionado",
  countryListAriaLabel: "Lista de países",
  searchPlaceholder: "Procurar",
  zeroSearchResults: "Nenhum resultado encontrado",
  oneSearchResult: "1 resultado encontrado",
  multipleSearchResults: "${count} resultados encontrados",
  // additional countries (not supported by country-list library)
  ac: "Ilha de Ascensão",
  xk: "Kosovo"
}, Sl = { ...$l, ...Cl }, xl = {
  ad: "Andorra",
  ae: "Förenade Arabemiraten",
  af: "Afghanistan",
  ag: "Antigua och Barbuda",
  ai: "Anguilla",
  al: "Albanien",
  am: "Armenien",
  ao: "Angola",
  ar: "Argentina",
  as: "Amerikanska Samoa",
  at: "Österrike",
  au: "Australien",
  aw: "Aruba",
  ax: "Åland",
  az: "Azerbajdzjan",
  ba: "Bosnien och Hercegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgien",
  bf: "Burkina Faso",
  bg: "Bulgarien",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "S:t Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Karibiska Nederländerna",
  br: "Brasilien",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Vitryssland",
  bz: "Belize",
  ca: "Kanada",
  cc: "Kokosöarna",
  cd: "Kongo-Kinshasa",
  cf: "Centralafrikanska republiken",
  cg: "Kongo-Brazzaville",
  ch: "Schweiz",
  ci: "Côte d’Ivoire",
  ck: "Cooköarna",
  cl: "Chile",
  cm: "Kamerun",
  cn: "Kina",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Kuba",
  cv: "Kap Verde",
  cw: "Curaçao",
  cx: "Julön",
  cy: "Cypern",
  cz: "Tjeckien",
  de: "Tyskland",
  dj: "Djibouti",
  dk: "Danmark",
  dm: "Dominica",
  do: "Dominikanska republiken",
  dz: "Algeriet",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Egypten",
  eh: "Västsahara",
  er: "Eritrea",
  es: "Spanien",
  et: "Etiopien",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falklandsöarna",
  fm: "Mikronesien",
  fo: "Färöarna",
  fr: "Frankrike",
  ga: "Gabon",
  gb: "Storbritannien",
  gd: "Grenada",
  ge: "Georgien",
  gf: "Franska Guyana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Grönland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Ekvatorialguinea",
  gr: "Grekland",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Hongkong",
  hn: "Honduras",
  hr: "Kroatien",
  ht: "Haiti",
  hu: "Ungern",
  id: "Indonesien",
  ie: "Irland",
  il: "Israel",
  im: "Isle of Man",
  in: "Indien",
  io: "Brittiska territoriet i Indiska oceanen",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italien",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordanien",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kirgizistan",
  kh: "Kambodja",
  ki: "Kiribati",
  km: "Komorerna",
  kn: "S:t Kitts och Nevis",
  kp: "Nordkorea",
  kr: "Sydkorea",
  kw: "Kuwait",
  ky: "Caymanöarna",
  kz: "Kazakstan",
  la: "Laos",
  lb: "Libanon",
  lc: "S:t Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litauen",
  lu: "Luxemburg",
  lv: "Lettland",
  ly: "Libyen",
  ma: "Marocko",
  mc: "Monaco",
  md: "Moldavien",
  me: "Montenegro",
  mf: "Saint-Martin",
  mg: "Madagaskar",
  mh: "Marshallöarna",
  mk: "Nordmakedonien",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongoliet",
  mo: "Macao",
  mp: "Nordmarianerna",
  mq: "Martinique",
  mr: "Mauretanien",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldiverna",
  mw: "Malawi",
  mx: "Mexiko",
  my: "Malaysia",
  mz: "Moçambique",
  na: "Namibia",
  nc: "Nya Kaledonien",
  ne: "Niger",
  nf: "Norfolkön",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Nederländerna",
  no: "Norge",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nya Zeeland",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Franska Polynesien",
  pg: "Papua Nya Guinea",
  ph: "Filippinerna",
  pk: "Pakistan",
  pl: "Polen",
  pm: "S:t Pierre och Miquelon",
  pr: "Puerto Rico",
  ps: "Palestinska territorierna",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Rumänien",
  rs: "Serbien",
  ru: "Ryssland",
  rw: "Rwanda",
  sa: "Saudiarabien",
  sb: "Salomonöarna",
  sc: "Seychellerna",
  sd: "Sudan",
  se: "Sverige",
  sg: "Singapore",
  sh: "S:t Helena",
  si: "Slovenien",
  sj: "Svalbard och Jan Mayen",
  sk: "Slovakien",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Surinam",
  ss: "Sydsudan",
  st: "São Tomé och Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syrien",
  sz: "Swaziland",
  tc: "Turks- och Caicosöarna",
  td: "Tchad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadzjikistan",
  tk: "Tokelau",
  tl: "Östtimor",
  tm: "Turkmenistan",
  tn: "Tunisien",
  to: "Tonga",
  tr: "Turkiet",
  tt: "Trinidad och Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraina",
  ug: "Uganda",
  us: "USA",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Vatikanstaten",
  vc: "S:t Vincent och Grenadinerna",
  ve: "Venezuela",
  vg: "Brittiska Jungfruöarna",
  vi: "Amerikanska Jungfruöarna",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis- och Futunaöarna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Sydafrika",
  zm: "Zambia",
  zw: "Zimbabwe"
}, zl = {
  selectedCountryAriaLabel: "Valt land",
  noCountrySelected: "Inget land valt",
  countryListAriaLabel: "Lista över länder",
  searchPlaceholder: "Sök",
  zeroSearchResults: "Inga resultat hittades",
  oneSearchResult: "1 resultat hittades",
  multipleSearchResults: "${count} resultat hittades",
  // additional countries (not supported by country-list library)
  ac: "Ascension",
  xk: "Kosovo"
}, Al = { ...xl, ...zl }, Nl = {
  en: ll,
  fr: _l,
  it: vl,
  es: dl,
  de: rl,
  da: nl,
  hr: pl,
  nb: va,
  nl: va,
  pt: Sl,
  sv: Al
}, ka = {
  error: "is-error"
}, wa = {
  error: {
    name: "error-warning-fill",
    color: "error"
  }
}, Ol = "_title_ej2xw_37", Il = "_text_ej2xw_41", Qe = {
  "radio-group": "_radio-group_ej2xw_29",
  "group-label": "_group-label_ej2xw_34",
  title: Ol,
  text: Il,
  "has-error": "_has-error_ej2xw_48",
  "error-message": "_error-message_ej2xw_51"
};
function wn({
  children: t,
  defaultValue: e,
  label: n,
  helperContent: a,
  errorMessage: o,
  disabled: r,
  onChange: i,
  onBlur: s,
  value: l,
  name: c
}) {
  const u = !!o, d = !!(n ?? a);
  return /* @__PURE__ */ B(
    Ks,
    {
      name: c,
      onValueChange: i,
      defaultValue: e,
      className: H(Qe["radio-group"], o && Qe["has-error"]),
      disabled: r,
      onBlur: s,
      value: l,
      children: [
        d && /* @__PURE__ */ B("div", { className: Qe["group-label"], children: [
          n && /* @__PURE__ */ y("label", { className: Qe.title, children: n }),
          a && /* @__PURE__ */ y("p", { className: Qe.text, children: a })
        ] }),
        t,
        u && /* @__PURE__ */ B("p", { className: Qe["error-message"], children: [
          /* @__PURE__ */ y(Ke, { name: "error-warning-fill", color: "error" }),
          o
        ] })
      ]
    }
  );
}
wn.Item = Ys;
var Ll = [
  [
    "af",
    // Afghanistan
    "93"
  ],
  [
    "ax",
    // Åland Islands
    "358",
    1
  ],
  [
    "al",
    // Albania
    "355"
  ],
  [
    "dz",
    // Algeria
    "213"
  ],
  [
    "as",
    // American Samoa
    "1",
    5,
    ["684"]
  ],
  [
    "ad",
    // Andorra
    "376"
  ],
  [
    "ao",
    // Angola
    "244"
  ],
  [
    "ai",
    // Anguilla
    "1",
    6,
    ["264"]
  ],
  [
    "ag",
    // Antigua and Barbuda
    "1",
    7,
    ["268"]
  ],
  [
    "ar",
    // Argentina
    "54"
  ],
  [
    "am",
    // Armenia
    "374"
  ],
  [
    "aw",
    // Aruba
    "297"
  ],
  [
    "ac",
    // Ascension Island
    "247"
  ],
  [
    "au",
    // Australia
    "61",
    0,
    null,
    "0"
  ],
  [
    "at",
    // Austria
    "43"
  ],
  [
    "az",
    // Azerbaijan
    "994"
  ],
  [
    "bs",
    // Bahamas
    "1",
    8,
    ["242"]
  ],
  [
    "bh",
    // Bahrain
    "973"
  ],
  [
    "bd",
    // Bangladesh
    "880"
  ],
  [
    "bb",
    // Barbados
    "1",
    9,
    ["246"]
  ],
  [
    "by",
    // Belarus
    "375"
  ],
  [
    "be",
    // Belgium
    "32"
  ],
  [
    "bz",
    // Belize
    "501"
  ],
  [
    "bj",
    // Benin
    "229"
  ],
  [
    "bm",
    // Bermuda
    "1",
    10,
    ["441"]
  ],
  [
    "bt",
    // Bhutan
    "975"
  ],
  [
    "bo",
    // Bolivia
    "591"
  ],
  [
    "ba",
    // Bosnia and Herzegovina
    "387"
  ],
  [
    "bw",
    // Botswana
    "267"
  ],
  [
    "br",
    // Brazil
    "55"
  ],
  [
    "io",
    // British Indian Ocean Territory
    "246"
  ],
  [
    "vg",
    // British Virgin Islands
    "1",
    11,
    ["284"]
  ],
  [
    "bn",
    // Brunei
    "673"
  ],
  [
    "bg",
    // Bulgaria
    "359"
  ],
  [
    "bf",
    // Burkina Faso
    "226"
  ],
  [
    "bi",
    // Burundi
    "257"
  ],
  [
    "kh",
    // Cambodia
    "855"
  ],
  [
    "cm",
    // Cameroon
    "237"
  ],
  [
    "ca",
    // Canada
    "1",
    1,
    ["204", "226", "236", "249", "250", "263", "289", "306", "343", "354", "365", "367", "368", "382", "387", "403", "416", "418", "428", "431", "437", "438", "450", "584", "468", "474", "506", "514", "519", "548", "579", "581", "584", "587", "604", "613", "639", "647", "672", "683", "705", "709", "742", "753", "778", "780", "782", "807", "819", "825", "867", "873", "879", "902", "905"]
  ],
  [
    "cv",
    // Cape Verde
    "238"
  ],
  [
    "bq",
    // Caribbean Netherlands
    "599",
    1,
    ["3", "4", "7"]
  ],
  [
    "ky",
    // Cayman Islands
    "1",
    12,
    ["345"]
  ],
  [
    "cf",
    // Central African Republic
    "236"
  ],
  [
    "td",
    // Chad
    "235"
  ],
  [
    "cl",
    // Chile
    "56"
  ],
  [
    "cn",
    // China
    "86"
  ],
  [
    "cx",
    // Christmas Island
    "61",
    2,
    ["89164"],
    "0"
  ],
  [
    "cc",
    // Cocos (Keeling) Islands
    "61",
    1,
    ["89162"],
    "0"
  ],
  [
    "co",
    // Colombia
    "57"
  ],
  [
    "km",
    // Comoros
    "269"
  ],
  [
    "cg",
    // Congo (Brazzaville)
    "242"
  ],
  [
    "cd",
    // Congo (Kinshasa)
    "243"
  ],
  [
    "ck",
    // Cook Islands
    "682"
  ],
  [
    "cr",
    // Costa Rica
    "506"
  ],
  [
    "ci",
    // Côte d'Ivoire
    "225"
  ],
  [
    "hr",
    // Croatia
    "385"
  ],
  [
    "cu",
    // Cuba
    "53"
  ],
  [
    "cw",
    // Curaçao
    "599",
    0
  ],
  [
    "cy",
    // Cyprus
    "357"
  ],
  [
    "cz",
    // Czech Republic
    "420"
  ],
  [
    "dk",
    // Denmark
    "45"
  ],
  [
    "dj",
    // Djibouti
    "253"
  ],
  [
    "dm",
    // Dominica
    "1",
    13,
    ["767"]
  ],
  [
    "do",
    // Dominican Republic
    "1",
    2,
    ["809", "829", "849"]
  ],
  [
    "ec",
    // Ecuador
    "593"
  ],
  [
    "eg",
    // Egypt
    "20"
  ],
  [
    "sv",
    // El Salvador
    "503"
  ],
  [
    "gq",
    // Equatorial Guinea
    "240"
  ],
  [
    "er",
    // Eritrea
    "291"
  ],
  [
    "ee",
    // Estonia
    "372"
  ],
  [
    "sz",
    // Eswatini
    "268"
  ],
  [
    "et",
    // Ethiopia
    "251"
  ],
  [
    "fk",
    // Falkland Islands (Malvinas)
    "500"
  ],
  [
    "fo",
    // Faroe Islands
    "298"
  ],
  [
    "fj",
    // Fiji
    "679"
  ],
  [
    "fi",
    // Finland
    "358",
    0
  ],
  [
    "fr",
    // France
    "33"
  ],
  [
    "gf",
    // French Guiana
    "594"
  ],
  [
    "pf",
    // French Polynesia
    "689"
  ],
  [
    "ga",
    // Gabon
    "241"
  ],
  [
    "gm",
    // Gambia
    "220"
  ],
  [
    "ge",
    // Georgia
    "995"
  ],
  [
    "de",
    // Germany
    "49"
  ],
  [
    "gh",
    // Ghana
    "233"
  ],
  [
    "gi",
    // Gibraltar
    "350"
  ],
  [
    "gr",
    // Greece
    "30"
  ],
  [
    "gl",
    // Greenland
    "299"
  ],
  [
    "gd",
    // Grenada
    "1",
    14,
    ["473"]
  ],
  [
    "gp",
    // Guadeloupe
    "590",
    0
  ],
  [
    "gu",
    // Guam
    "1",
    15,
    ["671"]
  ],
  [
    "gt",
    // Guatemala
    "502"
  ],
  [
    "gg",
    // Guernsey
    "44",
    1,
    ["1481", "7781", "7839", "7911"],
    "0"
  ],
  [
    "gn",
    // Guinea
    "224"
  ],
  [
    "gw",
    // Guinea-Bissau
    "245"
  ],
  [
    "gy",
    // Guyana
    "592"
  ],
  [
    "ht",
    // Haiti
    "509"
  ],
  [
    "hn",
    // Honduras
    "504"
  ],
  [
    "hk",
    // Hong Kong SAR China
    "852"
  ],
  [
    "hu",
    // Hungary
    "36"
  ],
  [
    "is",
    // Iceland
    "354"
  ],
  [
    "in",
    // India
    "91"
  ],
  [
    "id",
    // Indonesia
    "62"
  ],
  [
    "ir",
    // Iran
    "98"
  ],
  [
    "iq",
    // Iraq
    "964"
  ],
  [
    "ie",
    // Ireland
    "353"
  ],
  [
    "im",
    // Isle of Man
    "44",
    2,
    ["1624", "74576", "7524", "7924", "7624"],
    "0"
  ],
  [
    "il",
    // Israel
    "972"
  ],
  [
    "it",
    // Italy
    "39",
    0
  ],
  [
    "jm",
    // Jamaica
    "1",
    4,
    ["876", "658"]
  ],
  [
    "jp",
    // Japan
    "81"
  ],
  [
    "je",
    // Jersey
    "44",
    3,
    ["1534", "7509", "7700", "7797", "7829", "7937"],
    "0"
  ],
  [
    "jo",
    // Jordan
    "962"
  ],
  [
    "kz",
    // Kazakhstan
    "7",
    1,
    ["33", "7"],
    "8"
  ],
  [
    "ke",
    // Kenya
    "254"
  ],
  [
    "ki",
    // Kiribati
    "686"
  ],
  [
    "xk",
    // Kosovo
    "383"
  ],
  [
    "kw",
    // Kuwait
    "965"
  ],
  [
    "kg",
    // Kyrgyzstan
    "996"
  ],
  [
    "la",
    // Laos
    "856"
  ],
  [
    "lv",
    // Latvia
    "371"
  ],
  [
    "lb",
    // Lebanon
    "961"
  ],
  [
    "ls",
    // Lesotho
    "266"
  ],
  [
    "lr",
    // Liberia
    "231"
  ],
  [
    "ly",
    // Libya
    "218"
  ],
  [
    "li",
    // Liechtenstein
    "423"
  ],
  [
    "lt",
    // Lithuania
    "370"
  ],
  [
    "lu",
    // Luxembourg
    "352"
  ],
  [
    "mo",
    // Macao SAR China
    "853"
  ],
  [
    "mg",
    // Madagascar
    "261"
  ],
  [
    "mw",
    // Malawi
    "265"
  ],
  [
    "my",
    // Malaysia
    "60"
  ],
  [
    "mv",
    // Maldives
    "960"
  ],
  [
    "ml",
    // Mali
    "223"
  ],
  [
    "mt",
    // Malta
    "356"
  ],
  [
    "mh",
    // Marshall Islands
    "692"
  ],
  [
    "mq",
    // Martinique
    "596"
  ],
  [
    "mr",
    // Mauritania
    "222"
  ],
  [
    "mu",
    // Mauritius
    "230"
  ],
  [
    "yt",
    // Mayotte
    "262",
    1,
    ["269", "639"],
    "0"
  ],
  [
    "mx",
    // Mexico
    "52"
  ],
  [
    "fm",
    // Micronesia
    "691"
  ],
  [
    "md",
    // Moldova
    "373"
  ],
  [
    "mc",
    // Monaco
    "377"
  ],
  [
    "mn",
    // Mongolia
    "976"
  ],
  [
    "me",
    // Montenegro
    "382"
  ],
  [
    "ms",
    // Montserrat
    "1",
    16,
    ["664"]
  ],
  [
    "ma",
    // Morocco
    "212",
    0,
    null,
    "0"
  ],
  [
    "mz",
    // Mozambique
    "258"
  ],
  [
    "mm",
    // Myanmar (Burma)
    "95"
  ],
  [
    "na",
    // Namibia
    "264"
  ],
  [
    "nr",
    // Nauru
    "674"
  ],
  [
    "np",
    // Nepal
    "977"
  ],
  [
    "nl",
    // Netherlands
    "31"
  ],
  [
    "nc",
    // New Caledonia
    "687"
  ],
  [
    "nz",
    // New Zealand
    "64"
  ],
  [
    "ni",
    // Nicaragua
    "505"
  ],
  [
    "ne",
    // Niger
    "227"
  ],
  [
    "ng",
    // Nigeria
    "234"
  ],
  [
    "nu",
    // Niue
    "683"
  ],
  [
    "nf",
    // Norfolk Island
    "672"
  ],
  [
    "kp",
    // North Korea
    "850"
  ],
  [
    "mk",
    // North Macedonia
    "389"
  ],
  [
    "mp",
    // Northern Mariana Islands
    "1",
    17,
    ["670"]
  ],
  [
    "no",
    // Norway
    "47",
    0
  ],
  [
    "om",
    // Oman
    "968"
  ],
  [
    "pk",
    // Pakistan
    "92"
  ],
  [
    "pw",
    // Palau
    "680"
  ],
  [
    "ps",
    // Palestinian Territories
    "970"
  ],
  [
    "pa",
    // Panama
    "507"
  ],
  [
    "pg",
    // Papua New Guinea
    "675"
  ],
  [
    "py",
    // Paraguay
    "595"
  ],
  [
    "pe",
    // Peru
    "51"
  ],
  [
    "ph",
    // Philippines
    "63"
  ],
  [
    "pl",
    // Poland
    "48"
  ],
  [
    "pt",
    // Portugal
    "351"
  ],
  [
    "pr",
    // Puerto Rico
    "1",
    3,
    ["787", "939"]
  ],
  [
    "qa",
    // Qatar
    "974"
  ],
  [
    "re",
    // Réunion
    "262",
    0,
    null,
    "0"
  ],
  [
    "ro",
    // Romania
    "40"
  ],
  [
    "ru",
    // Russia
    "7",
    0,
    null,
    "8"
  ],
  [
    "rw",
    // Rwanda
    "250"
  ],
  [
    "ws",
    // Samoa
    "685"
  ],
  [
    "sm",
    // San Marino
    "378"
  ],
  [
    "st",
    // São Tomé & Príncipe
    "239"
  ],
  [
    "sa",
    // Saudi Arabia
    "966"
  ],
  [
    "sn",
    // Senegal
    "221"
  ],
  [
    "rs",
    // Serbia
    "381"
  ],
  [
    "sc",
    // Seychelles
    "248"
  ],
  [
    "sl",
    // Sierra Leone
    "232"
  ],
  [
    "sg",
    // Singapore
    "65"
  ],
  [
    "sx",
    // Sint Maarten
    "1",
    21,
    ["721"]
  ],
  [
    "sk",
    // Slovakia
    "421"
  ],
  [
    "si",
    // Slovenia
    "386"
  ],
  [
    "sb",
    // Solomon Islands
    "677"
  ],
  [
    "so",
    // Somalia
    "252"
  ],
  [
    "za",
    // South Africa
    "27"
  ],
  [
    "kr",
    // South Korea
    "82"
  ],
  [
    "ss",
    // South Sudan
    "211"
  ],
  [
    "es",
    // Spain
    "34"
  ],
  [
    "lk",
    // Sri Lanka
    "94"
  ],
  [
    "bl",
    // St. Barthélemy
    "590",
    1
  ],
  [
    "sh",
    // St. Helena
    "290"
  ],
  [
    "kn",
    // St. Kitts & Nevis
    "1",
    18,
    ["869"]
  ],
  [
    "lc",
    // St. Lucia
    "1",
    19,
    ["758"]
  ],
  [
    "mf",
    // St. Martin
    "590",
    2
  ],
  [
    "pm",
    // St. Pierre & Miquelon
    "508"
  ],
  [
    "vc",
    // St. Vincent & Grenadines
    "1",
    20,
    ["784"]
  ],
  [
    "sd",
    // Sudan
    "249"
  ],
  [
    "sr",
    // Suriname
    "597"
  ],
  [
    "sj",
    // Svalbard & Jan Mayen
    "47",
    1,
    ["79"]
  ],
  [
    "se",
    // Sweden
    "46"
  ],
  [
    "ch",
    // Switzerland
    "41"
  ],
  [
    "sy",
    // Syria
    "963"
  ],
  [
    "tw",
    // Taiwan
    "886"
  ],
  [
    "tj",
    // Tajikistan
    "992"
  ],
  [
    "tz",
    // Tanzania
    "255"
  ],
  [
    "th",
    // Thailand
    "66"
  ],
  [
    "tl",
    // Timor-Leste
    "670"
  ],
  [
    "tg",
    // Togo
    "228"
  ],
  [
    "tk",
    // Tokelau
    "690"
  ],
  [
    "to",
    // Tonga
    "676"
  ],
  [
    "tt",
    // Trinidad & Tobago
    "1",
    22,
    ["868"]
  ],
  [
    "tn",
    // Tunisia
    "216"
  ],
  [
    "tr",
    // Turkey
    "90"
  ],
  [
    "tm",
    // Turkmenistan
    "993"
  ],
  [
    "tc",
    // Turks & Caicos Islands
    "1",
    23,
    ["649"]
  ],
  [
    "tv",
    // Tuvalu
    "688"
  ],
  [
    "vi",
    // U.S. Virgin Islands
    "1",
    24,
    ["340"]
  ],
  [
    "ug",
    // Uganda
    "256"
  ],
  [
    "ua",
    // Ukraine
    "380"
  ],
  [
    "ae",
    // United Arab Emirates
    "971"
  ],
  [
    "gb",
    // United Kingdom
    "44",
    0,
    null,
    "0"
  ],
  [
    "us",
    // United States
    "1",
    0
  ],
  [
    "uy",
    // Uruguay
    "598"
  ],
  [
    "uz",
    // Uzbekistan
    "998"
  ],
  [
    "vu",
    // Vanuatu
    "678"
  ],
  [
    "va",
    // Vatican City
    "39",
    1,
    ["06698"]
  ],
  [
    "ve",
    // Venezuela
    "58"
  ],
  [
    "vn",
    // Vietnam
    "84"
  ],
  [
    "wf",
    // Wallis & Futuna
    "681"
  ],
  [
    "eh",
    // Western Sahara
    "212",
    1,
    ["5288", "5289"],
    "0"
  ],
  [
    "ye",
    // Yemen
    "967"
  ],
  [
    "zm",
    // Zambia
    "260"
  ],
  [
    "zw",
    // Zimbabwe
    "263"
  ]
], rr = [];
for (const t of Ll)
  rr.push({
    name: "",
    // populated in the plugin
    iso2: t[0],
    dialCode: t[1],
    priority: t[2] || 0,
    areaCodes: t[3] || null,
    nodeById: {},
    // populated by the plugin
    nationalPrefix: t[4] || null
  });
var dt = rr, Dl = {
  ad: "Andorra",
  ae: "United Arab Emirates",
  af: "Afghanistan",
  ag: "Antigua & Barbuda",
  ai: "Anguilla",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "American Samoa",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Åland Islands",
  az: "Azerbaijan",
  ba: "Bosnia & Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgium",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "St. Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Caribbean Netherlands",
  br: "Brazil",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Belarus",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocos (Keeling) Islands",
  cd: "Congo - Kinshasa",
  cf: "Central African Republic",
  cg: "Congo - Brazzaville",
  ch: "Switzerland",
  ci: "Côte d’Ivoire",
  ck: "Cook Islands",
  cl: "Chile",
  cm: "Cameroon",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cape Verde",
  cw: "Curaçao",
  cx: "Christmas Island",
  cy: "Cyprus",
  cz: "Czechia",
  de: "Germany",
  dj: "Djibouti",
  dk: "Denmark",
  dm: "Dominica",
  do: "Dominican Republic",
  dz: "Algeria",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egypt",
  eh: "Western Sahara",
  er: "Eritrea",
  es: "Spain",
  et: "Ethiopia",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falkland Islands",
  fm: "Micronesia",
  fo: "Faroe Islands",
  fr: "France",
  ga: "Gabon",
  gb: "United Kingdom",
  gd: "Grenada",
  ge: "Georgia",
  gf: "French Guiana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Greenland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Equatorial Guinea",
  gr: "Greece",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Hong Kong SAR China",
  hn: "Honduras",
  hr: "Croatia",
  ht: "Haiti",
  hu: "Hungary",
  id: "Indonesia",
  ie: "Ireland",
  il: "Israel",
  im: "Isle of Man",
  in: "India",
  io: "British Indian Ocean Territory",
  iq: "Iraq",
  ir: "Iran",
  is: "Iceland",
  it: "Italy",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kyrgyzstan",
  kh: "Cambodia",
  ki: "Kiribati",
  km: "Comoros",
  kn: "St. Kitts & Nevis",
  kp: "North Korea",
  kr: "South Korea",
  kw: "Kuwait",
  ky: "Cayman Islands",
  kz: "Kazakhstan",
  la: "Laos",
  lb: "Lebanon",
  lc: "St. Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Lithuania",
  lu: "Luxembourg",
  lv: "Latvia",
  ly: "Libya",
  ma: "Morocco",
  mc: "Monaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "St. Martin",
  mg: "Madagascar",
  mh: "Marshall Islands",
  mk: "North Macedonia",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongolia",
  mo: "Macao SAR China",
  mp: "Northern Mariana Islands",
  mq: "Martinique",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldives",
  mw: "Malawi",
  mx: "Mexico",
  my: "Malaysia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "New Caledonia",
  ne: "Niger",
  nf: "Norfolk Island",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Netherlands",
  no: "Norway",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "New Zealand",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "French Polynesia",
  pg: "Papua New Guinea",
  ph: "Philippines",
  pk: "Pakistan",
  pl: "Poland",
  pm: "St. Pierre & Miquelon",
  pr: "Puerto Rico",
  ps: "Palestinian Territories",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Romania",
  rs: "Serbia",
  ru: "Russia",
  rw: "Rwanda",
  sa: "Saudi Arabia",
  sb: "Solomon Islands",
  sc: "Seychelles",
  sd: "Sudan",
  se: "Sweden",
  sg: "Singapore",
  sh: "St. Helena",
  si: "Slovenia",
  sj: "Svalbard & Jan Mayen",
  sk: "Slovakia",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "South Sudan",
  st: "São Tomé & Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syria",
  sz: "Eswatini",
  tc: "Turks & Caicos Islands",
  td: "Chad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tajikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunisia",
  to: "Tonga",
  tr: "Turkey",
  tt: "Trinidad & Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraine",
  ug: "Uganda",
  us: "United States",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Vatican City",
  vc: "St. Vincent & Grenadines",
  ve: "Venezuela",
  vg: "British Virgin Islands",
  vi: "U.S. Virgin Islands",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis & Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "South Africa",
  zm: "Zambia",
  zw: "Zimbabwe"
}, Ml = Dl, El = {
  selectedCountryAriaLabel: "Change country, selected ${countryName} (${dialCode})",
  noCountrySelected: "Select country",
  countryListAriaLabel: "List of countries",
  searchPlaceholder: "Search",
  clearSearchAriaLabel: "Clear search",
  zeroSearchResults: "No results found",
  oneSearchResult: "1 result found",
  multipleSearchResults: "${count} results found",
  // additional countries (not supported by country-list library)
  ac: "Ascension Island",
  xk: "Kosovo"
}, jl = El, Pl = { ...Ml, ...jl }, ir = Pl;
for (const t of dt)
  t.name = ir[t.iso2];
var Tl = 0, _n = (t) => typeof window < "u" && typeof window.matchMedia == "function" && window.matchMedia(t).matches, Rl = () => {
  if (typeof navigator < "u" && typeof window < "u") {
    const t = /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent), e = _n("(max-width: 500px)"), n = _n("(max-height: 600px)"), a = _n("(pointer: coarse)");
    return t || e || a && n;
  }
  return !1;
}, sr = {
  // Allow alphanumeric "phonewords" (e.g. +1 800 FLOWERS) as valid numbers
  allowPhonewords: !1,
  //* Whether or not to allow the dropdown.
  allowDropdown: !0,
  //* Add a placeholder in the input with an example number for the selected country.
  autoPlaceholder: "polite",
  //* Modify the parentClass.
  containerClass: "",
  //* The order of the countries in the dropdown. Defaults to alphabetical.
  countryOrder: null,
  //* Add a country search input at the top of the dropdown.
  countrySearch: !0,
  //* Modify the auto placeholder.
  customPlaceholder: null,
  //* Append menu to specified element.
  dropdownContainer: null,
  //* Don't display these countries.
  excludeCountries: [],
  //* Fix the dropdown width to the input width (rather than being as wide as the longest country name).
  fixDropdownWidth: !0,
  //* Format the number as the user types
  formatAsYouType: !0,
  //* Format the input value during initialisation and on setNumber.
  formatOnDisplay: !0,
  //* geoIp lookup function.
  geoIpLookup: null,
  //* Inject a hidden input with the name returned from this function, and on submit, populate it with the result of getNumber.
  hiddenInput: null,
  //* Internationalise the plugin text e.g. search input placeholder, country names.
  i18n: {},
  //* Initial country.
  initialCountry: "",
  //* A function to load the utils script.
  loadUtils: null,
  //* National vs international formatting for numbers e.g. placeholders and displaying existing numbers.
  nationalMode: !0,
  //* Display only these countries.
  onlyCountries: [],
  //* Number type to use for placeholders.
  placeholderNumberType: "MOBILE",
  //* Show flags - for both the selected country, and in the country dropdown
  showFlags: !0,
  //* Display the international dial code next to the selected flag.
  separateDialCode: !1,
  //* Only allow certain chars e.g. a plus followed by numeric digits, and cap at max valid length.
  strictMode: !1,
  //* Use full screen popup instead of dropdown for country list.
  useFullscreenPopup: Rl(),
  //* The number type to enforce during validation.
  validationNumberTypes: ["MOBILE"]
}, Bl = [
  "800",
  "822",
  "833",
  "844",
  "855",
  "866",
  "877",
  "880",
  "881",
  "882",
  "883",
  "884",
  "885",
  "886",
  "887",
  "888",
  "889"
], Mt = (t) => t.replace(/\D/g, ""), $a = (t = "") => t.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase(), Ca = (t) => {
  const e = Mt(t);
  if (e.charAt(0) === "1") {
    const n = e.substring(1, 4);
    return Bl.includes(n);
  }
  return !1;
}, Fl = (t, e, n, a) => {
  if (n === 0 && !a)
    return 0;
  let o = 0;
  for (let r = 0; r < e.length; r++) {
    if (/[+0-9]/.test(e[r]) && o++, o === t && !a)
      return r + 1;
    if (a && o === t + 1)
      return r;
  }
  return e.length;
}, oe = (t, e, n) => {
  const a = document.createElement(t);
  return e && Object.entries(e).forEach(([o, r]) => a.setAttribute(o, r)), n && n.appendChild(a), a;
}, gt = (t, ...e) => {
  const { instances: n } = E;
  Object.values(n).forEach((a) => a[t](...e));
}, Vl = class $n {
  /**
   * Build a space-delimited class string from an object map of className -> truthy/falsey.
   * Only keys with truthy values are included.
   */
  static _buildClassNames(e) {
    return Object.keys(e).filter((n) => !!e[n]).join(" ");
  }
  constructor(e, n = {}) {
    this.id = Tl++, this.telInput = e, this.highlightedItem = null, this.options = Object.assign({}, sr, n), this.hadInitialPlaceholder = !!e.getAttribute("placeholder");
  }
  //* Can't be private as it's called from intlTelInput convenience wrapper.
  _init() {
    this.options.useFullscreenPopup && (this.options.fixDropdownWidth = !1), this.options.onlyCountries.length === 1 && (this.options.initialCountry = this.options.onlyCountries[0]), this.options.separateDialCode && (this.options.nationalMode = !1), this.options.allowDropdown && !this.options.showFlags && !this.options.separateDialCode && (this.options.nationalMode = !1), this.options.useFullscreenPopup && !this.options.dropdownContainer && (this.options.dropdownContainer = document.body), this.isAndroid = typeof navigator < "u" ? /Android/i.test(navigator.userAgent) : !1, this.isRTL = !!this.telInput.closest("[dir=rtl]"), this.telInput.dir = "ltr";
    const e = this.options.allowDropdown || this.options.separateDialCode;
    this.showSelectedCountryOnLeft = this.isRTL ? !e : e, this.options.separateDialCode && (this.isRTL ? this.originalPaddingRight = this.telInput.style.paddingRight : this.originalPaddingLeft = this.telInput.style.paddingLeft), this.options.i18n = { ...ir, ...this.options.i18n };
    const n = new Promise((o, r) => {
      this.resolveAutoCountryPromise = o, this.rejectAutoCountryPromise = r;
    }), a = new Promise((o, r) => {
      this.resolveUtilsScriptPromise = o, this.rejectUtilsScriptPromise = r;
    });
    this.promise = Promise.all([n, a]), this.selectedCountryData = {}, this._processCountryData(), this._generateMarkup(), this._setInitialState(), this._initListeners(), this._initRequests();
  }
  //********************
  //*  PRIVATE METHODS
  //********************
  //* Prepare all of the country data, including onlyCountries, excludeCountries, countryOrder options.
  _processCountryData() {
    this._processAllCountries(), this._processDialCodes(), this._translateCountryNames(), this._sortCountries(), this.countryByIso2 = new Map(this.countries.map((e) => [e.iso2, e])), this._cacheSearchTokens();
  }
  //* Precompute and cache country search tokens to speed up filtering
  _cacheSearchTokens() {
    for (const e of this.countries)
      e.normalisedName = $a(e.name), e.initials = e.name.split(/[^a-zA-ZÀ-ÿа-яА-Я]/).map((n) => n[0]).join("").toLowerCase(), e.dialCodePlus = `+${e.dialCode}`;
  }
  //* Sort countries by countryOrder option (if present), then name.
  _sortCountries() {
    this.options.countryOrder && (this.options.countryOrder = this.options.countryOrder.map((e) => e.toLowerCase())), this.countries.sort((e, n) => {
      const { countryOrder: a } = this.options;
      if (a) {
        const o = a.indexOf(e.iso2), r = a.indexOf(n.iso2), i = o > -1, s = r > -1;
        if (i || s)
          return i && s ? o - r : i ? -1 : 1;
      }
      return e.name.localeCompare(n.name);
    });
  }
  //* Add a dial code to this.dialCodeToIso2Map.
  _addToDialCodeMap(e, n, a) {
    if (!e || !n)
      return;
    n.length > this.dialCodeMaxLen && (this.dialCodeMaxLen = n.length), this.dialCodeToIso2Map.hasOwnProperty(n) || (this.dialCodeToIso2Map[n] = []);
    const o = this.dialCodeToIso2Map[n];
    if (o.includes(e))
      return;
    const r = a !== void 0 ? a : o.length;
    o[r] = e;
  }
  //* Process onlyCountries or excludeCountries array if present.
  _processAllCountries() {
    const { onlyCountries: e, excludeCountries: n } = this.options;
    if (e.length) {
      const a = e.map(
        (o) => o.toLowerCase()
      );
      this.countries = dt.filter(
        (o) => a.includes(o.iso2)
      );
    } else if (n.length) {
      const a = n.map(
        (o) => o.toLowerCase()
      );
      this.countries = dt.filter(
        (o) => !a.includes(o.iso2)
      );
    } else
      this.countries = dt;
  }
  //* Translate Countries by object literal provided on config.
  _translateCountryNames() {
    for (const e of this.countries) {
      const n = e.iso2.toLowerCase();
      this.options.i18n.hasOwnProperty(n) && (e.name = this.options.i18n[n]);
    }
  }
  //* Generate this.dialCodes and this.dialCodeToIso2Map.
  _processDialCodes() {
    this.dialCodes = /* @__PURE__ */ new Set(), this.dialCodeMaxLen = 0, this.dialCodeToIso2Map = {};
    for (const e of this.countries)
      this.dialCodes.has(e.dialCode) || this.dialCodes.add(e.dialCode), this._addToDialCodeMap(e.iso2, e.dialCode, e.priority);
    (this.options.onlyCountries.length || this.options.excludeCountries.length) && this.dialCodes.forEach((e) => {
      this.dialCodeToIso2Map[e] = this.dialCodeToIso2Map[e].filter(Boolean);
    });
    for (const e of this.countries)
      if (e.areaCodes) {
        const n = this.dialCodeToIso2Map[e.dialCode][0];
        for (const a of e.areaCodes) {
          for (let o = 1; o < a.length; o++) {
            const r = a.substring(0, o), i = e.dialCode + r;
            this._addToDialCodeMap(n, i), this._addToDialCodeMap(e.iso2, i);
          }
          this._addToDialCodeMap(e.iso2, e.dialCode + a);
        }
      }
  }
  //* Generate all of the markup for the plugin: the selected country overlay, and the dropdown.
  _generateMarkup() {
    this.telInput.classList.add("iti__tel-input"), !this.telInput.hasAttribute("autocomplete") && !(this.telInput.form && this.telInput.form.hasAttribute("autocomplete")) && this.telInput.setAttribute("autocomplete", "off");
    const {
      allowDropdown: e,
      separateDialCode: n,
      showFlags: a,
      containerClass: o,
      hiddenInput: r,
      dropdownContainer: i,
      fixDropdownWidth: s,
      useFullscreenPopup: l,
      countrySearch: c,
      i18n: u
    } = this.options, d = $n._buildClassNames({
      iti: !0,
      "iti--allow-dropdown": e,
      "iti--show-flags": a,
      "iti--inline-dropdown": !l,
      [o]: !!o
    }), h = oe("div", { class: d });
    if (this.telInput.parentNode?.insertBefore(h, this.telInput), e || a || n) {
      this.countryContainer = oe(
        "div",
        // visibly hidden until we measure it's width to set the input padding correctly
        { class: "iti__country-container iti__v-hide" },
        h
      ), this.showSelectedCountryOnLeft ? this.countryContainer.style.left = "0px" : this.countryContainer.style.right = "0px", e ? (this.selectedCountry = oe(
        "button",
        {
          type: "button",
          class: "iti__selected-country",
          "aria-expanded": "false",
          "aria-label": this.options.i18n.noCountrySelected,
          "aria-haspopup": "dialog",
          "aria-controls": `iti-${this.id}__dropdown-content`
        },
        this.countryContainer
      ), this.telInput.disabled && this.selectedCountry.setAttribute("disabled", "true")) : this.selectedCountry = oe(
        "div",
        { class: "iti__selected-country" },
        this.countryContainer
      );
      const f = oe(
        "div",
        { class: "iti__selected-country-primary" },
        this.selectedCountry
      );
      if (this.selectedCountryInner = oe(
        "div",
        { class: "iti__flag" },
        f
      ), e && (this.dropdownArrow = oe(
        "div",
        { class: "iti__arrow", "aria-hidden": "true" },
        f
      )), n && (this.selectedDialCode = oe(
        "div",
        { class: "iti__selected-dial-code", dir: "ltr" },
        this.selectedCountry
      )), e) {
        const m = s ? "" : "iti--flexible-dropdown-width";
        if (this.dropdownContent = oe("div", {
          id: `iti-${this.id}__dropdown-content`,
          class: `iti__dropdown-content iti__hide ${m}`,
          role: "dialog",
          "aria-modal": "true"
        }), c) {
          const b = oe(
            "div",
            { class: "iti__search-input-wrapper" },
            this.dropdownContent
          );
          this.searchIcon = oe(
            "span",
            {
              class: "iti__search-icon",
              "aria-hidden": "true"
            },
            b
          ), this.searchIcon.innerHTML = `
            <svg class="iti__search-icon-svg" width="14" height="14" viewBox="0 0 24 24" focusable="false" aria-hidden="true">
              <circle cx="11" cy="11" r="7" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>`, this.searchInput = oe(
            "input",
            {
              id: `iti-${this.id}__search-input`,
              // Chrome says inputs need either a name or an id
              type: "search",
              class: "iti__search-input",
              placeholder: u.searchPlaceholder,
              // role=combobox + aria-autocomplete=list + aria-activedescendant allows maintaining focus on the search input while allowing users to navigate search results with up/down keyboard keys
              role: "combobox",
              "aria-expanded": "true",
              "aria-label": u.searchPlaceholder,
              "aria-controls": `iti-${this.id}__country-listbox`,
              "aria-autocomplete": "list",
              autocomplete: "off"
            },
            b
          ), this.searchClearButton = oe(
            "button",
            {
              type: "button",
              class: "iti__search-clear iti__hide",
              "aria-label": u.clearSearchAriaLabel,
              tabindex: "-1"
            },
            b
          );
          const w = `iti-${this.id}-clear-mask`;
          this.searchClearButton.innerHTML = `
            <svg class="iti__search-clear-svg" width="12" height="12" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
              <mask id="${w}" maskUnits="userSpaceOnUse">
                <rect width="16" height="16" fill="white" />
                <path d="M5.2 5.2 L10.8 10.8 M10.8 5.2 L5.2 10.8" stroke="black" stroke-linecap="round" class="iti__search-clear-x" />
              </mask>
              <circle cx="8" cy="8" r="8" class="iti__search-clear-bg" mask="url(#${w})" />
            </svg>`, this.searchResultsA11yText = oe(
            "span",
            { class: "iti__a11y-text" },
            this.dropdownContent
          ), this.searchNoResults = oe(
            "div",
            {
              class: "iti__no-results iti__hide",
              "aria-hidden": "true"
              // all a11y messaging happens in this.searchResultsA11yText
            },
            this.dropdownContent
          ), this.searchNoResults.textContent = u.zeroSearchResults;
        }
        if (this.countryList = oe(
          "ul",
          {
            class: "iti__country-list",
            id: `iti-${this.id}__country-listbox`,
            role: "listbox",
            "aria-label": u.countryListAriaLabel
          },
          this.dropdownContent
        ), this._appendListItems(), c && this._updateSearchResultsA11yText(), i) {
          const b = $n._buildClassNames({
            iti: !0,
            "iti--container": !0,
            "iti--fullscreen-popup": l,
            "iti--inline-dropdown": !l,
            [o]: !!o
          });
          this.dropdown = oe("div", { class: b }), this.dropdown.appendChild(this.dropdownContent);
        } else
          this.countryContainer.appendChild(this.dropdownContent);
      }
    }
    if (h.appendChild(this.telInput), this.countryContainer && (this._updateInputPadding(), this.countryContainer.classList.remove("iti__v-hide")), r) {
      const f = this.telInput.getAttribute("name") || "", m = r(f);
      if (m.phone) {
        const b = this.telInput.form?.querySelector(`input[name="${m.phone}"]`);
        b ? this.hiddenInput = b : (this.hiddenInput = oe("input", {
          type: "hidden",
          name: m.phone
        }), h.appendChild(this.hiddenInput));
      }
      if (m.country) {
        const b = this.telInput.form?.querySelector(`input[name="${m.country}"]`);
        b ? this.hiddenInputCountry = b : (this.hiddenInputCountry = oe("input", {
          type: "hidden",
          name: m.country
        }), h.appendChild(this.hiddenInputCountry));
      }
    }
  }
  //* For each country: add a country list item <li> to the countryList <ul> container.
  _appendListItems() {
    for (let e = 0; e < this.countries.length; e++) {
      const n = this.countries[e], a = e === 0 ? "iti__highlight" : "", o = oe(
        "li",
        {
          id: `iti-${this.id}__item-${n.iso2}`,
          class: `iti__country ${a}`,
          tabindex: "-1",
          role: "option",
          "data-dial-code": n.dialCode,
          "data-country-code": n.iso2,
          "aria-selected": "false"
        },
        this.countryList
      );
      n.nodeById[this.id] = o;
      let r = "";
      this.options.showFlags && (r += `<div class='iti__flag iti__${n.iso2}'></div>`), r += `<span class='iti__country-name'>${n.name}</span>`, r += `<span class='iti__dial-code' dir='ltr'>+${n.dialCode}</span>`, o.insertAdjacentHTML("beforeend", r);
    }
  }
  //* Set the initial state of the input value and the selected country by:
  //* 1. Extracting a dial code from the given number
  //* 2. Using explicit initialCountry
  _setInitialState(e = !1) {
    const n = this.telInput.getAttribute("value"), a = this.telInput.value, o = n && n.charAt(0) === "+" && (!a || a.charAt(0) !== "+") ? n : a, r = this._getDialCode(o), i = Ca(o), { initialCountry: s, geoIpLookup: l } = this.options, c = s === "auto" && l;
    if (r && !i)
      this._updateCountryFromNumber(o);
    else if (!c || e) {
      const u = s ? s.toLowerCase() : "";
      u && this._getCountryData(u, !0) ? this._setCountry(u) : r && i ? this._setCountry("us") : this._setCountry();
    }
    o && this._updateValFromNumber(o);
  }
  //* Initialise the main event listeners: input keyup, and click selected country.
  _initListeners() {
    this._initTelInputListeners(), this.options.allowDropdown && this._initDropdownListeners(), (this.hiddenInput || this.hiddenInputCountry) && this.telInput.form && this._initHiddenInputListener();
  }
  //* Update hidden input on form submit.
  _initHiddenInputListener() {
    this._handleHiddenInputSubmit = () => {
      this.hiddenInput && (this.hiddenInput.value = this.getNumber()), this.hiddenInputCountry && (this.hiddenInputCountry.value = this.getSelectedCountryData().iso2 || "");
    }, this.telInput.form?.addEventListener(
      "submit",
      this._handleHiddenInputSubmit
    );
  }
  //* initialise the dropdown listeners.
  _initDropdownListeners() {
    this._handleLabelClick = (n) => {
      this.dropdownContent.classList.contains("iti__hide") ? this.telInput.focus() : n.preventDefault();
    };
    const e = this.telInput.closest("label");
    e && e.addEventListener("click", this._handleLabelClick), this._handleClickSelectedCountry = () => {
      this.dropdownContent.classList.contains("iti__hide") && !this.telInput.disabled && !this.telInput.readOnly && this._openDropdown();
    }, this.selectedCountry.addEventListener("click", this._handleClickSelectedCountry), this._handleCountryContainerKeydown = (n) => {
      this.dropdownContent.classList.contains("iti__hide") && ["ArrowUp", "ArrowDown", " ", "Enter"].includes(n.key) && (n.preventDefault(), n.stopPropagation(), this._openDropdown()), n.key === "Tab" && this._closeDropdown();
    }, this.countryContainer.addEventListener(
      "keydown",
      this._handleCountryContainerKeydown
    );
  }
  //* Init many requests: utils script / geo ip lookup.
  _initRequests() {
    let { loadUtils: e, initialCountry: n, geoIpLookup: a } = this.options;
    e && !E.utils ? (this._handlePageLoad = () => {
      window.removeEventListener("load", this._handlePageLoad), E.attachUtils(e)?.catch(() => {
      });
    }, E.documentReady() ? this._handlePageLoad() : window.addEventListener("load", this._handlePageLoad)) : this.resolveUtilsScriptPromise(), n === "auto" && a && !this.selectedCountryData.iso2 ? this._loadAutoCountry() : this.resolveAutoCountryPromise();
  }
  //* Perform the geo ip lookup.
  _loadAutoCountry() {
    E.autoCountry ? this.handleAutoCountry() : E.startedLoadingAutoCountry || (E.startedLoadingAutoCountry = !0, typeof this.options.geoIpLookup == "function" && this.options.geoIpLookup(
      (e = "") => {
        const n = e.toLowerCase();
        n && this._getCountryData(n, !0) ? (E.autoCountry = n, setTimeout(() => gt("handleAutoCountry"))) : (this._setInitialState(!0), gt("rejectAutoCountryPromise"));
      },
      () => {
        this._setInitialState(!0), gt("rejectAutoCountryPromise");
      }
    ));
  }
  _openDropdownWithPlus() {
    this._openDropdown(), this.searchInput.value = "+", this._filterCountries("");
  }
  //* Initialize the tel input listeners.
  _initTelInputListeners() {
    const { strictMode: e, formatAsYouType: n, separateDialCode: a, allowDropdown: o, countrySearch: r } = this.options;
    let i = !1;
    new RegExp("\\p{L}", "u").test(this.telInput.value) && (i = !0), this._handleInputEvent = (s) => {
      if (this.isAndroid && s?.data === "+" && a && o && r) {
        const d = this.telInput.selectionStart || 0, h = this.telInput.value.substring(0, d - 1), f = this.telInput.value.substring(d);
        this.telInput.value = h + f, this._openDropdownWithPlus();
        return;
      }
      this._updateCountryFromNumber(this.telInput.value) && this._triggerCountryChange();
      const l = s?.data && /[^+0-9]/.test(s.data), c = s?.inputType === "insertFromPaste" && this.telInput.value;
      l || c && !e ? i = !0 : /[^+0-9]/.test(this.telInput.value) || (i = !1);
      const u = s?.detail && s.detail.isSetNumber;
      if (n && !i && !u) {
        const d = this.telInput.selectionStart || 0, h = this.telInput.value.substring(0, d).replace(/[^+0-9]/g, "").length, f = s?.inputType === "deleteContentForward", m = this._formatNumberAsYouType(), b = Fl(h, m, d, f);
        this.telInput.value = m, this.telInput.setSelectionRange(b, b);
      }
    }, this.telInput.addEventListener("input", this._handleInputEvent), (e || a) && (this._handleKeydownEvent = (s) => {
      if (s.key && s.key.length === 1 && !s.altKey && !s.ctrlKey && !s.metaKey) {
        if (a && o && r && s.key === "+") {
          s.preventDefault(), this._openDropdownWithPlus();
          return;
        }
        if (e) {
          const l = this.telInput.value, c = l.charAt(0) !== "+" && this.telInput.selectionStart === 0 && s.key === "+", u = /^[0-9]$/.test(s.key), d = a ? u : c || u, h = l.slice(0, this.telInput.selectionStart) + s.key + l.slice(this.telInput.selectionEnd), f = this._getFullNumber(h), m = E.utils.getCoreNumber(f, this.selectedCountryData.iso2), b = this.maxCoreNumberLength && m.length > this.maxCoreNumberLength, w = this._getNewCountryFromNumber(f) !== null;
          (!d || b && !w && !c) && s.preventDefault();
        }
      }
    }, this.telInput.addEventListener("keydown", this._handleKeydownEvent));
  }
  //* Adhere to the input's maxlength attr.
  _cap(e) {
    const n = parseInt(this.telInput.getAttribute("maxlength") || "", 10);
    return n && e.length > n ? e.substring(0, n) : e;
  }
  //* Trigger a custom event on the input.
  _trigger(e, n = {}) {
    const a = new CustomEvent(e, {
      bubbles: !0,
      cancelable: !0,
      detail: n
    });
    this.telInput.dispatchEvent(a);
  }
  //* Open the dropdown.
  _openDropdown() {
    const { fixDropdownWidth: e, countrySearch: n } = this.options;
    if (e && (this.dropdownContent.style.width = `${this.telInput.offsetWidth}px`), this.dropdownContent.classList.remove("iti__hide"), this.selectedCountry.setAttribute("aria-expanded", "true"), this._setDropdownPosition(), n) {
      const a = this.countryList.firstElementChild;
      a && (this._highlightListItem(a, !1), this.countryList.scrollTop = 0), this.searchInput.focus();
    }
    this._bindDropdownListeners(), this.dropdownArrow.classList.add("iti__arrow--up"), this._trigger("open:countrydropdown");
  }
  //* Set the dropdown position
  _setDropdownPosition() {
    if (this.options.dropdownContainer && this.options.dropdownContainer.appendChild(this.dropdown), !this.options.useFullscreenPopup) {
      const e = this.telInput.getBoundingClientRect(), n = this.telInput.offsetHeight;
      this.options.dropdownContainer && (this.dropdown.style.top = `${e.top + n}px`, this.dropdown.style.left = `${e.left}px`, this._handleWindowScroll = () => this._closeDropdown(), window.addEventListener("scroll", this._handleWindowScroll));
    }
  }
  //* We only bind dropdown listeners when the dropdown is open.
  _bindDropdownListeners() {
    this._handleMouseoverCountryList = (a) => {
      const o = a.target?.closest(".iti__country");
      o && this._highlightListItem(o, !1);
    }, this.countryList.addEventListener(
      "mouseover",
      this._handleMouseoverCountryList
    ), this._handleClickCountryList = (a) => {
      const o = a.target?.closest(".iti__country");
      o && this._selectListItem(o);
    }, this.countryList.addEventListener("click", this._handleClickCountryList), this._handleClickOffToClose = (a) => {
      a.target.closest(`#iti-${this.id}__dropdown-content`) || this._closeDropdown();
    }, setTimeout(() => {
      document.documentElement.addEventListener(
        "click",
        this._handleClickOffToClose
      );
    }, 0);
    let e = "", n = null;
    if (this._handleKeydownOnDropdown = (a) => {
      ["ArrowUp", "ArrowDown", "Enter", "Escape"].includes(a.key) && (a.preventDefault(), a.stopPropagation(), a.key === "ArrowUp" || a.key === "ArrowDown" ? this._handleUpDownKey(a.key) : a.key === "Enter" ? this._handleEnterKey() : a.key === "Escape" && this._closeDropdown()), !this.options.countrySearch && /^[a-zA-ZÀ-ÿа-яА-Я ]$/.test(a.key) && (a.stopPropagation(), n && clearTimeout(n), e += a.key.toLowerCase(), this._searchForCountry(e), n = setTimeout(() => {
        e = "";
      }, 1e3));
    }, document.addEventListener("keydown", this._handleKeydownOnDropdown), this.options.countrySearch) {
      const a = () => {
        const r = this.searchInput.value.trim();
        this._filterCountries(r), this.searchInput.value ? this.searchClearButton.classList.remove("iti__hide") : this.searchClearButton.classList.add("iti__hide");
      };
      let o = null;
      this._handleSearchChange = () => {
        o && clearTimeout(o), o = setTimeout(() => {
          a(), o = null;
        }, 100);
      }, this.searchInput.addEventListener("input", this._handleSearchChange), this._handleSearchClear = () => {
        this.searchInput.value = "", this.searchInput.focus(), a();
      }, this.searchClearButton.addEventListener("click", this._handleSearchClear);
    }
  }
  //* Hidden search (countrySearch disabled): Find the first list item whose name starts with the query string.
  _searchForCountry(e) {
    for (const n of this.countries)
      if (n.name.substring(0, e.length).toLowerCase() === e) {
        const a = n.nodeById[this.id];
        this._highlightListItem(a, !1), this._scrollTo(a);
        break;
      }
  }
  //* Country search enabled: Filter the countries according to the search query.
  _filterCountries(e) {
    let n = !0;
    this.countryList.innerHTML = "";
    const a = $a(e);
    let o;
    if (e === "")
      o = this.countries;
    else {
      const r = [], i = [], s = [], l = [], c = [], u = [];
      for (const d of this.countries)
        d.iso2 === a ? r.push(d) : d.normalisedName.startsWith(a) ? i.push(d) : d.normalisedName.includes(a) ? s.push(d) : a === d.dialCode || a === d.dialCodePlus ? l.push(d) : d.dialCodePlus.includes(a) ? c.push(d) : d.initials.includes(a) && u.push(d);
      o = [
        ...r.sort((d, h) => d.priority - h.priority),
        ...i.sort((d, h) => d.priority - h.priority),
        ...s.sort((d, h) => d.priority - h.priority),
        ...l.sort((d, h) => d.priority - h.priority),
        ...c.sort((d, h) => d.priority - h.priority),
        ...u.sort((d, h) => d.priority - h.priority)
      ];
    }
    for (const r of o) {
      const i = r.nodeById[this.id];
      i && (this.countryList.appendChild(i), n && (this._highlightListItem(i, !1), n = !1));
    }
    n ? (this._highlightListItem(null, !1), this.searchNoResults && this.searchNoResults.classList.remove("iti__hide")) : this.searchNoResults && this.searchNoResults.classList.add("iti__hide"), this.countryList.scrollTop = 0, this._updateSearchResultsA11yText();
  }
  //* Update search results text (for a11y).
  _updateSearchResultsA11yText() {
    const { i18n: e } = this.options, n = this.countryList.childElementCount;
    let a;
    n === 0 ? a = e.zeroSearchResults : e.searchResultsText ? a = e.searchResultsText(n) : n === 1 ? a = e.oneSearchResult : a = e.multipleSearchResults.replace("${count}", n.toString()), this.searchResultsA11yText.textContent = a;
  }
  //* Highlight the next/prev item in the list (and ensure it is visible).
  _handleUpDownKey(e) {
    let n = e === "ArrowUp" ? this.highlightedItem?.previousElementSibling : this.highlightedItem?.nextElementSibling;
    !n && this.countryList.childElementCount > 1 && (n = e === "ArrowUp" ? this.countryList.lastElementChild : this.countryList.firstElementChild), n && (this._scrollTo(n), this._highlightListItem(n, !1));
  }
  //* Select the currently highlighted item.
  _handleEnterKey() {
    this.highlightedItem && this._selectListItem(this.highlightedItem);
  }
  //* Update the input's value to the given val (format first if possible)
  //* NOTE: this is called from _setInitialState, handleUtils and setNumber.
  _updateValFromNumber(e) {
    let n = e;
    if (this.options.formatOnDisplay && E.utils && this.selectedCountryData) {
      const a = this.options.nationalMode || n.charAt(0) !== "+" && !this.options.separateDialCode, { NATIONAL: o, INTERNATIONAL: r } = E.utils.numberFormat, i = a ? o : r;
      n = E.utils.formatNumber(
        n,
        this.selectedCountryData.iso2,
        i
      );
    }
    n = this._beforeSetNumber(n), this.telInput.value = n;
  }
  //* Check if need to select a new country based on the given number
  //* Note: called from _setInitialState, keyup handler, setNumber.
  _updateCountryFromNumber(e) {
    const n = this._getNewCountryFromNumber(e);
    return n !== null ? this._setCountry(n) : !1;
  }
  _ensureHasDialCode(e) {
    const { dialCode: n, nationalPrefix: a } = this.selectedCountryData;
    if (e.charAt(0) === "+" || !n)
      return e;
    const o = a && e.charAt(0) === a && !this.options.separateDialCode ? e.substring(1) : e;
    return `+${n}${o}`;
  }
  // Get the country ISO2 code from the given number
  // BUT ONLY IF ITS CHANGED FROM THE CURRENTLY SELECTED COUNTRY
  // NOTE: consider refactoring this to be more clear
  _getNewCountryFromNumber(e) {
    const n = e.indexOf("+");
    let a = n ? e.substring(n) : e;
    const o = this.selectedCountryData.iso2, r = this.selectedCountryData.dialCode;
    a = this._ensureHasDialCode(a);
    const i = this._getDialCode(a, !0), s = Mt(a);
    if (i) {
      const l = Mt(i), c = this.dialCodeToIso2Map[l];
      if (c.length === 1)
        return c[0] === o ? null : c[0];
      if (!o && this.defaultCountry && c.includes(this.defaultCountry))
        return this.defaultCountry;
      if (r === "1" && Ca(s))
        return null;
      const u = this.selectedCountryData.areaCodes && s.length > l.length;
      if (!(o && c.includes(o) && !u))
        return c[0];
    } else {
      if (a.charAt(0) === "+" && s.length)
        return "";
      if ((!a || a === "+") && !o)
        return this.defaultCountry;
    }
    return null;
  }
  //* Remove highlighting from other list items and highlight the given item.
  _highlightListItem(e, n) {
    const a = this.highlightedItem;
    if (a && (a.classList.remove("iti__highlight"), a.setAttribute("aria-selected", "false")), this.highlightedItem = e, this.highlightedItem && (this.highlightedItem.classList.add("iti__highlight"), this.highlightedItem.setAttribute("aria-selected", "true"), this.options.countrySearch)) {
      const o = this.highlightedItem.getAttribute("id") || "";
      this.searchInput.setAttribute("aria-activedescendant", o);
    }
    n && this.highlightedItem.focus();
  }
  //* Find the country data for the given iso2 code
  //* the allowFail option is only used during init() for the initialCountry option, and for the iso2 returned from geoIpLookup - in these 2 cases we don't want to error out
  _getCountryData(e, n) {
    const a = this.countryByIso2.get(e);
    if (a)
      return a;
    if (n)
      return null;
    throw new Error(`No country data for '${e}'`);
  }
  //* Update the selected country, dial code (if separateDialCode), placeholder, title, and active list item.
  //* Note: called from _setInitialState, _updateCountryFromNumber, _selectListItem, setCountry.
  _setCountry(e) {
    const { separateDialCode: n, showFlags: a, i18n: o } = this.options, r = this.selectedCountryData.iso2 || "";
    if (this.selectedCountryData = e ? this._getCountryData(e, !1) || {} : {}, this.selectedCountryData.iso2 && (this.defaultCountry = this.selectedCountryData.iso2), this.selectedCountry) {
      const i = e && a ? `iti__flag iti__${e}` : "iti__flag iti__globe";
      let s, l;
      if (e) {
        const { name: c, dialCode: u } = this.selectedCountryData;
        l = c, s = o.selectedCountryAriaLabel.replace("${countryName}", c).replace("${dialCode}", `+${u}`);
      } else
        l = o.noCountrySelected, s = o.noCountrySelected;
      this.selectedCountryInner.className = i, this.selectedCountry.setAttribute("title", l), this.selectedCountry.setAttribute("aria-label", s);
    }
    if (n) {
      const i = this.selectedCountryData.dialCode ? `+${this.selectedCountryData.dialCode}` : "";
      this.selectedDialCode.innerHTML = i, this._updateInputPadding();
    }
    return this._updatePlaceholder(), this._updateMaxLength(), r !== e;
  }
  //* Update the input padding to make space for the selected country/dial code.
  _updateInputPadding() {
    if (this.selectedCountry) {
      const e = this.options.separateDialCode ? 78 : 42, n = (this.selectedCountry.offsetWidth || this._getHiddenSelectedCountryWidth() || e) + 6;
      this.showSelectedCountryOnLeft ? this.telInput.style.paddingLeft = `${n}px` : this.telInput.style.paddingRight = `${n}px`;
    }
  }
  //* Update the maximum valid number length for the currently selected country.
  _updateMaxLength() {
    const { strictMode: e, placeholderNumberType: n, validationNumberTypes: a } = this.options, { iso2: o } = this.selectedCountryData;
    if (e && E.utils)
      if (o) {
        const r = E.utils.numberType[n];
        let i = E.utils.getExampleNumber(
          o,
          !1,
          r,
          !0
        ), s = i;
        for (; E.utils.isPossibleNumber(i, o, a); )
          s = i, i += "0";
        const l = E.utils.getCoreNumber(s, o);
        this.maxCoreNumberLength = l.length, o === "by" && (this.maxCoreNumberLength = l.length + 1);
      } else
        this.maxCoreNumberLength = null;
  }
  //* When input is in a hidden container during init, we cannot calculate the selected country width.
  //* Fix: clone the markup, make it invisible, add it to the end of the DOM, and then measure it's width.
  //* To get the right styling to apply, all we need is a shallow clone of the container,
  //* and then to inject a deep clone of the selectedCountry element.
  _getHiddenSelectedCountryWidth() {
    if (this.telInput.parentNode) {
      let e;
      try {
        e = window.top.document.body;
      } catch {
        e = document.body;
      }
      const n = this.telInput.parentNode.cloneNode(!1);
      n.style.visibility = "hidden", e.appendChild(n);
      const a = this.countryContainer.cloneNode();
      n.appendChild(a);
      const o = this.selectedCountry.cloneNode(!0);
      a.appendChild(o);
      const r = o.offsetWidth;
      return e.removeChild(n), r;
    }
    return 0;
  }
  //* Update the input placeholder to an example number from the currently selected country.
  _updatePlaceholder() {
    const {
      autoPlaceholder: e,
      placeholderNumberType: n,
      nationalMode: a,
      customPlaceholder: o
    } = this.options, r = e === "aggressive" || !this.hadInitialPlaceholder && e === "polite";
    if (E.utils && r) {
      const i = E.utils.numberType[n];
      let s = this.selectedCountryData.iso2 ? E.utils.getExampleNumber(
        this.selectedCountryData.iso2,
        a,
        i
      ) : "";
      s = this._beforeSetNumber(s), typeof o == "function" && (s = o(s, this.selectedCountryData)), this.telInput.setAttribute("placeholder", s);
    }
  }
  //* Called when the user selects a list item from the dropdown.
  _selectListItem(e) {
    const n = this._setCountry(
      e.getAttribute("data-country-code")
    );
    this._closeDropdown(), this._updateDialCode(e.getAttribute("data-dial-code")), this.options.formatOnDisplay && this._updateValFromNumber(this.telInput.value), this.telInput.focus(), n && this._triggerCountryChange();
  }
  //* Close the dropdown and unbind any listeners.
  _closeDropdown() {
    this.dropdownContent.classList.add("iti__hide"), this.selectedCountry.setAttribute("aria-expanded", "false"), this.highlightedItem && this.highlightedItem.setAttribute("aria-selected", "false"), this.options.countrySearch && this.searchInput.removeAttribute("aria-activedescendant"), this.dropdownArrow.classList.remove("iti__arrow--up"), this.options.countrySearch && (this.searchInput.removeEventListener("input", this._handleSearchChange), this.searchClearButton.removeEventListener("click", this._handleSearchClear)), document.documentElement.removeEventListener(
      "click",
      this._handleClickOffToClose
    ), this.countryList.removeEventListener(
      "mouseover",
      this._handleMouseoverCountryList
    ), this.countryList.removeEventListener("click", this._handleClickCountryList), this.options.dropdownContainer && (this.options.useFullscreenPopup || window.removeEventListener("scroll", this._handleWindowScroll), this.dropdown.parentNode && this.dropdown.parentNode.removeChild(this.dropdown)), this._handlePageLoad && window.removeEventListener("load", this._handlePageLoad), this._trigger("close:countrydropdown");
  }
  //* Check if an element is visible within it's container, else scroll until it is.
  _scrollTo(e) {
    const n = this.countryList, a = document.documentElement.scrollTop, o = n.offsetHeight, r = n.getBoundingClientRect().top + a, i = r + o, s = e.offsetHeight, l = e.getBoundingClientRect().top + a, c = l + s, u = l - r + n.scrollTop;
    if (l < r)
      n.scrollTop = u;
    else if (c > i) {
      const d = o - s;
      n.scrollTop = u - d;
    }
  }
  //* Replace any existing dial code with the new one
  //* Note: called from _selectListItem and setCountry
  _updateDialCode(e) {
    const n = this.telInput.value, a = `+${e}`;
    let o;
    if (n.charAt(0) === "+") {
      const r = this._getDialCode(n);
      r ? o = n.replace(r, a) : o = a, this.telInput.value = o;
    }
  }
  //* Try and extract a valid international dial code from a full telephone number.
  //* Note: returns the raw string inc plus character and any whitespace/dots etc.
  _getDialCode(e, n) {
    let a = "";
    if (e.charAt(0) === "+") {
      let o = "";
      for (let r = 0; r < e.length; r++) {
        const i = e.charAt(r);
        if (!isNaN(parseInt(i, 10))) {
          if (o += i, n)
            this.dialCodeToIso2Map[o] && (a = e.substring(0, r + 1));
          else if (this.dialCodes.has(o)) {
            a = e.substring(0, r + 1);
            break;
          }
          if (o.length === this.dialCodeMaxLen)
            break;
        }
      }
    }
    return a;
  }
  //* Get the input val, adding the dial code if separateDialCode is enabled.
  _getFullNumber(e) {
    const n = e || this.telInput.value.trim(), { dialCode: a } = this.selectedCountryData;
    let o;
    const r = Mt(n);
    return this.options.separateDialCode && n.charAt(0) !== "+" && a && r ? o = `+${a}` : o = "", o + n;
  }
  //* Remove the dial code if separateDialCode is enabled also cap the length if the input has a maxlength attribute
  _beforeSetNumber(e) {
    let n = e;
    if (this.options.separateDialCode) {
      let a = this._getDialCode(n);
      if (a) {
        a = `+${this.selectedCountryData.dialCode}`;
        const o = n[a.length] === " " || n[a.length] === "-" ? a.length + 1 : a.length;
        n = n.substring(o);
      }
    }
    return this._cap(n);
  }
  //* Trigger the 'countrychange' event.
  _triggerCountryChange() {
    this._trigger("countrychange");
  }
  //* Format the number as the user types.
  _formatNumberAsYouType() {
    const e = this._getFullNumber(), n = E.utils ? E.utils.formatNumberAsYouType(e, this.selectedCountryData.iso2) : e, { dialCode: a } = this.selectedCountryData;
    return this.options.separateDialCode && this.telInput.value.charAt(0) !== "+" && n.includes(`+${a}`) ? (n.split(`+${a}`)[1] || "").trim() : n;
  }
  //**************************
  //*  SECRET PUBLIC METHODS
  //**************************
  //* This is called when the geoip call returns.
  handleAutoCountry() {
    this.options.initialCountry === "auto" && E.autoCountry && (this.defaultCountry = E.autoCountry, this.selectedCountryData.iso2 || this.selectedCountryInner.classList.contains("iti__globe") || this.setCountry(this.defaultCountry), this.resolveAutoCountryPromise());
  }
  //* This is called when the utils request completes.
  handleUtils() {
    E.utils && (this.telInput.value && this._updateValFromNumber(this.telInput.value), this.selectedCountryData.iso2 && (this._updatePlaceholder(), this._updateMaxLength())), this.resolveUtilsScriptPromise();
  }
  //********************
  //*  PUBLIC METHODS
  //********************
  //* Remove plugin.
  destroy() {
    this.telInput.iti = void 0;
    const { allowDropdown: e, separateDialCode: n } = this.options;
    if (e) {
      this._closeDropdown(), this.selectedCountry.removeEventListener(
        "click",
        this._handleClickSelectedCountry
      ), this.countryContainer.removeEventListener(
        "keydown",
        this._handleCountryContainerKeydown
      );
      const r = this.telInput.closest("label");
      r && r.removeEventListener("click", this._handleLabelClick);
    }
    const { form: a } = this.telInput;
    this._handleHiddenInputSubmit && a && a.removeEventListener("submit", this._handleHiddenInputSubmit), this.telInput.removeEventListener("input", this._handleInputEvent), this._handleKeydownEvent && this.telInput.removeEventListener("keydown", this._handleKeydownEvent), this.telInput.removeAttribute("data-intl-tel-input-id"), n && (this.isRTL ? this.telInput.style.paddingRight = this.originalPaddingRight : this.telInput.style.paddingLeft = this.originalPaddingLeft);
    const o = this.telInput.parentNode;
    o?.parentNode?.insertBefore(this.telInput, o), o?.parentNode?.removeChild(o), delete E.instances[this.id];
  }
  //* Get the extension from the current number.
  getExtension() {
    return E.utils ? E.utils.getExtension(
      this._getFullNumber(),
      this.selectedCountryData.iso2
    ) : "";
  }
  //* Format the number to the given format.
  getNumber(e) {
    if (E.utils) {
      const { iso2: n } = this.selectedCountryData;
      return E.utils.formatNumber(
        this._getFullNumber(),
        n,
        e
      );
    }
    return "";
  }
  //* Get the type of the entered number e.g. landline/mobile.
  getNumberType() {
    return E.utils ? E.utils.getNumberType(
      this._getFullNumber(),
      this.selectedCountryData.iso2
    ) : -99;
  }
  //* Get the country data for the currently selected country.
  getSelectedCountryData() {
    return this.selectedCountryData;
  }
  //* Get the validation error.
  getValidationError() {
    if (E.utils) {
      const { iso2: e } = this.selectedCountryData;
      return E.utils.getValidationError(this._getFullNumber(), e);
    }
    return -99;
  }
  //* Validate the input val (with precise=false)
  isValidNumber() {
    return this._validateNumber(!1);
  }
  //* Validate the input val (with precise=true)
  isValidNumberPrecise() {
    return this._validateNumber(!0);
  }
  _utilsIsPossibleNumber(e) {
    return E.utils ? E.utils.isPossibleNumber(e, this.selectedCountryData.iso2, this.options.validationNumberTypes) : null;
  }
  //* Shared internal validation logic to handle alpha character extension rules.
  _validateNumber(e) {
    if (!this.selectedCountryData.iso2)
      return !1;
    const n = (r) => e ? this._utilsIsValidNumber(r) : this._utilsIsPossibleNumber(r), a = this._getFullNumber(), o = a.search(new RegExp("\\p{L}", "u"));
    if (o > -1 && !this.options.allowPhonewords) {
      const r = a.substring(0, o), i = n(r), s = n(a);
      return i && s;
    }
    return n(a);
  }
  _utilsIsValidNumber(e) {
    return E.utils ? E.utils.isValidNumber(e, this.selectedCountryData.iso2, this.options.validationNumberTypes) : null;
  }
  //* Update the selected country, and update the input val accordingly.
  setCountry(e) {
    const n = e?.toLowerCase(), a = this.selectedCountryData.iso2;
    (e && n !== a || !e && a) && (this._setCountry(n), this._updateDialCode(this.selectedCountryData.dialCode), this.options.formatOnDisplay && this._updateValFromNumber(this.telInput.value), this._triggerCountryChange());
  }
  //* Set the input value and update the country.
  setNumber(e) {
    const n = this._updateCountryFromNumber(e);
    this._updateValFromNumber(e), n && this._triggerCountryChange(), this._trigger("input", { isSetNumber: !0 });
  }
  //* Set the placeholder number typ
  setPlaceholderNumberType(e) {
    this.options.placeholderNumberType = e, this._updatePlaceholder();
  }
  setDisabled(e) {
    this.telInput.disabled = e, e ? this.selectedCountry.setAttribute("disabled", "true") : this.selectedCountry.removeAttribute("disabled");
  }
}, Gl = (t) => {
  if (!E.utils && !E.startedLoadingUtilsScript) {
    let e;
    if (typeof t == "function")
      try {
        e = Promise.resolve(t());
      } catch (n) {
        return Promise.reject(n);
      }
    else
      return Promise.reject(new TypeError(`The argument passed to attachUtils must be a function that returns a promise for the utilities module, not ${typeof t}`));
    return E.startedLoadingUtilsScript = !0, e.then((n) => {
      const a = n?.default;
      if (!a || typeof a != "object")
        throw new TypeError("The loader function passed to attachUtils did not resolve to a module object with utils as its default export.");
      return E.utils = a, gt("handleUtils"), !0;
    }).catch((n) => {
      throw gt("rejectUtilsScriptPromise", n), n;
    });
  }
  return null;
}, E = Object.assign(
  (t, e) => {
    const n = new Vl(t, e);
    return n._init(), t.setAttribute("data-intl-tel-input-id", n.id.toString()), E.instances[n.id] = n, t.iti = n, n;
  },
  {
    defaults: sr,
    //* Using a static var like this allows us to mock it in the tests.
    documentReady: () => document.readyState === "complete",
    //* Get the country data object.
    getCountryData: () => dt,
    //* A getter for the plugin instance.
    getInstance: (t) => {
      const e = t.getAttribute("data-intl-tel-input-id");
      return e ? E.instances[e] : null;
    },
    //* A map from instance ID to instance object.
    instances: {},
    attachUtils: Gl,
    startedLoadingUtilsScript: !1,
    startedLoadingAutoCountry: !1,
    version: "25.10.6"
  }
), Ul = E, Zl = vt(function({
  initialValue: t = "",
  onChangeNumber: e = () => {
  },
  onChangeCountry: n = () => {
  },
  onChangeValidity: a = () => {
  },
  onChangeErrorCode: o = () => {
  },
  usePreciseValidation: r = !1,
  initOptions: i = {},
  inputProps: s = {},
  disabled: l = void 0
}, c) {
  const u = Et(null), d = Et(null);
  qr(c, () => ({
    getInstance: () => d.current,
    getInput: () => u.current
  }));
  const h = _o(() => {
    const f = d.current?.getNumber() || "", m = d.current?.getSelectedCountryData().iso2 || "";
    if (e(f), n(m), d.current)
      if (r ? d.current.isValidNumberPrecise() : d.current.isValidNumber())
        a(!0), o(null);
      else {
        const b = d.current.getValidationError();
        a(!1), o(b);
      }
  }, [n, o, e, a, r]);
  return Me(() => (u.current && (d.current = Ul(u.current, i)), () => {
    d.current?.destroy();
  }), []), Me(() => {
    const f = u.current;
    return f && (f.addEventListener("countrychange", h), d.current.promise.then(h)), () => {
      f && f.removeEventListener("countrychange", h);
    };
  }, [h]), Me(() => {
    d.current && l !== void 0 && d.current.setDisabled(l);
  }, [l]), /* @__PURE__ */ j.createElement(
    "input",
    {
      type: "tel",
      ref: u,
      onInput: h,
      defaultValue: t,
      ...s
    }
  );
}), Kl = Zl;
const Te = {
  "phone-number": "_phone-number_1ni27_30",
  "is-full-width": "_is-full-width_1ni27_41",
  "group-label": "_group-label_1ni27_44",
  "helper-text": "_helper-text_1ni27_53",
  "is-disabled": "_is-disabled_1ni27_58",
  "is-error": "_is-error_1ni27_73",
  "is-success": "_is-success_1ni27_144",
  "container-icon": "_container-icon_1ni27_166",
  "dialog-overlay-show": "_dialog-overlay-show_1ni27_1",
  "dialog-content-show": "_dialog-content-show_1ni27_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ni27_1"
};
vt(
  ({
    label: t,
    helperText: e,
    initialPhoneNumber: n,
    onChangePhoneNumber: a,
    initialCountry: o,
    onChangeCountry: r,
    locale: i = "en",
    message: s,
    status: l,
    disabled: c,
    isFullWidth: u,
    inputProps: d,
    setErrorCode: h,
    setIsValidPhoneNumber: f
  }, m) => {
    const { phoneNumber: b, country: w, handlePhoneNumberChange: I, handleCountryChange: k } = Xs({
      initialPhoneNumber: n,
      initialCountry: o,
      onChangePhoneNumber: a,
      onChangeCountry: r
    }), N = H(
      Te["phone-number"],
      c && Te["is-disabled"],
      l && Te[ka[l]],
      u && Te["is-full-width"]
    );
    return /* @__PURE__ */ B("div", { className: N, children: [
      /* @__PURE__ */ B("div", { className: Te["group-label"], children: [
        t && /* @__PURE__ */ y("label", { children: t }),
        e && /* @__PURE__ */ y("div", { className: Te["helper-text"], children: e })
      ] }),
      /* @__PURE__ */ y(
        Kl,
        {
          initialValue: b,
          onChangeErrorCode: h,
          onChangeValidity: f,
          onChangeCountry: k,
          onChangeNumber: I,
          inputProps: {
            disabled: c,
            "aria-label": d?.["aria-label"] || t,
            ...d
          },
          ref: m,
          initOptions: {
            strictMode: !0,
            initialCountry: w,
            i18n: Nl[i],
            useFullscreenPopup: !1,
            // Manually load the utils to prevent issues on SSR pages
            loadUtils: () => import("./utils-CaI5VMju-BMN_h3sy.js")
          }
        }
      ),
      s && l && !c && /* @__PURE__ */ B("div", { className: Te["container-icon"], children: [
        /* @__PURE__ */ y(Ke, { name: wa[l].name, size: "medium", color: wa[l].color }),
        /* @__PURE__ */ y("span", { className: Te[ka[l]], children: s })
      ] })
    ] });
  }
);
const ql = 0;
function Wl(t, e, n, a, o, r) {
  const [i, s] = Ce(!1), l = i ? n : a, [c, u] = Ce(l ? l.length : ql), [d, h] = Ce(!1);
  return {
    valueCounter: c,
    isOnBlur: d,
    hasLabelOrHelperText: !!(t ?? e),
    handleBlur: () => {
      h(!0), r?.();
    },
    handleChange: (f) => {
      s(!0), u(f.target.value.length), o && o(f), h(!1);
    }
  };
}
const Hl = "_container_1qc3k_29", Jl = "_filled_1qc3k_46", Yl = "_error_1qc3k_49", Ql = "_success_1qc3k_52", Xl = "_counter_1qc3k_131", _e = {
  container: Hl,
  "full-width": "_full-width_1qc3k_34",
  "group-label": "_group-label_1qc3k_37",
  filled: Jl,
  error: Yl,
  success: Ql,
  "helper-text": "_helper-text_1qc3k_55",
  "container-counter-icon": "_container-counter-icon_1qc3k_110",
  "container-icon": "_container-icon_1qc3k_117",
  "icon-error-warning-fill": "_icon-error-warning-fill_1qc3k_122",
  counter: Xl,
  "dialog-overlay-show": "_dialog-overlay-show_1qc3k_1",
  "dialog-content-show": "_dialog-content-show_1qc3k_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1qc3k_1"
};
function ec({
  id: t,
  disabled: e = !1,
  status: n,
  title: a,
  helperText: o,
  placeholder: r,
  maxLength: i,
  onChange: s,
  onBlur: l,
  message: c,
  value: u,
  defaultValue: d,
  name: h,
  isFullWidth: f = !1
}) {
  const {
    valueCounter: m,
    isOnBlur: b,
    handleBlur: w,
    handleChange: I,
    hasLabelOrHelperText: k
  } = Wl(a, o, u, d, s, l);
  return /* @__PURE__ */ B("div", { className: H(_e.container, f && _e["full-width"]), children: [
    k && /* @__PURE__ */ B("div", { className: _e["group-label"], children: [
      a && /* @__PURE__ */ y(
        "label",
        {
          htmlFor: t,
          className: H(n && _e[n], (m > 0 && b || e) && _e.filled),
          children: a
        }
      ),
      o && /* @__PURE__ */ y("div", { className: _e["helper-text"], children: o })
    ] }),
    /* @__PURE__ */ y(
      "textarea",
      {
        id: t,
        name: h,
        "aria-label": "textarea",
        placeholder: r,
        onChange: I,
        className: H(n && _e[n]),
        value: u,
        defaultValue: d,
        disabled: e,
        onBlur: w
      }
    ),
    /* @__PURE__ */ B("div", { className: _e["container-counter-icon"], children: [
      c && n && /* @__PURE__ */ B("div", { className: _e["container-icon"], children: [
        /* @__PURE__ */ y(
          Ke,
          {
            name: `${n === "error" ? "error-warning-fill" : "checkbox-fill"}`,
            size: "medium",
            className: H(_e[n])
          }
        ),
        /* @__PURE__ */ y("span", { className: _e[n], children: c })
      ] }),
      i && /* @__PURE__ */ B("div", { className: H(_e.counter, m > i && _e.error), children: [
        m,
        "/",
        i
      ] })
    ] })
  ] });
}
const Sa = 640, fn = {
  "is-extra-small": "_is-extra-small_17143_29",
  "is-small": "_is-small_17143_32",
  "is-medium": "_is-medium_17143_35",
  "is-large": "_is-large_17143_38",
  "is-extra-large": "_is-extra-large_17143_41",
  "is-auto": "_is-auto_17143_44",
  "is-full-width": "_is-full-width_17143_47",
  "no-border": "_no-border_17143_50",
  "has-sm-border": "_has-sm-border_17143_53",
  "has-full-border": "_has-full-border_17143_56",
  "dialog-overlay-show": "_dialog-overlay-show_17143_1",
  "dialog-content-show": "_dialog-content-show_17143_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_17143_1"
};
function lr({
  srcMobile: t,
  width: e = "auto",
  borderRadius: n = "none",
  className: a = "",
  ...o
}) {
  const r = H(fn.img, a, fn[tc[e]], fn[nc[n]]);
  return /* @__PURE__ */ B("picture", { children: [
    t && /* @__PURE__ */ y("source", { media: `(max-width: ${Sa}px)`, srcSet: t }),
    /* @__PURE__ */ y("source", { media: `(min-width: ${Sa + 1}px)` }),
    /* @__PURE__ */ y("img", { ...o, className: r, alt: o.alt, style: { width: `${o.widthInPx}px` } })
  ] });
}
const tc = {
  xsmall: "is-extra-small",
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  xlarge: "is-extra-large",
  auto: "is-auto",
  full: "is-full-width"
}, nc = {
  none: "no-border",
  small: "has-sm-border",
  full: "has-full-border"
}, ac = "_callout_7jl0x_29", oc = "_link_7jl0x_52", st = {
  callout: ac,
  "is-full-width": "_is-full-width_7jl0x_37",
  "is-small": "_is-small_7jl0x_47",
  link: oc,
  "is-medium": "_is-medium_7jl0x_55",
  "is-info": "_is-info_7jl0x_58",
  "is-warning": "_is-warning_7jl0x_61",
  "is-success": "_is-success_7jl0x_64",
  "is-error": "_is-error_7jl0x_67",
  "is-neutral": "_is-neutral_7jl0x_70",
  "is-collection": "_is-collection_7jl0x_73",
  "content-container": "_content-container_7jl0x_79",
  "dialog-overlay-show": "_dialog-overlay-show_7jl0x_1",
  "dialog-content-show": "_dialog-content-show_7jl0x_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_7jl0x_1"
}, xa = {
  info: {
    name: "information-circle",
    color: "secondary"
  },
  warning: {
    name: "warning",
    color: "warning"
  },
  success: {
    name: "verification-check",
    color: "success"
  },
  error: {
    name: "notification",
    color: "error"
  },
  neutral: {
    name: "information-circle",
    color: "secondary"
  },
  collection: {
    name: "information-circle",
    color: "primary"
  }
}, rc = {
  info: "is-info",
  warning: "is-warning",
  success: "is-success",
  error: "is-error",
  neutral: "is-neutral",
  collection: "is-collection"
}, ic = {
  small: "is-small",
  medium: "is-medium"
};
function sc({
  status: t = "info",
  size: e = "medium",
  children: n,
  hasIcon: a = !1,
  backgroundImage: o,
  isFullWidth: r = !1
}) {
  const i = H(st.callout, st[rc[t]], st[ic[e]], {
    [st["is-full-width"]]: r
  });
  return /* @__PURE__ */ B("div", { className: i, children: [
    a && /* @__PURE__ */ y(Ke, { name: xa[t].name, color: xa[t].color, size: "2xl" }),
    /* @__PURE__ */ y("div", { className: st["content-container"], children: n }),
    o && /* @__PURE__ */ y("img", { src: o, alt: "background" })
  ] });
}
const lc = {
  info: "is-info",
  warning: "is-warning",
  success: "is-success",
  error: "is-error",
  neutral: "is-neutral",
  collection: "is-collection"
}, cc = ({ imageSrc: t, imageSrcMobile: e, imageSrcTablet: n, alt: a, className: o }) => {
  const { isMobile: r, isTablet: i } = or();
  let s = t;
  return r && e && (s = e), i && n && (s = n), /* @__PURE__ */ y("img", { className: o, src: s, alt: a });
}, uc = "_banner_17hqf_29", Le = {
  "banner-container": "_banner-container_17hqf_29",
  banner: uc,
  "banner-image": "_banner-image_17hqf_39",
  "banner-content": "_banner-content_17hqf_42",
  "banner-text": "_banner-text_17hqf_48",
  "banner-cta": "_banner-cta_17hqf_51",
  "is-info": "_is-info_17hqf_92",
  "is-warning": "_is-warning_17hqf_95",
  "is-success": "_is-success_17hqf_98",
  "is-error": "_is-error_17hqf_101",
  "is-neutral": "_is-neutral_17hqf_104",
  "dialog-overlay-show": "_dialog-overlay-show_17hqf_1",
  "dialog-content-show": "_dialog-content-show_17hqf_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_17hqf_1"
};
function dc({ color: t, image: e, className: n, cta: a, title: o, description: r }) {
  const i = H(Le.banner, Le[lc[t]], n);
  return /* @__PURE__ */ y("div", { className: Le["banner-container"], children: /* @__PURE__ */ B("div", { className: i, children: [
    e && /* @__PURE__ */ y(cc, { className: Le["banner-image"], ...e }),
    /* @__PURE__ */ B("div", { className: Le["banner-content"], children: [
      /* @__PURE__ */ B("div", { className: Le["banner-text"], children: [
        /* @__PURE__ */ y(_t, { isBold: !0, className: Le.title, children: o }),
        /* @__PURE__ */ y(_t, { className: Le.description, children: r })
      ] }),
      a && /* @__PURE__ */ y(nt, { className: Le["banner-cta"], color: a.color, onClick: a.onClick, children: a.text })
    ] })
  ] }) });
}
const gc = "_columns_474cd_29", hc = "_column_474cd_29", Se = {
  columns: gc,
  "align-items-center": "_align-items-center_474cd_36",
  "align-items-flex-start": "_align-items-flex-start_474cd_39",
  "align-items-flex-end": "_align-items-flex-end_474cd_42",
  "reverse-on-mobile": "_reverse-on-mobile_474cd_57",
  column: hc,
  "center-content": "_center-content_474cd_68",
  "gap-0": "_gap-0_474cd_74",
  "gap-1": "_gap-1_474cd_77",
  "gap-2": "_gap-2_474cd_80",
  "gap-3": "_gap-3_474cd_83",
  "gap-4": "_gap-4_474cd_86",
  "gap-5": "_gap-5_474cd_89",
  "gap-6": "_gap-6_474cd_92",
  "gap-7": "_gap-7_474cd_95",
  "gap-8": "_gap-8_474cd_98",
  "gap-9": "_gap-9_474cd_101",
  "gap-10": "_gap-10_474cd_104",
  "gap-11": "_gap-11_474cd_107",
  "gap-12": "_gap-12_474cd_110",
  "gap-14": "_gap-14_474cd_113",
  "gap-16": "_gap-16_474cd_116",
  "gap-18": "_gap-18_474cd_119",
  "gap-20": "_gap-20_474cd_122",
  "gap-24": "_gap-24_474cd_125",
  "gap-28": "_gap-28_474cd_128",
  "gap-32": "_gap-32_474cd_131",
  "gap-36": "_gap-36_474cd_134",
  "gap-40": "_gap-40_474cd_137",
  "gap-44": "_gap-44_474cd_140",
  "gap-48": "_gap-48_474cd_143",
  "gap-52": "_gap-52_474cd_146",
  "gap-56": "_gap-56_474cd_149",
  "gap-60": "_gap-60_474cd_152",
  "gap-64": "_gap-64_474cd_155",
  "gap-72": "_gap-72_474cd_158",
  "gap-80": "_gap-80_474cd_161",
  "gap-96": "_gap-96_474cd_164",
  "hidden-content-on-mobile": "_hidden-content-on-mobile_474cd_167",
  "is-1": "_is-1_474cd_186",
  "is-2": "_is-2_474cd_190",
  "is-3": "_is-3_474cd_194",
  "is-4": "_is-4_474cd_198",
  "is-5": "_is-5_474cd_202",
  "is-6": "_is-6_474cd_206",
  "is-7": "_is-7_474cd_210",
  "is-8": "_is-8_474cd_214",
  "is-9": "_is-9_474cd_218",
  "is-10": "_is-10_474cd_222",
  "is-11": "_is-11_474cd_226",
  "is-12": "_is-12_474cd_230",
  "is-offset-1": "_is-offset-1_474cd_234",
  "is-offset-2": "_is-offset-2_474cd_237",
  "is-offset-3": "_is-offset-3_474cd_240",
  "is-offset-4": "_is-offset-4_474cd_243",
  "is-offset-5": "_is-offset-5_474cd_246",
  "is-offset-6": "_is-offset-6_474cd_249",
  "is-offset-7": "_is-offset-7_474cd_252",
  "is-offset-8": "_is-offset-8_474cd_255",
  "is-offset-9": "_is-offset-9_474cd_258",
  "is-offset-10": "_is-offset-10_474cd_261",
  "is-offset-11": "_is-offset-11_474cd_264",
  "is-narrow": "_is-narrow_474cd_267",
  "dialog-overlay-show": "_dialog-overlay-show_474cd_1",
  "dialog-content-show": "_dialog-content-show_474cd_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_474cd_1"
};
function cr({ children: t, className: e = "", reverseOnMobile: n = !1, alignItems: a, ...o }) {
  const r = H(
    Se.columns,
    n && Se["reverse-on-mobile"],
    a && Se[`align-items-${a}`],
    e
  );
  return /* @__PURE__ */ y("div", { className: r, ...o, children: t });
}
const _c = {
  auto: "",
  1: "is-1",
  2: "is-2",
  3: "is-3",
  4: "is-4",
  5: "is-5",
  6: "is-6",
  7: "is-7",
  8: "is-8",
  9: "is-9",
  10: "is-10",
  11: "is-11",
  12: "is-12"
}, fc = {
  auto: "",
  1: "is-offset-1",
  2: "is-offset-2",
  3: "is-offset-3",
  4: "is-offset-4",
  5: "is-offset-5",
  6: "is-offset-6",
  7: "is-offset-7",
  8: "is-offset-8",
  9: "is-offset-9",
  10: "is-offset-10",
  11: "is-offset-11",
  12: "is-offset-12"
};
function Bt({
  size: t = "auto",
  offset: e = "auto",
  isNarrow: n = !1,
  centerContent: a,
  className: o = "",
  children: r,
  gap: i,
  hiddenContentOnMobile: s = !1,
  ...l
}) {
  const c = H(
    Se.column,
    Se[_c[t]],
    Se[fc[e]],
    n && Se["is-narrow"],
    a && Se["center-content"],
    i && Se[`gap-${i}`],
    s && Se["hidden-content-on-mobile"],
    o
  );
  return /* @__PURE__ */ y("div", { className: c, ...l, children: r });
}
const mc = "_container_68o99_29", za = {
  container: mc,
  "is-fluid": "_is-fluid_68o99_50"
};
function pc({ isFluid: t = !1, children: e, className: n = "", ...a }) {
  const o = H(za.container, t && za["is-fluid"], n);
  return /* @__PURE__ */ y("div", { className: o, ...a, children: e });
}
const bc = "_section_g0e0c_29", yc = "_content_g0e0c_32", fe = {
  section: bc,
  content: yc,
  "is-top-bottom-padding": "_is-top-bottom-padding_g0e0c_35",
  "has-small-padding": "_has-small-padding_g0e0c_38",
  "has-medium-padding": "_has-medium-padding_g0e0c_41",
  "has-large-padding": "_has-large-padding_g0e0c_44",
  "bg-image": "_bg-image_g0e0c_48",
  "image-flex": "_image-flex_g0e0c_53",
  "image-container": "_image-container_g0e0c_63",
  "reverse-bg-color": "_reverse-bg-color_g0e0c_82",
  "image-reverse": "_image-reverse_g0e0c_88",
  "is-full-height": "_is-full-height_g0e0c_94",
  "center-content": "_center-content_g0e0c_97",
  "border-top": "_border-top_g0e0c_101",
  "border-bottom": "_border-bottom_g0e0c_104",
  "border-top-and-bottom": "_border-top-and-bottom_g0e0c_107",
  "is-primary": "_is-primary_g0e0c_111",
  "is-secondary": "_is-secondary_g0e0c_114",
  "is-tertiary": "_is-tertiary_g0e0c_117",
  "dialog-overlay-show": "_dialog-overlay-show_g0e0c_1",
  "dialog-content-show": "_dialog-content-show_g0e0c_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_g0e0c_1"
}, vc = {
  small: "has-small-padding",
  medium: "has-medium-padding",
  large: "has-large-padding"
}, kc = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary"
}, wc = {
  none: "",
  top: "border-top",
  bottom: "border-bottom",
  topAndBottom: "border-top-and-bottom"
};
function $c({
  children: t,
  className: e = "",
  color: n,
  border: a = "none",
  isFullHeight: o,
  centerContent: r,
  isTopBottomPadding: i,
  padding: s = "medium",
  imageSrc: l,
  imagePosition: c,
  imageAlt: u,
  reverseBGColor: d,
  bgImage: h,
  ...f
}) {
  const m = H(
    fe.section,
    e,
    n && fe[kc[n]],
    fe[wc[a]],
    o && fe["is-full-height"],
    r && fe["center-content"],
    l && fe["image-flex"],
    c === "right" && fe["image-reverse"],
    d && fe["reverse-bg-color"]
  ), { isMobile: b } = or();
  return /* @__PURE__ */ B("section", { ...f, className: m, children: [
    l && /* @__PURE__ */ y("div", { className: fe["image-container"], children: /* @__PURE__ */ y("img", { src: l, alt: u }) }),
    /* @__PURE__ */ y(
      "div",
      {
        className: H(
          fe.content,
          i && fe["is-top-bottom-padding"],
          s && fe[vc[s]],
          h && fe["bg-image"]
        ),
        style: !b && h ? { backgroundImage: `url(${h})` } : {},
        children: t
      }
    )
  ] });
}
function ur(t) {
  var e, n, a = "";
  if (typeof t == "string" || typeof t == "number") a += t;
  else if (typeof t == "object") if (Array.isArray(t)) {
    var o = t.length;
    for (e = 0; e < o; e++) t[e] && (n = ur(t[e])) && (a && (a += " "), a += n);
  } else for (n in t) t[n] && (a && (a += " "), a += n);
  return a;
}
function Cc() {
  for (var t, e, n = 0, a = "", o = arguments.length; n < o; n++) (t = arguments[n]) && (e = ur(t)) && (a && (a += " "), a += e);
  return a;
}
const Sc = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], xc = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, zc = Sc.map((t) => ({
  name: t,
  class: `icon-${t}`,
  paths: xc[t]
})), Ac = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, Nc = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl",
  "8xl": "is-8xl",
  "9xl": "is-9xl",
  "10xl": "is-10xl"
};
function Oc(t = 0) {
  const e = [];
  for (let n = 0; n < t; n++)
    e[n] = `path${n + 1}`;
  return e.map((n) => /* @__PURE__ */ y("span", { className: n }, n));
}
const Ic = vt(
  ({ name: t, size: e = "medium", color: n = "base", className: a = "", ...o }, r) => {
    const i = zc.find((l) => l.name === t), s = Cc("icon", `ds-${i?.class}`, Nc[e], Ac[n], a);
    return /* @__PURE__ */ y("i", { className: s, ...o, ref: r, children: Oc(i?.paths) });
  }
);
Ic.displayName = "Icon";
const Lc = ["en", "fr", "it"], dr = go({
  locale: "en"
});
function Dc({ children: t, ...e }) {
  return /* @__PURE__ */ y(dr.Provider, { value: e, children: t });
}
const Mc = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/;
function Ec(t) {
  return Lc.includes(t) && !0;
}
function jc(t, e) {
  const n = Mc.test(e);
  let a;
  return Ec(t) || n ? a = `${e}` : a = `/${t}${e}`, { url: a };
}
function Fn(t) {
  const { locale: e } = ho(dr);
  return jc(e, t);
}
function Pc() {
  const [t, e] = Ce({
    width: typeof window > "u" ? void 0 : window.innerWidth,
    height: typeof window > "u" ? void 0 : window.innerHeight
  });
  return Me(() => {
    function n() {
      e({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", n), n(), () => window.removeEventListener("resize", n);
  }, []), t;
}
function gr() {
  const { width: t } = Pc();
  let e = "desktop";
  return t && t <= na.MOBILE ? e = "mobile" : t && t <= na.TABLET && (e = "tablet"), {
    currentWidth: t,
    currentDevice: e,
    isMobile: e === "mobile",
    isTablet: e === "tablet",
    isDesktop: e === "desktop",
    isReady: typeof window < "u"
  };
}
const Aa = (t, e, n) => {
  if (t && "reportValidity" in t) {
    const a = S(n, e);
    t.setCustomValidity(a && a.message || ""), t.reportValidity();
  }
}, Cn = (t, e) => {
  for (const n in e.fields) {
    const a = e.fields[n];
    a && a.ref && "reportValidity" in a.ref ? Aa(a.ref, n, t) : a && a.refs && a.refs.forEach((o) => Aa(o, n, t));
  }
}, Na = (t, e) => {
  e.shouldUseNativeValidation && Cn(t, e);
  const n = {};
  for (const a in t) {
    const o = S(e.fields, a), r = Object.assign(t[a] || {}, { ref: o && o.ref });
    if (Tc(e.names || Object.keys(t), a)) {
      const i = Object.assign({}, S(n, a));
      G(i, "root", r), G(n, a, i);
    } else G(n, a, r);
  }
  return n;
}, Tc = (t, e) => {
  const n = Oa(e);
  return t.some((a) => Oa(a).match(`^${n}\\.\\d+`));
};
function Oa(t) {
  return t.replace(/\]|\[/g, "");
}
function v(t, e, n) {
  function a(s, l) {
    var c;
    Object.defineProperty(s, "_zod", {
      value: s._zod ?? {},
      enumerable: !1
    }), (c = s._zod).traits ?? (c.traits = /* @__PURE__ */ new Set()), s._zod.traits.add(t), e(s, l);
    for (const u in i.prototype)
      u in s || Object.defineProperty(s, u, { value: i.prototype[u].bind(s) });
    s._zod.constr = i, s._zod.def = l;
  }
  const o = n?.Parent ?? Object;
  class r extends o {
  }
  Object.defineProperty(r, "name", { value: t });
  function i(s) {
    var l;
    const c = n?.Parent ? new r() : this;
    a(c, s), (l = c._zod).deferred ?? (l.deferred = []);
    for (const u of c._zod.deferred)
      u();
    return c;
  }
  return Object.defineProperty(i, "init", { value: a }), Object.defineProperty(i, Symbol.hasInstance, {
    value: (s) => n?.Parent && s instanceof n.Parent ? !0 : s?._zod?.traits?.has(t)
  }), Object.defineProperty(i, "name", { value: t }), i;
}
class tt extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class hr extends Error {
  constructor(e) {
    super(`Encountered unidirectional transform during encode: ${e}`), this.name = "ZodEncodeError";
  }
}
const _r = {};
function We(t) {
  return _r;
}
function Rc(t) {
  const e = Object.values(t).filter((a) => typeof a == "number");
  return Object.entries(t).filter(([a, o]) => e.indexOf(+a) === -1).map(([a, o]) => o);
}
function Sn(t, e) {
  return typeof e == "bigint" ? e.toString() : e;
}
function Vn(t) {
  return {
    get value() {
      {
        const e = t();
        return Object.defineProperty(this, "value", { value: e }), e;
      }
    }
  };
}
function Gn(t) {
  return t == null;
}
function Un(t) {
  const e = t.startsWith("^") ? 1 : 0, n = t.endsWith("$") ? t.length - 1 : t.length;
  return t.slice(e, n);
}
const Ia = Symbol("evaluating");
function q(t, e, n) {
  let a;
  Object.defineProperty(t, e, {
    get() {
      if (a !== Ia)
        return a === void 0 && (a = Ia, a = n()), a;
    },
    set(o) {
      Object.defineProperty(t, e, {
        value: o
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function Bc(t) {
  return Object.create(Object.getPrototypeOf(t), Object.getOwnPropertyDescriptors(t));
}
function Re(t, e, n) {
  Object.defineProperty(t, e, {
    value: n,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function ot(...t) {
  const e = {};
  for (const n of t) {
    const a = Object.getOwnPropertyDescriptors(n);
    Object.assign(e, a);
  }
  return Object.defineProperties({}, e);
}
function La(t) {
  return JSON.stringify(t);
}
const fr = "captureStackTrace" in Error ? Error.captureStackTrace : (...t) => {
};
function Ft(t) {
  return typeof t == "object" && t !== null && !Array.isArray(t);
}
const Fc = Vn(() => {
  if (typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare"))
    return !1;
  try {
    const t = Function;
    return new t(""), !0;
  } catch {
    return !1;
  }
});
function mt(t) {
  if (Ft(t) === !1)
    return !1;
  const e = t.constructor;
  if (e === void 0)
    return !0;
  const n = e.prototype;
  return !(Ft(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
function mr(t) {
  return mt(t) ? { ...t } : Array.isArray(t) ? [...t] : t;
}
const Vc = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function Yt(t) {
  return t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Be(t, e, n) {
  const a = new t._zod.constr(e ?? t._zod.def);
  return (!e || n?.parent) && (a._zod.parent = t), a;
}
function M(t) {
  const e = t;
  if (!e)
    return {};
  if (typeof e == "string")
    return { error: () => e };
  if (e?.message !== void 0) {
    if (e?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    e.error = e.message;
  }
  return delete e.message, typeof e.error == "string" ? { ...e, error: () => e.error } : e;
}
function Gc(t) {
  return Object.keys(t).filter((e) => t[e]._zod.optin === "optional" && t[e]._zod.optout === "optional");
}
function Uc(t, e) {
  const n = t._zod.def, a = ot(t._zod.def, {
    get shape() {
      const o = {};
      for (const r in e) {
        if (!(r in n.shape))
          throw new Error(`Unrecognized key: "${r}"`);
        e[r] && (o[r] = n.shape[r]);
      }
      return Re(this, "shape", o), o;
    },
    checks: []
  });
  return Be(t, a);
}
function Zc(t, e) {
  const n = t._zod.def, a = ot(t._zod.def, {
    get shape() {
      const o = { ...t._zod.def.shape };
      for (const r in e) {
        if (!(r in n.shape))
          throw new Error(`Unrecognized key: "${r}"`);
        e[r] && delete o[r];
      }
      return Re(this, "shape", o), o;
    },
    checks: []
  });
  return Be(t, a);
}
function Kc(t, e) {
  if (!mt(e))
    throw new Error("Invalid input to extend: expected a plain object");
  const n = t._zod.def.checks;
  if (n && n.length > 0)
    throw new Error("Object schemas containing refinements cannot be extended. Use `.safeExtend()` instead.");
  const o = ot(t._zod.def, {
    get shape() {
      const r = { ...t._zod.def.shape, ...e };
      return Re(this, "shape", r), r;
    },
    checks: []
  });
  return Be(t, o);
}
function qc(t, e) {
  if (!mt(e))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const n = {
    ...t._zod.def,
    get shape() {
      const a = { ...t._zod.def.shape, ...e };
      return Re(this, "shape", a), a;
    },
    checks: t._zod.def.checks
  };
  return Be(t, n);
}
function Wc(t, e) {
  const n = ot(t._zod.def, {
    get shape() {
      const a = { ...t._zod.def.shape, ...e._zod.def.shape };
      return Re(this, "shape", a), a;
    },
    get catchall() {
      return e._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return Be(t, n);
}
function Hc(t, e, n) {
  const a = ot(e._zod.def, {
    get shape() {
      const o = e._zod.def.shape, r = { ...o };
      if (n)
        for (const i in n) {
          if (!(i in o))
            throw new Error(`Unrecognized key: "${i}"`);
          n[i] && (r[i] = t ? new t({
            type: "optional",
            innerType: o[i]
          }) : o[i]);
        }
      else
        for (const i in o)
          r[i] = t ? new t({
            type: "optional",
            innerType: o[i]
          }) : o[i];
      return Re(this, "shape", r), r;
    },
    checks: []
  });
  return Be(e, a);
}
function Jc(t, e, n) {
  const a = ot(e._zod.def, {
    get shape() {
      const o = e._zod.def.shape, r = { ...o };
      if (n)
        for (const i in n) {
          if (!(i in r))
            throw new Error(`Unrecognized key: "${i}"`);
          n[i] && (r[i] = new t({
            type: "nonoptional",
            innerType: o[i]
          }));
        }
      else
        for (const i in o)
          r[i] = new t({
            type: "nonoptional",
            innerType: o[i]
          });
      return Re(this, "shape", r), r;
    },
    checks: []
  });
  return Be(e, a);
}
function et(t, e = 0) {
  if (t.aborted === !0)
    return !0;
  for (let n = e; n < t.issues.length; n++)
    if (t.issues[n]?.continue !== !0)
      return !0;
  return !1;
}
function pr(t, e) {
  return e.map((n) => {
    var a;
    return (a = n).path ?? (a.path = []), n.path.unshift(t), n;
  });
}
function At(t) {
  return typeof t == "string" ? t : t?.message;
}
function He(t, e, n) {
  const a = { ...t, path: t.path ?? [] };
  if (!t.message) {
    const o = At(t.inst?._zod.def?.error?.(t)) ?? At(e?.error?.(t)) ?? At(n.customError?.(t)) ?? At(n.localeError?.(t)) ?? "Invalid input";
    a.message = o;
  }
  return delete a.inst, delete a.continue, e?.reportInput || delete a.input, a;
}
function Zn(t) {
  return Array.isArray(t) ? "array" : typeof t == "string" ? "string" : "unknown";
}
function pt(...t) {
  const [e, n, a] = t;
  return typeof e == "string" ? {
    message: e,
    code: "custom",
    input: n,
    inst: a
  } : { ...e };
}
const br = (t, e) => {
  t.name = "$ZodError", Object.defineProperty(t, "_zod", {
    value: t._zod,
    enumerable: !1
  }), Object.defineProperty(t, "issues", {
    value: e,
    enumerable: !1
  }), t.message = JSON.stringify(e, Sn, 2), Object.defineProperty(t, "toString", {
    value: () => t.message,
    enumerable: !1
  });
}, Kn = v("$ZodError", br), Qt = v("$ZodError", br, { Parent: Error });
function Yc(t, e = (n) => n.message) {
  const n = {}, a = [];
  for (const o of t.issues)
    o.path.length > 0 ? (n[o.path[0]] = n[o.path[0]] || [], n[o.path[0]].push(e(o))) : a.push(e(o));
  return { formErrors: a, fieldErrors: n };
}
function Qc(t, e) {
  const n = e || function(r) {
    return r.message;
  }, a = { _errors: [] }, o = (r) => {
    for (const i of r.issues)
      if (i.code === "invalid_union" && i.errors.length)
        i.errors.map((s) => o({ issues: s }));
      else if (i.code === "invalid_key")
        o({ issues: i.issues });
      else if (i.code === "invalid_element")
        o({ issues: i.issues });
      else if (i.path.length === 0)
        a._errors.push(n(i));
      else {
        let s = a, l = 0;
        for (; l < i.path.length; ) {
          const c = i.path[l];
          l === i.path.length - 1 ? (s[c] = s[c] || { _errors: [] }, s[c]._errors.push(n(i))) : s[c] = s[c] || { _errors: [] }, s = s[c], l++;
        }
      }
  };
  return o(t), a;
}
const Xt = (t) => (e, n, a, o) => {
  const r = a ? Object.assign(a, { async: !1 }) : { async: !1 }, i = e._zod.run({ value: n, issues: [] }, r);
  if (i instanceof Promise)
    throw new tt();
  if (i.issues.length) {
    const s = new (o?.Err ?? t)(i.issues.map((l) => He(l, r, We())));
    throw fr(s, o?.callee), s;
  }
  return i.value;
}, Xc = /* @__PURE__ */ Xt(Qt), en = (t) => async (e, n, a, o) => {
  const r = a ? Object.assign(a, { async: !0 }) : { async: !0 };
  let i = e._zod.run({ value: n, issues: [] }, r);
  if (i instanceof Promise && (i = await i), i.issues.length) {
    const s = new (o?.Err ?? t)(i.issues.map((l) => He(l, r, We())));
    throw fr(s, o?.callee), s;
  }
  return i.value;
}, eu = /* @__PURE__ */ en(Qt), tn = (t) => (e, n, a) => {
  const o = a ? { ...a, async: !1 } : { async: !1 }, r = e._zod.run({ value: n, issues: [] }, o);
  if (r instanceof Promise)
    throw new tt();
  return r.issues.length ? {
    success: !1,
    error: new (t ?? Kn)(r.issues.map((i) => He(i, o, We())))
  } : { success: !0, data: r.value };
}, tu = /* @__PURE__ */ tn(Qt), nn = (t) => async (e, n, a) => {
  const o = a ? Object.assign(a, { async: !0 }) : { async: !0 };
  let r = e._zod.run({ value: n, issues: [] }, o);
  return r instanceof Promise && (r = await r), r.issues.length ? {
    success: !1,
    error: new t(r.issues.map((i) => He(i, o, We())))
  } : { success: !0, data: r.value };
}, nu = /* @__PURE__ */ nn(Qt), au = (t) => (e, n, a) => {
  const o = a ? Object.assign(a, { direction: "backward" }) : { direction: "backward" };
  return Xt(t)(e, n, o);
}, ou = (t) => (e, n, a) => Xt(t)(e, n, a), ru = (t) => async (e, n, a) => {
  const o = a ? Object.assign(a, { direction: "backward" }) : { direction: "backward" };
  return en(t)(e, n, o);
}, iu = (t) => async (e, n, a) => en(t)(e, n, a), su = (t) => (e, n, a) => {
  const o = a ? Object.assign(a, { direction: "backward" }) : { direction: "backward" };
  return tn(t)(e, n, o);
}, lu = (t) => (e, n, a) => tn(t)(e, n, a), cu = (t) => async (e, n, a) => {
  const o = a ? Object.assign(a, { direction: "backward" }) : { direction: "backward" };
  return nn(t)(e, n, o);
}, uu = (t) => async (e, n, a) => nn(t)(e, n, a), du = /^[cC][^\s-]{8,}$/, gu = /^[0-9a-z]+$/, hu = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, _u = /^[0-9a-vA-V]{20}$/, fu = /^[A-Za-z0-9]{27}$/, mu = /^[a-zA-Z0-9_-]{21}$/, pu = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, bu = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, Da = (t) => t ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${t}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, yu = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, vu = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function ku() {
  return new RegExp(vu, "u");
}
const wu = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, $u = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, Cu = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, Su = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, xu = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, yr = /^[A-Za-z0-9_-]*$/, zu = /^(?=.{1,253}\.?$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[-0-9a-zA-Z]{0,61}[0-9a-zA-Z])?)*\.?$/, Au = /^\+(?:[0-9]){6,14}[0-9]$/, vr = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", Nu = /* @__PURE__ */ new RegExp(`^${vr}$`);
function kr(t) {
  const e = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof t.precision == "number" ? t.precision === -1 ? `${e}` : t.precision === 0 ? `${e}:[0-5]\\d` : `${e}:[0-5]\\d\\.\\d{${t.precision}}` : `${e}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function Ou(t) {
  return new RegExp(`^${kr(t)}$`);
}
function Iu(t) {
  const e = kr({ precision: t.precision }), n = ["Z"];
  t.local && n.push(""), t.offset && n.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const a = `${e}(?:${n.join("|")})`;
  return new RegExp(`^${vr}T(?:${a})$`);
}
const Lu = (t) => {
  const e = t ? `[\\s\\S]{${t?.minimum ?? 0},${t?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${e}$`);
}, Du = /^[^A-Z]*$/, Mu = /^[^a-z]*$/, Ae = /* @__PURE__ */ v("$ZodCheck", (t, e) => {
  var n;
  t._zod ?? (t._zod = {}), t._zod.def = e, (n = t._zod).onattach ?? (n.onattach = []);
}), Eu = /* @__PURE__ */ v("$ZodCheckMaxLength", (t, e) => {
  var n;
  Ae.init(t, e), (n = t._zod.def).when ?? (n.when = (a) => {
    const o = a.value;
    return !Gn(o) && o.length !== void 0;
  }), t._zod.onattach.push((a) => {
    const o = a._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    e.maximum < o && (a._zod.bag.maximum = e.maximum);
  }), t._zod.check = (a) => {
    const o = a.value;
    if (o.length <= e.maximum)
      return;
    const i = Zn(o);
    a.issues.push({
      origin: i,
      code: "too_big",
      maximum: e.maximum,
      inclusive: !0,
      input: o,
      inst: t,
      continue: !e.abort
    });
  };
}), ju = /* @__PURE__ */ v("$ZodCheckMinLength", (t, e) => {
  var n;
  Ae.init(t, e), (n = t._zod.def).when ?? (n.when = (a) => {
    const o = a.value;
    return !Gn(o) && o.length !== void 0;
  }), t._zod.onattach.push((a) => {
    const o = a._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    e.minimum > o && (a._zod.bag.minimum = e.minimum);
  }), t._zod.check = (a) => {
    const o = a.value;
    if (o.length >= e.minimum)
      return;
    const i = Zn(o);
    a.issues.push({
      origin: i,
      code: "too_small",
      minimum: e.minimum,
      inclusive: !0,
      input: o,
      inst: t,
      continue: !e.abort
    });
  };
}), Pu = /* @__PURE__ */ v("$ZodCheckLengthEquals", (t, e) => {
  var n;
  Ae.init(t, e), (n = t._zod.def).when ?? (n.when = (a) => {
    const o = a.value;
    return !Gn(o) && o.length !== void 0;
  }), t._zod.onattach.push((a) => {
    const o = a._zod.bag;
    o.minimum = e.length, o.maximum = e.length, o.length = e.length;
  }), t._zod.check = (a) => {
    const o = a.value, r = o.length;
    if (r === e.length)
      return;
    const i = Zn(o), s = r > e.length;
    a.issues.push({
      origin: i,
      ...s ? { code: "too_big", maximum: e.length } : { code: "too_small", minimum: e.length },
      inclusive: !0,
      exact: !0,
      input: a.value,
      inst: t,
      continue: !e.abort
    });
  };
}), an = /* @__PURE__ */ v("$ZodCheckStringFormat", (t, e) => {
  var n, a;
  Ae.init(t, e), t._zod.onattach.push((o) => {
    const r = o._zod.bag;
    r.format = e.format, e.pattern && (r.patterns ?? (r.patterns = /* @__PURE__ */ new Set()), r.patterns.add(e.pattern));
  }), e.pattern ? (n = t._zod).check ?? (n.check = (o) => {
    e.pattern.lastIndex = 0, !e.pattern.test(o.value) && o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: e.format,
      input: o.value,
      ...e.pattern ? { pattern: e.pattern.toString() } : {},
      inst: t,
      continue: !e.abort
    });
  }) : (a = t._zod).check ?? (a.check = () => {
  });
}), Tu = /* @__PURE__ */ v("$ZodCheckRegex", (t, e) => {
  an.init(t, e), t._zod.check = (n) => {
    e.pattern.lastIndex = 0, !e.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: n.value,
      pattern: e.pattern.toString(),
      inst: t,
      continue: !e.abort
    });
  };
}), Ru = /* @__PURE__ */ v("$ZodCheckLowerCase", (t, e) => {
  e.pattern ?? (e.pattern = Du), an.init(t, e);
}), Bu = /* @__PURE__ */ v("$ZodCheckUpperCase", (t, e) => {
  e.pattern ?? (e.pattern = Mu), an.init(t, e);
}), Fu = /* @__PURE__ */ v("$ZodCheckIncludes", (t, e) => {
  Ae.init(t, e);
  const n = Yt(e.includes), a = new RegExp(typeof e.position == "number" ? `^.{${e.position}}${n}` : n);
  e.pattern = a, t._zod.onattach.push((o) => {
    const r = o._zod.bag;
    r.patterns ?? (r.patterns = /* @__PURE__ */ new Set()), r.patterns.add(a);
  }), t._zod.check = (o) => {
    o.value.includes(e.includes, e.position) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: e.includes,
      input: o.value,
      inst: t,
      continue: !e.abort
    });
  };
}), Vu = /* @__PURE__ */ v("$ZodCheckStartsWith", (t, e) => {
  Ae.init(t, e);
  const n = new RegExp(`^${Yt(e.prefix)}.*`);
  e.pattern ?? (e.pattern = n), t._zod.onattach.push((a) => {
    const o = a._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(n);
  }), t._zod.check = (a) => {
    a.value.startsWith(e.prefix) || a.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: e.prefix,
      input: a.value,
      inst: t,
      continue: !e.abort
    });
  };
}), Gu = /* @__PURE__ */ v("$ZodCheckEndsWith", (t, e) => {
  Ae.init(t, e);
  const n = new RegExp(`.*${Yt(e.suffix)}$`);
  e.pattern ?? (e.pattern = n), t._zod.onattach.push((a) => {
    const o = a._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(n);
  }), t._zod.check = (a) => {
    a.value.endsWith(e.suffix) || a.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: e.suffix,
      input: a.value,
      inst: t,
      continue: !e.abort
    });
  };
}), Uu = /* @__PURE__ */ v("$ZodCheckOverwrite", (t, e) => {
  Ae.init(t, e), t._zod.check = (n) => {
    n.value = e.tx(n.value);
  };
});
class Zu {
  constructor(e = []) {
    this.content = [], this.indent = 0, this && (this.args = e);
  }
  indented(e) {
    this.indent += 1, e(this), this.indent -= 1;
  }
  write(e) {
    if (typeof e == "function") {
      e(this, { execution: "sync" }), e(this, { execution: "async" });
      return;
    }
    const a = e.split(`
`).filter((i) => i), o = Math.min(...a.map((i) => i.length - i.trimStart().length)), r = a.map((i) => i.slice(o)).map((i) => " ".repeat(this.indent * 2) + i);
    for (const i of r)
      this.content.push(i);
  }
  compile() {
    const e = Function, n = this?.args, o = [...(this?.content ?? [""]).map((r) => `  ${r}`)];
    return new e(...n, o.join(`
`));
  }
}
const Ku = {
  major: 4,
  minor: 1,
  patch: 8
}, se = /* @__PURE__ */ v("$ZodType", (t, e) => {
  var n;
  t ?? (t = {}), t._zod.def = e, t._zod.bag = t._zod.bag || {}, t._zod.version = Ku;
  const a = [...t._zod.def.checks ?? []];
  t._zod.traits.has("$ZodCheck") && a.unshift(t);
  for (const o of a)
    for (const r of o._zod.onattach)
      r(t);
  if (a.length === 0)
    (n = t._zod).deferred ?? (n.deferred = []), t._zod.deferred?.push(() => {
      t._zod.run = t._zod.parse;
    });
  else {
    const o = (i, s, l) => {
      let c = et(i), u;
      for (const d of s) {
        if (d._zod.def.when) {
          if (!d._zod.def.when(i))
            continue;
        } else if (c)
          continue;
        const h = i.issues.length, f = d._zod.check(i);
        if (f instanceof Promise && l?.async === !1)
          throw new tt();
        if (u || f instanceof Promise)
          u = (u ?? Promise.resolve()).then(async () => {
            await f, i.issues.length !== h && (c || (c = et(i, h)));
          });
        else {
          if (i.issues.length === h)
            continue;
          c || (c = et(i, h));
        }
      }
      return u ? u.then(() => i) : i;
    }, r = (i, s, l) => {
      if (et(i))
        return i.aborted = !0, i;
      const c = o(s, a, l);
      if (c instanceof Promise) {
        if (l.async === !1)
          throw new tt();
        return c.then((u) => t._zod.parse(u, l));
      }
      return t._zod.parse(c, l);
    };
    t._zod.run = (i, s) => {
      if (s.skipChecks)
        return t._zod.parse(i, s);
      if (s.direction === "backward") {
        const c = t._zod.parse({ value: i.value, issues: [] }, { ...s, skipChecks: !0 });
        return c instanceof Promise ? c.then((u) => r(u, i, s)) : r(c, i, s);
      }
      const l = t._zod.parse(i, s);
      if (l instanceof Promise) {
        if (s.async === !1)
          throw new tt();
        return l.then((c) => o(c, a, s));
      }
      return o(l, a, s);
    };
  }
  t["~standard"] = {
    validate: (o) => {
      try {
        const r = tu(t, o);
        return r.success ? { value: r.data } : { issues: r.error?.issues };
      } catch {
        return nu(t, o).then((i) => i.success ? { value: i.data } : { issues: i.error?.issues });
      }
    },
    vendor: "zod",
    version: 1
  };
}), qn = /* @__PURE__ */ v("$ZodString", (t, e) => {
  se.init(t, e), t._zod.pattern = [...t?._zod.bag?.patterns ?? []].pop() ?? Lu(t._zod.bag), t._zod.parse = (n, a) => {
    if (e.coerce)
      try {
        n.value = String(n.value);
      } catch {
      }
    return typeof n.value == "string" || n.issues.push({
      expected: "string",
      code: "invalid_type",
      input: n.value,
      inst: t
    }), n;
  };
}), J = /* @__PURE__ */ v("$ZodStringFormat", (t, e) => {
  an.init(t, e), qn.init(t, e);
}), qu = /* @__PURE__ */ v("$ZodGUID", (t, e) => {
  e.pattern ?? (e.pattern = bu), J.init(t, e);
}), Wu = /* @__PURE__ */ v("$ZodUUID", (t, e) => {
  if (e.version) {
    const a = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[e.version];
    if (a === void 0)
      throw new Error(`Invalid UUID version: "${e.version}"`);
    e.pattern ?? (e.pattern = Da(a));
  } else
    e.pattern ?? (e.pattern = Da());
  J.init(t, e);
}), Hu = /* @__PURE__ */ v("$ZodEmail", (t, e) => {
  e.pattern ?? (e.pattern = yu), J.init(t, e);
}), Ju = /* @__PURE__ */ v("$ZodURL", (t, e) => {
  J.init(t, e), t._zod.check = (n) => {
    try {
      const a = n.value.trim(), o = new URL(a);
      e.hostname && (e.hostname.lastIndex = 0, e.hostname.test(o.hostname) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: zu.source,
        input: n.value,
        inst: t,
        continue: !e.abort
      })), e.protocol && (e.protocol.lastIndex = 0, e.protocol.test(o.protocol.endsWith(":") ? o.protocol.slice(0, -1) : o.protocol) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: e.protocol.source,
        input: n.value,
        inst: t,
        continue: !e.abort
      })), e.normalize ? n.value = o.href : n.value = a;
      return;
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "url",
        input: n.value,
        inst: t,
        continue: !e.abort
      });
    }
  };
}), Yu = /* @__PURE__ */ v("$ZodEmoji", (t, e) => {
  e.pattern ?? (e.pattern = ku()), J.init(t, e);
}), Qu = /* @__PURE__ */ v("$ZodNanoID", (t, e) => {
  e.pattern ?? (e.pattern = mu), J.init(t, e);
}), Xu = /* @__PURE__ */ v("$ZodCUID", (t, e) => {
  e.pattern ?? (e.pattern = du), J.init(t, e);
}), ed = /* @__PURE__ */ v("$ZodCUID2", (t, e) => {
  e.pattern ?? (e.pattern = gu), J.init(t, e);
}), td = /* @__PURE__ */ v("$ZodULID", (t, e) => {
  e.pattern ?? (e.pattern = hu), J.init(t, e);
}), nd = /* @__PURE__ */ v("$ZodXID", (t, e) => {
  e.pattern ?? (e.pattern = _u), J.init(t, e);
}), ad = /* @__PURE__ */ v("$ZodKSUID", (t, e) => {
  e.pattern ?? (e.pattern = fu), J.init(t, e);
}), od = /* @__PURE__ */ v("$ZodISODateTime", (t, e) => {
  e.pattern ?? (e.pattern = Iu(e)), J.init(t, e);
}), rd = /* @__PURE__ */ v("$ZodISODate", (t, e) => {
  e.pattern ?? (e.pattern = Nu), J.init(t, e);
}), id = /* @__PURE__ */ v("$ZodISOTime", (t, e) => {
  e.pattern ?? (e.pattern = Ou(e)), J.init(t, e);
}), sd = /* @__PURE__ */ v("$ZodISODuration", (t, e) => {
  e.pattern ?? (e.pattern = pu), J.init(t, e);
}), ld = /* @__PURE__ */ v("$ZodIPv4", (t, e) => {
  e.pattern ?? (e.pattern = wu), J.init(t, e), t._zod.onattach.push((n) => {
    const a = n._zod.bag;
    a.format = "ipv4";
  });
}), cd = /* @__PURE__ */ v("$ZodIPv6", (t, e) => {
  e.pattern ?? (e.pattern = $u), J.init(t, e), t._zod.onattach.push((n) => {
    const a = n._zod.bag;
    a.format = "ipv6";
  }), t._zod.check = (n) => {
    try {
      new URL(`http://[${n.value}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: n.value,
        inst: t,
        continue: !e.abort
      });
    }
  };
}), ud = /* @__PURE__ */ v("$ZodCIDRv4", (t, e) => {
  e.pattern ?? (e.pattern = Cu), J.init(t, e);
}), dd = /* @__PURE__ */ v("$ZodCIDRv6", (t, e) => {
  e.pattern ?? (e.pattern = Su), J.init(t, e), t._zod.check = (n) => {
    const a = n.value.split("/");
    try {
      if (a.length !== 2)
        throw new Error();
      const [o, r] = a;
      if (!r)
        throw new Error();
      const i = Number(r);
      if (`${i}` !== r)
        throw new Error();
      if (i < 0 || i > 128)
        throw new Error();
      new URL(`http://[${o}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: n.value,
        inst: t,
        continue: !e.abort
      });
    }
  };
});
function wr(t) {
  if (t === "")
    return !0;
  if (t.length % 4 !== 0)
    return !1;
  try {
    return atob(t), !0;
  } catch {
    return !1;
  }
}
const gd = /* @__PURE__ */ v("$ZodBase64", (t, e) => {
  e.pattern ?? (e.pattern = xu), J.init(t, e), t._zod.onattach.push((n) => {
    n._zod.bag.contentEncoding = "base64";
  }), t._zod.check = (n) => {
    wr(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64",
      input: n.value,
      inst: t,
      continue: !e.abort
    });
  };
});
function hd(t) {
  if (!yr.test(t))
    return !1;
  const e = t.replace(/[-_]/g, (a) => a === "-" ? "+" : "/"), n = e.padEnd(Math.ceil(e.length / 4) * 4, "=");
  return wr(n);
}
const _d = /* @__PURE__ */ v("$ZodBase64URL", (t, e) => {
  e.pattern ?? (e.pattern = yr), J.init(t, e), t._zod.onattach.push((n) => {
    n._zod.bag.contentEncoding = "base64url";
  }), t._zod.check = (n) => {
    hd(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: n.value,
      inst: t,
      continue: !e.abort
    });
  };
}), fd = /* @__PURE__ */ v("$ZodE164", (t, e) => {
  e.pattern ?? (e.pattern = Au), J.init(t, e);
});
function md(t, e = null) {
  try {
    const n = t.split(".");
    if (n.length !== 3)
      return !1;
    const [a] = n;
    if (!a)
      return !1;
    const o = JSON.parse(atob(a));
    return !("typ" in o && o?.typ !== "JWT" || !o.alg || e && (!("alg" in o) || o.alg !== e));
  } catch {
    return !1;
  }
}
const pd = /* @__PURE__ */ v("$ZodJWT", (t, e) => {
  J.init(t, e), t._zod.check = (n) => {
    md(n.value, e.alg) || n.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: n.value,
      inst: t,
      continue: !e.abort
    });
  };
}), bd = /* @__PURE__ */ v("$ZodUnknown", (t, e) => {
  se.init(t, e), t._zod.parse = (n) => n;
}), yd = /* @__PURE__ */ v("$ZodNever", (t, e) => {
  se.init(t, e), t._zod.parse = (n, a) => (n.issues.push({
    expected: "never",
    code: "invalid_type",
    input: n.value,
    inst: t
  }), n);
});
function Ma(t, e, n) {
  t.issues.length && e.issues.push(...pr(n, t.issues)), e.value[n] = t.value;
}
const vd = /* @__PURE__ */ v("$ZodArray", (t, e) => {
  se.init(t, e), t._zod.parse = (n, a) => {
    const o = n.value;
    if (!Array.isArray(o))
      return n.issues.push({
        expected: "array",
        code: "invalid_type",
        input: o,
        inst: t
      }), n;
    n.value = Array(o.length);
    const r = [];
    for (let i = 0; i < o.length; i++) {
      const s = o[i], l = e.element._zod.run({
        value: s,
        issues: []
      }, a);
      l instanceof Promise ? r.push(l.then((c) => Ma(c, n, i))) : Ma(l, n, i);
    }
    return r.length ? Promise.all(r).then(() => n) : n;
  };
});
function Vt(t, e, n, a) {
  t.issues.length && e.issues.push(...pr(n, t.issues)), t.value === void 0 ? n in a && (e.value[n] = void 0) : e.value[n] = t.value;
}
function $r(t) {
  const e = Object.keys(t.shape);
  for (const a of e)
    if (!t.shape?.[a]?._zod?.traits?.has("$ZodType"))
      throw new Error(`Invalid element at key "${a}": expected a Zod schema`);
  const n = Gc(t.shape);
  return {
    ...t,
    keys: e,
    keySet: new Set(e),
    numKeys: e.length,
    optionalKeys: new Set(n)
  };
}
function Cr(t, e, n, a, o, r) {
  const i = [], s = o.keySet, l = o.catchall._zod, c = l.def.type;
  for (const u of Object.keys(e)) {
    if (s.has(u))
      continue;
    if (c === "never") {
      i.push(u);
      continue;
    }
    const d = l.run({ value: e[u], issues: [] }, a);
    d instanceof Promise ? t.push(d.then((h) => Vt(h, n, u, e))) : Vt(d, n, u, e);
  }
  return i.length && n.issues.push({
    code: "unrecognized_keys",
    keys: i,
    input: e,
    inst: r
  }), t.length ? Promise.all(t).then(() => n) : n;
}
const kd = /* @__PURE__ */ v("$ZodObject", (t, e) => {
  se.init(t, e);
  const n = Vn(() => $r(e));
  q(t._zod, "propValues", () => {
    const i = e.shape, s = {};
    for (const l in i) {
      const c = i[l]._zod;
      if (c.values) {
        s[l] ?? (s[l] = /* @__PURE__ */ new Set());
        for (const u of c.values)
          s[l].add(u);
      }
    }
    return s;
  });
  const a = Ft, o = e.catchall;
  let r;
  t._zod.parse = (i, s) => {
    r ?? (r = n.value);
    const l = i.value;
    if (!a(l))
      return i.issues.push({
        expected: "object",
        code: "invalid_type",
        input: l,
        inst: t
      }), i;
    i.value = {};
    const c = [], u = r.shape;
    for (const d of r.keys) {
      const f = u[d]._zod.run({ value: l[d], issues: [] }, s);
      f instanceof Promise ? c.push(f.then((m) => Vt(m, i, d, l))) : Vt(f, i, d, l);
    }
    return o ? Cr(c, l, i, s, n.value, t) : c.length ? Promise.all(c).then(() => i) : i;
  };
}), wd = /* @__PURE__ */ v("$ZodObjectJIT", (t, e) => {
  kd.init(t, e);
  const n = t._zod.parse, a = Vn(() => $r(e)), o = (h) => {
    const f = new Zu(["shape", "payload", "ctx"]), m = a.value, b = (N) => {
      const A = La(N);
      return `shape[${A}]._zod.run({ value: input[${A}], issues: [] }, ctx)`;
    };
    f.write("const input = payload.value;");
    const w = /* @__PURE__ */ Object.create(null);
    let I = 0;
    for (const N of m.keys)
      w[N] = `key_${I++}`;
    f.write("const newResult = {};");
    for (const N of m.keys) {
      const A = w[N], L = La(N);
      f.write(`const ${A} = ${b(N)};`), f.write(`
        if (${A}.issues.length) {
          payload.issues = payload.issues.concat(${A}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${L}, ...iss.path] : [${L}]
          })));
        }
        
        
        if (${A}.value === undefined) {
          if (${L} in input) {
            newResult[${L}] = undefined;
          }
        } else {
          newResult[${L}] = ${A}.value;
        }
        
      `);
    }
    f.write("payload.value = newResult;"), f.write("return payload;");
    const k = f.compile();
    return (N, A) => k(h, N, A);
  };
  let r;
  const i = Ft, s = !_r.jitless, c = s && Fc.value, u = e.catchall;
  let d;
  t._zod.parse = (h, f) => {
    d ?? (d = a.value);
    const m = h.value;
    return i(m) ? s && c && f?.async === !1 && f.jitless !== !0 ? (r || (r = o(e.shape)), h = r(h, f), u ? Cr([], m, h, f, d, t) : h) : n(h, f) : (h.issues.push({
      expected: "object",
      code: "invalid_type",
      input: m,
      inst: t
    }), h);
  };
});
function Ea(t, e, n, a) {
  for (const r of t)
    if (r.issues.length === 0)
      return e.value = r.value, e;
  const o = t.filter((r) => !et(r));
  return o.length === 1 ? (e.value = o[0].value, o[0]) : (e.issues.push({
    code: "invalid_union",
    input: e.value,
    inst: n,
    errors: t.map((r) => r.issues.map((i) => He(i, a, We())))
  }), e);
}
const $d = /* @__PURE__ */ v("$ZodUnion", (t, e) => {
  se.init(t, e), q(t._zod, "optin", () => e.options.some((o) => o._zod.optin === "optional") ? "optional" : void 0), q(t._zod, "optout", () => e.options.some((o) => o._zod.optout === "optional") ? "optional" : void 0), q(t._zod, "values", () => {
    if (e.options.every((o) => o._zod.values))
      return new Set(e.options.flatMap((o) => Array.from(o._zod.values)));
  }), q(t._zod, "pattern", () => {
    if (e.options.every((o) => o._zod.pattern)) {
      const o = e.options.map((r) => r._zod.pattern);
      return new RegExp(`^(${o.map((r) => Un(r.source)).join("|")})$`);
    }
  });
  const n = e.options.length === 1, a = e.options[0]._zod.run;
  t._zod.parse = (o, r) => {
    if (n)
      return a(o, r);
    let i = !1;
    const s = [];
    for (const l of e.options) {
      const c = l._zod.run({
        value: o.value,
        issues: []
      }, r);
      if (c instanceof Promise)
        s.push(c), i = !0;
      else {
        if (c.issues.length === 0)
          return c;
        s.push(c);
      }
    }
    return i ? Promise.all(s).then((l) => Ea(l, o, t, r)) : Ea(s, o, t, r);
  };
}), Cd = /* @__PURE__ */ v("$ZodIntersection", (t, e) => {
  se.init(t, e), t._zod.parse = (n, a) => {
    const o = n.value, r = e.left._zod.run({ value: o, issues: [] }, a), i = e.right._zod.run({ value: o, issues: [] }, a);
    return r instanceof Promise || i instanceof Promise ? Promise.all([r, i]).then(([l, c]) => ja(n, l, c)) : ja(n, r, i);
  };
});
function xn(t, e) {
  if (t === e)
    return { valid: !0, data: t };
  if (t instanceof Date && e instanceof Date && +t == +e)
    return { valid: !0, data: t };
  if (mt(t) && mt(e)) {
    const n = Object.keys(e), a = Object.keys(t).filter((r) => n.indexOf(r) !== -1), o = { ...t, ...e };
    for (const r of a) {
      const i = xn(t[r], e[r]);
      if (!i.valid)
        return {
          valid: !1,
          mergeErrorPath: [r, ...i.mergeErrorPath]
        };
      o[r] = i.data;
    }
    return { valid: !0, data: o };
  }
  if (Array.isArray(t) && Array.isArray(e)) {
    if (t.length !== e.length)
      return { valid: !1, mergeErrorPath: [] };
    const n = [];
    for (let a = 0; a < t.length; a++) {
      const o = t[a], r = e[a], i = xn(o, r);
      if (!i.valid)
        return {
          valid: !1,
          mergeErrorPath: [a, ...i.mergeErrorPath]
        };
      n.push(i.data);
    }
    return { valid: !0, data: n };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function ja(t, e, n) {
  if (e.issues.length && t.issues.push(...e.issues), n.issues.length && t.issues.push(...n.issues), et(t))
    return t;
  const a = xn(e.value, n.value);
  if (!a.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(a.mergeErrorPath)}`);
  return t.value = a.data, t;
}
const Sd = /* @__PURE__ */ v("$ZodEnum", (t, e) => {
  se.init(t, e);
  const n = Rc(e.entries), a = new Set(n);
  t._zod.values = a, t._zod.pattern = new RegExp(`^(${n.filter((o) => Vc.has(typeof o)).map((o) => typeof o == "string" ? Yt(o) : o.toString()).join("|")})$`), t._zod.parse = (o, r) => {
    const i = o.value;
    return a.has(i) || o.issues.push({
      code: "invalid_value",
      values: n,
      input: i,
      inst: t
    }), o;
  };
}), xd = /* @__PURE__ */ v("$ZodTransform", (t, e) => {
  se.init(t, e), t._zod.parse = (n, a) => {
    if (a.direction === "backward")
      throw new hr(t.constructor.name);
    const o = e.transform(n.value, n);
    if (a.async)
      return (o instanceof Promise ? o : Promise.resolve(o)).then((i) => (n.value = i, n));
    if (o instanceof Promise)
      throw new tt();
    return n.value = o, n;
  };
});
function Pa(t, e) {
  return t.issues.length && e === void 0 ? { issues: [], value: void 0 } : t;
}
const zd = /* @__PURE__ */ v("$ZodOptional", (t, e) => {
  se.init(t, e), t._zod.optin = "optional", t._zod.optout = "optional", q(t._zod, "values", () => e.innerType._zod.values ? /* @__PURE__ */ new Set([...e.innerType._zod.values, void 0]) : void 0), q(t._zod, "pattern", () => {
    const n = e.innerType._zod.pattern;
    return n ? new RegExp(`^(${Un(n.source)})?$`) : void 0;
  }), t._zod.parse = (n, a) => {
    if (e.innerType._zod.optin === "optional") {
      const o = e.innerType._zod.run(n, a);
      return o instanceof Promise ? o.then((r) => Pa(r, n.value)) : Pa(o, n.value);
    }
    return n.value === void 0 ? n : e.innerType._zod.run(n, a);
  };
}), Ad = /* @__PURE__ */ v("$ZodNullable", (t, e) => {
  se.init(t, e), q(t._zod, "optin", () => e.innerType._zod.optin), q(t._zod, "optout", () => e.innerType._zod.optout), q(t._zod, "pattern", () => {
    const n = e.innerType._zod.pattern;
    return n ? new RegExp(`^(${Un(n.source)}|null)$`) : void 0;
  }), q(t._zod, "values", () => e.innerType._zod.values ? /* @__PURE__ */ new Set([...e.innerType._zod.values, null]) : void 0), t._zod.parse = (n, a) => n.value === null ? n : e.innerType._zod.run(n, a);
}), Nd = /* @__PURE__ */ v("$ZodDefault", (t, e) => {
  se.init(t, e), t._zod.optin = "optional", q(t._zod, "values", () => e.innerType._zod.values), t._zod.parse = (n, a) => {
    if (a.direction === "backward")
      return e.innerType._zod.run(n, a);
    if (n.value === void 0)
      return n.value = e.defaultValue, n;
    const o = e.innerType._zod.run(n, a);
    return o instanceof Promise ? o.then((r) => Ta(r, e)) : Ta(o, e);
  };
});
function Ta(t, e) {
  return t.value === void 0 && (t.value = e.defaultValue), t;
}
const Od = /* @__PURE__ */ v("$ZodPrefault", (t, e) => {
  se.init(t, e), t._zod.optin = "optional", q(t._zod, "values", () => e.innerType._zod.values), t._zod.parse = (n, a) => (a.direction === "backward" || n.value === void 0 && (n.value = e.defaultValue), e.innerType._zod.run(n, a));
}), Id = /* @__PURE__ */ v("$ZodNonOptional", (t, e) => {
  se.init(t, e), q(t._zod, "values", () => {
    const n = e.innerType._zod.values;
    return n ? new Set([...n].filter((a) => a !== void 0)) : void 0;
  }), t._zod.parse = (n, a) => {
    const o = e.innerType._zod.run(n, a);
    return o instanceof Promise ? o.then((r) => Ra(r, t)) : Ra(o, t);
  };
});
function Ra(t, e) {
  return !t.issues.length && t.value === void 0 && t.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: t.value,
    inst: e
  }), t;
}
const Ld = /* @__PURE__ */ v("$ZodCatch", (t, e) => {
  se.init(t, e), q(t._zod, "optin", () => e.innerType._zod.optin), q(t._zod, "optout", () => e.innerType._zod.optout), q(t._zod, "values", () => e.innerType._zod.values), t._zod.parse = (n, a) => {
    if (a.direction === "backward")
      return e.innerType._zod.run(n, a);
    const o = e.innerType._zod.run(n, a);
    return o instanceof Promise ? o.then((r) => (n.value = r.value, r.issues.length && (n.value = e.catchValue({
      ...n,
      error: {
        issues: r.issues.map((i) => He(i, a, We()))
      },
      input: n.value
    }), n.issues = []), n)) : (n.value = o.value, o.issues.length && (n.value = e.catchValue({
      ...n,
      error: {
        issues: o.issues.map((r) => He(r, a, We()))
      },
      input: n.value
    }), n.issues = []), n);
  };
}), Dd = /* @__PURE__ */ v("$ZodPipe", (t, e) => {
  se.init(t, e), q(t._zod, "values", () => e.in._zod.values), q(t._zod, "optin", () => e.in._zod.optin), q(t._zod, "optout", () => e.out._zod.optout), q(t._zod, "propValues", () => e.in._zod.propValues), t._zod.parse = (n, a) => {
    if (a.direction === "backward") {
      const r = e.out._zod.run(n, a);
      return r instanceof Promise ? r.then((i) => Nt(i, e.in, a)) : Nt(r, e.in, a);
    }
    const o = e.in._zod.run(n, a);
    return o instanceof Promise ? o.then((r) => Nt(r, e.out, a)) : Nt(o, e.out, a);
  };
});
function Nt(t, e, n) {
  return t.issues.length ? (t.aborted = !0, t) : e._zod.run({ value: t.value, issues: t.issues }, n);
}
const Md = /* @__PURE__ */ v("$ZodReadonly", (t, e) => {
  se.init(t, e), q(t._zod, "propValues", () => e.innerType._zod.propValues), q(t._zod, "values", () => e.innerType._zod.values), q(t._zod, "optin", () => e.innerType._zod.optin), q(t._zod, "optout", () => e.innerType._zod.optout), t._zod.parse = (n, a) => {
    if (a.direction === "backward")
      return e.innerType._zod.run(n, a);
    const o = e.innerType._zod.run(n, a);
    return o instanceof Promise ? o.then(Ba) : Ba(o);
  };
});
function Ba(t) {
  return t.value = Object.freeze(t.value), t;
}
const Ed = /* @__PURE__ */ v("$ZodCustom", (t, e) => {
  Ae.init(t, e), se.init(t, e), t._zod.parse = (n, a) => n, t._zod.check = (n) => {
    const a = n.value, o = e.fn(a);
    if (o instanceof Promise)
      return o.then((r) => Fa(r, n, a, t));
    Fa(o, n, a, t);
  };
});
function Fa(t, e, n, a) {
  if (!t) {
    const o = {
      code: "custom",
      input: n,
      inst: a,
      // incorporates params.error into issue reporting
      path: [...a._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !a._zod.def.abort
      // params: inst._zod.def.params,
    };
    a._zod.def.params && (o.params = a._zod.def.params), e.issues.push(pt(o));
  }
}
class jd {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(e, ...n) {
    const a = n[0];
    if (this._map.set(e, a), a && typeof a == "object" && "id" in a) {
      if (this._idmap.has(a.id))
        throw new Error(`ID ${a.id} already exists in the registry`);
      this._idmap.set(a.id, e);
    }
    return this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(e) {
    const n = this._map.get(e);
    return n && typeof n == "object" && "id" in n && this._idmap.delete(n.id), this._map.delete(e), this;
  }
  get(e) {
    const n = e._zod.parent;
    if (n) {
      const a = { ...this.get(n) ?? {} };
      delete a.id;
      const o = { ...a, ...this._map.get(e) };
      return Object.keys(o).length ? o : void 0;
    }
    return this._map.get(e);
  }
  has(e) {
    return this._map.has(e);
  }
}
function Pd() {
  return new jd();
}
const Ot = /* @__PURE__ */ Pd();
function Td(t, e) {
  return new t({
    type: "string",
    ...M(e)
  });
}
function Rd(t, e) {
  return new t({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...M(e)
  });
}
function Va(t, e) {
  return new t({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...M(e)
  });
}
function Bd(t, e) {
  return new t({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...M(e)
  });
}
function Fd(t, e) {
  return new t({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...M(e)
  });
}
function Vd(t, e) {
  return new t({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...M(e)
  });
}
function Gd(t, e) {
  return new t({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...M(e)
  });
}
function Ud(t, e) {
  return new t({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...M(e)
  });
}
function Zd(t, e) {
  return new t({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...M(e)
  });
}
function Kd(t, e) {
  return new t({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...M(e)
  });
}
function qd(t, e) {
  return new t({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...M(e)
  });
}
function Wd(t, e) {
  return new t({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...M(e)
  });
}
function Hd(t, e) {
  return new t({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...M(e)
  });
}
function Jd(t, e) {
  return new t({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...M(e)
  });
}
function Yd(t, e) {
  return new t({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...M(e)
  });
}
function Qd(t, e) {
  return new t({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...M(e)
  });
}
function Xd(t, e) {
  return new t({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...M(e)
  });
}
function eg(t, e) {
  return new t({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...M(e)
  });
}
function tg(t, e) {
  return new t({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...M(e)
  });
}
function ng(t, e) {
  return new t({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...M(e)
  });
}
function ag(t, e) {
  return new t({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...M(e)
  });
}
function og(t, e) {
  return new t({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...M(e)
  });
}
function rg(t, e) {
  return new t({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...M(e)
  });
}
function ig(t, e) {
  return new t({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...M(e)
  });
}
function sg(t, e) {
  return new t({
    type: "string",
    format: "date",
    check: "string_format",
    ...M(e)
  });
}
function lg(t, e) {
  return new t({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...M(e)
  });
}
function cg(t, e) {
  return new t({
    type: "string",
    format: "duration",
    check: "string_format",
    ...M(e)
  });
}
function ug(t) {
  return new t({
    type: "unknown"
  });
}
function dg(t, e) {
  return new t({
    type: "never",
    ...M(e)
  });
}
function Sr(t, e) {
  return new Eu({
    check: "max_length",
    ...M(e),
    maximum: t
  });
}
function Gt(t, e) {
  return new ju({
    check: "min_length",
    ...M(e),
    minimum: t
  });
}
function xr(t, e) {
  return new Pu({
    check: "length_equals",
    ...M(e),
    length: t
  });
}
function gg(t, e) {
  return new Tu({
    check: "string_format",
    format: "regex",
    ...M(e),
    pattern: t
  });
}
function hg(t) {
  return new Ru({
    check: "string_format",
    format: "lowercase",
    ...M(t)
  });
}
function _g(t) {
  return new Bu({
    check: "string_format",
    format: "uppercase",
    ...M(t)
  });
}
function fg(t, e) {
  return new Fu({
    check: "string_format",
    format: "includes",
    ...M(e),
    includes: t
  });
}
function mg(t, e) {
  return new Vu({
    check: "string_format",
    format: "starts_with",
    ...M(e),
    prefix: t
  });
}
function pg(t, e) {
  return new Gu({
    check: "string_format",
    format: "ends_with",
    ...M(e),
    suffix: t
  });
}
function $t(t) {
  return new Uu({
    check: "overwrite",
    tx: t
  });
}
function bg(t) {
  return $t((e) => e.normalize(t));
}
function yg() {
  return $t((t) => t.trim());
}
function vg() {
  return $t((t) => t.toLowerCase());
}
function kg() {
  return $t((t) => t.toUpperCase());
}
function wg(t, e, n) {
  return new t({
    type: "array",
    element: e,
    // get element() {
    //   return element;
    // },
    ...M(n)
  });
}
function $g(t, e, n) {
  return new t({
    type: "custom",
    check: "custom",
    fn: e,
    ...M(n)
  });
}
function Cg(t) {
  const e = Sg((n) => (n.addIssue = (a) => {
    if (typeof a == "string")
      n.issues.push(pt(a, n.value, e._zod.def));
    else {
      const o = a;
      o.fatal && (o.continue = !1), o.code ?? (o.code = "custom"), o.input ?? (o.input = n.value), o.inst ?? (o.inst = e), o.continue ?? (o.continue = !e._zod.def.abort), n.issues.push(pt(o));
    }
  }, t(n.value, n)));
  return e;
}
function Sg(t, e) {
  const n = new Ae({
    check: "custom",
    ...M(e)
  });
  return n._zod.check = t, n;
}
function Ga(t, e) {
  try {
    var n = t();
  } catch (a) {
    return e(a);
  }
  return n && n.then ? n.then(void 0, e) : n;
}
function xg(t, e) {
  for (var n = {}; t.length; ) {
    var a = t[0], o = a.code, r = a.message, i = a.path.join(".");
    if (!n[i]) if ("unionErrors" in a) {
      var s = a.unionErrors[0].errors[0];
      n[i] = { message: s.message, type: s.code };
    } else n[i] = { message: r, type: o };
    if ("unionErrors" in a && a.unionErrors.forEach(function(u) {
      return u.errors.forEach(function(d) {
        return t.push(d);
      });
    }), e) {
      var l = n[i].types, c = l && l[a.code];
      n[i] = jn(i, e, n, o, c ? [].concat(c, a.message) : a.message);
    }
    t.shift();
  }
  return n;
}
function zg(t, e) {
  for (var n = {}; t.length; ) {
    var a = t[0], o = a.code, r = a.message, i = a.path.join(".");
    if (!n[i]) if (a.code === "invalid_union" && a.errors.length > 0) {
      var s = a.errors[0][0];
      n[i] = { message: s.message, type: s.code };
    } else n[i] = { message: r, type: o };
    if (a.code === "invalid_union" && a.errors.forEach(function(u) {
      return u.forEach(function(d) {
        return t.push(d);
      });
    }), e) {
      var l = n[i].types, c = l && l[a.code];
      n[i] = jn(i, e, n, o, c ? [].concat(c, a.message) : a.message);
    }
    t.shift();
  }
  return n;
}
function Ag(t, e, n) {
  if (n === void 0 && (n = {}), function(a) {
    return "_def" in a && typeof a._def == "object" && "typeName" in a._def;
  }(t)) return function(a, o, r) {
    try {
      return Promise.resolve(Ga(function() {
        return Promise.resolve(t[n.mode === "sync" ? "parse" : "parseAsync"](a, e)).then(function(i) {
          return r.shouldUseNativeValidation && Cn({}, r), { errors: {}, values: n.raw ? Object.assign({}, a) : i };
        });
      }, function(i) {
        if (function(s) {
          return Array.isArray(s?.issues);
        }(i)) return { values: {}, errors: Na(xg(i.errors, !r.shouldUseNativeValidation && r.criteriaMode === "all"), r) };
        throw i;
      }));
    } catch (i) {
      return Promise.reject(i);
    }
  };
  if (function(a) {
    return "_zod" in a && typeof a._zod == "object";
  }(t)) return function(a, o, r) {
    try {
      return Promise.resolve(Ga(function() {
        return Promise.resolve((n.mode === "sync" ? Xc : eu)(t, a, e)).then(function(i) {
          return r.shouldUseNativeValidation && Cn({}, r), { errors: {}, values: n.raw ? Object.assign({}, a) : i };
        });
      }, function(i) {
        if (function(s) {
          return s instanceof Kn;
        }(i)) return { values: {}, errors: Na(zg(i.issues, !r.shouldUseNativeValidation && r.criteriaMode === "all"), r) };
        throw i;
      }));
    } catch (i) {
      return Promise.reject(i);
    }
  };
  throw new Error("Invalid input: not a Zod schema");
}
const Ng = /* @__PURE__ */ v("ZodISODateTime", (t, e) => {
  od.init(t, e), Y.init(t, e);
});
function Og(t) {
  return ig(Ng, t);
}
const Ig = /* @__PURE__ */ v("ZodISODate", (t, e) => {
  rd.init(t, e), Y.init(t, e);
});
function Lg(t) {
  return sg(Ig, t);
}
const Dg = /* @__PURE__ */ v("ZodISOTime", (t, e) => {
  id.init(t, e), Y.init(t, e);
});
function Mg(t) {
  return lg(Dg, t);
}
const Eg = /* @__PURE__ */ v("ZodISODuration", (t, e) => {
  sd.init(t, e), Y.init(t, e);
});
function jg(t) {
  return cg(Eg, t);
}
const Pg = (t, e) => {
  Kn.init(t, e), t.name = "ZodError", Object.defineProperties(t, {
    format: {
      value: (n) => Qc(t, n)
      // enumerable: false,
    },
    flatten: {
      value: (n) => Yc(t, n)
      // enumerable: false,
    },
    addIssue: {
      value: (n) => {
        t.issues.push(n), t.message = JSON.stringify(t.issues, Sn, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (n) => {
        t.issues.push(...n), t.message = JSON.stringify(t.issues, Sn, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return t.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, ye = v("ZodError", Pg, {
  Parent: Error
}), Tg = /* @__PURE__ */ Xt(ye), Rg = /* @__PURE__ */ en(ye), Bg = /* @__PURE__ */ tn(ye), Fg = /* @__PURE__ */ nn(ye), Vg = /* @__PURE__ */ au(ye), Gg = /* @__PURE__ */ ou(ye), Ug = /* @__PURE__ */ ru(ye), Zg = /* @__PURE__ */ iu(ye), Kg = /* @__PURE__ */ su(ye), qg = /* @__PURE__ */ lu(ye), Wg = /* @__PURE__ */ cu(ye), Hg = /* @__PURE__ */ uu(ye), le = /* @__PURE__ */ v("ZodType", (t, e) => (se.init(t, e), t.def = e, t.type = e.type, Object.defineProperty(t, "_def", { value: e }), t.check = (...n) => t.clone(
  {
    ...e,
    checks: [
      ...e.checks ?? [],
      ...n.map((a) => typeof a == "function" ? { _zod: { check: a, def: { check: "custom" }, onattach: [] } } : a)
    ]
  }
  // { parent: true }
), t.clone = (n, a) => Be(t, n, a), t.brand = () => t, t.register = (n, a) => (n.add(t, a), t), t.parse = (n, a) => Tg(t, n, a, { callee: t.parse }), t.safeParse = (n, a) => Bg(t, n, a), t.parseAsync = async (n, a) => Rg(t, n, a, { callee: t.parseAsync }), t.safeParseAsync = async (n, a) => Fg(t, n, a), t.spa = t.safeParseAsync, t.encode = (n, a) => Vg(t, n, a), t.decode = (n, a) => Gg(t, n, a), t.encodeAsync = async (n, a) => Ug(t, n, a), t.decodeAsync = async (n, a) => Zg(t, n, a), t.safeEncode = (n, a) => Kg(t, n, a), t.safeDecode = (n, a) => qg(t, n, a), t.safeEncodeAsync = async (n, a) => Wg(t, n, a), t.safeDecodeAsync = async (n, a) => Hg(t, n, a), t.refine = (n, a) => t.check(Bh(n, a)), t.superRefine = (n) => t.check(Fh(n)), t.overwrite = (n) => t.check($t(n)), t.optional = () => qa(t), t.nullable = () => Wa(t), t.nullish = () => qa(Wa(t)), t.nonoptional = (n) => Dh(t, n), t.array = () => bh(t), t.or = (n) => wh([t, n]), t.and = (n) => Ch(t, n), t.transform = (n) => Ha(t, zh(n)), t.default = (n) => Oh(t, n), t.prefault = (n) => Lh(t, n), t.catch = (n) => Eh(t, n), t.pipe = (n) => Ha(t, n), t.readonly = () => Th(t), t.describe = (n) => {
  const a = t.clone();
  return Ot.add(a, { description: n }), a;
}, Object.defineProperty(t, "description", {
  get() {
    return Ot.get(t)?.description;
  },
  configurable: !0
}), t.meta = (...n) => {
  if (n.length === 0)
    return Ot.get(t);
  const a = t.clone();
  return Ot.add(a, n[0]), a;
}, t.isOptional = () => t.safeParse(void 0).success, t.isNullable = () => t.safeParse(null).success, t)), zr = /* @__PURE__ */ v("_ZodString", (t, e) => {
  qn.init(t, e), le.init(t, e);
  const n = t._zod.bag;
  t.format = n.format ?? null, t.minLength = n.minimum ?? null, t.maxLength = n.maximum ?? null, t.regex = (...a) => t.check(gg(...a)), t.includes = (...a) => t.check(fg(...a)), t.startsWith = (...a) => t.check(mg(...a)), t.endsWith = (...a) => t.check(pg(...a)), t.min = (...a) => t.check(Gt(...a)), t.max = (...a) => t.check(Sr(...a)), t.length = (...a) => t.check(xr(...a)), t.nonempty = (...a) => t.check(Gt(1, ...a)), t.lowercase = (a) => t.check(hg(a)), t.uppercase = (a) => t.check(_g(a)), t.trim = () => t.check(yg()), t.normalize = (...a) => t.check(bg(...a)), t.toLowerCase = () => t.check(vg()), t.toUpperCase = () => t.check(kg());
}), Jg = /* @__PURE__ */ v("ZodString", (t, e) => {
  qn.init(t, e), zr.init(t, e), t.email = (n) => t.check(Rd(Yg, n)), t.url = (n) => t.check(Ud(Qg, n)), t.jwt = (n) => t.check(rg(hh, n)), t.emoji = (n) => t.check(Zd(Xg, n)), t.guid = (n) => t.check(Va(Za, n)), t.uuid = (n) => t.check(Bd(It, n)), t.uuidv4 = (n) => t.check(Fd(It, n)), t.uuidv6 = (n) => t.check(Vd(It, n)), t.uuidv7 = (n) => t.check(Gd(It, n)), t.nanoid = (n) => t.check(Kd(eh, n)), t.guid = (n) => t.check(Va(Za, n)), t.cuid = (n) => t.check(qd(th, n)), t.cuid2 = (n) => t.check(Wd(nh, n)), t.ulid = (n) => t.check(Hd(ah, n)), t.base64 = (n) => t.check(ng(uh, n)), t.base64url = (n) => t.check(ag(dh, n)), t.xid = (n) => t.check(Jd(oh, n)), t.ksuid = (n) => t.check(Yd(rh, n)), t.ipv4 = (n) => t.check(Qd(ih, n)), t.ipv6 = (n) => t.check(Xd(sh, n)), t.cidrv4 = (n) => t.check(eg(lh, n)), t.cidrv6 = (n) => t.check(tg(ch, n)), t.e164 = (n) => t.check(og(gh, n)), t.datetime = (n) => t.check(Og(n)), t.date = (n) => t.check(Lg(n)), t.time = (n) => t.check(Mg(n)), t.duration = (n) => t.check(jg(n));
});
function Ua(t) {
  return Td(Jg, t);
}
const Y = /* @__PURE__ */ v("ZodStringFormat", (t, e) => {
  J.init(t, e), zr.init(t, e);
}), Yg = /* @__PURE__ */ v("ZodEmail", (t, e) => {
  Hu.init(t, e), Y.init(t, e);
}), Za = /* @__PURE__ */ v("ZodGUID", (t, e) => {
  qu.init(t, e), Y.init(t, e);
}), It = /* @__PURE__ */ v("ZodUUID", (t, e) => {
  Wu.init(t, e), Y.init(t, e);
}), Qg = /* @__PURE__ */ v("ZodURL", (t, e) => {
  Ju.init(t, e), Y.init(t, e);
}), Xg = /* @__PURE__ */ v("ZodEmoji", (t, e) => {
  Yu.init(t, e), Y.init(t, e);
}), eh = /* @__PURE__ */ v("ZodNanoID", (t, e) => {
  Qu.init(t, e), Y.init(t, e);
}), th = /* @__PURE__ */ v("ZodCUID", (t, e) => {
  Xu.init(t, e), Y.init(t, e);
}), nh = /* @__PURE__ */ v("ZodCUID2", (t, e) => {
  ed.init(t, e), Y.init(t, e);
}), ah = /* @__PURE__ */ v("ZodULID", (t, e) => {
  td.init(t, e), Y.init(t, e);
}), oh = /* @__PURE__ */ v("ZodXID", (t, e) => {
  nd.init(t, e), Y.init(t, e);
}), rh = /* @__PURE__ */ v("ZodKSUID", (t, e) => {
  ad.init(t, e), Y.init(t, e);
}), ih = /* @__PURE__ */ v("ZodIPv4", (t, e) => {
  ld.init(t, e), Y.init(t, e);
}), sh = /* @__PURE__ */ v("ZodIPv6", (t, e) => {
  cd.init(t, e), Y.init(t, e);
}), lh = /* @__PURE__ */ v("ZodCIDRv4", (t, e) => {
  ud.init(t, e), Y.init(t, e);
}), ch = /* @__PURE__ */ v("ZodCIDRv6", (t, e) => {
  dd.init(t, e), Y.init(t, e);
}), uh = /* @__PURE__ */ v("ZodBase64", (t, e) => {
  gd.init(t, e), Y.init(t, e);
}), dh = /* @__PURE__ */ v("ZodBase64URL", (t, e) => {
  _d.init(t, e), Y.init(t, e);
}), gh = /* @__PURE__ */ v("ZodE164", (t, e) => {
  fd.init(t, e), Y.init(t, e);
}), hh = /* @__PURE__ */ v("ZodJWT", (t, e) => {
  pd.init(t, e), Y.init(t, e);
}), _h = /* @__PURE__ */ v("ZodUnknown", (t, e) => {
  bd.init(t, e), le.init(t, e);
});
function Ka() {
  return ug(_h);
}
const fh = /* @__PURE__ */ v("ZodNever", (t, e) => {
  yd.init(t, e), le.init(t, e);
});
function mh(t) {
  return dg(fh, t);
}
const ph = /* @__PURE__ */ v("ZodArray", (t, e) => {
  vd.init(t, e), le.init(t, e), t.element = e.element, t.min = (n, a) => t.check(Gt(n, a)), t.nonempty = (n) => t.check(Gt(1, n)), t.max = (n, a) => t.check(Sr(n, a)), t.length = (n, a) => t.check(xr(n, a)), t.unwrap = () => t.element;
});
function bh(t, e) {
  return wg(ph, t, e);
}
const yh = /* @__PURE__ */ v("ZodObject", (t, e) => {
  wd.init(t, e), le.init(t, e), q(t, "shape", () => e.shape), t.keyof = () => Sh(Object.keys(t._zod.def.shape)), t.catchall = (n) => t.clone({ ...t._zod.def, catchall: n }), t.passthrough = () => t.clone({ ...t._zod.def, catchall: Ka() }), t.loose = () => t.clone({ ...t._zod.def, catchall: Ka() }), t.strict = () => t.clone({ ...t._zod.def, catchall: mh() }), t.strip = () => t.clone({ ...t._zod.def, catchall: void 0 }), t.extend = (n) => Kc(t, n), t.safeExtend = (n) => qc(t, n), t.merge = (n) => Wc(t, n), t.pick = (n) => Uc(t, n), t.omit = (n) => Zc(t, n), t.partial = (...n) => Hc(Ar, t, n[0]), t.required = (...n) => Jc(Nr, t, n[0]);
});
function vh(t, e) {
  const n = {
    type: "object",
    get shape() {
      return Re(this, "shape", t ? Bc(t) : {}), this.shape;
    },
    ...M(e)
  };
  return new yh(n);
}
const kh = /* @__PURE__ */ v("ZodUnion", (t, e) => {
  $d.init(t, e), le.init(t, e), t.options = e.options;
});
function wh(t, e) {
  return new kh({
    type: "union",
    options: t,
    ...M(e)
  });
}
const $h = /* @__PURE__ */ v("ZodIntersection", (t, e) => {
  Cd.init(t, e), le.init(t, e);
});
function Ch(t, e) {
  return new $h({
    type: "intersection",
    left: t,
    right: e
  });
}
const zn = /* @__PURE__ */ v("ZodEnum", (t, e) => {
  Sd.init(t, e), le.init(t, e), t.enum = e.entries, t.options = Object.values(e.entries);
  const n = new Set(Object.keys(e.entries));
  t.extract = (a, o) => {
    const r = {};
    for (const i of a)
      if (n.has(i))
        r[i] = e.entries[i];
      else
        throw new Error(`Key ${i} not found in enum`);
    return new zn({
      ...e,
      checks: [],
      ...M(o),
      entries: r
    });
  }, t.exclude = (a, o) => {
    const r = { ...e.entries };
    for (const i of a)
      if (n.has(i))
        delete r[i];
      else
        throw new Error(`Key ${i} not found in enum`);
    return new zn({
      ...e,
      checks: [],
      ...M(o),
      entries: r
    });
  };
});
function Sh(t, e) {
  const n = Array.isArray(t) ? Object.fromEntries(t.map((a) => [a, a])) : t;
  return new zn({
    type: "enum",
    entries: n,
    ...M(e)
  });
}
const xh = /* @__PURE__ */ v("ZodTransform", (t, e) => {
  xd.init(t, e), le.init(t, e), t._zod.parse = (n, a) => {
    if (a.direction === "backward")
      throw new hr(t.constructor.name);
    n.addIssue = (r) => {
      if (typeof r == "string")
        n.issues.push(pt(r, n.value, e));
      else {
        const i = r;
        i.fatal && (i.continue = !1), i.code ?? (i.code = "custom"), i.input ?? (i.input = n.value), i.inst ?? (i.inst = t), n.issues.push(pt(i));
      }
    };
    const o = e.transform(n.value, n);
    return o instanceof Promise ? o.then((r) => (n.value = r, n)) : (n.value = o, n);
  };
});
function zh(t) {
  return new xh({
    type: "transform",
    transform: t
  });
}
const Ar = /* @__PURE__ */ v("ZodOptional", (t, e) => {
  zd.init(t, e), le.init(t, e), t.unwrap = () => t._zod.def.innerType;
});
function qa(t) {
  return new Ar({
    type: "optional",
    innerType: t
  });
}
const Ah = /* @__PURE__ */ v("ZodNullable", (t, e) => {
  Ad.init(t, e), le.init(t, e), t.unwrap = () => t._zod.def.innerType;
});
function Wa(t) {
  return new Ah({
    type: "nullable",
    innerType: t
  });
}
const Nh = /* @__PURE__ */ v("ZodDefault", (t, e) => {
  Nd.init(t, e), le.init(t, e), t.unwrap = () => t._zod.def.innerType, t.removeDefault = t.unwrap;
});
function Oh(t, e) {
  return new Nh({
    type: "default",
    innerType: t,
    get defaultValue() {
      return typeof e == "function" ? e() : mr(e);
    }
  });
}
const Ih = /* @__PURE__ */ v("ZodPrefault", (t, e) => {
  Od.init(t, e), le.init(t, e), t.unwrap = () => t._zod.def.innerType;
});
function Lh(t, e) {
  return new Ih({
    type: "prefault",
    innerType: t,
    get defaultValue() {
      return typeof e == "function" ? e() : mr(e);
    }
  });
}
const Nr = /* @__PURE__ */ v("ZodNonOptional", (t, e) => {
  Id.init(t, e), le.init(t, e), t.unwrap = () => t._zod.def.innerType;
});
function Dh(t, e) {
  return new Nr({
    type: "nonoptional",
    innerType: t,
    ...M(e)
  });
}
const Mh = /* @__PURE__ */ v("ZodCatch", (t, e) => {
  Ld.init(t, e), le.init(t, e), t.unwrap = () => t._zod.def.innerType, t.removeCatch = t.unwrap;
});
function Eh(t, e) {
  return new Mh({
    type: "catch",
    innerType: t,
    catchValue: typeof e == "function" ? e : () => e
  });
}
const jh = /* @__PURE__ */ v("ZodPipe", (t, e) => {
  Dd.init(t, e), le.init(t, e), t.in = e.in, t.out = e.out;
});
function Ha(t, e) {
  return new jh({
    type: "pipe",
    in: t,
    out: e
    // ...util.normalizeParams(params),
  });
}
const Ph = /* @__PURE__ */ v("ZodReadonly", (t, e) => {
  Md.init(t, e), le.init(t, e), t.unwrap = () => t._zod.def.innerType;
});
function Th(t) {
  return new Ph({
    type: "readonly",
    innerType: t
  });
}
const Rh = /* @__PURE__ */ v("ZodCustom", (t, e) => {
  Ed.init(t, e), le.init(t, e);
});
function Bh(t, e = {}) {
  return $g(Rh, t, e);
}
function Fh(t) {
  return Cg(t);
}
const Ut = "9", Vh = vh({
  reasonId: Ua({ error: "reasons_for_cancellation_needed" }),
  comment: Ua().optional()
}).refine((t) => !(t.reasonId === Ut && !t.comment), {
  error: "reasons_other_comment_needed",
  path: ["comment"]
}).refine((t) => !(t.reasonId === Ut && t.comment && t.comment.length > 255), {
  error: "common:error.characters_max_limit",
  path: ["comment"]
});
function Gh({ onClickContinue: t, cancellationReasons: e, conversation: n, user: a }) {
  const { t: o } = Rn(["conversations", "common"]), [r, i] = Ce(!1), [s, l] = Ce(!1), c = async (m) => {
    try {
      i(!0), await Wr(n.id, m.reasonId, m.comment);
      const b = e.find((w) => w.id.toString() === m.reasonId);
      Rx(
        {
          exchange_status: "cancelled",
          cancellation_reason: b?.name,
          exchange_type: n.exchanges.length === 1 ? "guest_point_exchange" : "reciprocal_exchange",
          collection: a.is_he_collection
        },
        { eventCallback: () => t(), eventTimeout: 2e3 }
      );
    } catch (b) {
      throw l(!0), b;
    } finally {
      i(!1);
    }
  }, u = _i({
    resolver: Ag(Vh)
  }), { watch: d } = u, h = fo(
    () => e.map((m) => ({
      id: m.id.toString(),
      name: o(`reasons_for_cancellation_${m.name}`)
    })),
    [e, o]
  ), f = d("reasonId") === Ut;
  return {
    isLoading: r,
    requestHasError: s,
    onSubmitCancellationForm: c,
    cancellationReasonsRadioItems: h,
    displayCommentTextarea: f,
    cancellationForm: u
  };
}
function Uh({ onClickContinue: t, cancellationReasons: e, conversation: n, user: a }) {
  const { url: o } = Fn(`/conversations/${n.id}`), { t: r } = Rn(["conversations", "common"]), { isDesktop: i } = gr(), {
    isLoading: s,
    requestHasError: l,
    onSubmitCancellationForm: c,
    cancellationReasonsRadioItems: u,
    displayCommentTextarea: d,
    cancellationForm: {
      control: h,
      handleSubmit: f,
      setValue: m,
      formState: { errors: b }
    }
  } = Gh({ onClickContinue: t, cancellationReasons: e, conversation: n, user: a });
  return /* @__PURE__ */ B(cr, { children: [
    /* @__PURE__ */ B(Bt, { size: 6, centerContent: !0, children: [
      /* @__PURE__ */ y(Mo, { level: 2, children: r("cancellation-page.reason_step.title") }),
      /* @__PURE__ */ y("form", { onSubmit: f(c), children: /* @__PURE__ */ B(Eo, { isFullWidth: !0, flexGrow: !0, alignItems: "stretch", direction: "column", children: [
        /* @__PURE__ */ y(
          aa,
          {
            name: "reasonId",
            control: h,
            render: ({ field: w }) => /* @__PURE__ */ y(
              wn,
              {
                ...w,
                errorMessage: b.reasonId?.message ? r(b.reasonId.message) : void 0,
                onChange: (I) => {
                  I !== Ut && d && m("comment", ""), w.onChange(I);
                },
                label: r("cancellation-page.reason_step.checboxes_label"),
                children: u.map((I) => /* @__PURE__ */ y(wn.Item, { value: I.id, id: I.id, label: I.name }, I.id))
              }
            )
          }
        ),
        d && /* @__PURE__ */ y(
          aa,
          {
            name: "comment",
            control: h,
            render: ({ field: w }) => /* @__PURE__ */ y(
              ec,
              {
                placeholder: r("cancellation-page.reason_step.comment_placeholder"),
                id: "reason-comment",
                status: b.comment?.message ? "error" : void 0,
                message: b.comment?.message ? r(b.comment?.message, { limit: 255 }) : void 0,
                maxLength: 255,
                ...w
              }
            )
          }
        ),
        l && !s && /* @__PURE__ */ B(sc, { status: "error", hasIcon: !0, children: [
          /* @__PURE__ */ y("span", { style: { fontWeight: "bold" }, children: r("common:errors.unable_to_submit.title") }),
          /* @__PURE__ */ y(_t, { children: r("common:errors.unable_to_submit.subtitle") })
        ] }),
        /* @__PURE__ */ B(Do, { flexGrowButtons: !0, children: [
          /* @__PURE__ */ y(nt, { isLoading: s, disabled: s, color: "destructive", type: "submit", children: r("cancellation-page.cancel-exchange") }),
          /* @__PURE__ */ y(nt, { disabled: s, color: "tertiary", href: o, children: r("cancellation-page.keep-exchange") })
        ] })
      ] }) })
    ] }),
    i && /* @__PURE__ */ y(Bt, { size: 6, centerContent: !0, children: /* @__PURE__ */ y(
      lr,
      {
        width: "full",
        src: "https://gtg-prod.s3.eu-west-1.amazonaws.com/images/website/migration/cancellation/cancellation-regular-desktop.svg",
        alt: "cancellation-warning"
      }
    ) })
  ] });
}
function Zh({ onClickContinue: t, conversation: e }) {
  const { t: n } = Rn("conversations"), { isTablet: a, isMobile: o, isDesktop: r } = gr(), { url: i } = Fn(`/conversations/${e.id}`), s = /* @__PURE__ */ B(Do, { flexGrowButtons: !0, children: [
    /* @__PURE__ */ y(nt, { onClick: t, children: n("cancellation-page.continue-cancellation") }),
    /* @__PURE__ */ y(nt, { color: "tertiary", href: i, children: n("cancellation-page.keep-exchange") })
  ] });
  return /* @__PURE__ */ B(cr, { children: [
    /* @__PURE__ */ B(Bt, { size: 6, centerContent: !0, children: [
      /* @__PURE__ */ y(Mo, { level: 2, children: n("cancellation-page.cancel-exchange") }),
      /* @__PURE__ */ y(_t, { children: n("cancellation-page.warning-step.first-warning") }),
      /* @__PURE__ */ y(_t, { isBold: !0, children: n("cancellation-page.warning-step.second-warning") }),
      r && s
    ] }),
    /* @__PURE__ */ B(Bt, { size: 6, centerContent: !0, children: [
      /* @__PURE__ */ y(
        lr,
        {
          width: "full",
          src: "https://gtg-prod.s3.eu-west-1.amazonaws.com/images/website/migration/cancellation/cancellation-regular-desktop.svg",
          alt: "cancellation-warning"
        }
      ),
      (a || o) && s
    ] })
  ] });
}
const Or = "https://www.homeexchange.com/blog/calculate-the-carbon-footprint-of-your-trip/", Kh = {
  fr: "https://www.homeexchange.fr/blog/calculez-lempreinte-carbone-de-votre-voyage/",
  es: "https://es.homeexchange.com/es/blog/calcula-la-huella-de-carbono-de-tus-viajes/",
  en: Or
};
function Wx({
  className: t,
  title: e,
  description: n,
  locale: a,
  ctaText: o,
  onClickCTA: r
}) {
  return /* @__PURE__ */ y(
    dc,
    {
      className: t,
      color: "info",
      title: e,
      description: n,
      image: {
        alt: "transportation-banner-logo",
        imageSrc: "https://gtg-prod.s3.eu-west-1.amazonaws.com/images/website/migration/transportation/transportation-banner-logo.svg",
        imageSrcMobile: "https://gtg-prod.s3.eu-west-1.amazonaws.com/images/website/migration/transportation/transportation-banner-logo-small.svg"
      },
      cta: {
        color: "eco-green",
        text: o,
        onClick: async () => {
          await r(), window.open(Kh[a] || Or, "_blank");
        }
      }
    }
  );
}
const qh = (t, e, n, a) => {
  window.dataLayer = window.dataLayer || [], window.dataLayer.push({ event_data: null, page_data: null, user_data: null });
  const { eventCallback: o, ...r } = {}, i = (s) => {
    o && typeof o == "function" && s.startsWith("GTM-") && o(s);
  };
  window.dataLayer.push({
    event: "data_layer_init",
    event_data: {
      collection: n,
      method: null,
      text: null
    },
    page_data: {
      location: window.location.href,
      referrer: document.referrer,
      title: document.title,
      language: navigator.language
    },
    user_data: {
      login_status: "logged",
      uid: t,
      profile: e
    },
    eventCallback: i,
    ...r
  });
}, Ir = (t, e, n) => {
  window.dataLayer = window.dataLayer || [], window.dataLayer.push({ event_data: null });
  const { eventCallback: a, ...o } = n || {}, r = (i) => {
    a && typeof a == "function" && i.startsWith("GTM-") && a(i);
  };
  window.dataLayer.push({
    event: t,
    event_data: e,
    ...o,
    eventCallback: r
  }), !window.google_tag_manager && n?.eventCallback && typeof n.eventCallback == "function" && n.eventCallback();
}, Wh = (t, e, n) => {
  Ir("funnel_progress", {
    funnel_name: t,
    funnel_step: e,
    ...n
  });
}, Hh = (t) => t.subscriptionEndOn ? t.isHeCollection ? "member_collection" : new Date(t.subscriptionEndOn) < /* @__PURE__ */ new Date() ? "expired" : "member_regular" : "lead", D = (t) => typeof t == "string", lt = () => {
  let t, e;
  const n = new Promise((a, o) => {
    t = a, e = o;
  });
  return n.resolve = t, n.reject = e, n;
}, Ja = (t) => t == null ? "" : "" + t, Jh = (t, e, n) => {
  t.forEach((a) => {
    e[a] && (n[a] = e[a]);
  });
}, Yh = /###/g, Ya = (t) => t && t.indexOf("###") > -1 ? t.replace(Yh, ".") : t, Qa = (t) => !t || D(t), ht = (t, e, n) => {
  const a = D(e) ? e.split(".") : e;
  let o = 0;
  for (; o < a.length - 1; ) {
    if (Qa(t)) return {};
    const r = Ya(a[o]);
    !t[r] && n && (t[r] = new n()), Object.prototype.hasOwnProperty.call(t, r) ? t = t[r] : t = {}, ++o;
  }
  return Qa(t) ? {} : {
    obj: t,
    k: Ya(a[o])
  };
}, Xa = (t, e, n) => {
  const {
    obj: a,
    k: o
  } = ht(t, e, Object);
  if (a !== void 0 || e.length === 1) {
    a[o] = n;
    return;
  }
  let r = e[e.length - 1], i = e.slice(0, e.length - 1), s = ht(t, i, Object);
  for (; s.obj === void 0 && i.length; )
    r = `${i[i.length - 1]}.${r}`, i = i.slice(0, i.length - 1), s = ht(t, i, Object), s?.obj && typeof s.obj[`${s.k}.${r}`] < "u" && (s.obj = void 0);
  s.obj[`${s.k}.${r}`] = n;
}, Qh = (t, e, n, a) => {
  const {
    obj: o,
    k: r
  } = ht(t, e, Object);
  o[r] = o[r] || [], o[r].push(n);
}, Zt = (t, e) => {
  const {
    obj: n,
    k: a
  } = ht(t, e);
  if (n && Object.prototype.hasOwnProperty.call(n, a))
    return n[a];
}, Xh = (t, e, n) => {
  const a = Zt(t, n);
  return a !== void 0 ? a : Zt(e, n);
}, Lr = (t, e, n) => {
  for (const a in e)
    a !== "__proto__" && a !== "constructor" && (a in t ? D(t[a]) || t[a] instanceof String || D(e[a]) || e[a] instanceof String ? n && (t[a] = e[a]) : Lr(t[a], e[a], n) : t[a] = e[a]);
  return t;
}, Xe = (t) => t.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var e_ = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const t_ = (t) => D(t) ? t.replace(/[&<>"'\/]/g, (e) => e_[e]) : t;
class n_ {
  constructor(e) {
    this.capacity = e, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(e) {
    const n = this.regExpMap.get(e);
    if (n !== void 0)
      return n;
    const a = new RegExp(e);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(e, a), this.regExpQueue.push(e), a;
  }
}
const a_ = [" ", ",", "?", "!", ";"], o_ = new n_(20), r_ = (t, e, n) => {
  e = e || "", n = n || "";
  const a = a_.filter((i) => e.indexOf(i) < 0 && n.indexOf(i) < 0);
  if (a.length === 0) return !0;
  const o = o_.getRegExp(`(${a.map((i) => i === "?" ? "\\?" : i).join("|")})`);
  let r = !o.test(t);
  if (!r) {
    const i = t.indexOf(n);
    i > 0 && !o.test(t.substring(0, i)) && (r = !0);
  }
  return r;
}, An = (t, e, n = ".") => {
  if (!t) return;
  if (t[e])
    return Object.prototype.hasOwnProperty.call(t, e) ? t[e] : void 0;
  const a = e.split(n);
  let o = t;
  for (let r = 0; r < a.length; ) {
    if (!o || typeof o != "object")
      return;
    let i, s = "";
    for (let l = r; l < a.length; ++l)
      if (l !== r && (s += n), s += a[l], i = o[s], i !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof i) > -1 && l < a.length - 1)
          continue;
        r += l - r + 1;
        break;
      }
    o = i;
  }
  return o;
}, bt = (t) => t?.replace("_", "-"), i_ = {
  type: "logger",
  log(t) {
    this.output("log", t);
  },
  warn(t) {
    this.output("warn", t);
  },
  error(t) {
    this.output("error", t);
  },
  output(t, e) {
    console?.[t]?.apply?.(console, e);
  }
};
class Kt {
  constructor(e, n = {}) {
    this.init(e, n);
  }
  init(e, n = {}) {
    this.prefix = n.prefix || "i18next:", this.logger = e || i_, this.options = n, this.debug = n.debug;
  }
  log(...e) {
    return this.forward(e, "log", "", !0);
  }
  warn(...e) {
    return this.forward(e, "warn", "", !0);
  }
  error(...e) {
    return this.forward(e, "error", "");
  }
  deprecate(...e) {
    return this.forward(e, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(e, n, a, o) {
    return o && !this.debug ? null : (D(e[0]) && (e[0] = `${a}${this.prefix} ${e[0]}`), this.logger[n](e));
  }
  create(e) {
    return new Kt(this.logger, {
      prefix: `${this.prefix}:${e}:`,
      ...this.options
    });
  }
  clone(e) {
    return e = e || this.options, e.prefix = e.prefix || this.prefix, new Kt(this.logger, e);
  }
}
var ze = new Kt();
class on {
  constructor() {
    this.observers = {};
  }
  on(e, n) {
    return e.split(" ").forEach((a) => {
      this.observers[a] || (this.observers[a] = /* @__PURE__ */ new Map());
      const o = this.observers[a].get(n) || 0;
      this.observers[a].set(n, o + 1);
    }), this;
  }
  off(e, n) {
    if (this.observers[e]) {
      if (!n) {
        delete this.observers[e];
        return;
      }
      this.observers[e].delete(n);
    }
  }
  emit(e, ...n) {
    this.observers[e] && Array.from(this.observers[e].entries()).forEach(([o, r]) => {
      for (let i = 0; i < r; i++)
        o(...n);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach(([o, r]) => {
      for (let i = 0; i < r; i++)
        o.apply(o, [e, ...n]);
    });
  }
}
class eo extends on {
  constructor(e, n = {
    ns: ["translation"],
    defaultNS: "translation"
  }) {
    super(), this.data = e || {}, this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(e) {
    this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
  }
  removeNamespaces(e) {
    const n = this.options.ns.indexOf(e);
    n > -1 && this.options.ns.splice(n, 1);
  }
  getResource(e, n, a, o = {}) {
    const r = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator, i = o.ignoreJSONStructure !== void 0 ? o.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let s;
    e.indexOf(".") > -1 ? s = e.split(".") : (s = [e, n], a && (Array.isArray(a) ? s.push(...a) : D(a) && r ? s.push(...a.split(r)) : s.push(a)));
    const l = Zt(this.data, s);
    return !l && !n && !a && e.indexOf(".") > -1 && (e = s[0], n = s[1], a = s.slice(2).join(".")), l || !i || !D(a) ? l : An(this.data?.[e]?.[n], a, r);
  }
  addResource(e, n, a, o, r = {
    silent: !1
  }) {
    const i = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator;
    let s = [e, n];
    a && (s = s.concat(i ? a.split(i) : a)), e.indexOf(".") > -1 && (s = e.split("."), o = n, n = s[1]), this.addNamespaces(n), Xa(this.data, s, o), r.silent || this.emit("added", e, n, a, o);
  }
  addResources(e, n, a, o = {
    silent: !1
  }) {
    for (const r in a)
      (D(a[r]) || Array.isArray(a[r])) && this.addResource(e, n, r, a[r], {
        silent: !0
      });
    o.silent || this.emit("added", e, n, a);
  }
  addResourceBundle(e, n, a, o, r, i = {
    silent: !1,
    skipCopy: !1
  }) {
    let s = [e, n];
    e.indexOf(".") > -1 && (s = e.split("."), o = a, a = n, n = s[1]), this.addNamespaces(n);
    let l = Zt(this.data, s) || {};
    i.skipCopy || (a = JSON.parse(JSON.stringify(a))), o ? Lr(l, a, r) : l = {
      ...l,
      ...a
    }, Xa(this.data, s, l), i.silent || this.emit("added", e, n, a);
  }
  removeResourceBundle(e, n) {
    this.hasResourceBundle(e, n) && delete this.data[e][n], this.removeNamespaces(n), this.emit("removed", e, n);
  }
  hasResourceBundle(e, n) {
    return this.getResource(e, n) !== void 0;
  }
  getResourceBundle(e, n) {
    return n || (n = this.options.defaultNS), this.getResource(e, n);
  }
  getDataByLanguage(e) {
    return this.data[e];
  }
  hasLanguageSomeTranslations(e) {
    const n = this.getDataByLanguage(e);
    return !!(n && Object.keys(n) || []).find((o) => n[o] && Object.keys(n[o]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Dr = {
  processors: {},
  addPostProcessor(t) {
    this.processors[t.name] = t;
  },
  handle(t, e, n, a, o) {
    return t.forEach((r) => {
      e = this.processors[r]?.process(e, n, a, o) ?? e;
    }), e;
  }
};
const Mr = Symbol("i18next/PATH_KEY");
function s_() {
  const t = [], e = /* @__PURE__ */ Object.create(null);
  let n;
  return e.get = (a, o) => (n?.revoke?.(), o === Mr ? t : (t.push(o), n = Proxy.revocable(a, e), n.proxy)), Proxy.revocable(/* @__PURE__ */ Object.create(null), e).proxy;
}
function Nn(t, e) {
  const {
    [Mr]: n
  } = t(s_());
  return n.join(e?.keySeparator ?? ".");
}
const to = {}, no = (t) => !D(t) && typeof t != "boolean" && typeof t != "number";
class qt extends on {
  constructor(e, n = {}) {
    super(), Jh(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, this), this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = ze.create("translator");
  }
  changeLanguage(e) {
    e && (this.language = e);
  }
  exists(e, n = {
    interpolation: {}
  }) {
    const a = {
      ...n
    };
    return e == null ? !1 : this.resolve(e, a)?.res !== void 0;
  }
  extractFromKey(e, n) {
    let a = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    a === void 0 && (a = ":");
    const o = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let r = n.ns || this.options.defaultNS || [];
    const i = a && e.indexOf(a) > -1, s = !this.options.userDefinedKeySeparator && !n.keySeparator && !this.options.userDefinedNsSeparator && !n.nsSeparator && !r_(e, a, o);
    if (i && !s) {
      const l = e.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: e,
          namespaces: D(r) ? [r] : r
        };
      const c = e.split(a);
      (a !== o || a === o && this.options.ns.indexOf(c[0]) > -1) && (r = c.shift()), e = c.join(o);
    }
    return {
      key: e,
      namespaces: D(r) ? [r] : r
    };
  }
  translate(e, n, a) {
    let o = typeof n == "object" ? {
      ...n
    } : n;
    if (typeof o != "object" && this.options.overloadTranslationOptionHandler && (o = this.options.overloadTranslationOptionHandler(arguments)), typeof o == "object" && (o = {
      ...o
    }), o || (o = {}), e == null) return "";
    typeof e == "function" && (e = Nn(e, {
      ...this.options,
      ...o
    })), Array.isArray(e) || (e = [String(e)]);
    const r = o.returnDetails !== void 0 ? o.returnDetails : this.options.returnDetails, i = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator, {
      key: s,
      namespaces: l
    } = this.extractFromKey(e[e.length - 1], o), c = l[l.length - 1];
    let u = o.nsSeparator !== void 0 ? o.nsSeparator : this.options.nsSeparator;
    u === void 0 && (u = ":");
    const d = o.lng || this.language, h = o.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (d?.toLowerCase() === "cimode")
      return h ? r ? {
        res: `${c}${u}${s}`,
        usedKey: s,
        exactUsedKey: s,
        usedLng: d,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(o)
      } : `${c}${u}${s}` : r ? {
        res: s,
        usedKey: s,
        exactUsedKey: s,
        usedLng: d,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(o)
      } : s;
    const f = this.resolve(e, o);
    let m = f?.res;
    const b = f?.usedKey || s, w = f?.exactUsedKey || s, I = ["[object Number]", "[object Function]", "[object RegExp]"], k = o.joinArrays !== void 0 ? o.joinArrays : this.options.joinArrays, N = !this.i18nFormat || this.i18nFormat.handleAsObject, A = o.count !== void 0 && !D(o.count), L = qt.hasDefaultValue(o), F = A ? this.pluralResolver.getSuffix(d, o.count, o) : "", U = o.ordinal && A ? this.pluralResolver.getSuffix(d, o.count, {
      ordinal: !1
    }) : "", ne = A && !o.ordinal && o.count === 0, Q = ne && o[`defaultValue${this.options.pluralSeparator}zero`] || o[`defaultValue${F}`] || o[`defaultValue${U}`] || o.defaultValue;
    let X = m;
    N && !m && L && (X = Q);
    const ce = no(X), T = Object.prototype.toString.apply(X);
    if (N && X && ce && I.indexOf(T) < 0 && !(D(k) && Array.isArray(X))) {
      if (!o.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const P = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(b, X, {
          ...o,
          ns: l
        }) : `key '${s} (${this.language})' returned an object instead of string.`;
        return r ? (f.res = P, f.usedParams = this.getUsedParamsDetails(o), f) : P;
      }
      if (i) {
        const P = Array.isArray(X), R = P ? [] : {}, Z = P ? w : b;
        for (const W in X)
          if (Object.prototype.hasOwnProperty.call(X, W)) {
            const ae = `${Z}${i}${W}`;
            L && !m ? R[W] = this.translate(ae, {
              ...o,
              defaultValue: no(Q) ? Q[W] : void 0,
              joinArrays: !1,
              ns: l
            }) : R[W] = this.translate(ae, {
              ...o,
              joinArrays: !1,
              ns: l
            }), R[W] === ae && (R[W] = X[W]);
          }
        m = R;
      }
    } else if (N && D(k) && Array.isArray(m))
      m = m.join(k), m && (m = this.extendTranslation(m, e, o, a));
    else {
      let P = !1, R = !1;
      !this.isValidLookup(m) && L && (P = !0, m = Q), this.isValidLookup(m) || (R = !0, m = s);
      const W = (o.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && R ? void 0 : m, ae = L && Q !== m && this.options.updateMissing;
      if (R || P || ae) {
        if (this.logger.log(ae ? "updateKey" : "missingKey", d, c, s, ae ? Q : m), i) {
          const ue = this.resolve(s, {
            ...o,
            keySeparator: !1
          });
          ue && ue.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let ve = [];
        const ke = this.languageUtils.getFallbackCodes(this.options.fallbackLng, o.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && ke && ke[0])
          for (let ue = 0; ue < ke.length; ue++)
            ve.push(ke[ue]);
        else this.options.saveMissingTo === "all" ? ve = this.languageUtils.toResolveHierarchy(o.lng || this.language) : ve.push(o.lng || this.language);
        const Fe = (ue, Ne, je) => {
          const Ct = L && je !== m ? je : W;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(ue, c, Ne, Ct, ae, o) : this.backendConnector?.saveMissing && this.backendConnector.saveMissing(ue, c, Ne, Ct, ae, o), this.emit("missingKey", ue, c, Ne, m);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && A ? ve.forEach((ue) => {
          const Ne = this.pluralResolver.getSuffixes(ue, o);
          ne && o[`defaultValue${this.options.pluralSeparator}zero`] && Ne.indexOf(`${this.options.pluralSeparator}zero`) < 0 && Ne.push(`${this.options.pluralSeparator}zero`), Ne.forEach((je) => {
            Fe([ue], s + je, o[`defaultValue${je}`] || Q);
          });
        }) : Fe(ve, s, Q));
      }
      m = this.extendTranslation(m, e, o, f, a), R && m === s && this.options.appendNamespaceToMissingKey && (m = `${c}${u}${s}`), (R || P) && this.options.parseMissingKeyHandler && (m = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${c}${u}${s}` : s, P ? m : void 0, o));
    }
    return r ? (f.res = m, f.usedParams = this.getUsedParamsDetails(o), f) : m;
  }
  extendTranslation(e, n, a, o, r) {
    if (this.i18nFormat?.parse)
      e = this.i18nFormat.parse(e, {
        ...this.options.interpolation.defaultVariables,
        ...a
      }, a.lng || this.language || o.usedLng, o.usedNS, o.usedKey, {
        resolved: o
      });
    else if (!a.skipInterpolation) {
      a.interpolation && this.interpolator.init({
        ...a,
        interpolation: {
          ...this.options.interpolation,
          ...a.interpolation
        }
      });
      const l = D(e) && (a?.interpolation?.skipOnVariables !== void 0 ? a.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let c;
      if (l) {
        const d = e.match(this.interpolator.nestingRegexp);
        c = d && d.length;
      }
      let u = a.replace && !D(a.replace) ? a.replace : a;
      if (this.options.interpolation.defaultVariables && (u = {
        ...this.options.interpolation.defaultVariables,
        ...u
      }), e = this.interpolator.interpolate(e, u, a.lng || this.language || o.usedLng, a), l) {
        const d = e.match(this.interpolator.nestingRegexp), h = d && d.length;
        c < h && (a.nest = !1);
      }
      !a.lng && o && o.res && (a.lng = this.language || o.usedLng), a.nest !== !1 && (e = this.interpolator.nest(e, (...d) => r?.[0] === d[0] && !a.context ? (this.logger.warn(`It seems you are nesting recursively key: ${d[0]} in key: ${n[0]}`), null) : this.translate(...d, n), a)), a.interpolation && this.interpolator.reset();
    }
    const i = a.postProcess || this.options.postProcess, s = D(i) ? [i] : i;
    return e != null && s?.length && a.applyPostProcessor !== !1 && (e = Dr.handle(s, e, n, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...o,
        usedParams: this.getUsedParamsDetails(a)
      },
      ...a
    } : a, this)), e;
  }
  resolve(e, n = {}) {
    let a, o, r, i, s;
    return D(e) && (e = [e]), e.forEach((l) => {
      if (this.isValidLookup(a)) return;
      const c = this.extractFromKey(l, n), u = c.key;
      o = u;
      let d = c.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const h = n.count !== void 0 && !D(n.count), f = h && !n.ordinal && n.count === 0, m = n.context !== void 0 && (D(n.context) || typeof n.context == "number") && n.context !== "", b = n.lngs ? n.lngs : this.languageUtils.toResolveHierarchy(n.lng || this.language, n.fallbackLng);
      d.forEach((w) => {
        this.isValidLookup(a) || (s = w, !to[`${b[0]}-${w}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(s) && (to[`${b[0]}-${w}`] = !0, this.logger.warn(`key "${o}" for languages "${b.join(", ")}" won't get resolved as namespace "${s}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), b.forEach((I) => {
          if (this.isValidLookup(a)) return;
          i = I;
          const k = [u];
          if (this.i18nFormat?.addLookupKeys)
            this.i18nFormat.addLookupKeys(k, u, I, w, n);
          else {
            let A;
            h && (A = this.pluralResolver.getSuffix(I, n.count, n));
            const L = `${this.options.pluralSeparator}zero`, F = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (h && (n.ordinal && A.indexOf(F) === 0 && k.push(u + A.replace(F, this.options.pluralSeparator)), k.push(u + A), f && k.push(u + L)), m) {
              const U = `${u}${this.options.contextSeparator || "_"}${n.context}`;
              k.push(U), h && (n.ordinal && A.indexOf(F) === 0 && k.push(U + A.replace(F, this.options.pluralSeparator)), k.push(U + A), f && k.push(U + L));
            }
          }
          let N;
          for (; N = k.pop(); )
            this.isValidLookup(a) || (r = N, a = this.getResource(I, w, N, n));
        }));
      });
    }), {
      res: a,
      usedKey: o,
      exactUsedKey: r,
      usedLng: i,
      usedNS: s
    };
  }
  isValidLookup(e) {
    return e !== void 0 && !(!this.options.returnNull && e === null) && !(!this.options.returnEmptyString && e === "");
  }
  getResource(e, n, a, o = {}) {
    return this.i18nFormat?.getResource ? this.i18nFormat.getResource(e, n, a, o) : this.resourceStore.getResource(e, n, a, o);
  }
  getUsedParamsDetails(e = {}) {
    const n = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], a = e.replace && !D(e.replace);
    let o = a ? e.replace : e;
    if (a && typeof e.count < "u" && (o.count = e.count), this.options.interpolation.defaultVariables && (o = {
      ...this.options.interpolation.defaultVariables,
      ...o
    }), !a) {
      o = {
        ...o
      };
      for (const r of n)
        delete o[r];
    }
    return o;
  }
  static hasDefaultValue(e) {
    const n = "defaultValue";
    for (const a in e)
      if (Object.prototype.hasOwnProperty.call(e, a) && n === a.substring(0, n.length) && e[a] !== void 0)
        return !0;
    return !1;
  }
}
class ao {
  constructor(e) {
    this.options = e, this.supportedLngs = this.options.supportedLngs || !1, this.logger = ze.create("languageUtils");
  }
  getScriptPartFromCode(e) {
    if (e = bt(e), !e || e.indexOf("-") < 0) return null;
    const n = e.split("-");
    return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
  }
  getLanguagePartFromCode(e) {
    if (e = bt(e), !e || e.indexOf("-") < 0) return e;
    const n = e.split("-");
    return this.formatLanguageCode(n[0]);
  }
  formatLanguageCode(e) {
    if (D(e) && e.indexOf("-") > -1) {
      let n;
      try {
        n = Intl.getCanonicalLocales(e)[0];
      } catch {
      }
      return n && this.options.lowerCaseLng && (n = n.toLowerCase()), n || (this.options.lowerCaseLng ? e.toLowerCase() : e);
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
  }
  isSupportedCode(e) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
  }
  getBestMatchFromCodes(e) {
    if (!e) return null;
    let n;
    return e.forEach((a) => {
      if (n) return;
      const o = this.formatLanguageCode(a);
      (!this.options.supportedLngs || this.isSupportedCode(o)) && (n = o);
    }), !n && this.options.supportedLngs && e.forEach((a) => {
      if (n) return;
      const o = this.getScriptPartFromCode(a);
      if (this.isSupportedCode(o)) return n = o;
      const r = this.getLanguagePartFromCode(a);
      if (this.isSupportedCode(r)) return n = r;
      n = this.options.supportedLngs.find((i) => {
        if (i === r) return i;
        if (!(i.indexOf("-") < 0 && r.indexOf("-") < 0) && (i.indexOf("-") > 0 && r.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === r || i.indexOf(r) === 0 && r.length > 1))
          return i;
      });
    }), n || (n = this.getFallbackCodes(this.options.fallbackLng)[0]), n;
  }
  getFallbackCodes(e, n) {
    if (!e) return [];
    if (typeof e == "function" && (e = e(n)), D(e) && (e = [e]), Array.isArray(e)) return e;
    if (!n) return e.default || [];
    let a = e[n];
    return a || (a = e[this.getScriptPartFromCode(n)]), a || (a = e[this.formatLanguageCode(n)]), a || (a = e[this.getLanguagePartFromCode(n)]), a || (a = e.default), a || [];
  }
  toResolveHierarchy(e, n) {
    const a = this.getFallbackCodes((n === !1 ? [] : n) || this.options.fallbackLng || [], e), o = [], r = (i) => {
      i && (this.isSupportedCode(i) ? o.push(i) : this.logger.warn(`rejecting language code not found in supportedLngs: ${i}`));
    };
    return D(e) && (e.indexOf("-") > -1 || e.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && r(this.formatLanguageCode(e)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && r(this.getScriptPartFromCode(e)), this.options.load !== "currentOnly" && r(this.getLanguagePartFromCode(e))) : D(e) && r(this.formatLanguageCode(e)), a.forEach((i) => {
      o.indexOf(i) < 0 && r(this.formatLanguageCode(i));
    }), o;
  }
}
const oo = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, ro = {
  select: (t) => t === 1 ? "one" : "other",
  resolvedOptions: () => ({
    pluralCategories: ["one", "other"]
  })
};
class l_ {
  constructor(e, n = {}) {
    this.languageUtils = e, this.options = n, this.logger = ze.create("pluralResolver"), this.pluralRulesCache = {};
  }
  addRule(e, n) {
    this.rules[e] = n;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(e, n = {}) {
    const a = bt(e === "dev" ? "en" : e), o = n.ordinal ? "ordinal" : "cardinal", r = JSON.stringify({
      cleanedCode: a,
      type: o
    });
    if (r in this.pluralRulesCache)
      return this.pluralRulesCache[r];
    let i;
    try {
      i = new Intl.PluralRules(a, {
        type: o
      });
    } catch {
      if (!Intl)
        return this.logger.error("No Intl support, please use an Intl polyfill!"), ro;
      if (!e.match(/-|_/)) return ro;
      const l = this.languageUtils.getLanguagePartFromCode(e);
      i = this.getRule(l, n);
    }
    return this.pluralRulesCache[r] = i, i;
  }
  needsPlural(e, n = {}) {
    let a = this.getRule(e, n);
    return a || (a = this.getRule("dev", n)), a?.resolvedOptions().pluralCategories.length > 1;
  }
  getPluralFormsOfKey(e, n, a = {}) {
    return this.getSuffixes(e, a).map((o) => `${n}${o}`);
  }
  getSuffixes(e, n = {}) {
    let a = this.getRule(e, n);
    return a || (a = this.getRule("dev", n)), a ? a.resolvedOptions().pluralCategories.sort((o, r) => oo[o] - oo[r]).map((o) => `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${o}`) : [];
  }
  getSuffix(e, n, a = {}) {
    const o = this.getRule(e, a);
    return o ? `${this.options.prepend}${a.ordinal ? `ordinal${this.options.prepend}` : ""}${o.select(n)}` : (this.logger.warn(`no plural rule found for: ${e}`), this.getSuffix("dev", n, a));
  }
}
const io = (t, e, n, a = ".", o = !0) => {
  let r = Xh(t, e, n);
  return !r && o && D(n) && (r = An(t, n, a), r === void 0 && (r = An(e, n, a))), r;
}, mn = (t) => t.replace(/\$/g, "$$$$");
class c_ {
  constructor(e = {}) {
    this.logger = ze.create("interpolator"), this.options = e, this.format = e?.interpolation?.format || ((n) => n), this.init(e);
  }
  init(e = {}) {
    e.interpolation || (e.interpolation = {
      escapeValue: !0
    });
    const {
      escape: n,
      escapeValue: a,
      useRawValueToEscape: o,
      prefix: r,
      prefixEscaped: i,
      suffix: s,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: d,
      nestingPrefix: h,
      nestingPrefixEscaped: f,
      nestingSuffix: m,
      nestingSuffixEscaped: b,
      nestingOptionsSeparator: w,
      maxReplaces: I,
      alwaysFormat: k
    } = e.interpolation;
    this.escape = n !== void 0 ? n : t_, this.escapeValue = a !== void 0 ? a : !0, this.useRawValueToEscape = o !== void 0 ? o : !1, this.prefix = r ? Xe(r) : i || "{{", this.suffix = s ? Xe(s) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = h ? Xe(h) : f || Xe("$t("), this.nestingSuffix = m ? Xe(m) : b || Xe(")"), this.nestingOptionsSeparator = w || ",", this.maxReplaces = I || 1e3, this.alwaysFormat = k !== void 0 ? k : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const e = (n, a) => n?.source === a ? (n.lastIndex = 0, n) : new RegExp(a, "g");
    this.regexp = e(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = e(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = e(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
  }
  interpolate(e, n, a, o) {
    let r, i, s;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (f) => {
      if (f.indexOf(this.formatSeparator) < 0) {
        const I = io(n, l, f, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(I, void 0, a, {
          ...o,
          ...n,
          interpolationkey: f
        }) : I;
      }
      const m = f.split(this.formatSeparator), b = m.shift().trim(), w = m.join(this.formatSeparator).trim();
      return this.format(io(n, l, b, this.options.keySeparator, this.options.ignoreJSONStructure), w, a, {
        ...o,
        ...n,
        interpolationkey: b
      });
    };
    this.resetRegExp();
    const u = o?.missingInterpolationHandler || this.options.missingInterpolationHandler, d = o?.interpolation?.skipOnVariables !== void 0 ? o.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (f) => mn(f)
    }, {
      regex: this.regexp,
      safeValue: (f) => this.escapeValue ? mn(this.escape(f)) : mn(f)
    }].forEach((f) => {
      for (s = 0; r = f.regex.exec(e); ) {
        const m = r[1].trim();
        if (i = c(m), i === void 0)
          if (typeof u == "function") {
            const w = u(e, r, o);
            i = D(w) ? w : "";
          } else if (o && Object.prototype.hasOwnProperty.call(o, m))
            i = "";
          else if (d) {
            i = r[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${m} for interpolating ${e}`), i = "";
        else !D(i) && !this.useRawValueToEscape && (i = Ja(i));
        const b = f.safeValue(i);
        if (e = e.replace(r[0], b), d ? (f.regex.lastIndex += i.length, f.regex.lastIndex -= r[0].length) : f.regex.lastIndex = 0, s++, s >= this.maxReplaces)
          break;
      }
    }), e;
  }
  nest(e, n, a = {}) {
    let o, r, i;
    const s = (l, c) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0) return l;
      const d = l.split(new RegExp(`${u}[ ]*{`));
      let h = `{${d[1]}`;
      l = d[0], h = this.interpolate(h, i);
      const f = h.match(/'/g), m = h.match(/"/g);
      ((f?.length ?? 0) % 2 === 0 && !m || m.length % 2 !== 0) && (h = h.replace(/'/g, '"'));
      try {
        i = JSON.parse(h), c && (i = {
          ...c,
          ...i
        });
      } catch (b) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, b), `${l}${u}${h}`;
      }
      return i.defaultValue && i.defaultValue.indexOf(this.prefix) > -1 && delete i.defaultValue, l;
    };
    for (; o = this.nestingRegexp.exec(e); ) {
      let l = [];
      i = {
        ...a
      }, i = i.replace && !D(i.replace) ? i.replace : i, i.applyPostProcessor = !1, delete i.defaultValue;
      const c = /{.*}/.test(o[1]) ? o[1].lastIndexOf("}") + 1 : o[1].indexOf(this.formatSeparator);
      if (c !== -1 && (l = o[1].slice(c).split(this.formatSeparator).map((u) => u.trim()).filter(Boolean), o[1] = o[1].slice(0, c)), r = n(s.call(this, o[1].trim(), i), i), r && o[0] === e && !D(r)) return r;
      D(r) || (r = Ja(r)), r || (this.logger.warn(`missed to resolve ${o[1]} for nesting ${e}`), r = ""), l.length && (r = l.reduce((u, d) => this.format(u, d, a.lng, {
        ...a,
        interpolationkey: o[1].trim()
      }), r.trim())), e = e.replace(o[0], r), this.regexp.lastIndex = 0;
    }
    return e;
  }
}
const u_ = (t) => {
  let e = t.toLowerCase().trim();
  const n = {};
  if (t.indexOf("(") > -1) {
    const a = t.split("(");
    e = a[0].toLowerCase().trim();
    const o = a[1].substring(0, a[1].length - 1);
    e === "currency" && o.indexOf(":") < 0 ? n.currency || (n.currency = o.trim()) : e === "relativetime" && o.indexOf(":") < 0 ? n.range || (n.range = o.trim()) : o.split(";").forEach((i) => {
      if (i) {
        const [s, ...l] = i.split(":"), c = l.join(":").trim().replace(/^'+|'+$/g, ""), u = s.trim();
        n[u] || (n[u] = c), c === "false" && (n[u] = !1), c === "true" && (n[u] = !0), isNaN(c) || (n[u] = parseInt(c, 10));
      }
    });
  }
  return {
    formatName: e,
    formatOptions: n
  };
}, so = (t) => {
  const e = {};
  return (n, a, o) => {
    let r = o;
    o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey] && (r = {
      ...r,
      [o.interpolationkey]: void 0
    });
    const i = a + JSON.stringify(r);
    let s = e[i];
    return s || (s = t(bt(a), o), e[i] = s), s(n);
  };
}, d_ = (t) => (e, n, a) => t(bt(n), a)(e);
class g_ {
  constructor(e = {}) {
    this.logger = ze.create("formatter"), this.options = e, this.init(e);
  }
  init(e, n = {
    interpolation: {}
  }) {
    this.formatSeparator = n.interpolation.formatSeparator || ",";
    const a = n.cacheInBuiltFormats ? so : d_;
    this.formats = {
      number: a((o, r) => {
        const i = new Intl.NumberFormat(o, {
          ...r
        });
        return (s) => i.format(s);
      }),
      currency: a((o, r) => {
        const i = new Intl.NumberFormat(o, {
          ...r,
          style: "currency"
        });
        return (s) => i.format(s);
      }),
      datetime: a((o, r) => {
        const i = new Intl.DateTimeFormat(o, {
          ...r
        });
        return (s) => i.format(s);
      }),
      relativetime: a((o, r) => {
        const i = new Intl.RelativeTimeFormat(o, {
          ...r
        });
        return (s) => i.format(s, r.range || "day");
      }),
      list: a((o, r) => {
        const i = new Intl.ListFormat(o, {
          ...r
        });
        return (s) => i.format(s);
      })
    };
  }
  add(e, n) {
    this.formats[e.toLowerCase().trim()] = n;
  }
  addCached(e, n) {
    this.formats[e.toLowerCase().trim()] = so(n);
  }
  format(e, n, a, o = {}) {
    const r = n.split(this.formatSeparator);
    if (r.length > 1 && r[0].indexOf("(") > 1 && r[0].indexOf(")") < 0 && r.find((s) => s.indexOf(")") > -1)) {
      const s = r.findIndex((l) => l.indexOf(")") > -1);
      r[0] = [r[0], ...r.splice(1, s)].join(this.formatSeparator);
    }
    return r.reduce((s, l) => {
      const {
        formatName: c,
        formatOptions: u
      } = u_(l);
      if (this.formats[c]) {
        let d = s;
        try {
          const h = o?.formatParams?.[o.interpolationkey] || {}, f = h.locale || h.lng || o.locale || o.lng || a;
          d = this.formats[c](s, f, {
            ...u,
            ...o,
            ...h
          });
        } catch (h) {
          this.logger.warn(h);
        }
        return d;
      } else
        this.logger.warn(`there was no format function for ${c}`);
      return s;
    }, e);
  }
}
const h_ = (t, e) => {
  t.pending[e] !== void 0 && (delete t.pending[e], t.pendingCount--);
};
class __ extends on {
  constructor(e, n, a, o = {}) {
    super(), this.backend = e, this.store = n, this.services = a, this.languageUtils = a.languageUtils, this.options = o, this.logger = ze.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = o.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = o.maxRetries >= 0 ? o.maxRetries : 5, this.retryTimeout = o.retryTimeout >= 1 ? o.retryTimeout : 350, this.state = {}, this.queue = [], this.backend?.init?.(a, o.backend, o);
  }
  queueLoad(e, n, a, o) {
    const r = {}, i = {}, s = {}, l = {};
    return e.forEach((c) => {
      let u = !0;
      n.forEach((d) => {
        const h = `${c}|${d}`;
        !a.reload && this.store.hasResourceBundle(c, d) ? this.state[h] = 2 : this.state[h] < 0 || (this.state[h] === 1 ? i[h] === void 0 && (i[h] = !0) : (this.state[h] = 1, u = !1, i[h] === void 0 && (i[h] = !0), r[h] === void 0 && (r[h] = !0), l[d] === void 0 && (l[d] = !0)));
      }), u || (s[c] = !0);
    }), (Object.keys(r).length || Object.keys(i).length) && this.queue.push({
      pending: i,
      pendingCount: Object.keys(i).length,
      loaded: {},
      errors: [],
      callback: o
    }), {
      toLoad: Object.keys(r),
      pending: Object.keys(i),
      toLoadLanguages: Object.keys(s),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(e, n, a) {
    const o = e.split("|"), r = o[0], i = o[1];
    n && this.emit("failedLoading", r, i, n), !n && a && this.store.addResourceBundle(r, i, a, void 0, void 0, {
      skipCopy: !0
    }), this.state[e] = n ? -1 : 2, n && a && (this.state[e] = 0);
    const s = {};
    this.queue.forEach((l) => {
      Qh(l.loaded, [r], i), h_(l, e), n && l.errors.push(n), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        s[c] || (s[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((d) => {
          s[c][d] === void 0 && (s[c][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", s), this.queue = this.queue.filter((l) => !l.done);
  }
  read(e, n, a, o = 0, r = this.retryTimeout, i) {
    if (!e.length) return i(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: e,
        ns: n,
        fcName: a,
        tried: o,
        wait: r,
        callback: i
      });
      return;
    }
    this.readingCalls++;
    const s = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (c && u && o < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, e, n, a, o + 1, r * 2, i);
        }, r);
        return;
      }
      i(c, u);
    }, l = this.backend[a].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(e, n);
        c && typeof c.then == "function" ? c.then((u) => s(null, u)).catch(s) : s(null, c);
      } catch (c) {
        s(c);
      }
      return;
    }
    return l(e, n, s);
  }
  prepareLoading(e, n, a = {}, o) {
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), o && o();
    D(e) && (e = this.languageUtils.toResolveHierarchy(e)), D(n) && (n = [n]);
    const r = this.queueLoad(e, n, a, o);
    if (!r.toLoad.length)
      return r.pending.length || o(), null;
    r.toLoad.forEach((i) => {
      this.loadOne(i);
    });
  }
  load(e, n, a) {
    this.prepareLoading(e, n, {}, a);
  }
  reload(e, n, a) {
    this.prepareLoading(e, n, {
      reload: !0
    }, a);
  }
  loadOne(e, n = "") {
    const a = e.split("|"), o = a[0], r = a[1];
    this.read(o, r, "read", void 0, void 0, (i, s) => {
      i && this.logger.warn(`${n}loading namespace ${r} for language ${o} failed`, i), !i && s && this.logger.log(`${n}loaded namespace ${r} for language ${o}`, s), this.loaded(e, i, s);
    });
  }
  saveMissing(e, n, a, o, r, i = {}, s = () => {
  }) {
    if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(n)) {
      this.logger.warn(`did not save key "${a}" as the namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(a == null || a === "")) {
      if (this.backend?.create) {
        const l = {
          ...i,
          isUpdate: r
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(e, n, a, o, l) : u = c(e, n, a, o), u && typeof u.then == "function" ? u.then((d) => s(null, d)).catch(s) : s(null, u);
          } catch (u) {
            s(u);
          }
        else
          c(e, n, a, o, s, l);
      }
      !e || !e[0] || this.store.addResource(e[0], n, a, o);
    }
  }
}
const lo = () => ({
  debug: !1,
  initAsync: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (t) => {
    let e = {};
    if (typeof t[1] == "object" && (e = t[1]), D(t[1]) && (e.defaultValue = t[1]), D(t[2]) && (e.tDescription = t[2]), typeof t[2] == "object" || typeof t[3] == "object") {
      const n = t[3] || t[2];
      Object.keys(n).forEach((a) => {
        e[a] = n[a];
      });
    }
    return e;
  },
  interpolation: {
    escapeValue: !0,
    format: (t) => t,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  },
  cacheInBuiltFormats: !0
}), co = (t) => (D(t.ns) && (t.ns = [t.ns]), D(t.fallbackLng) && (t.fallbackLng = [t.fallbackLng]), D(t.fallbackNS) && (t.fallbackNS = [t.fallbackNS]), t.supportedLngs?.indexOf?.("cimode") < 0 && (t.supportedLngs = t.supportedLngs.concat(["cimode"])), typeof t.initImmediate == "boolean" && (t.initAsync = t.initImmediate), t), Lt = () => {
}, f_ = (t) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(t)).forEach((n) => {
    typeof t[n] == "function" && (t[n] = t[n].bind(t));
  });
};
class yt extends on {
  constructor(e = {}, n) {
    if (super(), this.options = co(e), this.services = {}, this.logger = ze, this.modules = {
      external: []
    }, f_(this), n && !this.isInitialized && !e.isClone) {
      if (!this.options.initAsync)
        return this.init(e, n), this;
      setTimeout(() => {
        this.init(e, n);
      }, 0);
    }
  }
  init(e = {}, n) {
    this.isInitializing = !0, typeof e == "function" && (n = e, e = {}), e.defaultNS == null && e.ns && (D(e.ns) ? e.defaultNS = e.ns : e.ns.indexOf("translation") < 0 && (e.defaultNS = e.ns[0]));
    const a = lo();
    this.options = {
      ...a,
      ...this.options,
      ...co(e)
    }, this.options.interpolation = {
      ...a.interpolation,
      ...this.options.interpolation
    }, e.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = e.keySeparator), e.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = e.nsSeparator);
    const o = (c) => c ? typeof c == "function" ? new c() : c : null;
    if (!this.options.isClone) {
      this.modules.logger ? ze.init(o(this.modules.logger), this.options) : ze.init(null, this.options);
      let c;
      this.modules.formatter ? c = this.modules.formatter : c = g_;
      const u = new ao(this.options);
      this.store = new eo(this.options.resources, this.options);
      const d = this.services;
      d.logger = ze, d.resourceStore = this.store, d.languageUtils = u, d.pluralResolver = new l_(u, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), this.options.interpolation.format && this.options.interpolation.format !== a.interpolation.format && this.logger.deprecate("init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting"), c && (!this.options.interpolation.format || this.options.interpolation.format === a.interpolation.format) && (d.formatter = o(c), d.formatter.init && d.formatter.init(d, this.options), this.options.interpolation.format = d.formatter.format.bind(d.formatter)), d.interpolator = new c_(this.options), d.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, d.backendConnector = new __(o(this.modules.backend), d.resourceStore, d, this.options), d.backendConnector.on("*", (f, ...m) => {
        this.emit(f, ...m);
      }), this.modules.languageDetector && (d.languageDetector = o(this.modules.languageDetector), d.languageDetector.init && d.languageDetector.init(d, this.options.detection, this.options)), this.modules.i18nFormat && (d.i18nFormat = o(this.modules.i18nFormat), d.i18nFormat.init && d.i18nFormat.init(this)), this.translator = new qt(this.services, this.options), this.translator.on("*", (f, ...m) => {
        this.emit(f, ...m);
      }), this.modules.external.forEach((f) => {
        f.init && f.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, n || (n = Lt), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const c = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      c.length > 0 && c[0] !== "dev" && (this.options.lng = c[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((c) => {
      this[c] = (...u) => this.store[c](...u);
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((c) => {
      this[c] = (...u) => (this.store[c](...u), this);
    });
    const s = lt(), l = () => {
      const c = (u, d) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), s.resolve(d), n(u, d);
      };
      if (this.languages && !this.isInitialized) return c(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, c);
    };
    return this.options.resources || !this.options.initAsync ? l() : setTimeout(l, 0), s;
  }
  loadResources(e, n = Lt) {
    let a = n;
    const o = D(e) ? e : this.language;
    if (typeof e == "function" && (a = e), !this.options.resources || this.options.partialBundledLanguages) {
      if (o?.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return a();
      const r = [], i = (s) => {
        if (!s || s === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(s).forEach((c) => {
          c !== "cimode" && r.indexOf(c) < 0 && r.push(c);
        });
      };
      o ? i(o) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => i(l)), this.options.preload?.forEach?.((s) => i(s)), this.services.backendConnector.load(r, this.options.ns, (s) => {
        !s && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), a(s);
      });
    } else
      a(null);
  }
  reloadResources(e, n, a) {
    const o = lt();
    return typeof e == "function" && (a = e, e = void 0), typeof n == "function" && (a = n, n = void 0), e || (e = this.languages), n || (n = this.options.ns), a || (a = Lt), this.services.backendConnector.reload(e, n, (r) => {
      o.resolve(), a(r);
    }), o;
  }
  use(e) {
    if (!e) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return e.type === "backend" && (this.modules.backend = e), (e.type === "logger" || e.log && e.warn && e.error) && (this.modules.logger = e), e.type === "languageDetector" && (this.modules.languageDetector = e), e.type === "i18nFormat" && (this.modules.i18nFormat = e), e.type === "postProcessor" && Dr.addPostProcessor(e), e.type === "formatter" && (this.modules.formatter = e), e.type === "3rdParty" && this.modules.external.push(e), this;
  }
  setResolvedLanguage(e) {
    if (!(!e || !this.languages) && !(["cimode", "dev"].indexOf(e) > -1)) {
      for (let n = 0; n < this.languages.length; n++) {
        const a = this.languages[n];
        if (!(["cimode", "dev"].indexOf(a) > -1) && this.store.hasLanguageSomeTranslations(a)) {
          this.resolvedLanguage = a;
          break;
        }
      }
      !this.resolvedLanguage && this.languages.indexOf(e) < 0 && this.store.hasLanguageSomeTranslations(e) && (this.resolvedLanguage = e, this.languages.unshift(e));
    }
  }
  changeLanguage(e, n) {
    this.isLanguageChangingTo = e;
    const a = lt();
    this.emit("languageChanging", e);
    const o = (s) => {
      this.language = s, this.languages = this.services.languageUtils.toResolveHierarchy(s), this.resolvedLanguage = void 0, this.setResolvedLanguage(s);
    }, r = (s, l) => {
      l ? this.isLanguageChangingTo === e && (o(l), this.translator.changeLanguage(l), this.isLanguageChangingTo = void 0, this.emit("languageChanged", l), this.logger.log("languageChanged", l)) : this.isLanguageChangingTo = void 0, a.resolve((...c) => this.t(...c)), n && n(s, (...c) => this.t(...c));
    }, i = (s) => {
      !e && !s && this.services.languageDetector && (s = []);
      const l = D(s) ? s : s && s[0], c = this.store.hasLanguageSomeTranslations(l) ? l : this.services.languageUtils.getBestMatchFromCodes(D(s) ? [s] : s);
      c && (this.language || o(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector?.cacheUserLanguage?.(c)), this.loadResources(c, (u) => {
        r(u, c);
      });
    };
    return !e && this.services.languageDetector && !this.services.languageDetector.async ? i(this.services.languageDetector.detect()) : !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(i) : this.services.languageDetector.detect(i) : i(e), a;
  }
  getFixedT(e, n, a) {
    const o = (r, i, ...s) => {
      let l;
      typeof i != "object" ? l = this.options.overloadTranslationOptionHandler([r, i].concat(s)) : l = {
        ...i
      }, l.lng = l.lng || o.lng, l.lngs = l.lngs || o.lngs, l.ns = l.ns || o.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || a || o.keyPrefix);
      const c = this.options.keySeparator || ".";
      let u;
      return l.keyPrefix && Array.isArray(r) ? u = r.map((d) => (typeof d == "function" && (d = Nn(d, {
        ...this.options,
        ...i
      })), `${l.keyPrefix}${c}${d}`)) : (typeof r == "function" && (r = Nn(r, {
        ...this.options,
        ...i
      })), u = l.keyPrefix ? `${l.keyPrefix}${c}${r}` : r), this.t(u, l);
    };
    return D(e) ? o.lng = e : o.lngs = e, o.ns = n, o.keyPrefix = a, o;
  }
  t(...e) {
    return this.translator?.translate(...e);
  }
  exists(...e) {
    return this.translator?.exists(...e);
  }
  setDefaultNamespace(e) {
    this.options.defaultNS = e;
  }
  hasLoadedNamespace(e, n = {}) {
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const a = n.lng || this.resolvedLanguage || this.languages[0], o = this.options ? this.options.fallbackLng : !1, r = this.languages[this.languages.length - 1];
    if (a.toLowerCase() === "cimode") return !0;
    const i = (s, l) => {
      const c = this.services.backendConnector.state[`${s}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (n.precheck) {
      const s = n.precheck(this, i);
      if (s !== void 0) return s;
    }
    return !!(this.hasResourceBundle(a, e) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || i(a, e) && (!o || i(r, e)));
  }
  loadNamespaces(e, n) {
    const a = lt();
    return this.options.ns ? (D(e) && (e = [e]), e.forEach((o) => {
      this.options.ns.indexOf(o) < 0 && this.options.ns.push(o);
    }), this.loadResources((o) => {
      a.resolve(), n && n(o);
    }), a) : (n && n(), Promise.resolve());
  }
  loadLanguages(e, n) {
    const a = lt();
    D(e) && (e = [e]);
    const o = this.options.preload || [], r = e.filter((i) => o.indexOf(i) < 0 && this.services.languageUtils.isSupportedCode(i));
    return r.length ? (this.options.preload = o.concat(r), this.loadResources((i) => {
      a.resolve(), n && n(i);
    }), a) : (n && n(), Promise.resolve());
  }
  dir(e) {
    if (e || (e = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language)), !e) return "rtl";
    try {
      const o = new Intl.Locale(e);
      if (o && o.getTextInfo) {
        const r = o.getTextInfo();
        if (r && r.direction) return r.direction;
      }
    } catch {
    }
    const n = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], a = this.services?.languageUtils || new ao(lo());
    return e.toLowerCase().indexOf("-latn") > 1 ? "ltr" : n.indexOf(a.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance(e = {}, n) {
    return new yt(e, n);
  }
  cloneInstance(e = {}, n = Lt) {
    const a = e.forkResourceStore;
    a && delete e.forkResourceStore;
    const o = {
      ...this.options,
      ...e,
      isClone: !0
    }, r = new yt(o);
    if ((e.debug !== void 0 || e.prefix !== void 0) && (r.logger = r.logger.clone(e)), ["store", "services", "language"].forEach((s) => {
      r[s] = this[s];
    }), r.services = {
      ...this.services
    }, r.services.utils = {
      hasLoadedNamespace: r.hasLoadedNamespace.bind(r)
    }, a) {
      const s = Object.keys(this.store.data).reduce((l, c) => (l[c] = {
        ...this.store.data[c]
      }, l[c] = Object.keys(l[c]).reduce((u, d) => (u[d] = {
        ...l[c][d]
      }, u), l[c]), l), {});
      r.store = new eo(s, o), r.services.resourceStore = r.store;
    }
    return r.translator = new qt(r.services, o), r.translator.on("*", (s, ...l) => {
      r.emit(s, ...l);
    }), r.init(o, n), r.translator.options = o, r.translator.backendConnector.services.utils = {
      hasLoadedNamespace: r.hasLoadedNamespace.bind(r)
    }, r;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const ge = yt.createInstance();
ge.createInstance = yt.createInstance;
const m_ = ge.createInstance;
ge.dir;
ge.init;
ge.loadResources;
ge.reloadResources;
ge.use;
ge.changeLanguage;
ge.getFixedT;
ge.t;
ge.exists;
ge.setDefaultNamespace;
ge.hasLoadedNamespace;
ge.loadNamespaces;
ge.loadLanguages;
const p_ = "Studio", b_ = "{{count}} soveværelse", y_ = "{{count}} soveværelser", v_ = "", k_ = "{{count}} seng", w_ = "{{count}} senge", $_ = "Din kalender er blevet opdateret.", C_ = "", S_ = "", x_ = "", z_ = "", A_ = "", N_ = "", O_ = "", I_ = "", L_ = "Annuller", D_ = "Datoer", M_ = "Slet", E_ = "Beskrivelse", j_ = "Destination", P_ = "Sådan!", T_ = "Rediger", R_ = "Filtre", B_ = "", F_ = "", V_ = "Gæster", G_ = "boliger", U_ = "", Z_ = "Lokation", K_ = "Rediger", q_ = "Navn", W_ = "Næste", H_ = "", J_ = "", Y_ = "{{count}} voksne", Q_ = "", X_ = "", ef = "{{count}} babyer", tf = "", nf = "", af = "{{count}} børn", of = "{{count}} gæst", rf = "{{count}} gæst", sf = "{{count}} gæster", lf = "Telefonnummerets format er ikke gyldigt.", cf = "Modtag e-mailnotifikationer", uf = "Gem", df = "Ingen lokationer fundet", gf = "Rejseliste", hf = "", _f = "valgfrit", ff = {
  "autocomplete.button": "Søg",
  "autocomplete.placeholder": "Hvor skal du hen ?",
  bedroomsNumbers_zero: p_,
  bedroomsNumbers_one: b_,
  bedroomsNumbers_other: y_,
  beds_zero: v_,
  beds_one: k_,
  beds_other: w_,
  "button.free-signup": "Tilmeld dig gratis",
  "button.validate": "Bekræft",
  "common.try-again": "Prøv igen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Må ikke overstige {{limit}} tegn",
  "error.reload": "Opdater siden",
  "error.return-homepage": "Tilbage til startsiden",
  "error.subtitle": "Denne side kan desværre ikke nås..",
  "error.title": "Der opstod en fejl på siden",
  "errors.unable_to_submit.subtitle": '"Din formular kunne desværre ikke \\nindsendes lige nu. Prøv igen \\nsenere."',
  "errors.unable_to_submit.title": "Ups, vi løb ind i et problem",
  "global.back": "Tilbage",
  "global.cancel": "Annuller",
  "global.collection.browsehomes": "Se boliger",
  "global.collection.contactus": "Kontakt os",
  "global.confirm": "Bekræft",
  "global.continue": "Fortsæt",
  "global.getStarted": "Kom godt i gang",
  "global.login": "Log ind",
  "global.select": "Vælg",
  global_calendarUpdated_toast: $_,
  global_calendar_aMonth: C_,
  global_calendar_exactDates: S_,
  global_calendar_oneWeek: x_,
  global_calendar_oneWeekend: z_,
  global_calendar_plusMinusDay_zero: A_,
  global_calendar_plusMinusDay_one: N_,
  global_calendar_plusMinusDay_other: O_,
  global_calendar_twoWeeks: I_,
  global_cancel: L_,
  global_dates: D_,
  global_delete: M_,
  global_description: E_,
  global_destination: j_,
  global_done: P_,
  global_edit: T_,
  global_filters: R_,
  global_fixDates: B_,
  global_flexibleDates: F_,
  global_guests: V_,
  global_homes: G_,
  global_lastMinute: U_,
  global_location: Z_,
  global_modify: K_,
  global_name: q_,
  global_next: W_,
  global_numberOfAdults_zero: H_,
  global_numberOfAdults_one: J_,
  global_numberOfAdults_other: Y_,
  global_numberOfBabies_zero: Q_,
  global_numberOfBabies_one: X_,
  global_numberOfBabies_other: ef,
  global_numberOfChildren_zero: tf,
  global_numberOfChildren_one: nf,
  global_numberOfChildren_other: af,
  global_numberOfGuests_zero: of,
  global_numberOfGuests_one: rf,
  global_numberOfGuests_other: sf,
  global_phoneNumber_notValid: lf,
  global_receiveEmailAlerts: cf,
  global_save: uf,
  global_searchBar_noLocationFound: df,
  global_travelWishlist: gf,
  "modal.error-occured.content": "Vi beklager ulejligheden, men prøv \\nvenligst igen.",
  "modal.error-occured.title": "Åh nej, der er opstået en fejl!",
  no_result: hf,
  optional: _f,
  "privacy-policy": "Privatpolitik"
}, mf = "Når du har forhåndsgodkendt  dette boligbytte, skal din byttepartner bekræfte det. Byttepartneren har {nbDays} dage til at bekræfte boligbyttet (indtil {date}). Ellers vil din forhåndsgodkendelse udløbe, og du bliver nødt til at forhåndsgodkende boligbyttet igen.", pf = "Dobbelt booking (via en anden platform)", bf = "Familieproblemer", yf = "Helbredsproblemer", vf = "Skader i hjemmet", kf = "Flytning", wf = "Du skal angive årsagerne til, at du vil annullere boligbyttet.", $f = "Andre", Cf = "Transportproblemer", Sf = "Tillidsproblem", xf = "Arbejdsrelateret", zf = "Du er nødt til at indtaste en årsag", Af = {
  "cancellation-page.cancel-exchange": "Annuller boligbyttet",
  "cancellation-page.continue-cancellation": "Fortsæt annulleringen",
  "cancellation-page.keep-exchange": "Behold mit boligbytte",
  "cancellation-page.reason_step.checboxes_label": "Vælg hovedårsagen til din annullering:",
  "cancellation-page.reason_step.comment_placeholder": "Skriv årsagen til din annullering her.",
  "cancellation-page.reason_step.error": "Du er nødt til at indtaste en årsag",
  "cancellation-page.reason_step.title": "Hvorfor er du nødt til at annullere?",
  "cancellation-page.warning-step.first-warning": "Husk, at annullering af dit boligbytte kan have en negativ indvirkning på din byttepartner, som måske allerede har lavet rejseplaner!",
  "cancellation-page.warning-step.second-warning": "Vigtigt: I tilfælde af for mange uberettigede aflysninger som vært, kan din konto blive taget offline. Og som gæst får du muligvis ikke alle dine GuestPoints tilbage.",
  pre_approval_modal_expiration_description: mf,
  reasons_for_cancellation_double_booking_rental: pf,
  reasons_for_cancellation_family_issues: bf,
  reasons_for_cancellation_health_issues: yf,
  reasons_for_cancellation_home_damage: vf,
  reasons_for_cancellation_moving: kf,
  reasons_for_cancellation_needed: wf,
  reasons_for_cancellation_other: $f,
  reasons_for_cancellation_transportation_issues: Cf,
  reasons_for_cancellation_trust_issues: Sf,
  reasons_for_cancellation_work_related: xf,
  reasons_other_comment_needed: zf
}, Nf = "Studio", Of = "{{count}} schlafzimmer", If = "{{count}} schlafzimmer", Lf = "", Df = "{{count}} Bett", Mf = "{{count}} Betten", Ef = "Ihr Kalender wurde aktualisiert.", jf = "Ein Monat", Pf = "Genaue Daten", Tf = "Eine Woche", Rf = "Ein Wochenende", Bf = "", Ff = "{{count}} Tag", Vf = "{{count}} Tage", Gf = "Zwei Wochen", Uf = "Abbrechen", Zf = "Daten", Kf = "Löschen", qf = "Beschreibung", Wf = "Reiseziel", Hf = "Fertig!", Jf = "Bearbeiten", Yf = "Filter", Qf = "Feste Daten", Xf = "Flexible Daten", em = "Gäste", tm = "Unterkünfte", nm = "Last Minute", am = "Ort", om = "Ändern", rm = "Name", im = "Weiter", sm = "", lm = "{{count}} Erwachsener", cm = "{{count}} Erwachsene", um = "", dm = "{{count}} Baby", gm = "{{count}} Babys", hm = "", _m = "{{count}} Kind", fm = "{{count}} Kinder", mm = "{{count}} Gast", pm = "{{count}} Gast", bm = "{{count}} Gäste", ym = "Das Format der Telefonnummer ist ungültig.", vm = "Benachrichtigungen per E-Mail erhalten", km = "Speichern", wm = "Kein Reiseziel gefunden", $m = "Reiseprojekte", Cm = "", Sm = "optional", xm = {
  "autocomplete.button": "Suchen",
  "autocomplete.placeholder": "Wo gehst du hin ?",
  bedroomsNumbers_zero: Nf,
  bedroomsNumbers_one: Of,
  bedroomsNumbers_other: If,
  beds_zero: Lf,
  beds_one: Df,
  beds_other: Mf,
  "button.free-signup": "Kostenlos anmelden",
  "button.validate": "Bestätigen",
  "common.try-again": "Erneut versuchen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Darf {{limit}} Zeichen nicht überschreiten",
  "error.reload": "Aktualisieren Sie diese Seite",
  "error.return-homepage": "Zurück zur Startseite",
  "error.subtitle": "Leider ist diese Seite nicht erreichbar.",
  "error.title": "Es ist ein Fehler auf der Seite aufgetreten.",
  "errors.unable_to_submit.subtitle": "Leider konnte Ihr Formular im Moment nicht abgeschickt werden. Bitte versuchen Sie es später noch einmal.",
  "errors.unable_to_submit.title": "Hoppla, wir haben ein Problem",
  "global.back": "Zurück",
  "global.cancel": "Abbrechen",
  "global.collection.browsehomes": "Unterkünfte durchstöbern",
  "global.collection.contactus": "Kontaktieren Sie uns",
  "global.confirm": "Bestätigen",
  "global.continue": "Weiter",
  "global.getStarted": "Los geht's",
  "global.login": "Anmelden",
  "global.select": "Auswählen",
  global_calendarUpdated_toast: Ef,
  global_calendar_aMonth: jf,
  global_calendar_exactDates: Pf,
  global_calendar_oneWeek: Tf,
  global_calendar_oneWeekend: Rf,
  global_calendar_plusMinusDay_zero: Bf,
  global_calendar_plusMinusDay_one: Ff,
  global_calendar_plusMinusDay_other: Vf,
  global_calendar_twoWeeks: Gf,
  global_cancel: Uf,
  global_dates: Zf,
  global_delete: Kf,
  global_description: qf,
  global_destination: Wf,
  global_done: Hf,
  global_edit: Jf,
  global_filters: Yf,
  global_fixDates: Qf,
  global_flexibleDates: Xf,
  global_guests: em,
  global_homes: tm,
  global_lastMinute: nm,
  global_location: am,
  global_modify: om,
  global_name: rm,
  global_next: im,
  global_numberOfAdults_zero: sm,
  global_numberOfAdults_one: lm,
  global_numberOfAdults_other: cm,
  global_numberOfBabies_zero: um,
  global_numberOfBabies_one: dm,
  global_numberOfBabies_other: gm,
  global_numberOfChildren_zero: hm,
  global_numberOfChildren_one: _m,
  global_numberOfChildren_other: fm,
  global_numberOfGuests_zero: mm,
  global_numberOfGuests_one: pm,
  global_numberOfGuests_other: bm,
  global_phoneNumber_notValid: ym,
  global_receiveEmailAlerts: vm,
  global_save: km,
  global_searchBar_noLocationFound: wm,
  global_travelWishlist: $m,
  "modal.error-occured.content": "Wir entschuldigen uns für die Unannehmlichkeiten, bitte versuchen Sie es noch einmal.",
  "modal.error-occured.title": "Oh nein, es ist ein Fehler aufgetreten!",
  no_result: Cm,
  optional: Sm,
  "privacy-policy": "Datenschutz"
}, zm = "Nachdem Sie diesen Haustausch vorläufig bestätigt haben, muss Ihr Tauschpartner ihn finalisieren. Dazu hat Ihr Partner {nbDays} Tage Zeit (bis {date}). Nach Ablauf dieser Frist erlischt Ihre Vorabbestätigung und Sie müssen den Haustausch erneut vorläufig bestätigen.", Am = "Doppelbuchung (über eine andere Plattform)", Nm = "Familiäre Gründe", Om = "Gesundheitliche Probleme", Im = "Schäden an der Unterkunft", Lm = "Umzug", Dm = "Sie müssten bitte die Gründe für Ihre Annullierung angeben.", Mm = "Andere", Em = "Probleme bei der An-/Abreise", jm = "Vertrauensprobleme", Pm = "Arbeitsbedingte Gründe", Tm = "Sie müssen einen Grund angeben", Rm = {
  "cancellation-page.cancel-exchange": "Den Tausch stornieren",
  "cancellation-page.continue-cancellation": "Stornierung fortsetzen",
  "cancellation-page.keep-exchange": "Meinen Haustausch beibehalten",
  "cancellation-page.reason_step.checboxes_label": "Wählen Sie den Hauptgrund für Ihre Stornierung aus:",
  "cancellation-page.reason_step.comment_placeholder": "Bitte geben Sie hier den Grund für Ihre Stornierung an",
  "cancellation-page.reason_step.error": "Sie müssen einen Grund angeben",
  "cancellation-page.reason_step.title": "Warum müssen Sie stornieren?",
  "cancellation-page.warning-step.first-warning": "Beachten Sie, dass die Stornierung Ihres Haustauschs negative Auswirkungen auf Ihre Tauschpartner haben könnte, die möglicherweise bereits Reisepläne gemacht haben!",
  "cancellation-page.warning-step.second-warning": "Wichtig: Zu viele ungerechtfertigte Stornierungen können dazu führen, dass Ihr Konto als Gastgeber*in offline gestellt wird. Als Gast*in können Ihnen möglicherweise nicht alle Ihre GuestPoints zurückerstattet werden.",
  pre_approval_modal_expiration_description: zm,
  reasons_for_cancellation_double_booking_rental: Am,
  reasons_for_cancellation_family_issues: Nm,
  reasons_for_cancellation_health_issues: Om,
  reasons_for_cancellation_home_damage: Im,
  reasons_for_cancellation_moving: Lm,
  reasons_for_cancellation_needed: Dm,
  reasons_for_cancellation_other: Mm,
  reasons_for_cancellation_transportation_issues: Em,
  reasons_for_cancellation_trust_issues: jm,
  reasons_for_cancellation_work_related: Pm,
  reasons_other_comment_needed: Tm
}, Bm = "Studio", Fm = "{{count}} bedroom", Vm = "{{count}} bedrooms", Gm = "", Um = "{{count}} bed", Zm = "{{count}} beds", Km = "Your calendar has been updated.", qm = "A month", Wm = "Exact dates", Hm = "One week", Jm = "One weekend", Ym = "", Qm = "± {{count}} day", Xm = "± {{count}} days", ep = "Two weeks", tp = "Cancel", np = "Dates", ap = "Delete", op = "Description", rp = "Destination", ip = "Done!", sp = "Edit", lp = "Filters", cp = "Fixed dates", up = "Flexible dates", dp = "Guests", gp = "homes", hp = "Last minute", _p = "Location", fp = "Modify", mp = "Name", pp = "Next", bp = "", yp = "{{count}} adult", vp = "{{count}} adults", kp = "", wp = "{{count}} baby", $p = "{{count}} babies", Cp = "", Sp = "{{count}} child", xp = "{{count}} children", zp = "{{count}} guest", Ap = "{{count}} guest", Np = "{{count}} guests", Op = "The phone number format is not valid", Ip = "Receive email alerts", Lp = "Save", Dp = "No locations found", Mp = "Travel wishlist", Ep = "No result", jp = "optional", Pp = {
  "autocomplete.button": "Search",
  "autocomplete.placeholder": "Where are you going ?",
  bedroomsNumbers_zero: Bm,
  bedroomsNumbers_one: Fm,
  bedroomsNumbers_other: Vm,
  beds_zero: Gm,
  beds_one: Um,
  beds_other: Zm,
  "button.free-signup": "Sign up for free",
  "button.validate": "Validate",
  "common.try-again": "Try again",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Must not exceed {{limit}} characters",
  "error.reload": "Refresh this page",
  "error.return-homepage": "Return to home page",
  "error.subtitle": "Unfortunately this page can't be reached.",
  "error.title": "An error occurred on the page",
  "errors.unable_to_submit.subtitle": "Unfortunately your form couldn't be submitted right now. Please try again later.",
  "errors.unable_to_submit.title": "Oops, we've hit a problem",
  "global.back": "Back",
  "global.cancel": "Cancel",
  "global.collection.browsehomes": "Browse Homes",
  "global.collection.contactus": "Contact us",
  "global.confirm": "Confirm",
  "global.continue": "Continue",
  "global.getStarted": "Get started",
  "global.login": "Log in",
  "global.select": "Select",
  global_calendarUpdated_toast: Km,
  global_calendar_aMonth: qm,
  global_calendar_exactDates: Wm,
  global_calendar_oneWeek: Hm,
  global_calendar_oneWeekend: Jm,
  global_calendar_plusMinusDay_zero: Ym,
  global_calendar_plusMinusDay_one: Qm,
  global_calendar_plusMinusDay_other: Xm,
  global_calendar_twoWeeks: ep,
  global_cancel: tp,
  global_dates: np,
  global_delete: ap,
  global_description: op,
  global_destination: rp,
  global_done: ip,
  global_edit: sp,
  global_filters: lp,
  global_fixDates: cp,
  global_flexibleDates: up,
  global_guests: dp,
  global_homes: gp,
  global_lastMinute: hp,
  global_location: _p,
  global_modify: fp,
  global_name: mp,
  global_next: pp,
  global_numberOfAdults_zero: bp,
  global_numberOfAdults_one: yp,
  global_numberOfAdults_other: vp,
  global_numberOfBabies_zero: kp,
  global_numberOfBabies_one: wp,
  global_numberOfBabies_other: $p,
  global_numberOfChildren_zero: Cp,
  global_numberOfChildren_one: Sp,
  global_numberOfChildren_other: xp,
  global_numberOfGuests_zero: zp,
  global_numberOfGuests_one: Ap,
  global_numberOfGuests_other: Np,
  global_phoneNumber_notValid: Op,
  global_receiveEmailAlerts: Ip,
  global_save: Lp,
  global_searchBar_noLocationFound: Dp,
  global_travelWishlist: Mp,
  "modal.error-occured.content": "We're so sorry for the inconvenience, but please do try again.",
  "modal.error-occured.title": "Oh no, an error has occurred!",
  no_result: Ep,
  optional: jp,
  "privacy-policy": "Privacy Policy"
}, Tp = "After you pre-approve this exchange, your exchange partner will need to finalize it. They have {nbDays} days to finalize the exchange (until {date}). Otherwise, your pre-approval will expire and you will have to preapprove the exchange again.", Rp = "Double booking (via another platform)", Bp = "Family issue", Fp = "Health issue", Vp = "Home damage", Gp = "Moving home", Up = "You need to indicate the reasons for your cancellation.", Zp = "Other", Kp = "Transport issue", qp = "Trust issue", Wp = "Work related", Hp = "You need to enter a reason", Jp = {
  "cancellation-page.cancel-exchange": "Cancel the exchange",
  "cancellation-page.continue-cancellation": "Continue cancellation",
  "cancellation-page.keep-exchange": "Keep my exchange",
  "cancellation-page.reason_step.checboxes_label": "Select the main reason for your cancellation:",
  "cancellation-page.reason_step.comment_placeholder": "Write the reason for your cancellation here",
  "cancellation-page.reason_step.error": "You need to enter a reason",
  "cancellation-page.reason_step.title": "Why do you need to cancel?",
  "cancellation-page.warning-step.first-warning": "Remember that cancelling your exchange could impact negatively on your exchange partner, who might already have made plans!",
  "cancellation-page.warning-step.second-warning": "Important: In case of excessive unjustified cancellations as a host, your account may be taken offline. And as a guest, you may not have all your GuestPoints returned to you.",
  pre_approval_modal_expiration_description: Tp,
  reasons_for_cancellation_double_booking_rental: Rp,
  reasons_for_cancellation_family_issues: Bp,
  reasons_for_cancellation_health_issues: Fp,
  reasons_for_cancellation_home_damage: Vp,
  reasons_for_cancellation_moving: Gp,
  reasons_for_cancellation_needed: Up,
  reasons_for_cancellation_other: Zp,
  reasons_for_cancellation_transportation_issues: Kp,
  reasons_for_cancellation_trust_issues: qp,
  reasons_for_cancellation_work_related: Wp,
  reasons_other_comment_needed: Hp
}, Yp = "Estudio", Qp = "{{count}} dormitorio", Xp = "{{count}} dormitorios", eb = "", tb = "{{count}} cama", nb = "{{count}} camas", ab = "Tu calendario ha sido actualizado.", ob = "Un mes", rb = "Fechas exactas", ib = "Una semana", sb = "Un fin de semana", lb = "", cb = "± 1:{{count}} día", ub = "± 1:{{count}} días", db = "Dos semanas", gb = "Cancelar", hb = "Fechas", _b = "Eliminar", fb = "Descripción", mb = "Destino", pb = "¡Listo!", bb = "Editar", yb = "Filtros", vb = "Fechas fijas", kb = "Fechas flexibles", wb = "Invitados", $b = "casas", Cb = "Último minuto", Sb = "Ubicación", xb = "Modificar", zb = "Nombre", Ab = "Siguiente", Nb = "", Ob = "{{count}} adulto", Ib = "{{count}} adultos", Lb = "", Db = "{{count}} bebé", Mb = "bebé", Eb = "", jb = "{{count}} niño/a", Pb = "{{count}} niños", Tb = "", Rb = "{{count}} invitado/a", Bb = "{{count}} invitados", Fb = "El formato del número de teléfono no es válido.", Vb = "Recibir notificaciones por correo electrónico", Gb = "Guardar", Ub = "No encontramos este lugar", Zb = "Proyectos de viaje", Kb = "", qb = "opcional", Wb = {
  "autocomplete.button": "Buscar",
  "autocomplete.placeholder": "¿Adónde vas?",
  bedroomsNumbers_zero: Yp,
  bedroomsNumbers_one: Qp,
  bedroomsNumbers_other: Xp,
  beds_zero: eb,
  beds_one: tb,
  beds_other: nb,
  "button.free-signup": "Regístrate gratis",
  "button.validate": "Validar",
  "common.try-again": "",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "No puedes superar los {{limit}} caracteres",
  "error.reload": "Actualizar esta página",
  "error.return-homepage": "Volver a la página de inicio",
  "error.subtitle": "Lo sentimos, pero no se puede acceder a esta página.",
  "error.title": "Se ha producido un error en la página",
  "errors.unable_to_submit.subtitle": "Lo sentimos, se ha producido un error al enviar el formulario. Por favor, vuelve a intentarlo más tarde.",
  "errors.unable_to_submit.title": "¡Vaya! Algo ha fallado.",
  "global.back": "",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "Continuar",
  "global.getStarted": "",
  "global.login": "Iniciar sesión",
  "global.select": "Selecciona",
  global_calendarUpdated_toast: ab,
  global_calendar_aMonth: ob,
  global_calendar_exactDates: rb,
  global_calendar_oneWeek: ib,
  global_calendar_oneWeekend: sb,
  global_calendar_plusMinusDay_zero: lb,
  global_calendar_plusMinusDay_one: cb,
  global_calendar_plusMinusDay_other: ub,
  global_calendar_twoWeeks: db,
  global_cancel: gb,
  global_dates: hb,
  global_delete: _b,
  global_description: fb,
  global_destination: mb,
  global_done: pb,
  global_edit: bb,
  global_filters: yb,
  global_fixDates: vb,
  global_flexibleDates: kb,
  global_guests: wb,
  global_homes: $b,
  global_lastMinute: Cb,
  global_location: Sb,
  global_modify: xb,
  global_name: zb,
  global_next: Ab,
  global_numberOfAdults_zero: Nb,
  global_numberOfAdults_one: Ob,
  global_numberOfAdults_other: Ib,
  global_numberOfBabies_zero: Lb,
  global_numberOfBabies_one: Db,
  global_numberOfBabies_other: Mb,
  global_numberOfChildren_zero: Eb,
  global_numberOfChildren_one: jb,
  global_numberOfChildren_other: Pb,
  global_numberOfGuests_zero: Tb,
  global_numberOfGuests_one: Rb,
  global_numberOfGuests_other: Bb,
  global_phoneNumber_notValid: Fb,
  global_receiveEmailAlerts: Vb,
  global_save: Gb,
  global_searchBar_noLocationFound: Ub,
  global_travelWishlist: Zb,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: Kb,
  optional: qb,
  "privacy-policy": "Política de Privacidad"
}, Hb = "Después de preaprobar este intercambio, tus compañeros de intercambio tendrán que registrarlo. Tienes {nbDays} días para registrar el intercambio (hasta el {date}). De lo contrario, la preaprobación caducará y tendrás que volver a preaprobar el intercambio.", Jb = "Reserva doble (otra plataforma)", Yb = "Asuntos familiares", Qb = "Temas de salud", Xb = "Daños en la casa", ey = "Mudanza", ty = "Por favor, indica las razones de la cancelación", ny = "Otro", ay = "Problemas con el transporte", oy = "Temas de confianza", ry = "Asuntos laborales", iy = "Debes introducir un motivo", sy = {
  "cancellation-page.cancel-exchange": "Cancelar el intercambio",
  "cancellation-page.continue-cancellation": "Continuar con la cancelación",
  "cancellation-page.keep-exchange": "Mantener el intercambio",
  "cancellation-page.reason_step.checboxes_label": "Selecciona el motivo principal de la cancelación:",
  "cancellation-page.reason_step.comment_placeholder": "",
  "cancellation-page.reason_step.error": "Debes introducir un motivo",
  "cancellation-page.reason_step.title": "¿Por qué quieres cancelar el intercambio?",
  "cancellation-page.warning-step.first-warning": "No olvides que cancelar el intercambio puede afectar a tus compañeros de intercambio, que seguramente han hecho planes.",
  "cancellation-page.warning-step.second-warning": "Importante: un exceso de cancelaciones injustificadas por parte de los anfitriones puede resultar en la desactivación de su cuenta y, por parte de los invitados, puede implicar que no se recuperen todos los GuestPoints.",
  pre_approval_modal_expiration_description: Hb,
  reasons_for_cancellation_double_booking_rental: Jb,
  reasons_for_cancellation_family_issues: Yb,
  reasons_for_cancellation_health_issues: Qb,
  reasons_for_cancellation_home_damage: Xb,
  reasons_for_cancellation_moving: ey,
  reasons_for_cancellation_needed: ty,
  reasons_for_cancellation_other: ny,
  reasons_for_cancellation_transportation_issues: ay,
  reasons_for_cancellation_trust_issues: oy,
  reasons_for_cancellation_work_related: ry,
  reasons_other_comment_needed: iy
}, ly = "Studio", cy = "{{count}} chambre", uy = "{{count}} chambres", dy = "", gy = "{{count}} lit", hy = "{{count}} lits", _y = "Votre calendrier a été mis à jour.", fy = "Un mois", my = "Dates exactes", py = "Une semaine", by = "Un week-end", yy = "Vide", vy = "± {{count}} jour", ky = "± {{count}} jours", wy = "Deux semaines", $y = "Annuler", Cy = "Dates", Sy = "Supprimer", xy = "Description", zy = "Destination", Ay = "C'est prêt !", Ny = "Modifier", Oy = "Filtres", Iy = "Dates fixes", Ly = "Dates flexibles", Dy = "Personnes", My = "maisons", Ey = "Dernière minute", jy = "Lieu", Py = "Modifier", Ty = "Titre", Ry = "Suivant", By = "Vide", Fy = "{{count}} adulte", Vy = "{{count}} adultes", Gy = "Vide", Uy = "{{count}} bébé", Zy = "{{count}} bébés", Ky = "Vide", qy = "{{count}} enfant", Wy = "{{count}} enfants", Hy = "{{count}} invité·e", Jy = "{{count}} invité·e", Yy = "{{count}} invité·es", Qy = "Le format du numéro de téléphone est invalide.", Xy = "Recevoir des alertes par email", ev = "Sauvegarder", tv = "Aucun lieu trouvé", nv = "Projets de voyage", av = "", ov = "facultatif", rv = {
  "autocomplete.button": "Rechercher",
  "autocomplete.placeholder": "Où allez-vous ?",
  bedroomsNumbers_zero: ly,
  bedroomsNumbers_one: cy,
  bedroomsNumbers_other: uy,
  beds_zero: dy,
  beds_one: gy,
  beds_other: hy,
  "button.free-signup": "Inscrivez-vous gratuitement",
  "button.validate": "Valider",
  "common.try-again": "Compris !",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Ne doit pas dépasser {{limit}} caractères",
  "error.reload": "Actualiser la page",
  "error.return-homepage": "Retour à la page d'accueil",
  "error.subtitle": "Malheureusement, il y a un problème avec cette page.",
  "error.title": "Une erreur s'est produite sur la page",
  "errors.unable_to_submit.subtitle": "Malheureusement, votre réponse n'a pas pu être enregistrée. Merci de réessayer plus tard !",
  "errors.unable_to_submit.title": "Oups, on dirait bien qu'il y a un problème !",
  "global.back": "Retour",
  "global.cancel": "Annuler",
  "global.collection.browsehomes": "Découvrir les maisons",
  "global.collection.contactus": "Nous contacter",
  "global.confirm": "Confirmer",
  "global.continue": "Continuer",
  "global.getStarted": "Commencer",
  "global.login": "Se connecter",
  "global.select": "Sélectionner",
  global_calendarUpdated_toast: _y,
  global_calendar_aMonth: fy,
  global_calendar_exactDates: my,
  global_calendar_oneWeek: py,
  global_calendar_oneWeekend: by,
  global_calendar_plusMinusDay_zero: yy,
  global_calendar_plusMinusDay_one: vy,
  global_calendar_plusMinusDay_other: ky,
  global_calendar_twoWeeks: wy,
  global_cancel: $y,
  global_dates: Cy,
  global_delete: Sy,
  global_description: xy,
  global_destination: zy,
  global_done: Ay,
  global_edit: Ny,
  global_filters: Oy,
  global_fixDates: Iy,
  global_flexibleDates: Ly,
  global_guests: Dy,
  global_homes: My,
  global_lastMinute: Ey,
  global_location: jy,
  global_modify: Py,
  global_name: Ty,
  global_next: Ry,
  global_numberOfAdults_zero: By,
  global_numberOfAdults_one: Fy,
  global_numberOfAdults_other: Vy,
  global_numberOfBabies_zero: Gy,
  global_numberOfBabies_one: Uy,
  global_numberOfBabies_other: Zy,
  global_numberOfChildren_zero: Ky,
  global_numberOfChildren_one: qy,
  global_numberOfChildren_other: Wy,
  global_numberOfGuests_zero: Hy,
  global_numberOfGuests_one: Jy,
  global_numberOfGuests_other: Yy,
  global_phoneNumber_notValid: Qy,
  global_receiveEmailAlerts: Xy,
  global_save: ev,
  global_searchBar_noLocationFound: tv,
  global_travelWishlist: nv,
  "modal.error-occured.content": "Toutes nos excuses : quelque chose ne s'est pas passé comme prévu, il va falloir que vous retentiez votre chance !",
  "modal.error-occured.title": "Une erreur s'est produite",
  no_result: av,
  optional: ov,
  "privacy-policy": "Charte de vie privée"
}, iv = "Après cette pré-approbation, votre partenaire d'échange disposera de {nbDays} jour(s) pour finaliser (jusqu'au {date}). Sinon, votre pré-approbation expirera et vous devrez pré-approuver l'échange de nouveau.", sv = "Double réservation (via une autre plateforme)", lv = "Imprévu familial", cv = "Problème de santé", uv = "Dégâts à mon domicile", dv = "Déménagement", gv = "Vous devez indiquer les raisons de votre annulation.", hv = "Autre", _v = "Problème de transport", fv = "Problème de confiance", mv = "Imprévu professionnel", pv = "Vous devez saisir un motif", bv = {
  "cancellation-page.cancel-exchange": "Annuler l'échange",
  "cancellation-page.continue-cancellation": "Poursuivre l'annulation",
  "cancellation-page.keep-exchange": "Conserver mon échange",
  "cancellation-page.reason_step.checboxes_label": "Sélectionnez la raison principale de votre annulation :",
  "cancellation-page.reason_step.comment_placeholder": "Indiquez la raison de votre annulation juste ici",
  "cancellation-page.reason_step.error": "Vous devez saisir un motif",
  "cancellation-page.reason_step.title": "Pourquoi devez-vous annuler ?",
  "cancellation-page.warning-step.first-warning": "N'oubliez pas que l'annulation de votre échange peut avoir un impact négatif sur votre partenaire d'échange, qui a peut-être déjà planifié son voyage !",
  "cancellation-page.warning-step.second-warning": "Important : Face à un nombre excessif d'annulations injustifiées en tant qu'hôte, votre compte pourrait être mis hors ligne et, en tant qu'invité-e, vous pourriez ne pas récupérer l'intégralité de vos GuestPoints.",
  pre_approval_modal_expiration_description: iv,
  reasons_for_cancellation_double_booking_rental: sv,
  reasons_for_cancellation_family_issues: lv,
  reasons_for_cancellation_health_issues: cv,
  reasons_for_cancellation_home_damage: uv,
  reasons_for_cancellation_moving: dv,
  reasons_for_cancellation_needed: gv,
  reasons_for_cancellation_other: hv,
  reasons_for_cancellation_transportation_issues: _v,
  reasons_for_cancellation_trust_issues: fv,
  reasons_for_cancellation_work_related: mv,
  reasons_other_comment_needed: pv
}, yv = "Studio", vv = "{{count}} soba", kv = "{{count}} sobe", wv = "{{count}} sobe", $v = "", Cv = "{{count}} krevet", Sv = "{{count}} kreveti", xv = "{{count}} kreveti", zv = "Vaš je kalendar ažuriran.", Av = "Mjesec", Nv = "Točni datumi", Ov = "Jedan tjedan", Iv = "Jedan vikend", Lv = "dana", Dv = "dan", Mv = "dana", Ev = "± {{count}} dan", jv = "Dva tjedna", Pv = "Odustani", Tv = "Datumi", Rv = "Izbrišite", Bv = "Opis", Fv = "Odredište", Vv = "Gotovo!", Gv = "Uredite", Uv = "Filtri", Zv = "Fiksni datumi", Kv = "Fleksibilni datumi", qv = "Gosti", Wv = "domova", Hv = "U zadnji tren", Jv = "Lokacija", Yv = "Uredi", Qv = "", Xv = "Dalje", ek = "odraslih osoba", tk = "odrasla osoba", nk = "odrasle osobe", ak = "odraslih osoba", ok = "beba", rk = "beba", ik = "bebe", sk = "beba", lk = "djece", ck = "dijete", uk = "djeteta", dk = "djece", gk = "gostiju", hk = "gost", _k = "gosta", fk = "gostiju", mk = "Format telefonskog broja nije valjan.", pk = "Primajte obavijesti e-poštom", bk = "Spremi", yk = "Nema pronađenih lokacija", vk = "Planovi putovanja", kk = "", wk = "nije obavezno", $k = {
  "autocomplete.button": "Pretražite",
  "autocomplete.placeholder": "Gdje ideš ?",
  bedroomsNumbers_zero: yv,
  bedroomsNumbers_one: vv,
  bedroomsNumbers_few: kv,
  bedroomsNumbers_other: wv,
  beds_zero: $v,
  beds_one: Cv,
  beds_few: Sv,
  beds_other: xv,
  "button.free-signup": "Prijavite se besplatno",
  "button.validate": "Potvrdite",
  "common.try-again": "Pokušajte ponovno",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Ne smije biti dulje od {{limit}} znakova",
  "error.reload": "Osvježite stranicu",
  "error.return-homepage": "Vratite se na početnu stranicu",
  "error.subtitle": "Nažalost ne može se pristupiti ovoj stranici.",
  "error.title": "Došlo je do greške na stranici.",
  "errors.unable_to_submit.subtitle": "Nažalost, Vaš obrazac trenutačno ne može biti predan. Molimo da kasnije pokušate ponovno.",
  "errors.unable_to_submit.title": "Ups, imamo problem",
  "global.back": "Natrag",
  "global.cancel": "Odustani",
  "global.collection.browsehomes": "Pretražujte domove",
  "global.collection.contactus": "Kontaktirajte nas",
  "global.confirm": "Potvrdi",
  "global.continue": "Nastavite",
  "global.getStarted": "Započnite",
  "global.login": "Prijava",
  "global.select": "Odaberi",
  global_calendarUpdated_toast: zv,
  global_calendar_aMonth: Av,
  global_calendar_exactDates: Nv,
  global_calendar_oneWeek: Ov,
  global_calendar_oneWeekend: Iv,
  global_calendar_plusMinusDay_zero: Lv,
  global_calendar_plusMinusDay_one: Dv,
  global_calendar_plusMinusDay_few: Mv,
  global_calendar_plusMinusDay_other: Ev,
  global_calendar_twoWeeks: jv,
  global_cancel: Pv,
  global_dates: Tv,
  global_delete: Rv,
  global_description: Bv,
  global_destination: Fv,
  global_done: Vv,
  global_edit: Gv,
  global_filters: Uv,
  global_fixDates: Zv,
  global_flexibleDates: Kv,
  global_guests: qv,
  global_homes: Wv,
  global_lastMinute: Hv,
  global_location: Jv,
  global_modify: Yv,
  global_name: Qv,
  global_next: Xv,
  global_numberOfAdults_zero: ek,
  global_numberOfAdults_one: tk,
  global_numberOfAdults_few: nk,
  global_numberOfAdults_other: ak,
  global_numberOfBabies_zero: ok,
  global_numberOfBabies_one: rk,
  global_numberOfBabies_few: ik,
  global_numberOfBabies_other: sk,
  global_numberOfChildren_zero: lk,
  global_numberOfChildren_one: ck,
  global_numberOfChildren_few: uk,
  global_numberOfChildren_other: dk,
  global_numberOfGuests_zero: gk,
  global_numberOfGuests_one: hk,
  global_numberOfGuests_few: _k,
  global_numberOfGuests_other: fk,
  global_phoneNumber_notValid: mk,
  global_receiveEmailAlerts: pk,
  global_save: bk,
  global_searchBar_noLocationFound: yk,
  global_travelWishlist: vk,
  "modal.error-occured.content": "Žao nam je zbog neugodnosti, ali pokušajte ponovno.",
  "modal.error-occured.title": "Došlo je do pogreške.",
  no_result: kk,
  optional: wk,
  "privacy-policy": "Pravila o privatnosti"
}, Ck = "Nakon što unaprijed odobrite ovu zamjenu, Vaš partner za zamjenu ju mora finalizirati. Za to ima {nbDays} dana (do {date}). Ako ne, Vaše će prethodno odobrenje isteći i trebat ćete ponovno prethodno odobriti zamjenu.", Sk = "Dvostruka rezervacija (druga platforma)", xk = "Obiteljski problemi", zk = "Zdravstveni problemi", Ak = "Oštećenje doma", Nk = "Preseljenje", Ok = "Morate navesti razloge otkazivanja", Ik = "Ostalo", Lk = "Problemi s prijevozom", Dk = "Nepovjerenje", Mk = "Poslovni problemi", Ek = "Trebate unijeti razlog", jk = {
  "cancellation-page.cancel-exchange": "Otkažite zamjenu",
  "cancellation-page.continue-cancellation": "Nastavite s otkazivanjem",
  "cancellation-page.keep-exchange": "Zadržite svoju zamjenu",
  "cancellation-page.reason_step.checboxes_label": "Odaberite glavni razlog zašto otkazujete:",
  "cancellation-page.reason_step.comment_placeholder": "Ovdje unesite razlog otkazivanja zamjene",
  "cancellation-page.reason_step.error": "Trebate unijeti razlog",
  "cancellation-page.reason_step.title": "Zašto trebate otkazati?",
  "cancellation-page.warning-step.first-warning": "Vodite računa o tome da otkazivanje zamjene može negativno utjecati na Vašeg partnera za zamjenu koji je već možda napravio planove za putovanje!",
  "cancellation-page.warning-step.second-warning": "Važno: U slučaju pretjeranih neopradanih otkazivanja u svojstvu domaćina, Vaš dom može biti uklonjen s interneta. A kao gost, možda nećete dobiti natrag svoje GuestPoints.",
  pre_approval_modal_expiration_description: Ck,
  reasons_for_cancellation_double_booking_rental: Sk,
  reasons_for_cancellation_family_issues: xk,
  reasons_for_cancellation_health_issues: zk,
  reasons_for_cancellation_home_damage: Ak,
  reasons_for_cancellation_moving: Nk,
  reasons_for_cancellation_needed: Ok,
  reasons_for_cancellation_other: Ik,
  reasons_for_cancellation_transportation_issues: Lk,
  reasons_for_cancellation_trust_issues: Dk,
  reasons_for_cancellation_work_related: Mk,
  reasons_other_comment_needed: Ek
}, Pk = "Monolocale", Tk = "{{count}} camera da letto", Rk = "{{count}} camere da letto", Bk = "", Fk = "{{count}} letto", Vk = "{{count}} letti", Gk = "Il tuo calendario è stato aggiornato.", Uk = "", Zk = "", Kk = "", qk = "", Wk = "", Hk = "", Jk = "", Yk = "", Qk = "Annulla", Xk = "Date", ew = "Elimina", tw = "Descrizione", nw = "Destinazione", aw = "Fatto!", ow = "Modifica", rw = "Filtri", iw = "", sw = "", lw = "Ospiti", cw = "case", uw = "", dw = "Posizione", gw = "Modifica", hw = "Nome", _w = "Avanti", fw = "Zero", mw = "Uno", pw = "Altro", bw = "Zero", yw = "Uno", vw = "Altro", kw = "Zero", ww = "Uno", $w = "Altro", Cw = "Zero", Sw = "Uno", xw = "Altro", zw = "Il formato del numero di telefono non è valido.", Aw = "Ricevi avvisi via email", Nw = "Salva", Ow = "Nessuna posizione trovata", Iw = "Lista dei programmi di viaggio", Lw = "", Dw = "facoltativo", Mw = {
  "autocomplete.button": "Ricerca",
  "autocomplete.placeholder": "Dove stai andando?",
  bedroomsNumbers_zero: Pk,
  bedroomsNumbers_one: Tk,
  bedroomsNumbers_other: Rk,
  beds_zero: Bk,
  beds_one: Fk,
  beds_other: Vk,
  "button.free-signup": "Iscriviti gratis",
  "button.validate": "Convalida",
  "common.try-again": "Prova ancora",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Non deve superare i {{limit}} caratteri",
  "error.reload": "Aggiorna la pagina",
  "error.return-homepage": "Ritorna alla home page",
  "error.subtitle": "Si è verificato un errore e non è stato possibile caricare questa pagina.",
  "error.title": "Si è verificato un errore nella pagina",
  "errors.unable_to_submit.subtitle": "Errore durante l'invio del modulo. Per favore riprova più tardi.",
  "errors.unable_to_submit.title": "Errore: è impossibile inviare",
  "global.back": "Indietro",
  "global.cancel": "Annulla",
  "global.collection.browsehomes": "Sfoglia le case",
  "global.collection.contactus": "Contattaci",
  "global.confirm": "Conferma",
  "global.continue": "Continua",
  "global.getStarted": "Cominciare",
  "global.login": "Accedi",
  "global.select": "Seleziona",
  global_calendarUpdated_toast: Gk,
  global_calendar_aMonth: Uk,
  global_calendar_exactDates: Zk,
  global_calendar_oneWeek: Kk,
  global_calendar_oneWeekend: qk,
  global_calendar_plusMinusDay_zero: Wk,
  global_calendar_plusMinusDay_one: Hk,
  global_calendar_plusMinusDay_other: Jk,
  global_calendar_twoWeeks: Yk,
  global_cancel: Qk,
  global_dates: Xk,
  global_delete: ew,
  global_description: tw,
  global_destination: nw,
  global_done: aw,
  global_edit: ow,
  global_filters: rw,
  global_fixDates: iw,
  global_flexibleDates: sw,
  global_guests: lw,
  global_homes: cw,
  global_lastMinute: uw,
  global_location: dw,
  global_modify: gw,
  global_name: hw,
  global_next: _w,
  global_numberOfAdults_zero: fw,
  global_numberOfAdults_one: mw,
  global_numberOfAdults_other: pw,
  global_numberOfBabies_zero: bw,
  global_numberOfBabies_one: yw,
  global_numberOfBabies_other: vw,
  global_numberOfChildren_zero: kw,
  global_numberOfChildren_one: ww,
  global_numberOfChildren_other: $w,
  global_numberOfGuests_zero: Cw,
  global_numberOfGuests_one: Sw,
  global_numberOfGuests_other: xw,
  global_phoneNumber_notValid: zw,
  global_receiveEmailAlerts: Aw,
  global_save: Nw,
  global_searchBar_noLocationFound: Ow,
  global_travelWishlist: Iw,
  "modal.error-occured.content": "Ci spiace davvero per l'inconveniente, ti chiediamo di riprovare.",
  "modal.error-occured.title": "Oh no, si è verificato un errore!",
  no_result: Lw,
  optional: Dw,
  "privacy-policy": "Informativa sulla privacy"
}, Ew = "Dopo aver pre-approvato questo scambio, il tuo partner di scambio dovrà finalizzarlo. Avrà tempo {nbDays} giorni per finalizzare lo scambio (fino al giorno {date}). In caso contrario, la tua pre-approvazione scadrà e dovrai pre-approvare lo scambio nuovamente.", jw = "Doppia prenotazione (con un'altra piattaforma)", Pw = "Ragioni familiari", Tw = "Motivi di salute", Rw = "Danni alla proprietà", Bw = "Trasferimento", Fw = "È necessario indicare i motivi per la cancellazione.", Vw = "Altro", Gw = "Problemi di trasporto", Uw = "Problemi di fiducia", Zw = "Motivi legati al lavoro", Kw = "È necessario inserire un motivo", qw = {
  "cancellation-page.cancel-exchange": "Annulla lo scambio",
  "cancellation-page.continue-cancellation": "Continua con la cancellazione",
  "cancellation-page.keep-exchange": "Mantieni il mio scambio",
  "cancellation-page.reason_step.checboxes_label": "Seleziona il motivo principale della tua cancellazione:",
  "cancellation-page.reason_step.comment_placeholder": "Inserisci qui la ragione della cancellazione",
  "cancellation-page.reason_step.error": "È necessario inserire un motivo",
  "cancellation-page.reason_step.title": "Perché devi annullare?",
  "cancellation-page.warning-step.first-warning": "Ricorda che annullare il tuo scambio può avere un impatto negativo sul tuo partner di scambio, che potrebbe già aver pianificato il viaggio!",
  "cancellation-page.warning-step.second-warning": "Importante: In caso di eccessive cancellazioni ingiustificate in qualità di host, il tuo account potrebbe essere disattivato. E come ospite, potresti non recuperare tutti i tuoi GuestPoints.",
  pre_approval_modal_expiration_description: Ew,
  reasons_for_cancellation_double_booking_rental: jw,
  reasons_for_cancellation_family_issues: Pw,
  reasons_for_cancellation_health_issues: Tw,
  reasons_for_cancellation_home_damage: Rw,
  reasons_for_cancellation_moving: Bw,
  reasons_for_cancellation_needed: Fw,
  reasons_for_cancellation_other: Vw,
  reasons_for_cancellation_transportation_issues: Gw,
  reasons_for_cancellation_trust_issues: Uw,
  reasons_for_cancellation_work_related: Zw,
  reasons_other_comment_needed: Kw
}, Ww = "Studio", Hw = "{{count}} soverom", Jw = "{{count}} soverom", Yw = "", Qw = "{{count}} seng", Xw = "{{count}} senger", e$ = "", t$ = "", n$ = "", a$ = "", o$ = "", r$ = "", i$ = "", s$ = "", l$ = "", c$ = "", u$ = "", d$ = "", g$ = "", h$ = "", _$ = "", f$ = "", m$ = "", p$ = "", b$ = "", y$ = "", v$ = "", k$ = "", w$ = "", $$ = "", C$ = "", S$ = "", x$ = "", z$ = "", A$ = "", N$ = "", O$ = "", I$ = "", L$ = "", D$ = "", M$ = "", E$ = "", j$ = "", P$ = "", T$ = "", R$ = "", B$ = "", F$ = "", V$ = "", G$ = "", U$ = "", Z$ = {
  "autocomplete.button": "Søk",
  "autocomplete.placeholder": "Hvor skal du ?",
  bedroomsNumbers_zero: Ww,
  bedroomsNumbers_one: Hw,
  bedroomsNumbers_other: Jw,
  beds_zero: Yw,
  beds_one: Qw,
  beds_other: Xw,
  "button.free-signup": "Registrer deg gratis",
  "button.validate": "Bekreft",
  "common.try-again": "",
  "contact-tech-email": "contact@homeexchange.com",
  "error.characters_max_limit": "Kan ikke overstige {{limit}} tegn",
  "error.reload": "Oppdater siden",
  "error.return-homepage": "Gå tilbake til startsiden",
  "error.subtitle": "Denne siden kan dessverre ikke nås.",
  "error.title": "En feil har oppstått på siden",
  "errors.unable_to_submit.subtitle": "Skjemaet ditt kunne dessverre ikke sendes inn akkurat nå. Vennligst prøv igjen senere.",
  "errors.unable_to_submit.title": "Oops, det har oppstått et problem",
  "global.back": "Tilbake",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "Fortsett",
  "global.getStarted": "",
  "global.login": "",
  "global.select": "",
  global_calendarUpdated_toast: e$,
  global_calendar_aMonth: t$,
  global_calendar_exactDates: n$,
  global_calendar_oneWeek: a$,
  global_calendar_oneWeekend: o$,
  global_calendar_plusMinusDay_zero: r$,
  global_calendar_plusMinusDay_one: i$,
  global_calendar_plusMinusDay_other: s$,
  global_calendar_twoWeeks: l$,
  global_cancel: c$,
  global_dates: u$,
  global_delete: d$,
  global_description: g$,
  global_destination: h$,
  global_done: _$,
  global_edit: f$,
  global_filters: m$,
  global_fixDates: p$,
  global_flexibleDates: b$,
  global_guests: y$,
  global_homes: v$,
  global_lastMinute: k$,
  global_location: w$,
  global_modify: $$,
  global_name: C$,
  global_next: S$,
  global_numberOfAdults_zero: x$,
  global_numberOfAdults_one: z$,
  global_numberOfAdults_other: A$,
  global_numberOfBabies_zero: N$,
  global_numberOfBabies_one: O$,
  global_numberOfBabies_other: I$,
  global_numberOfChildren_zero: L$,
  global_numberOfChildren_one: D$,
  global_numberOfChildren_other: M$,
  global_numberOfGuests_zero: E$,
  global_numberOfGuests_one: j$,
  global_numberOfGuests_other: P$,
  global_phoneNumber_notValid: T$,
  global_receiveEmailAlerts: R$,
  global_save: B$,
  global_searchBar_noLocationFound: F$,
  global_travelWishlist: V$,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: G$,
  optional: U$,
  "privacy-policy": "Personvernpolicy"
}, K$ = "Etter at du har forhåndsgodkjent dette boligbyttet må din boligbyttepartner ferdigstille det. De har {nbDays} dager på seg til å ferdigstille boligbyttet (frem til {date}). Om ikke vil forhåndsgodkjenningen din utløpe, og du må forhåndsgodkjenne boligbyttet på nytt.", q$ = "Dobbelbooking (via en annen plattform)", W$ = "Famileproblemer", H$ = "Helseproblemer", J$ = "Skade på boligen", Y$ = "Flytting", Q$ = "Du må angi årsakene til avbestillingen.", X$ = "Annet", eC = "Transportproblemer", tC = "Tillitsbrudd", nC = "Arbeidsrelatert", aC = "Du må oppgi en grunn", oC = {
  "cancellation-page.cancel-exchange": "Kanseller boligbyttet",
  "cancellation-page.continue-cancellation": "Fortsett kansellering",
  "cancellation-page.keep-exchange": "Behold boligbyttet",
  "cancellation-page.reason_step.checboxes_label": "Velg hovedårsaken for din kansellering:",
  "cancellation-page.reason_step.comment_placeholder": "Oppgi årsaken for din kansellering her",
  "cancellation-page.reason_step.error": "Du må oppgi en grunn",
  "cancellation-page.reason_step.title": "Hvorfor ønsker du å kansellere?",
  "cancellation-page.warning-step.first-warning": "Husk at det å kansellere boligbyttet kan ha en negativ innvirkning på din boligbyttepartner, som kanskje allerede har lagt reiseplaner!",
  "cancellation-page.warning-step.second-warning": "Viktig: Dersom du kansellerer et boligbytte som vert uten gyldig grunn kan din konto bli sperret. Som gjest kan konsekvensen være at du ikke får refundert alle dine GuestPoints.",
  pre_approval_modal_expiration_description: K$,
  reasons_for_cancellation_double_booking_rental: q$,
  reasons_for_cancellation_family_issues: W$,
  reasons_for_cancellation_health_issues: H$,
  reasons_for_cancellation_home_damage: J$,
  reasons_for_cancellation_moving: Y$,
  reasons_for_cancellation_needed: Q$,
  reasons_for_cancellation_other: X$,
  reasons_for_cancellation_transportation_issues: eC,
  reasons_for_cancellation_trust_issues: tC,
  reasons_for_cancellation_work_related: nC,
  reasons_other_comment_needed: aC
}, rC = "Studio", iC = "{{count}} slaapkamer", sC = "{{count}} slaapkamers", lC = "", cC = "{{count}} bed", uC = "{{count}} bedden", dC = "Je kalender is bijgewerkt.", gC = "Een maand", hC = "Exacte data", _C = "Een week", fC = "Een weekend", mC = "", pC = "", bC = "± {{count}} dagen", yC = "Twee weken", vC = "Annuleren", kC = "Data", wC = "Verwijderen", $C = "Beschrijving", CC = "Bestemming", SC = "Klaar!", xC = "Bewerken", zC = "Filters", AC = "Vaste data", NC = "Flexibele data", OC = "Gasten", IC = "huizen", LC = "Last minute", DC = "Locatie", MC = "Wijzigen", EC = "Naam", jC = "Volgende", PC = "", TC = "{{count}} volwassene", RC = "{{count}} volwassenen", BC = "", FC = "{{count}} baby", VC = "{{count}} baby's", GC = "", UC = "{{count}} kind", ZC = "{{count}} kinderen", KC = "", qC = "{{count}} gast", WC = "{{count}} gasten", HC = "De indeling van het telefoonnummer is niet geldig.", JC = "E-mailmeldingen ontvangen", YC = "Opslaan", QC = "Geen locaties gevonden", XC = "Reisplannen", eS = "Geen resultaat", tS = "optioneel", nS = {
  "autocomplete.button": "Zoeken",
  "autocomplete.placeholder": "Waar ga je naar toe ?",
  bedroomsNumbers_zero: rC,
  bedroomsNumbers_one: iC,
  bedroomsNumbers_other: sC,
  beds_zero: lC,
  beds_one: cC,
  beds_other: uC,
  "button.free-signup": "Meld je gratis aan",
  "button.validate": "Bevestigen",
  "common.try-again": "Opnieuw proberen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Mag de {{limit}} karakters niet overschrijden",
  "error.reload": "Deze pagina vernieuwen ",
  "error.return-homepage": "Terug naar de startpagina",
  "error.subtitle": "Helaas kon deze pagina niet gevonden worden.",
  "error.title": "Er is een fout opgetreden op de pagina",
  "errors.unable_to_submit.subtitle": "Helaas kon het formulier niet verzonden worden. Probeer het later nog eens.",
  "errors.unable_to_submit.title": "Oeps... het is niet gelukt om het formulier te verzenden.",
  "global.back": "Terug",
  "global.cancel": "Annuleren",
  "global.collection.browsehomes": "Blader door huizen",
  "global.collection.contactus": "Neem contact met ons op",
  "global.confirm": "Bevestigen",
  "global.continue": "Doorgaan",
  "global.getStarted": "Ga van start",
  "global.login": "Inloggen",
  "global.select": "Selecteren",
  global_calendarUpdated_toast: dC,
  global_calendar_aMonth: gC,
  global_calendar_exactDates: hC,
  global_calendar_oneWeek: _C,
  global_calendar_oneWeekend: fC,
  global_calendar_plusMinusDay_zero: mC,
  global_calendar_plusMinusDay_one: pC,
  global_calendar_plusMinusDay_other: bC,
  global_calendar_twoWeeks: yC,
  global_cancel: vC,
  global_dates: kC,
  global_delete: wC,
  global_description: $C,
  global_destination: CC,
  global_done: SC,
  global_edit: xC,
  global_filters: zC,
  global_fixDates: AC,
  global_flexibleDates: NC,
  global_guests: OC,
  global_homes: IC,
  global_lastMinute: LC,
  global_location: DC,
  global_modify: MC,
  global_name: EC,
  global_next: jC,
  global_numberOfAdults_zero: PC,
  global_numberOfAdults_one: TC,
  global_numberOfAdults_other: RC,
  global_numberOfBabies_zero: BC,
  global_numberOfBabies_one: FC,
  global_numberOfBabies_other: VC,
  global_numberOfChildren_zero: GC,
  global_numberOfChildren_one: UC,
  global_numberOfChildren_other: ZC,
  global_numberOfGuests_zero: KC,
  global_numberOfGuests_one: qC,
  global_numberOfGuests_other: WC,
  global_phoneNumber_notValid: HC,
  global_receiveEmailAlerts: JC,
  global_save: YC,
  global_searchBar_noLocationFound: QC,
  global_travelWishlist: XC,
  "modal.error-occured.content": "Onze excuses voor het ongemak, probeer het alsjeblieft opnieuw.",
  "modal.error-occured.title": "Oh nee, er is een fout opgetreden!",
  no_result: eS,
  optional: tS,
  "privacy-policy": "Privacy"
}, aS = "Nadat je de uitwisseling hebt goedgekeurd, moet je uitwisselingspartner deze bevestigen. Hij of zij heeft {nbDays} dagen de tijd om dit te doen (tot {date}). Anders vervalt je voorlopige goedkeuring en moet je de uitwisseling opnieuw goedkeuren.", oS = "Dubbele boeking (via een ander platform)", rS = "Familiale redenen", iS = "Gezondheidsproblemen", sS = "Schade aan het huis", lS = "Verhuis", cS = "U dient aan te geven in de redenen voor uw annulering.", uS = "Andere", dS = "Problemen met het transport", gS = "Vertrouwenskwestie", hS = "Werkgerelateerde redenen", _S = "Je moet een reden opgeven", fS = {
  "cancellation-page.cancel-exchange": "Annuleer de uitwisseling",
  "cancellation-page.continue-cancellation": "Doorgaan met annuleren",
  "cancellation-page.keep-exchange": "Mijn uitwisseling behouden",
  "cancellation-page.reason_step.checboxes_label": "Selecteer de hoofdreden voor je annulering:",
  "cancellation-page.reason_step.comment_placeholder": "Schrijf hier de reden van de annulering.",
  "cancellation-page.reason_step.error": "Je moet een reden opgeven",
  "cancellation-page.reason_step.title": "Waarom moet je annuleren?",
  "cancellation-page.warning-step.first-warning": "Vergeet niet dat het annuleren van je uitwisseling negatieve gevolgen kan hebben voor je uitwisselingspartner, die misschien al reisplannen heeft gemaakt!",
  "cancellation-page.warning-step.second-warning": "Belangrijk: Als je als gastheer/-vrouw te vaak onterecht annuleert, kan je account offline worden gehaald. En als gast kan het zijn dat je niet al je GuestPoints terugkrijgt.",
  pre_approval_modal_expiration_description: aS,
  reasons_for_cancellation_double_booking_rental: oS,
  reasons_for_cancellation_family_issues: rS,
  reasons_for_cancellation_health_issues: iS,
  reasons_for_cancellation_home_damage: sS,
  reasons_for_cancellation_moving: lS,
  reasons_for_cancellation_needed: cS,
  reasons_for_cancellation_other: uS,
  reasons_for_cancellation_transportation_issues: dS,
  reasons_for_cancellation_trust_issues: gS,
  reasons_for_cancellation_work_related: hS,
  reasons_other_comment_needed: _S
}, mS = "Studio", pS = "{{count}} quarto", bS = "{{count}} quartos", yS = "", vS = "{{count}} cama", kS = "{{count}} camas", wS = "O seu calendário foi atualizado.", $S = "Um mês", CS = "Datas exatas", SS = "Uma semana", xS = "Um fim de semana", zS = "", AS = "± 1:{{count}} dia", NS = "± {{count]] dias", OS = "Duas semanas", IS = "Cancelar", LS = "Datas", DS = "Eliminar", MS = "Descrição", ES = "Destino", jS = "Feito!", PS = "Editar", TS = "Filtros", RS = "Datas fixas", BS = "Datas flexíveis", FS = "Convidados", VS = "casas", GS = "Última hora", US = "Localização", ZS = "Modificar", KS = "Nome", qS = "Seguinte", WS = "", HS = "{{count}} adulto", JS = "{{count}} adultos", YS = "", QS = "{{count}} bebé", XS = "{{count}} bebés", e1 = "", t1 = "{{count}} criança", n1 = "{{count}} crianças", a1 = "", o1 = "{{count}} convidado", r1 = "{{count}} convidados", i1 = "O formato do número de telefone não é válido.", s1 = "Receber alertas por e-mail", l1 = "Guardar", c1 = "Não foram encontradas localizações", u1 = "Ideias de viagens", d1 = "", g1 = "", h1 = {
  "autocomplete.button": "Procurar",
  "autocomplete.placeholder": "Para onde vai ?",
  bedroomsNumbers_zero: mS,
  bedroomsNumbers_one: pS,
  bedroomsNumbers_other: bS,
  beds_zero: yS,
  beds_one: vS,
  beds_other: kS,
  "button.free-signup": "Filie-se gratuitamente",
  "button.validate": "Validar",
  "common.try-again": "",
  "contact-tech-email": "",
  "error.characters_max_limit": "Não deve ser superior a {{limit}} caracteres",
  "error.reload": "Atualizar esta página",
  "error.return-homepage": "Voltar à página inicial",
  "error.subtitle": "Infelizmente, não foi possível aceder a esta página.",
  "error.title": "Ocorreu um erro na página",
  "errors.unable_to_submit.subtitle": "Infelizmente, não foi possível submeter o formulário. Tente novamente mais tarde.",
  "errors.unable_to_submit.title": "Ups, ocorreu um problema!",
  "global.back": "",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "",
  "global.getStarted": "",
  "global.login": "",
  "global.select": "",
  global_calendarUpdated_toast: wS,
  global_calendar_aMonth: $S,
  global_calendar_exactDates: CS,
  global_calendar_oneWeek: SS,
  global_calendar_oneWeekend: xS,
  global_calendar_plusMinusDay_zero: zS,
  global_calendar_plusMinusDay_one: AS,
  global_calendar_plusMinusDay_other: NS,
  global_calendar_twoWeeks: OS,
  global_cancel: IS,
  global_dates: LS,
  global_delete: DS,
  global_description: MS,
  global_destination: ES,
  global_done: jS,
  global_edit: PS,
  global_filters: TS,
  global_fixDates: RS,
  global_flexibleDates: BS,
  global_guests: FS,
  global_homes: VS,
  global_lastMinute: GS,
  global_location: US,
  global_modify: ZS,
  global_name: KS,
  global_next: qS,
  global_numberOfAdults_zero: WS,
  global_numberOfAdults_one: HS,
  global_numberOfAdults_other: JS,
  global_numberOfBabies_zero: YS,
  global_numberOfBabies_one: QS,
  global_numberOfBabies_other: XS,
  global_numberOfChildren_zero: e1,
  global_numberOfChildren_one: t1,
  global_numberOfChildren_other: n1,
  global_numberOfGuests_zero: a1,
  global_numberOfGuests_one: o1,
  global_numberOfGuests_other: r1,
  global_phoneNumber_notValid: i1,
  global_receiveEmailAlerts: s1,
  global_save: l1,
  global_searchBar_noLocationFound: c1,
  global_travelWishlist: u1,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: d1,
  optional: g1,
  "privacy-policy": "Privacidade"
}, _1 = "Após pré-aprovar esta troca, o seu parceiro de troca terá de a finalizar e terá {nbDays} dias para o fazer (até {date}). Caso contrário, a sua pré-aprovação irá expirar e terá de voltar a pré-aprovar a troca.", f1 = "Reserva dupla (outra plataforma)", m1 = "Motivos familiares", p1 = "Motivos de saúde", b1 = "Danos na propriedade", y1 = "Mudanças", v1 = "Você precisa indicar os motivos do cancelamento.", k1 = "Outro", w1 = "Problemas de transporte", $1 = "Problemas de confiança", C1 = "Motivos laborais", S1 = "É obrigatório introduzir um motivo", x1 = {
  "cancellation-page.cancel-exchange": "Cancelar a troca",
  "cancellation-page.continue-cancellation": "Continuar com o cancelamento",
  "cancellation-page.keep-exchange": "Manter a minha troca",
  "cancellation-page.reason_step.checboxes_label": "Selecione o motivo principal para o cancelamento:",
  "cancellation-page.reason_step.comment_placeholder": "Escreva aqui o motivo do cancelamento",
  "cancellation-page.reason_step.error": "É obrigatório introduzir um motivo",
  "cancellation-page.reason_step.title": "Por que motivo precisa de cancelar?",
  "cancellation-page.warning-step.first-warning": "Lembre-se que cancelar a sua troca pode ter um impacto negativo para o seu parceiro de troca, que pode já ter feito planos de viagem!",
  "cancellation-page.warning-step.second-warning": "Importante: Caso tenha demasiados cancelamentos injustificados como anfitrião, a sua conta poderá ser colocada offline. Caso isto aconteça enquanto convidado, poderá não receber todos os seus GuestPoints de volta.",
  pre_approval_modal_expiration_description: _1,
  reasons_for_cancellation_double_booking_rental: f1,
  reasons_for_cancellation_family_issues: m1,
  reasons_for_cancellation_health_issues: p1,
  reasons_for_cancellation_home_damage: b1,
  reasons_for_cancellation_moving: y1,
  reasons_for_cancellation_needed: v1,
  reasons_for_cancellation_other: k1,
  reasons_for_cancellation_transportation_issues: w1,
  reasons_for_cancellation_trust_issues: $1,
  reasons_for_cancellation_work_related: C1,
  reasons_other_comment_needed: S1
}, z1 = "Studio", A1 = "{{count}} sovrum", N1 = "{{count}} sovrum", O1 = "", I1 = "{{count}} säng", L1 = "{{count}} sängar", D1 = "", M1 = "En månad", E1 = "Exakta datum", j1 = "En vecka", P1 = "En helg", T1 = "", R1 = "± {{count}} dag", B1 = "± {{count}} dagar", F1 = "Två veckor", V1 = "Avbryt", G1 = "Datum", U1 = "Ta bort", Z1 = "Beskrivning", K1 = "Resmål", q1 = "Klart!", W1 = "", H1 = "", J1 = "Fasta datum", Y1 = "Flexibla datum", Q1 = "", X1 = "hem", ex = "Sista minuten", tx = "Plats", nx = "Ändra", ax = "Namn", ox = "Nästa", rx = "", ix = "{{count}} vuxen", sx = "{{count}} vuxna", lx = "", cx = "{{count}} bebis", ux = "{{count}} bebisar", dx = "", gx = "{{count}} barn", hx = "{{count}} barn", _x = "{{count}} gäst", fx = "{{count}} gäst", mx = "{{count}} gäster", px = "Telefonnumrets format är inte giltigt.", bx = "Få e-postaviseringar", yx = "Spara", vx = "Inga resmål hittades", kx = "", wx = "", $x = "valfritt", Cx = {
  "autocomplete.button": "Sök",
  "autocomplete.placeholder": "Vart ska du ?",
  bedroomsNumbers_zero: z1,
  bedroomsNumbers_one: A1,
  bedroomsNumbers_other: N1,
  beds_zero: O1,
  beds_one: I1,
  beds_other: L1,
  "button.free-signup": "Registrera dig gratis",
  "button.validate": "Godkänn",
  "common.try-again": "Försök igen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Får inte överskrida {{limit}} tecken",
  "error.reload": "Ladda om sidan",
  "error.return-homepage": "Gå tillbaka till startsidan",
  "error.subtitle": "Tyvärr kan inte den här sidan nås.",
  "error.title": "Ett fel uppstod på sidan",
  "errors.unable_to_submit.subtitle": "Tyvärr kunde inte ditt formulär skickas in just nu. Vänligen försök igen senare.",
  "errors.unable_to_submit.title": "Hoppsan, vi har stött på ett problem",
  "global.back": "Tillbaka",
  "global.cancel": "Avbryt",
  "global.collection.browsehomes": "Se fler hem",
  "global.collection.contactus": "Kontakta oss",
  "global.confirm": "Bekräfta",
  "global.continue": "Fortsätt",
  "global.getStarted": "Kom igång",
  "global.login": "Logga in",
  "global.select": "Välj",
  global_calendarUpdated_toast: D1,
  global_calendar_aMonth: M1,
  global_calendar_exactDates: E1,
  global_calendar_oneWeek: j1,
  global_calendar_oneWeekend: P1,
  global_calendar_plusMinusDay_zero: T1,
  global_calendar_plusMinusDay_one: R1,
  global_calendar_plusMinusDay_other: B1,
  global_calendar_twoWeeks: F1,
  global_cancel: V1,
  global_dates: G1,
  global_delete: U1,
  global_description: Z1,
  global_destination: K1,
  global_done: q1,
  global_edit: W1,
  global_filters: H1,
  global_fixDates: J1,
  global_flexibleDates: Y1,
  global_guests: Q1,
  global_homes: X1,
  global_lastMinute: ex,
  global_location: tx,
  global_modify: nx,
  global_name: ax,
  global_next: ox,
  global_numberOfAdults_zero: rx,
  global_numberOfAdults_one: ix,
  global_numberOfAdults_other: sx,
  global_numberOfBabies_zero: lx,
  global_numberOfBabies_one: cx,
  global_numberOfBabies_other: ux,
  global_numberOfChildren_zero: dx,
  global_numberOfChildren_one: gx,
  global_numberOfChildren_other: hx,
  global_numberOfGuests_zero: _x,
  global_numberOfGuests_one: fx,
  global_numberOfGuests_other: mx,
  global_phoneNumber_notValid: px,
  global_receiveEmailAlerts: bx,
  global_save: yx,
  global_searchBar_noLocationFound: vx,
  global_travelWishlist: kx,
  "modal.error-occured.content": "Vi ber om ursäkt för det, men försök gärna igen.",
  "modal.error-occured.title": "Hoppsan, ett fel uppstod!",
  no_result: wx,
  optional: $x,
  "privacy-policy": "Sekretesspolicy"
}, Sx = "Efter att du har förgodkänt det här hembytet behöver din hembytespartner bekräfta det. Hen har {nbDays} dagar på sig att bekräfta det (till {date}). Annars kommer ditt förgodkännande att löpa ut och du behöver förgodkänna hembytet igen.", xx = "Dubbelbokning (annan plattform)", zx = "Familjeproblem", Ax = "Hälsoproblem", Nx = "Skada i hemmet", Ox = "Flytt", Ix = "Du måste ange orsaken till din avbokning.", Lx = "Övrigt", Dx = "Transportproblem", Mx = "Bristande förtroende", Ex = "Arbetsrelaterat", jx = "Du behöver ange en anledning", Px = {
  "cancellation-page.cancel-exchange": "Avboka hembytet",
  "cancellation-page.continue-cancellation": "Fortsätt avbokning",
  "cancellation-page.keep-exchange": "Behåll mitt hembyte",
  "cancellation-page.reason_step.checboxes_label": "Välj huvudanledningen till din avbokning:",
  "cancellation-page.reason_step.comment_placeholder": "Ange anledningen till din avbokning här.",
  "cancellation-page.reason_step.error": "Du behöver ange en anledning",
  "cancellation-page.reason_step.title": "Varför behöver du avboka?",
  "cancellation-page.warning-step.first-warning": "Kom ihåg att ifall du avbokar ditt hembyte kan det ha en negativ inverkan på din hembytespartner, som kanske redan har planerat sin resa!",
  "cancellation-page.warning-step.second-warning": "Viktigt: Vid överdrivna och omotiverade avbokningar som värd kan ditt konto tas offline. Och som gäst kanske inte alla dina GuestPoints återgäldas till dig.",
  pre_approval_modal_expiration_description: Sx,
  reasons_for_cancellation_double_booking_rental: xx,
  reasons_for_cancellation_family_issues: zx,
  reasons_for_cancellation_health_issues: Ax,
  reasons_for_cancellation_home_damage: Nx,
  reasons_for_cancellation_moving: Ox,
  reasons_for_cancellation_needed: Ix,
  reasons_for_cancellation_other: Lx,
  reasons_for_cancellation_transportation_issues: Dx,
  reasons_for_cancellation_trust_issues: Mx,
  reasons_for_cancellation_work_related: Ex,
  reasons_other_comment_needed: jx
}, Tx = "en", Er = m_({
  fallbackLng: Tx,
  debug: !1,
  interpolation: {
    escapeValue: !1
  },
  returnEmptyString: !1,
  resources: {
    da: {
      common: ff,
      conversations: Af
    },
    de: {
      common: xm,
      conversations: Rm
    },
    en: {
      conversations: Jp,
      common: Pp
    },
    es: {
      conversations: sy,
      common: Wb
    },
    fr: {
      conversations: bv,
      common: rv
    },
    hr: {
      conversations: jk,
      common: $k
    },
    it: {
      conversations: qw,
      common: Mw
    },
    nb: {
      conversations: oC,
      common: Z$
    },
    nl: {
      conversations: fS,
      common: nS
    },
    pt: {
      conversations: x1,
      common: h1
    },
    sv: {
      conversations: Px,
      common: Cx
    }
  }
});
Er.init();
const uo = Er, Rx = (t, e) => {
  Ir("exchange_status", t, e);
}, Hx = (t, e) => {
  const n = {
    weekday: "long",
    month: "long",
    day: "numeric"
  };
  return mo(new Date(t), e).toLocaleDateString(document.body.dataset.locale, n);
}, Jx = (t, e, n) => {
  const a = mo(new Date(e), n);
  return new Date(t) > a;
}, On = "warning_step", jr = "reason_step", Bx = {
  [On]: Zh,
  [jr]: Uh
};
function Fx({
  cancellationReasons: t,
  conversation: e,
  user: n
}) {
  const [a, o] = Ce(On), r = Bx[a], { url: i } = Fn(`/conversations/${e.id}`);
  return Me(() => {
    const s = Hh({
      isHeCollection: n.is_he_collection,
      subscriptionEndOn: n?.subscription?.end_on
    });
    qh(n.id, s, n.is_he_collection);
  }, [n]), /* @__PURE__ */ y($c, { color: "primary", isFullHeight: !0, centerContent: !0, children: /* @__PURE__ */ y(pc, { children: /* @__PURE__ */ y(
    r,
    {
      cancellationReasons: t,
      conversation: e,
      user: n,
      onClickContinue: () => {
        a === On ? (Wh("exchange_cancellation", "exchange_cancellation_reason_selection", {
          collection: n.is_he_collection
        }), window.scrollTo(0, 0), o(jr)) : window.location.assign(i);
      }
    }
  ) }) });
}
function Yx({ cancellationReasons: t, conversation: e, locale: n, user: a, apiUrl: o }) {
  return uo.changeLanguage(n), Hr(o), /* @__PURE__ */ y(Dc, { locale: n, children: /* @__PURE__ */ y(Ni, { i18n: uo, children: /* @__PURE__ */ y(Fx, { cancellationReasons: t, conversation: e, user: a }) }) });
}
const Qx = "WITH-GP", Xx = "RECIPROCAL", ez = "RECIPROCAL-WITH-GP", tz = "NEW", nz = "ACCEPTED", az = "EXPIRED", oz = "MANUALLY_DECLINED", rz = "AUTOMATICALLY_DECLINED", iz = "PAST_DATES_DECLINE";
export {
  Yx as CancellationPage,
  Uh as ReasonStep,
  nz as STAY_REQUEST_STATUS_ACCEPTED,
  rz as STAY_REQUEST_STATUS_AUTOMATICALLY_DECLINED,
  az as STAY_REQUEST_STATUS_EXPIRED,
  oz as STAY_REQUEST_STATUS_MANUALLY_DECLINED,
  tz as STAY_REQUEST_STATUS_NEW,
  iz as STAY_REQUEST_STATUS_PAST_DATES_DECLINE,
  Xx as STAY_TYPE_RECIPROCAL,
  ez as STAY_TYPE_RECIPROCAL_WITH_GP,
  Qx as STAY_TYPE_WITH_GP,
  Wx as TransportationBanner,
  Zh as WarningStep,
  Wr as cancel,
  cz as cancelPreApprobation,
  uz as changeStayRequestToNonReciprocal,
  dz as changeStayRequestToReciprocal,
  gz as createStayRequest,
  hz as getCancellationInformations,
  _z as getExchangeConfig,
  Hx as getExpirationDate,
  fz as getLastSentStayRequestMessage,
  mz as getStayRequest,
  pz as getV1StayRequest,
  bz as heFetch,
  uo as i18nConfig,
  yz as isCancellationPossible,
  Jx as isStartDateAfterExpirationDate,
  vz as manualDecline,
  kz as preapproveExchange,
  Hr as setConversationsFetchConfig,
  Rx as trackExchangeStatus,
  wz as updateStayRequestDates
};
